

export const mobileStyle = `<style>* {

// gin247 css



  // gin247 css end
// satsport css start 

.main-popular-games{
        margin-right: -10px;
        scroll-behavior: smooth !important;
        min-height: 76px;
       
    }
        .slider-cat-header{
    cursor: grab;
    overflow: scroll hidden;
    scroll-snap-type: x mandatory;
    max-width: calc(100vw - 4px);
     background-image: url(../images/casino-bg.gif);
}
        .slider-cat-header .category-scroll-slider.card-version {
        gap: 3px;
        display: flex;
    flex-wrap: nowrap;
    }
        .slider-cat-header .category-scroll-slider.card-version .category-box {
               width: 8vw;
        position: relative;
        min-width: 25vw;
        text-align: center !important;
        flex-shrink: 0;
    }
        .banner-post {
                border: 1px solid #b4b4b4;
           margin-left: 0 !important;
        padding: 20px 5px !important;
        font-size: 12px;
        margin: 10px 0;
        border-radius: 8px;
        background-size: cover;
        background-position: center center;
        color: #fff;
        margin: 3px 0;
        font-size: 14px;
        font-weight: 600;
        line-height: 6px;
        padding: 18px !important;
        box-shadow: 4px 4px 10px #00000017 !important;
        white-space: nowrap;
        display: block;
        position: relative;
}
// satsport css end 
   .col-12 .p-0{
       padding: 0 !important;
    flex: 0 0 100%;
    max-width: 100%;
    position: relative;
    width: 100%;
   }
    .slider-cat{
        cursor: grab;
    overflow: scroll hidden;
    scroll-snap-type: x mandatory;
    padding: 0 10px;
    }
    .category-scroll-slider{
        display: flex
;
    flex-wrap: nowrap;
    }
    .category-box{
        position: relative;
    }
        .category-item{
            white-space: nowrap;
    display: block;
    padding: 4px 8px;
    margin: 10px 5px;
    position: relative;
    min-width: 80px;
    border-radius: 5px;
    box-shadow: none;
    background-color: #ffffff;
    color: #ffffff;
    box-shadow: 0 4px 8px var(--sp-cat-tb-shaddow);
        }
 
    .active-sport-tab-item{
    border-top: 7px solid #ffc11c;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    bottom: -7px;
    width: 1px;
    left: 0;
    right: 0;
    margin: auto;
    }
   .category-scroll-slider
    .category-box
    
    .active{
        background-color: #ffc11c;
    color: #000000;
    box-shadow: none;
    margin: 10px 5px 10px 0;
    white-space: nowrap;
    display: block;
    padding: 4px 8px;
    margin: 10px 5px;
    position: relative;
    min-width: 80px;
    border-radius: 5px;
    margin-left: 0 !important;
        }
    .inner-content{
        position: relative;
    display: flex
;
    align-items: center;
    }
    .tag-live{
 background-image: linear-gradient(180deg, #262626, #262626);
    color: #fff;
    position: absolute;
    top: -12px;
    right: 0;
    min-width: 33px;
    height: 15px;
    border-radius: 3px;
    padding-right: 3px;
    color: #ffffff;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    box-shadow: 0 1px 3px 0 #000000;
    display: flex
;
    z-index: 1;
    justify-content: center;
    align-items: center;
}
        .tag-live strong{
        background-image: linear-gradient(180deg, #fff, #fff 89%);
    color: #262626;
    flex: 1;
    margin-right: 3px;
    padding: 0 2px;
    border-radius: 2px 0 0 2px;
    display: flex
;
    justify-content: center;
    align-items: center;
        }
    .img-icon-box-20{
        display: inline-flex
;
    height: 20px;
    aspect-ratio: 1;
    }
    .img-icon-box-20 img{
    vertical-align: middle;
    border-style: none;
    }
    .category-scroll-slider-name .title{
    font-weight: bold;
    white-space: nowrap;
    color:#000;
    transition: all .2s;
    padding: 5px 0 5px 5px !important;
    font-size: 12px !important;
    }
    margin: 0;
    padding: 0;
}

*:focus {
    outline: none;
}

html,
body {
    font-family: Helvetica, Tahoma, sans-serif;
    color: #1e1e1e;
    font-size: 3.46667vw;
    -webkit-text-size-adjust: 100%;
    line-height: 1.3;
    background-color: #eee;
}

.login-head,
.pass-head {
    position: relative;
    height: 74.66667vw;

    background-size: 100% 100%;
    margin-bottom: 12vw;
}

.betsbuzz365 .pass-head h1 {
    top: 1.66667vw;
    width: 42.46667vw;
    height: 18vw;
    background-image: url(../images/headerlogo.png);
    margin-left: -21.73333vw;
    background-repeat: no-repeat;
}

.login-head h1,
.pass-head h1 {
    position: absolute;
    left: 50%;
    top: 37.86667vw;
    width: 65.33333vw;
    height: 15.46667vw;

    background-size: contain;
    margin-left: -32.53333vw;
}




header li.main-wallet .a-wallet {
    width: 100%;
    height: auto;
    line-height: initial;
    border: 0;
    border-radius: 0.8vw 0 0 0.8vw;
    box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.5);
    padding: 0;
}

header li.main-wallet .a-wallet ul {
    position: relative;
    flex-wrap: wrap;
    height: 8vw;
    line-height: 3.2vw;
    padding: 1.06667vw 10.66667vw 0 1.86667vw;
    border-radius: 1.06667vw 0 0 0;
}

header li.main-wallet li {
    font-weight: bold;
}

header li.main-wallet span:first-of-type {

    font-weight: normal;
}

.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.menu-list a {
    flex: 1;
    position: relative;
    font-size: 4vw;
    font-weight: bold;
    line-height: 1.6;
    padding: 2.13333vw 9.06667vw 2.13333vw 2.66667vw;
    flex-wrap: wrap;
    align-items: center;
}

.mob-sports-highlight-list,
.inplay-list,
.upcoming-list,
.menu-list {
    background-color: #fff;
    border-bottom: 1px solid #7e97a7;
    margin-bottom: 20px;
}

.mob-sports-highlight-list a:after,
.inplay-list a:after,
.upcoming-list a:after,
.menu-list a:after {
    position: absolute;
    top: 1.86667vw;
    right: 2.66667vw;
    content: '';
    width: 6.4vw;
    height: 6.4vw;
    background: #fff url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgb(30,30,30)" fill-rule="evenodd" d="M9.718 5L17 12l-7.282 7L8 17.348 13.592 12 8 6.652"/></svg>') no-repeat;
    background-size: contain;
    border: 1px solid #E0E6E6;
    border-radius: 1.06667vw;
}

.menu-list a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* .a-refresh img {
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-7 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="rgb(30,30,30)"/></g></svg>') no-repeat;
    filter: invert(0.8);
} */
header li.main-wallet .a-wallet li:last-child {
    margin-right: 0;
}

.betsbuzz365 header li.main-wallet .nums {
    border-color: rgba(255, 255, 255, 0.7);
}

header li.main-wallet .nums {
    position: absolute;
    top: 2.4vw;
    right: 1.86667vw;
    height: 3.73333vw;
    font-size: 2.93333vw;
    line-height: 3.73333vw;
    border: 0.26667vw solid rgba(0, 0, 0, 0.3);
    border-radius: 0.8vw;
    padding: 0 2.13333vw;
}

.btn-box,
.in-play.game-fancy pre,
.in-play.game-sportsbook pre,
.in-play.game-bookmaker pre,
.in-play.game-live pre,
header li.main-wallet .nums,
header .badge-currency,
header a,
.tv-control a,
.mob-live-number,
.mob-live-number strong,
.btn-minmax_bet,
.back-gradient dd,
.lay-gradient dd,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
    justify-content: center;
    align-items: center;
}

header li.main-wallet .nums span {
    opacity: 1 !important;
    font-size: 2.66667vw;
    font-weight: bold;
    margin-left: 0.26667vw;
}

header a.a-refresh {
    border: none;
    border-left: 0.26667vw solid #BD8C16;
    border-radius: 0 1.06667vw 1.06667vw 0;
    box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.5);
}

header a {
    color: #1E1E1E;
    height: 5.86667vw;
    line-height: 5.33333vw;
    font-weight: bold;
    border: 0.26667vw solid #BD8C16;
    box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.5);
    border-radius: 1.06667vw;
    padding: 1.6vw 1.86667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    html,
    body {
        font-size: 1.94903vmax;
    }
}

a {
    text-decoration: none;
    color: #000;
    outline: none;
    -webkit-tap-highlight-color: rgba(182, 223, 253, 0.5);
}

a:hover {
    text-decoration: none;
    cursor: pointer;
}

table {
    border-collapse: collapse;
}

input {
    position: relative;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.1);
    border-radius: 1.6vw;
    color: #1e1e1e;
    font-size: 4vw;
    font-family: Helvetica, Tahoma, sans-serif;
    padding: 2.66667vw 1.86667vw;
    margin-bottom: 1.86667vw;
    /* -webkit-appearance: none; */
}

@media screen and (min-aspect-ratio: 16 / 9) {
    input {
        border-radius: 0.89955vmax;
        font-size: 2.24888vmax;
        padding: 1.49925vmax 1.04948vmax;
        margin-bottom: 1.04948vmax;
    }
}

img {
    background-size: contain !important;
}

h3 {
    background-image: linear-gradient(-180deg, #2e4b5e 0%, #243a48 82%);
    color: #fff;
    font-size: 3.7333333333vw;
    line-height: 2.2;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    h3 {
        font-size: 2.09895vmax;
    }
}

.clearfix:after,
.now-play:after,
.info-rotate:after {
    content: "";
    display: block;
    clear: both;
}

.clearfix,
.now-play,
.info-rotate {
    zoom: 1;
}

.clear,
.mob-main-content .casinozone a:after {
    clear: both;
}

.float-L,
.mob-bet-show img,
.marquee-box .marquee a,
.now-play span,
.game-team.racing h4,
.scores-time li:before,
.info-rotate:before,
.btn-fancy_info:before,
.marquee-pop .function-wrap label span:before,
.article-date dt {
    float: left;
}

.float-R {
    float: right;
}

.align-L,
.table th,
.tc-wrap h3,
.mob-announce-content h3,
.game-team h4,
.scores-time,
.pop-wrap h3,
.select-list h3,
.mob-announce-content table,
.mob-announce-content table th {
    text-align: left;
}

.align-R,
header li.main-wallet p,
header li.main-wallet li,
.bets-back dd span,
.bets-lay dd span,
.bets-book dd span,
.bets-head dd span,
.setting-block input {
    text-align: right;
}

.align-C,
h3,
.btn,
.btn-send,
.login,
.form-select,
.pages a,
.logout,
.bets-selections a,
.trade p,
.trade-2 p,
.info-bet dt span,
.info-matched dt span,
.bets-back dt span,
.bets-lay dt span,
.bets-book dt span,
.bets-head dt span,
header .mob-login-index,
header .btn-signup,
.saddle_1,
.saddle_1A,
.saddle_1B,
.saddle_1C,
.saddle_1D,
.saddle_1X,
.saddle_1Y,
.saddle_2,
.saddle_2B,
.saddle_2C,
.saddle_2X,
.saddle_3,
.saddle_3C,
.saddle_3D,
.saddle_3E,
.saddle_3X,
.saddle_4,
.saddle_4D,
.saddle_4X,
.saddle_5,
.saddle_6,
.saddle_7,
.saddle_8,
.saddle_9,
.saddle_10,
.saddle_11,
.saddle_11F,
.saddle_12,
.saddle_12F,
.saddle_13,
.saddle_13F,
.saddle_14,
.saddle_14F,
.saddle_15,
.saddle_15F,
.saddle_16,
.saddle_16F,
.saddle_17,
.saddle_17F,
.saddle_18,
.saddle_18F,
.saddle_19,
.saddle_19F,
.saddle_20,
.saddle_20F,
.saddle_21,
.saddle_21F,
.saddle_22,
.saddle_22F,
.saddle_23,
.saddle_23F,
.saddle_24,
.saddle_24F,
.saddle_25,
.saddle_25F,
.saddle_26,
.saddle_26F,
.saddle_27,
.saddle_27F,
.saddle_28,
.saddle_28F,
.saddle_29,
.saddle_29F,
.saddle_30,
.saddle_30F,
.form-login dt,
.slip-note,
nav a,
.upcoming-list-col3 h4,
.tab-wrap li,
.quick_link a,
.game-team.tennis .team-scores,
.game-team.tennis .team-scores h4,
.game-team.soccer .team-scores,
.game-team.soccer .team-scores h4,
.sum-status,
.horse-box,
.input-num,
.coin-list a,
.keyboard-wrap a,
.no-data,
.btn-book,
.support-wrap,
.special_bets-tab li,
.stake-setting input,
.col-stake_edit a,
.loading-wrap p,
footer,
.article-date,
.closed-next {
    text-align: center;
}

.displayB,
.btn,
.btn-send,
.login,
.form-select,
.pages a,
.logout:after,
.mob-sports-highlight-list .time,
.inplay-list .time,
.upcoming-list .time,
.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.sports-side-menu-list a,
.mob-sports-highlight-list a:after,
.inplay-list a:after,
.upcoming-list a:after,
.sports-side-menu-list a:after,
.tv-head .close:before,
.tv-head .btn-line:before,
.bets-selections span,
.bets-selections-head span,
.trade span,
.trade-2 span,
.info-bet dt span,
.info-matched dt span,
.bets-back dt span,
.bets-lay dt span,
.bets-book dt span,
.bets-head dt span,
.power-content-b img,
.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after,
.in-play.game-fancy pre:before,
.in-play.game-sportsbook pre:before,
.in-play.game-bookmaker pre:before,
.in-play.game-live pre:before,
.fancy_bet-head h4 span,
.sportsbook_bet-head h4 span,
.fancy_bet-head .in-play pre:before,
.sportsbook_bet-head .in-play pre:before,
.login-head,
.login-head .close:before,
.form-login,
.form-login .error:after,
header img,
.mob-bet-show .slip-note:before,
.message-content.to-open_bets:before,
.close:before,
.back_home .back-button_home:after,
.marquee-box h4:before,
.marquee-box h4:after,
.marquee-box .marquee a span,
nav .main-nav:before,
nav a,
nav img,
.now-play:after,
.now-play span,
.tv-box:after,
.tv-control a:before,
.channel-list a,
.channel-list a:after,
.mob-nav-highlight img,
.mob-nav-highlight .a-tab_next,
.mob-nav-highlight .a-tab_prev,
.a-tab_next:after,
.a-tab_prev:after,
.game-E i:before,
.game-E i:after,
.tab-wrap a,
.path-wrap li:after,
.go_back,
.account-id:before,
.account-id .time-zone,
.info-icon img,
.game-team span,
.game-team a,
.scores-time li:before,
.soccer-map:after,
.sum-status,
.mob-market-type a,
.disabled dd a:before,
.bets-selections-head .a-depth,
.input-num a:before,
.input-num .typeing:after,
.input-stake span:before,
.input-odds span:before,
.coin-list a,
.keyboard-wrap a,
.keyboard-wrap .btn-delete:before,
.info-rotate:before,
.no-data h3:before,
.line_market-head h4:after,
.line_market-head .btn-rules:before,
.mob-inform-link,
.btn-head_rules:before,
.other-tab:before,
.other-tab:after,
.fancy-bet .bets-selections dt ul,
.fancy-bet .bets-selections dl.tips,
.btn-fancy_info,
.btn-fancy_info:before,
.bet-setting .bet-check:before,
.special_bets-tab li:after,
.special_bets-tab a,
.sports-book.close,
.to-expand:after,
.info-bet dd span,
.info-matched dd span,
.trashcan:before,
.bets-back dd span,
.bets-lay dd span,
.bets-book dd span,
.bets-head dd span,
.a-edit:before,
.check-list a:before,
.setting-block a,
.switch_on span:after,
.switch_off span:after,
.form-select:after,
.select-list li,
.select-list a,
.to-BackLay li:after,
footer li:first-child,
footer .confirm-checkbox,
.result-wrap h3,
.fairenter .now-play:before,
.betbarter .back_home {
    display: block;
}

.displayI,
.path-wrap li {
    display: inline;
}

.displayIB,
.mob-sports-highlight-list .inplay-on a:before,
.inplay-list .inplay-on a:before,
.upcoming-list .inplay-on a:before,
.sports-side-menu-list .inplay-on a:before,
.mob-sports-highlight-list .inplay-off a:before,
.inplay-list .inplay-off a:before,
.upcoming-list .inplay-off a:before,
.sports-side-menu-list .inplay-off a:before,
.to-win:before,
.to-lose:before,
.saddle_1:before,
.saddle_1A:before,
.saddle_1B:before,
.saddle_1C:before,
.saddle_1D:before,
.saddle_1X:before,
.saddle_1Y:before,
.saddle_2:before,
.saddle_2B:before,
.saddle_2C:before,
.saddle_2X:before,
.saddle_3:before,
.saddle_3C:before,
.saddle_3D:before,
.saddle_3E:before,
.saddle_3X:before,
.saddle_4:before,
.saddle_4D:before,
.saddle_4X:before,
.saddle_5:before,
.saddle_6:before,
.saddle_7:before,
.saddle_8:before,
.saddle_9:before,
.saddle_10:before,
.saddle_11:before,
.saddle_11F:before,
.saddle_12:before,
.saddle_12F:before,
.saddle_13:before,
.saddle_13F:before,
.saddle_14:before,
.saddle_14F:before,
.saddle_15:before,
.saddle_15F:before,
.saddle_16:before,
.saddle_16F:before,
.saddle_17:before,
.saddle_17F:before,
.saddle_18:before,
.saddle_18F:before,
.saddle_19:before,
.saddle_19F:before,
.saddle_20:before,
.saddle_20F:before,
.saddle_21:before,
.saddle_21F:before,
.saddle_22:before,
.saddle_22F:before,
.saddle_23:before,
.saddle_23F:before,
.saddle_24:before,
.saddle_24F:before,
.saddle_25:before,
.saddle_25F:before,
.saddle_26:before,
.saddle_26F:before,
.saddle_27:before,
.saddle_27F:before,
.saddle_28:before,
.saddle_28F:before,
.saddle_29:before,
.saddle_29F:before,
.saddle_30:before,
.saddle_30F:before,
.login:after,
header .mob-login-index:before,
.message .back,
.message .lay,
.game-team h4 span,
.game-team .game-low_liq,
.scores-time li,
.mob-inform-link li,
.appdl-link-android a,
.appdl-link-ios a,
.bet-limit,
.bet-limit:before,
.bet-limit:after,
.fancy-bet .bets-selections dt li:before,
.btn-edit:after,
footer li,
footer .confirm-checkbox:before {
    display: inline-block;
}

.displayF,
.logout,
.bets-bookmaker .bets-selections-head ul,
.bets-selections dt ul,
.fancy-bet .bets-selections-head ul,
header ul,
nav ul,
.mob-nav-highlight ul,
.tab-wrap ul,
.quick_link,
.path-wrap ul,
.info-icon,
.mob-market-type ul,
.btn-list,
.coin-list,
.keyboard-wrap ul,
.bets-back .col-ref ul,
.bets-lay .col-ref ul,
.bets-book .col-ref ul,
.bets-head .col-ref ul,
.check-list,
.to-BackLay,
.in-play.game-fancy pre,
.in-play.game-sportsbook pre,
.in-play.game-bookmaker pre,
.in-play.game-live pre,
header a,
.tv-control a,
.mob-live-number,
.mob-live-number strong,
.btn-minmax_bet,
.back-gradient dd,
.lay-gradient dd,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd,
.mob-sports-highlight-list li,
.inplay-list li,
.upcoming-list li,
.sports-side-menu-list li,
.mob-sports-highlight-list dt,
.inplay-list dt,
.upcoming-list dt,
.sports-side-menu-list dt,
.tv-head .close,
.tv-head .btn-line,
.bets-selections,
.bets-selections-head,
.trade,
.trade-2,
.bets-selections dt,
.bets-selections-head dt,
.trade dt,
.trade-2 dt,
.bets-selections dd,
.bets-selections-head dd,
.trade dd,
.trade-2 dd,
.fancy .bets-selections .mode-land,
.fancy .bets-selections-head .mode-land,
.fancy .trade .mode-land,
.fancy .trade-2 .mode-land,
.bets-selections a,
.trade p,
.trade-2 p,
.suspend-full,
.bets-selections .suspend,
.suspend-fancy,
.suspend-spb,
.mode-land .btn-fancy_info,
.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info,
.fancy_bet-head,
.sportsbook_bet-head,
.fancy_bet-head h4,
.sportsbook_bet-head h4,
.fancy_bet-head .in-play span,
.sportsbook_bet-head .in-play span,
.fancy_bet-head .in-play pre,
.sportsbook_bet-head .in-play pre,
.fancy-bet>h5,
.fancy-bet>h4,
.sports-book>h4,
.bets-bookmaker>h4,
.login-head .close,
header,
header li.main-wallet,
header li.main-wallet ul,
header .live-tv-icon,
.slip-note,
.loading-bar,
.message-content,
.close,
.back_home .back-button_home,
.marquee-box,
.marquee-box h4,
.marquee-box .marquee a,
.tv-head,
.tv-control,
.mob-nav-highlight a,
.upcoming-list-col3 ul,
.game-E i,
.quick_link a,
.side-content .sports-side-menu-list a,
.path-wrap,
.account-id,
.game-info,
.info-icon li,
.fm-match-button,
.fm-match-button a,
.horse-info,
.input-num,
.input-num a,
.input-num span,
.keyboard-wrap,
.keyboard-wrap .btn-delete,
.no-data h3,
.line_market-head,
.line_market-head h4,
.line_market-head .btn-rules,
.extra-wrap,
.btn-head_rules,
.fancy-bet .bets-selections dl.tips dt,
.fancy_info-popup.show,
.show.limit_info-popup,
.bet-setting,
.bet-setting .bet-check,
.special_bets-tab,
.to-expand,
.back-gradient,
.lay-gradient,
.overlay,
.info-bet,
.info-matched,
.info-bet dt,
.info-matched dt,
.side-wrap,
.side-head,
.side-head h3,
.side-content h3,
.trashcan,
.bets-back,
.bets-lay,
.bets-book,
.bets-head,
.bets-back dt,
.bets-lay dt,
.bets-book dt,
.bets-head dt,
.bets-back dd,
.bets-lay dd,
.bets-book dd,
.bets-head dd,
.a-edit,
.check-list a,
.setting-block,
.setting-block dt,
.setting-block dd,
.switch_on span,
.switch_off span,
.loading-overlay,
.loading-wrap,
.trade-wrap,
.announce-header,
.mob-news-popup,
.marquee-pop .function-wrap,
.result-wrap dl,
.result-wrap dt,
.result-wrap dd,
.o_12bet .back_home,
.o_spondemo .back_home,
.o_dafabet .back_home {
    display: flex;
}

.border-box,
.mob-sports-highlight-list .inplay-on a:before,
.inplay-list .inplay-on a:before,
.upcoming-list .inplay-on a:before,
.sports-side-menu-list .inplay-on a:before,
.mob-sports-highlight-list .inplay-off a:before,
.inplay-list .inplay-off a:before,
.upcoming-list .inplay-off a:before,
.sports-side-menu-list .inplay-off a:before,
.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.sports-side-menu-list a,
.mob-sports-highlight-list a:after,
.inplay-list a:after,
.upcoming-list a:after,
.sports-side-menu-list a:after,
.bets-selections dt,
.bets-selections-head dt,
.trade dt,
.trade-2 dt,
.bets-selections dd,
.bets-selections-head dd,
.trade dd,
.trade-2 dd,
.bets-selections a,
.trade p,
.trade-2 p,
.suspend-full,
.bets-selections .suspend,
.suspend-fancy,
.suspend-spb,
.saddle_1,
.saddle_1A,
.saddle_1B,
.saddle_1C,
.saddle_1D,
.saddle_1X,
.saddle_1Y,
.saddle_2,
.saddle_2B,
.saddle_2C,
.saddle_2X,
.saddle_3,
.saddle_3C,
.saddle_3D,
.saddle_3E,
.saddle_3X,
.saddle_4,
.saddle_4D,
.saddle_4X,
.saddle_5,
.saddle_6,
.saddle_7,
.saddle_8,
.saddle_9,
.saddle_10,
.saddle_11,
.saddle_11F,
.saddle_12,
.saddle_12F,
.saddle_13,
.saddle_13F,
.saddle_14,
.saddle_14F,
.saddle_15,
.saddle_15F,
.saddle_16,
.saddle_16F,
.saddle_17,
.saddle_17F,
.saddle_18,
.saddle_18F,
.saddle_19,
.saddle_19F,
.saddle_20,
.saddle_20F,
.saddle_21,
.saddle_21F,
.saddle_22,
.saddle_22F,
.saddle_23,
.saddle_23F,
.saddle_24,
.saddle_24F,
.saddle_25,
.saddle_25F,
.saddle_26,
.saddle_26F,
.saddle_27,
.saddle_27F,
.saddle_28,
.saddle_28F,
.saddle_29,
.saddle_29F,
.saddle_30,
.saddle_30F,
header,
.slip-note,
nav a,
.mob-live-number,
.game-E,
.tab-wrap,
.quick_link li,
.quick_link a,
.account-id,
.fm-match-button a,
.mob-market-type a,
.input-num,
.input-num a,
.keyboard-wrap a,
.info-rotate:before,
.line_market-selection h4,
.mob-inform-link,
.info-bet dt,
.info-matched dt,
.info-bet dd,
.info-matched dd,
.a-edit,
.check-list a:before,
.setting-block dt,
.setting-block dd,
.stake-setting input,
.announce-header,
footer,
footer .confirm-checkbox:before,
footer .btn,
footer .btn-send,
footer .login,
footer .form-select,
footer .pages a,
.pages footer a,
.live_events,
.live_events .live_icon span,
.live_events .live_icon span:before,
.live_events dd span,
.result-wrap h3,
.result-wrap dl,
.result-wrap dt,
.result-wrap dd,
.result-wrap p {
    box-sizing: border-box;
}

.mob-main-content {
    position: relative;
    padding: 0 0 17.6vw;
    overflow: hidden;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-main-content {
        padding: 0;
    }
}

.btn,
.btn-send,
.login,
.form-select,
.pages a {
    background-image: linear-gradient(-180deg, #fff 0%, #eee 89%);
    border: 1px solid #aaa;
    border-radius: 1.6vw;
    font-size: 4vw;
    font-weight: bold;
    line-height: 2.6;
    color: #1e1e1e;
}

.btn.disable,
.disable.btn-send,
.disable.login,
.disable.form-select,
.pages a.disable {
    background: #dfdfdf;
    color: #999;
    cursor: not-allowed;
}

.btn.select,
.select.btn-send,
.select.login,
.select.form-select,
.pages a.select {
    background: #ffcc2e;
    border: 1px solid #be7809;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.1);
}

.btn.secondary,
.secondary.btn-send,
.secondary.login,
.secondary.form-select,
.pages a.secondary {
    background-image: linear-gradient(180deg, #000 0%, #000 89%);
    border: 1px solid #969696;
}

.btn.secondary:hover,
.secondary.btn-send:hover,
.secondary.login:hover,
.secondary.form-select:hover,
.pages a.secondary:hover {
    background-image: linear-gradient(180deg, #b2b2b2 0%, #d6d6d6 89%);
    border: 1px solid #969696;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .btn,
    .btn-send,
    .login,
    .form-select,
    .pages a {
        border-radius: 0.89955vmax;
        font-size: 2.24888vmax;
    }

    .btn.select,
    .select.btn-send,
    .select.login,
    .select.form-select,
    .pages a.select {
        box-shadow: inset 0 0.29985vmax 0 0 rgba(0, 0, 0, 0.1);
    }
}

.btn-send,
.login {
    background-image: linear-gradient(-180deg, #000 15%, #000 100%);
    border-color: #bf7809;
}

.btn-send.disable,
.disable.login {
    background-image: linear-gradient(-180deg, #ffe9b6 0%, #ffe2b6 100%);
    border-color: #efd9b5;
    color: #999;
}


.logout {
    height: 12.8vw;
    background-image: linear-gradient(-180deg, #e93522 0%, #be2414 100%);
    border: 1px solid #8a0011;
    border-width: 1px 0 1px 0;
    color: #fff;
    font-size: 4.26667vw;
    font-weight: bold;
    margin-bottom: 5.33333vw;
    justify-content: center;
    align-items: center;
}

.logout:after {
    content: "";
    width: 4vw;
    height: 4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M5.672 11.238l2.066-2.355H0V7.117h7.776L5.672 4.762 6.8 3.5 10.82 8 6.8 12.5 5.67 11.238zM13.348 0c.435 0 .82.17 1.153.508.334.338.5.73.5 1.172v11.64c0 .443-.166.834-.5 1.172-.332.34-.717.508-1.152.508H1.898c-.434 0-.818-.17-1.15-.508-.334-.338-.5-.73-.5-1.172V10h1.65v3.32h11.45V1.68H1.898V5H.25V1.68c0-.443.166-.834.5-1.172C1.08.168 1.463 0 1.897 0h11.45z"/></svg>') no-repeat;
    background-size: contain;
    margin-left: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .logout {
        height: 7.1964vmax;
        font-size: 2.3988vmax;
        margin-bottom: 2.9985vmax;
    }

    .logout:after {
        width: 2.24888vmax;
        height: 2.24888vmax;
        margin-left: 0.74963vmax;
    }
}

.table {
    width: 100%;
    border-bottom: 1px solid #7e97a7;
}

.table th {
    padding: 2.13333vw 1.86667vw;
    background-color: #d6e4e5;
    border-bottom: 0.26667vw solid #bbc8c9;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .table th {
        padding: 1.1994vmax 1.04948vmax;
        border-bottom-width: 0.14993vmax;
    }
}

.table td,
.table .mob-announce-content table th,
.mob-announce-content table .table th {
    padding: 2.13333vw 1.86667vw;
    border: 0.26667vw solid #e0e6e6;
    border-width: 0 0 0.26667vw 0.26667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .table td,
    .table .mob-announce-content table th,
    .mob-announce-content table .table th {
        padding: 1.1994vmax 1.04948vmax;
        border-bottom-width: 0.14993vmax;
    }
}

.table tr:last-of-type td,
.table tr:last-of-type .mob-announce-content table th,
.mob-announce-content table .table tr:last-of-type th {
    border-bottom-width: 0;
}

.icon-home {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M20.574 10.945v7.107c0 .52-.43.948-.952.948h-5.717v-5.686h-3.81V19H4.378c-.52 0-.952-.43-.952-.948v-7.107c0-.03.015-.06.015-.088L12 3.837l8.56 7.02c.014.03.014.06.014.088zm3.32-1.02l-.923 1.094c-.074.088-.193.148-.312.162h-.044c-.12 0-.224-.03-.313-.103L12 2.535 1.7 11.08c-.105.073-.224.117-.358.102-.12-.014-.238-.074-.313-.163L.105 9.923c-.163-.193-.134-.504.06-.666L10.87.388c.624-.518 1.636-.518 2.26 0l3.633 3.02V.523c0-.267.21-.474.477-.474h2.858c.268 0 .476.207.476.474v6.04l3.26 2.696c.194.162.223.473.06.666z"/></svg>') no-repeat;
}

.icon-inplay {
    background: url('data:image/svg+xml,<svg width="20" height="21" xmlns="http://www.w3.org/2000/svg"><path d="M10 18.944c1.94 0 3.592-.718 4.953-2.154 1.362-1.436 2.042-3.165 2.042-5.189 0-2.023-.68-3.744-2.042-5.164-1.361-1.42-3.012-2.13-4.953-2.13-1.94 0-3.592.71-4.953 2.13-1.362 1.42-2.042 3.141-2.042 5.164 0 2.024.68 3.753 2.042 5.19 1.361 1.435 3.012 2.153 4.953 2.153zm0-16.741c2.504 0 4.632.922 6.385 2.766 1.753 1.843 2.63 4.054 2.63 6.632 0 2.579-.877 4.79-2.63 6.633C14.632 20.078 12.504 21 10 21s-4.632-.922-6.385-2.766C1.862 16.39.985 14.18.985 11.601c0-2.578.877-4.789 2.63-6.632C5.368 3.125 7.496 2.203 10 2.203zm.516 4.21v5.482l3.991 2.448-.751 1.272-4.742-2.937V6.413h1.502zM5.87 1.566L1.268 5.58 0 4.014 4.6 0 5.87 1.566zM20 4.014l-1.268 1.615-4.6-4.063L15.398 0 20 4.014z" fill="rgb(255,255,255)" fill-rule="evenodd"/></svg>') no-repeat;
}

.icon-sports {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26"><path fill="rgb(255,255,255)" fill-rule="nonzero" d="M31.57 1.78c-.4-.313-1.26-.65-4.092.065-.153.04-.303.078-.45.12.273-1.2.38-1.965.38-1.965H4.21s.102.72.358 1.857l-.046-.012C1.688 1.13.83 1.467.432 1.78c-.318.252-.47.627-.424 1.058.063.62.733 6.152 4.646 9.276 1.725 1.377 3.81 2.07 6.22 2.07h.032c.884.752 1.878 1.365 2.992 1.774v3.963h-3.32l-1.514 1.594V26h13.728v-4.486l-1.514-1.593H17.62v-3.925c1.16-.41 2.188-1.04 3.1-1.818.136.004.272.007.406.007 2.41 0 4.495-.693 6.22-2.07 3.913-3.124 4.583-8.656 4.646-9.276.045-.43-.106-.806-.423-1.057zM5.325 11.255c-3.564-2.845-4.18-7.956-4.24-8.53-.005-.05.002-.07 0-.07.006-.005.39-.423 2.99.21.268.063.532.133.786.204.74 2.823 2.204 7.004 4.857 9.954-1.676-.184-3.148-.773-4.394-1.768zm12.295.64c-.584.27-1.233.422-1.918.422-.64 0-1.25-.132-1.804-.37-1.66-.71-2.825-2.37-2.825-4.308 0-2.584 2.072-4.678 4.63-4.678 2.556 0 4.628 2.094 4.628 4.678 0 1.89-1.11 3.52-2.71 4.256zm13.294-9.17c-.06.574-.676 5.685-4.24 8.53-1.348 1.076-2.96 1.678-4.807 1.806 2.638-2.91 4.106-7.04 4.858-9.873.374-.11.782-.223 1.198-.324 2.606-.633 2.986-.212 2.99-.21 0 0 .006.02 0 .072z"/></svg>') no-repeat;
}

.icon-pin {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm5.09-13.203c-.09 0-.18-.032-.27-.095-.49-.19-.802-.49-.936-.9L15.18 5.203v-.237c0-.253.222-.46.668-.617l.067-.048h.067c.536-.158.804-.426.804-.806 0-.443-.09-.72-.268-.83-.18-.11-.49-.166-.938-.166H9.42c-.447 0-.76.055-.938.166-.178.11-.268.387-.268.83 0 .38.268.648.804.806h.067l.067.048c.446.158.67.364.67.617v.237L8.615 10.8c-.134.412-.446.712-.937.902-.09.063-.18.095-.27.095-1.606.57-2.41 1.44-2.41 2.61 0 .378.067.64.2.78.135.144.403.215.804.215h5.425l.802 8.348h.536l.803-8.348h5.426c.4 0 .67-.063.803-.19.133-.126.2-.395.2-.806 0-1.17-.804-2.04-2.41-2.61z"/></svg>') no-repeat;
}

.icon-account,
.account-id:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M10 0c2.756 0 5.112.978 7.067 2.933C19.022 4.888 20 7.243 20 10c0 2.756-.978 5.112-2.933 7.067C15.112 19.022 12.757 20 10 20c-2.756 0-5.112-.978-7.067-2.933C.978 15.112 0 12.757 0 10c0-2.756.978-5.112 2.933-7.067C4.888.978 7.243 0 10 0zm0 19.183c2.82 0 5.16-1.106 7.02-3.318-1.38-.544-2.87-1.057-4.472-1.538-.096-.064-.144-.24-.144-.53 0-.223.112-.592.336-1.105.16-.32.305-.833.433-1.538.32-.385.545-.898.673-1.54.096-.576.096-1.024 0-1.345-.032-.033-.048-.065-.048-.097-.096-.32-.048-.93.144-1.827.16-.833-.08-1.667-.72-2.5-.61-.833-1.54-1.282-2.79-1.346h-.865c-1.25.096-2.18.545-2.788 1.346-.642.833-.883 1.667-.722 2.5.192.898.24 1.507.144 1.827v.096c-.128.384-.144.833-.048 1.345.16.673.384 1.202.673 1.587.128.64.272 1.138.433 1.49.128.257.192.64.192 1.154 0 .257-.048.417-.144.48-1.603.45-3.045.962-4.327 1.54 1.828 2.21 4.167 3.317 7.02 3.317z"/></svg>') no-repeat;
}

.icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>') no-repeat;
}

.select .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(249, 173, 0)" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>') no-repeat no-repeat;
}

.icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>') no-repeat;
}

.select .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(249, 173, 0)" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>') no-repeat no-repeat;
}

.icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>') no-repeat;
}

.select .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(249, 173, 0)" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>') no-repeat no-repeat;
}

.icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,255,255)" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.select .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,255,255)" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

.select .icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

.icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="rgb(255,255,255)" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.select .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="rgb(0,0,0)" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.select .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(0,0,0)" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>') no-repeat;
}

.select .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="rgb(0,0,0)" fill-rule="nonzero"/></svg>') no-repeat;
}

.icon-casino {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M20 18.624v-16.038c0-.748-.696-1.361-1.544-1.361h-.95c.051.135.068.269.085.404l1.578 15.978c.119 1.152-.848 2.169-2.154 2.274l-1.459.12h2.918c.831-.015 1.527-.628 1.527-1.376z" id="Path" fill="%23CFBCC7"/><path d="M16.42 16.761l-3.062-15.642c-.148-.741-.922-1.231-1.745-1.097l-10.371 1.646c-.823.133-1.366.83-1.218 1.572l3.078 15.642c.148.741.922 1.231 1.745 1.097l10.371-1.646c.807-.133 1.35-.83 1.202-1.572zm-4.313-5.041c-.626.815-1.728 1.142-2.733.904.082.208.132.371.181.43.23.371 1.004.652.84.993-.165.326-.477-.03-1.333.104-.856.133-1.021.563-1.3.311-.28-.267.346-.771.412-1.186.016-.074.016-.237 0-.46-.856.534-2.025.563-2.914-.015-1.152-.726-1.432-2.165-.626-3.202.774-.993 2.864-3.455 2.864-3.455s2.897 1.661 4 2.357c1.136.741 1.416 2.179.609 3.217z" fill="%23FFFFFF" fill-rule="nonzero"/><path d="M18.218 17.754l-1.483-16.091c-.064-.753-.781-1.311-1.579-1.25l-.973.075.08.271 2.966 15.895c.207 1.145-.606 2.245-1.818 2.441l-2.966.497 4.449-.362c.797-.045 1.387-.723 1.324-1.476z" fill="%23CFBCC7"/></g></svg>') no-repeat;
}

.select .icon-casino {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M20 18.624v-16.038c0-.748-.696-1.361-1.544-1.361h-.95c.051.135.068.269.085.404l1.578 15.978c.119 1.152-.848 2.169-2.154 2.274l-1.459.12h2.918c.831-.015 1.527-.628 1.527-1.376z" id="Path" fill="%23CFBCC7"/><path d="M16.42 16.761l-3.062-15.642c-.148-.741-.922-1.231-1.745-1.097l-10.371 1.646c-.823.133-1.366.83-1.218 1.572l3.078 15.642c.148.741.922 1.231 1.745 1.097l10.371-1.646c.807-.133 1.35-.83 1.202-1.572zm-4.313-5.041c-.626.815-1.728 1.142-2.733.904.082.208.132.371.181.43.23.371 1.004.652.84.993-.165.326-.477-.03-1.333.104-.856.133-1.021.563-1.3.311-.28-.267.346-.771.412-1.186.016-.074.016-.237 0-.46-.856.534-2.025.563-2.914-.015-1.152-.726-1.432-2.165-.626-3.202.774-.993 2.864-3.455 2.864-3.455s2.897 1.661 4 2.357c1.136.741 1.416 2.179.609 3.217z" fill="%23000000" fill-rule="nonzero"/><path d="M18.218 17.754l-1.483-16.091c-.064-.753-.781-1.311-1.579-1.25l-.973.075.08.271 2.966 15.895c.207 1.145-.606 2.245-1.818 2.441l-2.966.497 4.449-.362c.797-.045 1.387-.723 1.324-1.476z" fill="%23CFBCC7"/></g></svg>') no-repeat;
}

.info-inplay {
    background: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="%235EA80E" d="M0 0h18v18H0z"/><path d="M9 13.83c1.16 0 2.15-.42 2.97-1.24a4.05 4.05 0 0 0 1.23-2.96 4 4 0 0 0-1.23-2.95A4.06 4.06 0 0 0 9 5.46c-1.16 0-2.15.4-2.97 1.22A4 4 0 0 0 4.8 9.63c0 1.16.41 2.14 1.23 2.96.82.82 1.8 1.24 2.97 1.24zm0-9.57c1.5 0 2.78.53 3.83 1.58a5.17 5.17 0 0 1 1.58 3.79c0 1.47-.53 2.74-1.58 3.79A5.21 5.21 0 0 1 9 15c-1.5 0-2.78-.53-3.83-1.58a5.17 5.17 0 0 1-1.58-3.8c0-1.46.53-2.73 1.58-3.78A5.21 5.21 0 0 1 9 4.26zm.31 2.4V9.8l2.4 1.4-.46.72-2.84-1.68V6.66h.9zM6.52 3.9L3.76 6.19 3 5.29 5.76 3l.76.9zM15 5.3l-.76.92-2.76-2.32.76-.9L15 5.3z" fill="%23FFF"/></g></svg>') no-repeat;
    border-radius: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .info-inplay {
        border-radius: 0.74963vmax;
    }
}

.info-cashout {
    background: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="%23FFB80C" d="M0 0h18v18H0z"/><path d="M5.19 9h1.9l-2.53 2.98L2 9h1.9c0-1.08.24-2.08.7-3.02a5.46 5.46 0 0 1 1.84-2.15 4.4 4.4 0 0 1 5.27.12l-.93 1.08a3.31 3.31 0 0 0-3.7.08c-.58.4-1.04.95-1.38 1.64A5.01 5.01 0 0 0 5.19 9zm8.25-2.98L16 9h-1.9c0 1.08-.24 2.08-.7 3.02a5.46 5.46 0 0 1-1.84 2.15 4.4 4.4 0 0 1-3.98.58c-.47-.17-.9-.4-1.3-.7l.94-1.08a3.31 3.31 0 0 0 3.7-.08c.58-.4 1.04-.95 1.38-1.64.34-.68.51-1.44.51-2.25h-1.9l2.53-2.98z" fill="%23000"/></g></svg>') no-repeat;
    border-radius: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .info-cashout {
        border-radius: 0.74963vmax;
    }
}

.red {
    color: #d0021b !important;
}

.green {
    color: #508d0e !important;
}

.mode-land .btn-fancy_info,
.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info,
.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live,
.fancy_bet-head .in-play pre,
.sportsbook_bet-head .in-play pre,
.login-head h1,
.login-head .close,
header .mob-header-logo,
.close,
.back_home h1,
.back_home .back-button_home,
.tv-control a,
.mob-live-number strong,
.a-tab_next,
.a-tab_prev,
.pin-on,
.pin-off,
.go_back,
.game-team .refresh,
.game-team .multi-Go,
.bets-selections-head .a-depth,
.input-num a,
.keyboard-wrap .btn-delete,
.download-list dd a,
.btn-head_rules,
.btn-minmax_bet,
.a-edit,
.a-search,
.search-back,
.search-clear,
.search-collapse,
.live_events .live_icon span,
.betsbuzz365 header .sky-logo,
.betsbuzz365 header .sky-logo,
.wickets247 header .sky-logo {
    font-size: 0;
    text-indent: -99999px;
}

.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.sports-side-menu-list a,
.mob-sports-highlight-list dd,
.inplay-list dd,
.upcoming-list dd,
.sports-side-menu-list dd,
.bets-selections a span,
.trade p span,
.trade-2 p span,
.fancy-bet>h5 span,
.fancy-bet>h4 span,
.sports-book>h4 span,
.bets-bookmaker>h4 span,
nav a,
.now-play,
.channel-list a,
.side-content .sports-side-menu-list a p,
.path-wrap ul,
.account-id span:first-of-type,
.game-team h4,
.scores-time,
.bets-selections h4,
.horse-name li,
.support-wrap .support-detail a span,
.fancy-bet .bets-selections dt li,
.bets-back dt,
.bets-lay dt,
.bets-book dt,
.bets-head dt,
.bets-back dd,
.bets-lay dd,
.bets-book dd,
.bets-head dd,
.bets-back h4,
.bets-lay h4,
.bets-book h4,
.bets-head h4,
.bets-back dd span,
.bets-lay dd span,
.bets-book dd span,
.bets-head dd span,
.select-list a,
.suggestion-wrap li p,
.suggestion-wrap li a,
.live_events dd p,
.result-wrap h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fancy_info-popup,
.limit_info-popup {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.7);
}

.bets-bookmaker .bets-selections-head ul li,
.bets-selections dt ul li,
.fancy-bet .bets-selections-head ul li,
header ul li,
nav ul li,
.mob-nav-highlight ul li,
.tab-wrap ul li,
.quick_link li,
.path-wrap ul li,
.info-icon li,
.mob-market-type ul li,
.btn-list li,
.coin-list li,
.keyboard-wrap ul li,
.bets-back .col-ref ul li,
.bets-lay .col-ref ul li,
.bets-book .col-ref ul li,
.bets-head .col-ref ul li,
.check-list li,
.to-BackLay li {
    list-style: none;
}

.mob-nav-highlight .menu-casino a:after,
.mob-main-content .casinozone a:after {
    content: "";
    display: block;
}

.mob-live-number strong:before,
.btn-minmax_bet:before,
.live_events .live_icon span:before {
    content: "";
    display: block;
}

.in-play.game-fancy pre,
.in-play.game-sportsbook pre,
.in-play.game-bookmaker pre,
.in-play.game-live pre,
header a,
.tv-control a,
.mob-live-number,
.mob-live-number strong,
.btn-minmax_bet,
.back-gradient dd,
.lay-gradient dd,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
    justify-content: center;
    align-items: center;
}

.betsbuzz365 input {
    border: 1px solid #666;
}

.form-login input {

    width: calc(100% - 2 * (1.86vw));
    margin-bottom: 0;
}

input {
    position: relative;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.1);
    border-radius: 1.6vw;
    color: #1E1E1E;
    font-size: 4vw;
    font-family: Helvetica, Tahoma, sans-serif;
    padding: 2.66667vw 1.86667vw;
    margin-bottom: 1.86667vw;
    /* -webkit-appearance: none; */
}

@media (orientation: landscape) {
    .form-login input {
        width: calc(100% - 2 * (1.86vw));
        border-radius: 1.6vw;
        font-size: 4vw;
        padding: 2.66667vw 1.86667vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .form-login input {
        width: calc(100% - 2 * (1.04vmax));
        border-radius: 0.89955vmax;
        font-size: 2.24888vmax;
        padding: 1.49925vmax 1.04948vmax;
    }
}

.mob-inform-link {
    color: rgba(255, 255, 255, 0.5);
}

.mob-inform-link a {
    color: rgba(255, 255, 255, 0.6);
}

.tc-wrap,
.mob-announce-content {
    overflow-y: scroll;
    background-color: #fff;
    font-size: 4vw;
    line-height: 1.5;
    padding: 4.26667vw 3.46667vw;
    box-sizing: border-box;
}

.tc-wrap h1,
.mob-announce-content h1 {
    margin-top: 12.8vw;
    margin-bottom: 6.4vw;
    font-size: 6.4vw;
    color: #000;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 1.33333vw;
    padding: 2.66667vw;
}

.tc-wrap h2,
.mob-announce-content h2 {
    font-size: 5.86667vw;
    line-height: 1.2;
    color: #1b2d38;
    padding-bottom: 2.13333vw;
    margin-bottom: 4.8vw;
    border-bottom: 1px dashed #e0e6e6;
}

.tc-wrap h3,
.mob-announce-content h3 {
    font-size: 4.53333vw;
    margin-bottom: 3.2vw;
    color: rgba(30, 30, 30, 0.9);
    line-height: 1.2;
    background: transparent;
}

.tc-wrap h4,
.mob-announce-content h4 {
    font-size: 4vw;
    color: rgba(30, 30, 30, 0.9);
    margin-bottom: 2.66667vw;
}

.tc-wrap h5,
.mob-announce-content h5 {
    font-size: 4vw;
    color: rgba(30, 30, 30, 0.9);
    margin-bottom: 2.66667vw;
    text-decoration: underline;
}

.tc-wrap ul,
.mob-announce-content ul,
.tc-wrap ol,
.mob-announce-content ol {
    margin-left: 6.4vw;
}

.tc-wrap ul li,
.mob-announce-content ul li,
.tc-wrap ol li,
.mob-announce-content ol li {
    margin-bottom: 3.46667vw;
}

.tc-wrap p,
.mob-announce-content p {
    margin: 0 0 3.2vw 0;
}

.tc-wrap address,
.mob-announce-content address {
    font-size: 3.46667vw;
    margin-bottom: 4vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .tc-wrap,
    .mob-announce-content {
        font-size: 2.24888vmax;
        padding: 3.14843vmax 3.14843vmax;
    }

    .tc-wrap h2,
    .mob-announce-content h2 {
        font-size: 3.29835vmax;
        padding-bottom: 1.1994vmax;
        margin-bottom: 2.3988vmax;
    }

    .tc-wrap h3,
    .mob-announce-content h3 {
        font-size: 2.54873vmax;
        margin-bottom: 2.24888vmax;
    }

    .tc-wrap h4,
    .mob-announce-content h4 {
        font-size: 2.24888vmax;
        margin-bottom: 1.49925vmax;
    }

    .tc-wrap h5,
    .mob-announce-content h5 {
        font-size: 2.24888vmax;
        margin-bottom: 1.49925vmax;
    }

    .tc-wrap ul,
    .mob-announce-content ul,
    .tc-wrap ol,
    .mob-announce-content ol {
        margin-left: 3.5982vmax;
    }

    .tc-wrap ul li,
    .mob-announce-content ul li,
    .tc-wrap ol li,
    .mob-announce-content ol li {
        margin-bottom: 1.94903vmax;
    }

    .tc-wrap p,
    .mob-announce-content p {
        margin: 0 0 1.94903vmax 0;
    }

    .tc-wrap address,
    .mob-announce-content address {
        font-size: 1.94903vmax;
        margin-bottom: 2.24888vmax;
    }
}

.betsbuzz365 .login-pop .login-head {
    background-image: url('../images/kv/mobile-login.png');
}

.betsbuzz365 .login-pop .login-head h1 {
    top: 34.66667vw;
    width: 65.86667vw;
    height: 22.13333vw;
    /* background-image: url('../images/newlogo.png'); */
    margin-left: -33.06667vw;
}

@media (orientation: landscape) {
    .betsbuzz365 .login-pop .login-head {
        background-image: linear-gradient(-180deg, #414141 0%, #000 100%);
    }

    .betsbuzz365 .login-pop .login-head h1 {
        top: -10.53333vw;
        width: 66.46667vw;
        height: 41.33333vw;
        /* background-image: url('../images/newlogo.png'); */
        margin-left: -33.06667vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .betsbuzz365 .login-pop .login-head h1 {
        top: 1.04948vmax;
        width: 28.93553vmax;
        height: 9.74513vmax;
        margin-left: -14.3928vmax;
    }
}

body .betsbuzz365 {
    height: 100%;
}

@media screen and (min-aspect-ratio: 16/9) {
    .form-login dd .CaptchaPopup {
        position: absolute;
        right: 0.26667vw;
        width: 6.6666vw;
        top: 1vw;
    }
}

@media (orientation: landscape) {
    .form-login dd .CaptchaPopup {

        width: 8.66667vw;
        height: 5.06667vw;
        right: 0;
        /* padding-top: 1vw; */
        border-radius: 1.06667vw;
    }
}

.CaptchaPopup {
    position: absolute;
    right: -0.13333vw;
    width: 14.6666vw;
    top: 1vw;
}

.mob-sports-highlight-list .inplay-on a:before,
.inplay-list .inplay-on a:before,
.upcoming-list .inplay-on a:before,
.sports-side-menu-list .inplay-on a:before,
.mob-sports-highlight-list .inplay-off a:before,
.inplay-list .inplay-off a:before,
.upcoming-list .inplay-off a:before,
.sports-side-menu-list .inplay-off a:before {
    content: "";
    width: 2.66667vw;
    height: 2.66667vw;
    border-radius: 50%;
    background-color: #6bbd11;
    border: 1px solid rgba(51, 51, 51, 0.4);
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .mob-sports-highlight-list .inplay-on a:before,
    .inplay-list .inplay-on a:before,
    .upcoming-list .inplay-on a:before,
    .sports-side-menu-list .inplay-on a:before,
    .mob-sports-highlight-list .inplay-off a:before,
    .inplay-list .inplay-off a:before,
    .upcoming-list .inplay-off a:before,
    .sports-side-menu-list .inplay-off a:before {
        width: 1.49925vmax;
        height: 1.49925vmax;
        margin-right: 0.74963vmax;
    }
}

.mob-sports-highlight-list .time,
.inplay-list .time,
.upcoming-list .time {
    font-size: 3.2vw;
    line-height: 1.1;
    color: #777;
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .mob-sports-highlight-list .time,
    .inplay-list .time,
    .upcoming-list .time {
        font-size: 1.7991vmax;
        margin-right: 0.74963vmax;
    }
}

.mob-sports-highlight-list,
.inplay-list,
.upcoming-list,
.sports-side-menu-list {
    background-color: #fff;
    border-bottom: 1px solid #7e97a7;
    margin-bottom: 20px;
}

.mob-sports-highlight-list li,
.inplay-list li,
.upcoming-list li,
.sports-side-menu-list li {
    border-bottom: 1px solid #E0E6E6;
    list-style: none;
    align-items: center;
}

.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.sports-side-menu-list a {
    flex: 1;
    position: relative;
    font-size: 4vw;
    font-weight: bold;
    line-height: 1.6;
    padding: 2.13333vw 9.06667vw 2.13333vw 2.66667vw;
    flex-wrap: wrap;
    align-items: center;
}

.mob-sports-highlight-list a:after,
.inplay-list a:after,
.upcoming-list a:after,
.sports-side-menu-list a:after {
    position: absolute;
    top: 1.86667vw;
    right: 2.66667vw;
    content: "";

}

.mob-sports-highlight-list .inplay-on span,
.inplay-list .inplay-on span,
.upcoming-list .inplay-on span,
.sports-side-menu-list .inplay-on span {
    color: #508d0e;
    font-weight: bold;
}

.mob-sports-highlight-list .inplay-off a:before,
.inplay-list .inplay-off a:before,
.upcoming-list .inplay-off a:before,
.sports-side-menu-list .inplay-off a:before {
    background-color: #c5d0d8;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .mob-sports-highlight-list a,
    .inplay-list a,
    .upcoming-list a,
    .sports-side-menu-list a {
        font-size: 2.24888vmax;
        padding: 1.1994vmax 5.09745vmax 1.1994vmax 1.49925vmax;
    }

    .mob-sports-highlight-list a:after,
    .inplay-list a:after,
    .upcoming-list a:after,
    .sports-side-menu-list a:after {
        top: 1.04948vmax;
        right: 1.49925vmax;
        width: 3.5982vmax;
        height: 3.5982vmax;
        border-radius: 0.5997vmax;
    }
}

.tv-head .close,
.tv-head .btn-line {
    flex-basis: 10.66667vw;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.2);
    background-image: linear-gradient(-180deg, #393939 0%, #000 100%);
    color: #fff;
    justify-content: center;
    align-items: center;
}

.tv-head .close:before,
.tv-head .btn-line:before {
    content: "";
    background-repeat: no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .tv-head .close,
    .tv-head .btn-line {
        flex-basis: 5.997vmax;
    }
}

.bets-selections,
.bets-selections-head,
.trade,
.trade-2 {
    position: relative;
    min-height: 11.2vw;
    border-bottom: 1px solid #7e97a7;
}

.bets-selections dt,
.bets-selections-head dt,
.trade dt,
.trade-2 dt {
    flex: 1;
    font-size: 4vw;
    font-weight: bold;
    padding: 0 1.86667vw;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
}

.bets-selections dd,
.bets-selections-head dd,
.trade dd,
.trade-2 dd {
    border-right: 1px solid #fff;
}

.bets-selections dd:last-of-type,
.bets-selections-head dd:last-of-type,
.trade dd:last-of-type,
.trade-2 dd:last-of-type {
    border-right-width: 0;
}

.bets-selections span,
.bets-selections-head span,
.trade span,
.trade-2 span {
    font-weight: normal;
    font-size: 2.93333vw;
}

.bets-selections .mode-land,
.bets-selections-head .mode-land,
.trade .mode-land,
.trade-2 .mode-land {
    display: none;
}

.bets-selections:last-child,
.bets-selections-head:last-child,
.trade:last-child,
.trade-2:last-child {
    border-bottom-width: 0;
}

.fancy .bets-selections .mode-land,
.fancy .bets-selections-head .mode-land,
.fancy .trade .mode-land,
.fancy .trade-2 .mode-land {
    width: 8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .bets-selections,
    .bets-selections-head,
    .trade,
    .trade-2 {
        min-height: 6.29685vmax;
    }

    .bets-selections dt,
    .bets-selections-head dt,
    .trade dt,
    .trade-2 dt {
        font-size: 2.24888vmax;
        padding: 0 1.04948vmax;
    }

    .bets-selections span,
    .bets-selections-head span,
    .trade span,
    .trade-2 span {
        font-size: 1.64918vmax;
    }

    .bets-selections .mode-land,
    .bets-selections-head .mode-land,
    .trade .mode-land,
    .trade-2 .mode-land {
        display: flex;
    }

    .fancy .bets-selections .mode-land,
    .fancy .bets-selections-head .mode-land,
    .fancy .trade .mode-land,
    .fancy .trade-2 .mode-land {
        display: flex;
        width: 20.08996vmax;
    }
}

.bets-selections a,
.trade p,
.trade-2 p {
    width: 100%;
    font-weight: bold;
    color: #1e1e1e;
    padding: 1.6vw;
    flex-direction: column;
    justify-content: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .bets-selections a,
    .trade p,
    .trade-2 p {
        padding: 0.89955vmax;
    }
}

.back-1.spark,
.back-gradient dd.spark a,
.lay-gradient dd.spark a {
    animation: sparkBack 0.6s ease;
}

@keyframes sparkBack {
    0% {
        background-color: #72bbef;
        color: #1e1e1e;
    }

    50% {
        background-color: #f8e71c;
        color: #fff;
    }

    100% {
        background-color: #72bbef;
        color: #1e1e1e;
    }
}

.back-2.spark {
    animation: sparkBack_2 0.6s ease;
}

@keyframes sparkBack_2 {
    0% {
        background-color: #b7d5eb;
        color: #1e1e1e;
    }

    50% {
        background-color: #f8e71c;
        color: #fff;
    }

    100% {
        background-color: #b7d5eb;
        color: #1e1e1e;
    }
}

.back-3.spark {
    animation: sparkBack_3 0.6s ease;
}

@keyframes sparkBack_3 {
    0% {
        background-color: #d7e8f4;
        color: #1e1e1e;
    }

    50% {
        background-color: #f8e71c;
        color: #fff;
    }

    100% {
        background-color: #d7e8f4;
        color: #1e1e1e;
    }
}

.lay-1.spark,
.lay-gradient dd.spark a {
    animation: sparkLay 0.6s ease;
}

@keyframes sparkLay {
    0% {
        background-color: #faa9ba;
        color: #1e1e1e;
    }

    50% {
        background-color: #26f1f8;
        color: #fff;
    }

    100% {
        background-color: #faa9ba;
        color: #1e1e1e;
    }
}

.lay-2.spark {
    animation: sparkLay_2 0.6s ease;
}

@keyframes sparkLay_2 {
    0% {
        background-color: #efd3d9;
        color: #1e1e1e;
    }

    50% {
        background-color: #26f1f8;
        color: #fff;
    }

    100% {
        background-color: #efd3d9;
        color: #1e1e1e;
    }
}

.lay-3.spark {
    animation: sparkLay_3 0.6s ease;
}

@keyframes sparkLay_3 {
    0% {
        background-color: #f6e6ea;
        color: #1e1e1e;
    }

    50% {
        background-color: #26f1f8;
        color: #fff;
    }

    100% {
        background-color: #f6e6ea;
        color: #1e1e1e;
    }
}

.sports-book .back-1.spark {
    animation: sparkBook 0.6s ease;
}

@keyframes sparkBook {
    0% {
        background-color: #72e3a0;
        color: #1e1e1e;
    }

    50% {
        background-color: #f8e71c;
        color: #fff;
    }

    100% {
        background-color: #72e3a0;
        color: #1e1e1e;
    }
}

.bets-bookmaker .bets-selections-head ul,
.bets-selections dt ul,
.fancy-bet .bets-selections-head ul {
    font-weight: normal;
    font-size: 2.93333vw;
}

.bets-bookmaker .bets-selections-head ul li,
.bets-selections dt ul li,
.fancy-bet .bets-selections-head ul li {
    margin-right: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .bets-bookmaker .bets-selections-head ul,
    .bets-selections dt ul,
    .fancy-bet .bets-selections-head ul {
        font-size: 1.64918vmax;
    }

    .bets-bookmaker .bets-selections-head ul li,
    .bets-selections dt ul li,
    .fancy-bet .bets-selections-head ul li {
        margin-right: 0.5997vmax;
    }
}

.mob-sports-highlight-list a:after,
.inplay-list a:after,
.upcoming-list a:after,
.sports-side-menu-list a:after {
    position: absolute;
    top: 1.86667vw;
    right: 2.66667vw;
    content: '';
    width: 6.4vw;
    height: 6.4vw;
    background: #fff url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgb(120, 48, 207)" fill-rule="evenodd" d="M9.718 5L17 12l-7.282 7L8 17.348 13.592 12 8 6.652"/></svg>') no-repeat;
    background-size: contain;
    border: 1px solid #E0E6E6;
    border-radius: 1.06667vw;
}





.to-win:before,
.to-lose:before {
    content: "";
    width: 2.66667vw;
    height: 2.66667vw;
    background-repeat: no-repeat;
    background-size: contain;
    margin: -0.53333vw 1.06667vw 0 0;
    vertical-align: middle;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .to-win:before,
    .to-lose:before {
        width: 1.49925vmax;
        height: 1.49925vmax;
        margin: -0.29985vmax 0.5997vmax 0 0;
    }
}

.info-bet dt span,
.info-matched dt span,
.bets-back dt span,
.bets-lay dt span,
.bets-book dt span,
.bets-head dt span {
    width: 16vw;
    border-radius: 1.06667vw;
    margin-right: 1.86667vw;
}

.info-bet dt span.back,
.info-matched dt span.back,
.bets-back dt span.back,
.bets-lay dt span.back,
.bets-book dt span.back,
.bets-head dt span.back {
    background-color: #72bbef;
}

.info-bet dt span.lay,
.info-matched dt span.lay,
.bets-back dt span.lay,
.bets-lay dt span.lay,
.bets-book dt span.lay,
.bets-head dt span.lay {
    background-color: #faa9ba;
}

.info-bet dt span.book,
.info-matched dt span.book,
.bets-back dt span.book,
.bets-lay dt span.book,
.bets-book dt span.book,
.bets-head dt span.book {
    background-color: #72e3a0;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .info-bet dt span,
    .info-matched dt span,
    .bets-back dt span,
    .bets-lay dt span,
    .bets-book dt span,
    .bets-head dt span {
        width: 8.9955vmax;
        border-radius: 0.5997vmax;
        margin-right: 1.04948vmax;
    }
}

input.error,
.error input,
.input-num.error {
    color: #d0021b;

    border: 1px solid #d0021b;
}

.support-mail.open img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,255,255)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}

input:focus,
.input-num .typeing {
    color: #1e1e1e;
    background-color: #fff0ca;
    box-shadow: inset 0 0.26667vw 1.33333vw rgba(161, 128, 45, 0.6);
    border-color: #be7809;
}

input.disable,
.input-num.disable {
    background-color: #dcdcdc;
    color: #666;
    box-shadow: none;
    border: 1px solid #bbb;
}

.suspend-full,
.bets-selections .suspend {
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #d0021b;
    color: #d0021b;
    justify-content: center;
    align-items: center;
}

.suspend-fancy,
.suspend-spb {
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-weight: bold;
    text-shadow: 0 0.26667vw 1.06667vw rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
}

.card-yellow,
.card-red {
    position: absolute;
    width: 2.13333vw;
    height: 2.66667vw;
    box-shadow: 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 0.53333vw;
    margin-left: -1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .card-yellow,
    .card-red {
        width: 1.1994vmax;
        height: 1.49925vmax;
        box-shadow: 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.29985vmax;
        margin-left: -0.5997vmax;
    }
}

.side-content,
.mob-news-popup .mob-announce-content {
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

header .mob-login-index,
header .btn-signup {
    width: 28.8vw;
    height: 8.53333vw;
    border: 0.26667vw solid #710b0b;
    box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.5);
    line-height: 8.53333vw;
    padding: 0;
    color: #fff;
    border-radius: 1.06667vw;
    margin-top: 0.26667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    header .mob-login-index,
    header .btn-signup {
        width: 16.1919vmax;
        height: 4.7976vmax;
        line-height: 4.7976vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.5);
        border-width: 0.14993vmax;
        border-radius: 0.5997vmax;
        margin-top: 0.14993vmax;
    }
}

.saddle_1,
.saddle_1A,
.saddle_1B,
.saddle_1C,
.saddle_1D,
.saddle_1X,
.saddle_1Y,
.saddle_2,
.saddle_2B,
.saddle_2C,
.saddle_2X,
.saddle_3,
.saddle_3C,
.saddle_3D,
.saddle_3E,
.saddle_3X,
.saddle_4,
.saddle_4D,
.saddle_4X,
.saddle_5,
.saddle_6,
.saddle_7,
.saddle_8,
.saddle_9,
.saddle_10,
.saddle_11,
.saddle_11F,
.saddle_12,
.saddle_12F,
.saddle_13,
.saddle_13F,
.saddle_14,
.saddle_14F,
.saddle_15,
.saddle_15F,
.saddle_16,
.saddle_16F,
.saddle_17,
.saddle_17F,
.saddle_18,
.saddle_18F,
.saddle_19,
.saddle_19F,
.saddle_20,
.saddle_20F,
.saddle_21,
.saddle_21F,
.saddle_22,
.saddle_22F,
.saddle_23,
.saddle_23F,
.saddle_24,
.saddle_24F,
.saddle_25,
.saddle_25F,
.saddle_26,
.saddle_26F,
.saddle_27,
.saddle_27F,
.saddle_28,
.saddle_28F,
.saddle_29,
.saddle_29F,
.saddle_30,
.saddle_30F {
    line-height: 5.06667vw;
    font-size: 3.2vw;
    font-weight: normal;
    border-radius: 0.8vw;
    border: 0.26667vw solid transparent;
    background-image: none;
}

.saddle_1:before,
.saddle_1A:before,
.saddle_1B:before,
.saddle_1C:before,
.saddle_1D:before,
.saddle_1X:before,
.saddle_1Y:before,
.saddle_2:before,
.saddle_2B:before,
.saddle_2C:before,
.saddle_2X:before,
.saddle_3:before,
.saddle_3C:before,
.saddle_3D:before,
.saddle_3E:before,
.saddle_3X:before,
.saddle_4:before,
.saddle_4D:before,
.saddle_4X:before,
.saddle_5:before,
.saddle_6:before,
.saddle_7:before,
.saddle_8:before,
.saddle_9:before,
.saddle_10:before,
.saddle_11:before,
.saddle_11F:before,
.saddle_12:before,
.saddle_12F:before,
.saddle_13:before,
.saddle_13F:before,
.saddle_14:before,
.saddle_14F:before,
.saddle_15:before,
.saddle_15F:before,
.saddle_16:before,
.saddle_16F:before,
.saddle_17:before,
.saddle_17F:before,
.saddle_18:before,
.saddle_18F:before,
.saddle_19:before,
.saddle_19F:before,
.saddle_20:before,
.saddle_20F:before,
.saddle_21:before,
.saddle_21F:before,
.saddle_22:before,
.saddle_22F:before,
.saddle_23:before,
.saddle_23F:before,
.saddle_24:before,
.saddle_24F:before,
.saddle_25:before,
.saddle_25F:before,
.saddle_26:before,
.saddle_26F:before,
.saddle_27:before,
.saddle_27F:before,
.saddle_28:before,
.saddle_28F:before,
.saddle_29:before,
.saddle_29F:before,
.saddle_30:before,
.saddle_30F:before {
    vertical-align: middle;
}

.horse-info .uniform.saddle_1,
.horse-info .uniform.saddle_1A,
.horse-info .uniform.saddle_1B,
.horse-info .uniform.saddle_1C,
.horse-info .uniform.saddle_1D,
.horse-info .uniform.saddle_1X,
.horse-info .uniform.saddle_1Y,
.horse-info .uniform.saddle_2,
.horse-info .uniform.saddle_2B,
.horse-info .uniform.saddle_2C,
.horse-info .uniform.saddle_2X,
.horse-info .uniform.saddle_3,
.horse-info .uniform.saddle_3C,
.horse-info .uniform.saddle_3D,
.horse-info .uniform.saddle_3E,
.horse-info .uniform.saddle_3X,
.horse-info .uniform.saddle_4,
.horse-info .uniform.saddle_4D,
.horse-info .uniform.saddle_4X,
.horse-info .uniform.saddle_5,
.horse-info .uniform.saddle_6,
.horse-info .uniform.saddle_7,
.horse-info .uniform.saddle_8,
.horse-info .uniform.saddle_9,
.horse-info .uniform.saddle_10,
.horse-info .uniform.saddle_11,
.horse-info .uniform.saddle_11F,
.horse-info .uniform.saddle_12,
.horse-info .uniform.saddle_12F,
.horse-info .uniform.saddle_13,
.horse-info .uniform.saddle_13F,
.horse-info .uniform.saddle_14,
.horse-info .uniform.saddle_14F,
.horse-info .uniform.saddle_15,
.horse-info .uniform.saddle_15F,
.horse-info .uniform.saddle_16,
.horse-info .uniform.saddle_16F,
.horse-info .uniform.saddle_17,
.horse-info .uniform.saddle_17F,
.horse-info .uniform.saddle_18,
.horse-info .uniform.saddle_18F,
.horse-info .uniform.saddle_19,
.horse-info .uniform.saddle_19F,
.horse-info .uniform.saddle_20,
.horse-info .uniform.saddle_20F,
.horse-info .uniform.saddle_21,
.horse-info .uniform.saddle_21F,
.horse-info .uniform.saddle_22,
.horse-info .uniform.saddle_22F,
.horse-info .uniform.saddle_23,
.horse-info .uniform.saddle_23F,
.horse-info .uniform.saddle_24,
.horse-info .uniform.saddle_24F,
.horse-info .uniform.saddle_25,
.horse-info .uniform.saddle_25F,
.horse-info .uniform.saddle_26,
.horse-info .uniform.saddle_26F,
.horse-info .uniform.saddle_27,
.horse-info .uniform.saddle_27F,
.horse-info .uniform.saddle_28,
.horse-info .uniform.saddle_28F,
.horse-info .uniform.saddle_29,
.horse-info .uniform.saddle_29F,
.horse-info .uniform.saddle_30,
.horse-info .uniform.saddle_30F {
    background-image: none;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .saddle_1,
    .saddle_1A,
    .saddle_1B,
    .saddle_1C,
    .saddle_1D,
    .saddle_1X,
    .saddle_1Y,
    .saddle_2,
    .saddle_2B,
    .saddle_2C,
    .saddle_2X,
    .saddle_3,
    .saddle_3C,
    .saddle_3D,
    .saddle_3E,
    .saddle_3X,
    .saddle_4,
    .saddle_4D,
    .saddle_4X,
    .saddle_5,
    .saddle_6,
    .saddle_7,
    .saddle_8,
    .saddle_9,
    .saddle_10,
    .saddle_11,
    .saddle_11F,
    .saddle_12,
    .saddle_12F,
    .saddle_13,
    .saddle_13F,
    .saddle_14,
    .saddle_14F,
    .saddle_15,
    .saddle_15F,
    .saddle_16,
    .saddle_16F,
    .saddle_17,
    .saddle_17F,
    .saddle_18,
    .saddle_18F,
    .saddle_19,
    .saddle_19F,
    .saddle_20,
    .saddle_20F,
    .saddle_21,
    .saddle_21F,
    .saddle_22,
    .saddle_22F,
    .saddle_23,
    .saddle_23F,
    .saddle_24,
    .saddle_24F,
    .saddle_25,
    .saddle_25F,
    .saddle_26,
    .saddle_26F,
    .saddle_27,
    .saddle_27F,
    .saddle_28,
    .saddle_28F,
    .saddle_29,
    .saddle_29F,
    .saddle_30,
    .saddle_30F {
        line-height: 2.84858vmax;
        font-size: 1.7991vmax;
        border-radius: 0.44978vmax;
        border-width: 0.14993vmax;
    }
}

.power-content-b {
    width: 26.66667vw;
    height: 8.8vw;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 2.13333vw;
    padding: 0.8vw 1.86667vw 1.6vw;
    margin-bottom: 2.66667vw;
}

.power-content-b span {
    font-size: 2.66667vw;
    font-weight: normal;
}

.power-content-b img {
    width: 26.66667vw;
    height: 4.26667vw;
    /* background: url('../images/sprite/logo-betfair.png') no-repeat; */
    background-size: contain;
    opacity: 0.5;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .power-content-b {
        width: 14.9925vmax;
        height: 4.94753vmax;
        border-radius: 1.1994vmax;
        padding: 0.44978vmax 1.04948vmax 0.89955vmax;
        margin-bottom: 1.49925vmax;
    }

    .power-content-b span {
        font-size: 1.49925vmax;
    }

    .power-content-b img {
        width: 14.9925vmax;
        height: 2.3988vmax;
    }
}

.mode-land .btn-fancy_info,
.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info {
    width: 8vw;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: transparent;
    line-height: inherit;
    align-items: center;
    justify-content: center;
}

.mode-land .btn-fancy_info:before,
.fancy-bet .btn-fancy_info:before,
.sports-book .btn-fancy_info:before {
    width: 4vw;
    height: 4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%233B5160" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat;
    background-size: contain;
    float: none;
    margin: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .mode-land .btn-fancy_info,
    .fancy-bet .btn-fancy_info,
    .sports-book .btn-fancy_info {
        width: 4.49775vmax;
    }

    .mode-land .btn-fancy_info:before,
    .fancy-bet .btn-fancy_info:before,
    .sports-book .btn-fancy_info:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4.26667vw;
    height: 4vw;
    padding: 0;
    border-radius: 0.8vw;
    margin-right: 1.33333vw;
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after {
    content: "";
    background-size: cover;
    width: 2.93333vw;
    height: 2.93333vw;
}

.game-fancy:last-of-type,
.game-sportsbook:last-of-type,
.game-bookmaker:last-of-type,
.game-live:last-of-type {
    margin-right: 0;
}

.in-play.game-fancy,
.in-play.game-sportsbook,
.in-play.game-bookmaker,
.in-play.game-live {
    position: relative;
    padding: 0;
    overflow: auto;
    width: 8.53333vw;
}

.in-play.game-fancy pre,
.in-play.game-sportsbook pre,
.in-play.game-bookmaker pre,
.in-play.game-live pre {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #60ba1e;
    color: #fff;
    width: 4.26667vw;
    height: 4vw;
}

.in-play.game-fancy pre:before,
.in-play.game-sportsbook pre:before,
.in-play.game-bookmaker pre:before,
.in-play.game-live pre:before {
    content: "";
    width: 2.66667vw;
    height: 2.66667vw;
    background-image: url('data:image/svg+xml,<svg width="20" height="21" xmlns="http://www.w3.org/2000/svg"><path d="M10 18.944c1.94 0 3.592-.718 4.953-2.154 1.362-1.436 2.042-3.165 2.042-5.189 0-2.023-.68-3.744-2.042-5.164-1.361-1.42-3.012-2.13-4.953-2.13-1.94 0-3.592.71-4.953 2.13-1.362 1.42-2.042 3.141-2.042 5.164 0 2.024.68 3.753 2.042 5.19 1.361 1.435 3.012 2.153 4.953 2.153zm0-16.741c2.504 0 4.632.922 6.385 2.766 1.753 1.843 2.63 4.054 2.63 6.632 0 2.579-.877 4.79-2.63 6.633C14.632 20.078 12.504 21 10 21s-4.632-.922-6.385-2.766C1.862 16.39.985 14.18.985 11.601c0-2.578.877-4.789 2.63-6.632C5.368 3.125 7.496 2.203 10 2.203zm.516 4.21v5.482l3.991 2.448-.751 1.272-4.742-2.937V6.413h1.502zM5.87 1.566L1.268 5.58 0 4.014 4.6 0 5.87 1.566zM20 4.014l-1.268 1.615-4.6-4.063L15.398 0 20 4.014z" fill="%23C5F6EE" fill-rule="evenodd"/></svg>');
    background-size: contain;
}

.in-play.game-fancy:after,
.in-play.game-sportsbook:after,
.in-play.game-bookmaker:after,
.in-play.game-live:after {
    margin-left: 4.26667vw;
}

.game-team h4 .game-fancy,
.game-team h4 .game-sportsbook,
.game-team h4 .game-bookmaker,
.game-team h4 .game-live {
    display: inline-flex;
    line-height: initial;
    font-size: 0;
}

h4.game-info .game-fancy,
h4.game-info .game-sportsbook,
h4.game-info .game-bookmaker,
h4.game-info .game-live {
    width: 5.06667vw;
    height: 4.8vw;
}

h4.game-info .game-fancy:after,
h4.game-info .game-sportsbook:after,
h4.game-info .game-bookmaker:after,
h4.game-info .game-live:after {
    width: 3.46667vw;
    height: 3.46667vw;
}

.multi .game-fancy,
.multi .game-sportsbook,
.multi .game-bookmaker,
.multi .game-live {
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .game-fancy,
    .game-sportsbook,
    .game-bookmaker,
    .game-live {
        width: 2.3988vmax;
        height: 2.24888vmax;
        border-radius: 0.44978vmax;
        margin-right: 0.74963vmax;
    }

    .game-fancy:after,
    .game-sportsbook:after,
    .game-bookmaker:after,
    .game-live:after {
        width: 1.64918vmax;
        height: 1.64918vmax;
    }

    .in-play.game-fancy,
    .in-play.game-sportsbook,
    .in-play.game-bookmaker,
    .in-play.game-live {
        width: 4.7976vmax;
    }

    .in-play.game-fancy pre,
    .in-play.game-sportsbook pre,
    .in-play.game-bookmaker pre,
    .in-play.game-live pre {
        width: 2.3988vmax;
        height: 2.24888vmax;
    }

    .in-play.game-fancy pre:before,
    .in-play.game-sportsbook pre:before,
    .in-play.game-bookmaker pre:before,
    .in-play.game-live pre:before {
        width: 1.49925vmax;
        height: 1.49925vmax;
    }

    .in-play.game-fancy:after,
    .in-play.game-sportsbook:after,
    .in-play.game-bookmaker:after,
    .in-play.game-live:after {
        margin-left: 2.3988vmax;
    }

    h4.game-info .game-fancy,
    h4.game-info .game-sportsbook,
    h4.game-info .game-bookmaker,
    h4.game-info .game-live {
        width: 2.84858vmax;
        height: 2.69865vmax;
    }

    h4.game-info .game-fancy:after,
    h4.game-info .game-sportsbook:after,
    h4.game-info .game-bookmaker:after,
    h4.game-info .game-live:after {
        width: 1.94903vmax;
        height: 1.94903vmax;
    }

    .multi .game-fancy,
    .multi .game-sportsbook,
    .multi .game-bookmaker,
    .multi .game-live {
        margin-right: 0.74963vmax;
    }
}

.fancy_bet-head,
.sportsbook_bet-head {
    position: relative;
    line-height: 8vw;
    border-bottom: 1.06667vw solid #e4550f;
    margin-top: 5.33333vw;
}

.fancy_bet-head h4,
.sportsbook_bet-head h4 {
    height: 8vw;
    color: #fff;
    font-size: 3.73333vw;
    margin-right: 2.66667vw;
    z-index: 1;
}

.fancy_bet-head h4 span,
.sportsbook_bet-head h4 span {
    height: 100%;
    padding-left: 2.66667vw;
}

.fancy_bet-head .in-play span,
.sportsbook_bet-head .in-play span {
    align-items: center;
}

.fancy_bet-head .in-play pre,
.sportsbook_bet-head .in-play pre {
    width: 4.8vw;
    height: 4.8vw;
    background-image: linear-gradient(-180deg, #91d527 0%, #60ba1e 79%);
    border-radius: 1.06667vw;
    margin-right: 1.6vw;
    justify-content: center;
    align-items: center;
}

.fancy_bet-head .in-play pre:before,
.sportsbook_bet-head .in-play pre:before {
    content: "";
    width: 3.2vw;
    height: 3.2vw;
    background: url('data:image/svg+xml,<svg width="20" height="21" xmlns="http://www.w3.org/2000/svg"><path d="M10 18.944c1.94 0 3.592-.718 4.953-2.154 1.362-1.436 2.042-3.165 2.042-5.189 0-2.023-.68-3.744-2.042-5.164-1.361-1.42-3.012-2.13-4.953-2.13-1.94 0-3.592.71-4.953 2.13-1.362 1.42-2.042 3.141-2.042 5.164 0 2.024.68 3.753 2.042 5.19 1.361 1.435 3.012 2.153 4.953 2.153zm0-16.741c2.504 0 4.632.922 6.385 2.766 1.753 1.843 2.63 4.054 2.63 6.632 0 2.579-.877 4.79-2.63 6.633C14.632 20.078 12.504 21 10 21s-4.632-.922-6.385-2.766C1.862 16.39.985 14.18.985 11.601c0-2.578.877-4.789 2.63-6.632C5.368 3.125 7.496 2.203 10 2.203zm.516 4.21v5.482l3.991 2.448-.751 1.272-4.742-2.937V6.413h1.502zM5.87 1.566L1.268 5.58 0 4.014 4.6 0 5.87 1.566zM20 4.014l-1.268 1.615-4.6-4.063L15.398 0 20 4.014z" fill="%23ffffff" fill-rule="evenodd"/></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .fancy_bet-head,
    .sportsbook_bet-head {
        line-height: 4.49775vmax;
        border-bottom-width: 0.5997vmax;
        margin-top: 2.9985vmax;
    }

    .fancy_bet-head h4,
    .sportsbook_bet-head h4 {
        height: 4.49775vmax;
        font-size: 2.09895vmax;
        margin-right: 1.49925vmax;
    }

    .fancy_bet-head h4 span,
    .sportsbook_bet-head h4 span {
        padding-left: 1.49925vmax;
    }

    .fancy_bet-head .in-play pre,
    .sportsbook_bet-head .in-play pre {
        width: 2.69865vmax;
        height: 2.69865vmax;
        border-radius: 0.5997vmax;
        margin-right: 1.1994vmax;
    }

    .fancy_bet-head .in-play pre:before,
    .sportsbook_bet-head .in-play pre:before {
        width: 1.7991vmax;
        height: 1.7991vmax;
    }
}

.fancy-bet>h5,
.fancy-bet>h4,
.sports-book>h4,
.bets-bookmaker>h4 {
    position: relative;
    height: 8.53333vw;
    background-color: #000;
    color: #fff;
    font-size: 3.46667vw;
    line-height: 8.53333vw;
    padding: 0 0 0 1.86667vw;
    align-items: center;
    justify-content: space-between;
}

.fancy-bet>h5 span,
.fancy-bet>h4 span,
.sports-book>h4 span,
.bets-bookmaker>h4 span {
    flex: 1;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .fancy-bet>h5,
    .fancy-bet>h4,
    .sports-book>h4,
    .bets-bookmaker>h4 {
        height: 4.7976vmax;
        font-size: 1.94903vmax;
        line-height: 4.7976vmax;
        padding: 0 0 0 1.04948vmax;
    }
}

.fancy-bet>h5 {
    color: #000;
    background-color: #c7dbe9;
    background-color: #e4f1f9;
}

.bets-bookmaker .bets-selections-head {
    height: 5.86667vw;
    line-height: 5.86667vw;
}

.bets-bookmaker .bets-selections-head dt {
    padding: 0 1.86667vw;
}

.bets-bookmaker .bets-selections-head dd {
    padding: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-bookmaker .bets-selections-head {
        height: 3.29835vmax;
        line-height: 3.29835vmax;
    }

    .bets-bookmaker .bets-selections-head dt {
        padding: 0 1.04948vmax;
    }
}

@keyframes twinkling {
    0% {
        filter: brightness(100%);
    }

    50% {
        filter: brightness(30%);
    }

    100% {
        filter: brightness(100%);
    }
}

@keyframes twinkling {

    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.left-in {
    animation: leftIn 0.3s ease;
}

@keyframes leftIn {
    0% {
        opacity: 0;
        margin-left: -94.66667vw;
    }

    30% {
        opacity: 1;
    }

    100% {
        margin-left: 0;
    }
}

.right-in {
    animation: rightIn 0.3s ease;
}

@keyframes rightIn {
    0% {
        opacity: 0;
        margin-right: -94.66667vw;
    }

    30% {
        opacity: 1;
    }

    100% {
        margin-right: 0;
    }
}

@keyframes typeing {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes loading-1 {
    0% {
        left: 0;
    }

    50% {
        left: 50%;
    }

    100% {
        left: 0;
    }
}

@keyframes loading-2 {
    0% {
        left: 50%;
        z-index: 1;
    }

    49% {
        z-index: 1;
    }

    50% {
        left: 0;
        z-index: 10;
    }

    100% {
        left: 50%;
        z-index: 10;
    }
}

@keyframes loadBar {
    0% {
        opacity: 0.1;
    }

    50% {
        opacity: 1;
        transform: scale(1.4);
    }

    100% {
        opacity: 0.1;
    }
}

@keyframes urgent-notice {
    0% {
        top: -100%;
        opacity: 0;
    }

    100% {
        top: 0;
        opacity: 1;
    }
}

.cooldown dd a:after {
    animation: cooldown 5s linear;
}

@keyframes cooldown {
    0% {
        width: 100%;
        opacity: 0;
    }

    5% {
        width: 95%;
        opacity: 1;
    }

    95% {
        width: 5%;
        opacity: 1;
    }

    100% {
        width: 0;
        opacity: 0;
    }
}

.twinkling,
.mob-live-number strong:before,
.live_events .live_icon span:before {
    animation: twinkling 1.4s infinite ease;
}

@keyframes twinkling {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}

.loading-shimmer,
.mob-main-content .casinozone a:after {
    animation: placeHolderShimmer 1.25s infinite linear;
    background: #ced5da linear-gradient(to right, #ced5da 8%, #d8dfe4 18%, #ced5da 33%);
    background-size: 213.33333vw 27.73333vw;
    height: auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .loading-shimmer,
    .mob-main-content .casinozone a:after {
        background-size: 119.94003vmax 15.5922vmax;
    }
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -124.8vw 0;
    }

    100% {
        background-position: 124.8vw 0;
    }


}

.login-head {
    position: relative;
    height: 74.66667vw;

    background-size: 100% 100%;
    margin-bottom: 12vw;
}

.login-head h1 {
    position: absolute;
    left: 50%;
    top: 37.86667vw;
    width: 65.33333vw;
    height: 15.46667vw;

    background-size: contain;
    margin-left: -32.53333vw;
}

.login-head .close {
    position: fixed;
    right: 1.86667vw;
    justify-content: center;
    align-items: center;
    width: 9.33333vw;
    height: 9.33333vw;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    margin-top: 1.86667vw;
    z-index: 2;
}


.login-head .close:before {
    content: "";
    width: 3.46667vw;
    height: 3.46667vw;
    /* background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>')
        no-repeat; */
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .login-head .close {
        right: 1.04948vmax;
        width: 5.24738vmax;
        height: 5.24738vmax;
        margin-top: 1.04948vmax;
    }

    .login-head .close:before {
        width: 1.94903vmax;
        height: 1.94903vmax;
    }
}

@media (orientation: landscape) {
    .login-head {
        height: 21.33333vw;
        background-color: rgb(119, 48, 207);
        background-image: linear-gradient(-180deg, #ffcc2e 0%, #000 58%);
        margin-bottom: 5.33333vw;
    }

    .login-head h1 {
        top: 3.73333vw;
        width: 59.2vw;
        height: 14.13333vw;
        margin-left: -29.6vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .login-head {
        height: 11.994vmax;
        margin-bottom: 2.9985vmax;
    }

    .login-head h1 {
        top: 2.69865vmax;
        width: 33.28336vmax;
        height: 7.94603vmax;
        margin-left: -16.64168vmax;
    }
}

.form-login {
    width: 84vw;
    margin: 0 auto;
    color: #fff;
}

.form-login dt {
    font-size: 5.86667vw;
    margin-bottom: 8vw;
}

.form-login dd {
    position: relative;
    margin-bottom: 3.2vw;
}

.form-login dd:last-of-type {
    margin-bottom: 0;
}

.form-login img {
    position: absolute;
    background-color: #fff;
    width: 18.66667vw;
    height: 5.06667vw;
    right: 1.86667vw;
    top: 2.13333vw;
    padding-top: 1.33333vw;
    border-radius: 1.06667vw;
}

.pass-wrap .form-login {
    margin-bottom: 5.33333vw;
}

.form-login .error:after {
    position: absolute;
    right: 1.86667vw;
    top: 0vw;
    content: "";
    width: 4.26667vw;
    height: 4.26667vw;
    /* background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="rgb(208,2,27)" fill-rule="evenodd" d="M8.788 8.788V3.98H7.212V8.79h1.576zm0 3.23v-1.614H7.212v1.615h1.576zM8 0c1.462 0 2.814.365 4.058 1.096 1.205.692 2.154 1.64 2.846 2.846C15.634 5.186 16 6.538 16 8c0 1.462-.365 2.814-1.096 4.058-.692 1.205-1.64 2.154-2.846 2.846C10.814 15.634 9.462 16 8 16c-1.462 0-2.814-.365-4.058-1.096-1.205-.705-2.154-1.66-2.846-2.866C.366 10.795 0 9.448 0 8c0-1.45.365-2.795 1.096-4.038.705-1.206 1.66-2.16 2.866-2.866C5.205.366 6.552 0 8 0z"/></svg>')
        no-repeat; */
    background-size: contain;
}

.form-login .error img {
    margin-right: 6.13333vw;
}

@media (orientation: landscape) {
    .form-login {
        width: 84vw;
    }

    .form-login dt {
        font-size: 5.86667vw;
        margin-bottom: 8vw;
    }

    .form-login dd {
        margin-bottom: 3.2vw;
    }

    .form-login img {
        width: 18.66667vw;
        height: 5.06667vw;
        right: 1.86667vw;
        top: 2.13333vw;
        padding-top: 1.33333vw;
        border-radius: 1.06667vw;
    }

    .form-login .error:after {
        right: 1.86667vw;
        /* top: 3.2vw; */
        width: 4.26667vw;
        height: 4.26667vw;
    }

    .form-login .error img {
        margin-right: 6.13333vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .form-login {
        width: 47.22639vmax;
    }

    .form-login dt {
        font-size: 3.29835vmax;
        margin-bottom: 4.49775vmax;
    }

    .form-login dd {
        margin-bottom: 1.7991vmax;
    }

    .form-login img {
        width: 10.49475vmax;
        height: 2.84858vmax;
        right: 1.04948vmax;
        top: 1.1994vmax;
        padding-top: 0.74963vmax;
        border-radius: 0.5997vmax;
    }

    .form-login .error:after {
        right: 1.04948vmax;
        top: 1.7991vmax;
        width: 2.3988vmax;
        height: 2.3988vmax;
    }

    .form-login .error img {
        margin-right: 3.44828vmax;
    }
}

.login {
    border-width: 0;
    line-height: 2.9;
    font-size: 4.53333vw;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
}

.login:after {
    content: "";
    width: 4vw;
    height: 4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="rgb(30,30,30" fill-rule="evenodd" d="M5.672 11.238l2.066-2.355H0V7.117h7.776L5.672 4.762 6.8 3.5 10.82 8 6.8 12.5 5.67 11.238zM13.348 0c.435 0 .82.17 1.153.508.334.338.5.73.5 1.172v11.64c0 .443-.166.834-.5 1.172-.332.34-.717.508-1.152.508H1.898c-.434 0-.818-.17-1.15-.508-.334-.338-.5-.73-.5-1.172V10h1.65v3.32h11.45V1.68H1.898V5H.25V1.68c0-.443.166-.834.5-1.172C1.08.168 1.463 0 1.897 0h11.45z"/></svg>') no-repeat;
    background-size: contain;
    margin: 0.53333vw 0 0 1.33333vw;
}

@media (orientation: landscape) {
    .login {
        font-size: 4.53333vw;
        border-radius: 1.6vw;
    }

    .login:after {
        width: 4vw;
        height: 4vw;
        margin: 0.53333vw 0 0 1.33333vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .login {
        font-size: 2.54873vmax;
        border-radius: 0.89955vmax;
    }

    .login:after {
        width: 2.24888vmax;
        height: 2.24888vmax;
        margin: 0.29985vmax 0 0 0.74963vmax;
    }
}

.state {
    font-size: 3.2vw;
    color: #f8e71c;
}

@media (orientation: landscape) {
    .state {
        font-size: 3.2vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .state {
        font-size: 1.7991vmax;
    }
}

.index-login .mob-main-content {
    padding: 14.66667vw 0 17.6vw;
}

.index-login .promo-banner-wrap {
    top: 14.66667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .index-login .mob-main-content {
        padding: 8.24588vmax 0 9.89505vmax;
    }

    .index-login .promo-banner-wrap {
        top: 8.24588vmax;
    }
}

header {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    width: 100vw;
    height: 14.66667vw;
    padding: 2.66667vw 1.86667vw 2.66667vw 0;
    background: linear-gradient(90deg, rgb(208, 2, 27) 0%, rgb(255, 234, 33) 100%);
    z-index: 11;
}

header ul {
    position: relative;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

header li {
    margin-right: 2.53333vw;
}

header li:last-of-type {
    margin-right: 0;
}

header li.main-wallet {
    flex: 1;
    font-size: 2.66667vw;

    border: 0.26667vw solid rgba(0, 0, 0, 0.3);
    border-radius: 1.06667vw;
}

header li.main-wallet p {
    font-weight: bold;
    /* margin-right: 1.86667vw; */
    line-height: 1.4;
}


/* .betsbuzz365 .side-head .close:before {
    background-image: url("/images/icon-close-yellow.svg");
} */
.close:before {
    content: '';
    width: 2.4vw;
    height: 2.4vw;
    background: url(../images/sprite/icon-close-yellow.svg);
    background-size: contain;
    filter: grayscale(1)
}

header li.main-wallet ul {
    flex-wrap: wrap;

}

header li.main-wallet li {
    font-weight: bold;

}

header li.main-wallet span:first-of-type {
    opacity: 0.7;
    font-weight: normal;
}

html {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}


.mob-sports-highlight-list .inplay-on span,
.inplay-list .inplay-on span,
.upcoming-list .inplay-on span,
.sports-side-menu-list .inplay-on span {
    color: #508D0E;
}

body {

    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: scroll;
}


.form-login dd:last-of-type {
    margin-bottom: 0;
}

.betsbuzz365 .state {
    color: #fff;
}

.form-login dd {
    position: relative;
    margin-bottom: 3.2vw;
}

.state {
    font-size: 3.2vw;
    color: #F8E71C;
}

header a {
    color: #1e1e1e;
    height: 5.86667vw;
    line-height: 5.33333vw;
    font-weight: bold;
    border: 0.26667vw solid #bd8c16;
    border-radius: 1.06667vw;

}

header a.mob-bet-show {
    padding: 1.86667vw 0 1.33333vw;
    border-left-width: 0;
    border-radius: 0 1.06667vw 1.06667vw 0;
}

@media screen and (min-aspect-ratio: 16/9) {
    header a.mob-bet-show {
        padding: 0.89955vmax 0.89955vmax;
        border-radius: 0 0.5997vmax 0.5997vmax 0;
    }
}

header img {
    width: 5.06667vw;
    height: 5.06667vw;
}

header .loading-main {
    width: 21.33333vw;
    height: 2.66667vw;
    margin-top: 3.2vw;
}

header .live-tv-icon {
    min-width: 29.33333vw;
    max-width: 31.2vw;
    margin-left: -1px;
}

.betsbuzz365 header a,
.betsbuzz365 header li.main-wallet.no-multi a {
    border-color: #000;
    color: #000;
    background-color: #fff;
    box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.4);
}

header .a-open_tv {
    flex: 0 0 10.66667vw;
    background-color: #1e5f89;
    border-color: #0f476a;
    box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.4);
    border-radius: 0;
    padding: 1.86667vw 0 1.33333vw;
}

header .a-open_tv img {
    width: 5.6vw;
    height: 5.06667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="19"><defs><linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%"><stop offset="0%" stop-color="%23FFF"/><stop offset="100%" stop-color="%23E0E0E0"/></linearGradient><linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="72.529%"><stop offset="0%" stop-color="%2338AEFA"/><stop offset="100%" stop-color="%230B7DC5"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="url(%23a)" d="M4 0h13a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm3 17h7v2H7v-2zM4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm11 6.024L8 12V4l7 4.024z"/><path fill="url(%23b)" d="M4 2h13a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm11 6.024L8 4v8l7-3.976z"/></g></svg>') no-repeat;
}

header .mob-header-logo {
    flex: 1;
    width: 36.8vw;
    height: 8.8vw;

    background-repeat: no-repeat;
    background-size: contain;
    margin: -4.73333vw 14.2vw 1.2vw 0.86667vw;
}

header .mob-login-index {
    background-image: linear-gradient(-180deg, #f72424 0%, #bb1c00 100%);
}

header .mob-login-index:before {
    content: "";
    width: 4.53333vw;
    height: 4.53333vw;
    /* background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><path fill="rgb(0,0,0)" fill-rule="evenodd" d="M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z"/></svg>') */

    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z"/></svg>') no-repeat;
    background-size: contain;
    margin-right: 1.33333vw;
    vertical-align: top;
}

header .btn-signup {
    display: none;
    width: 19.2vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    header {
        position: relative;
        top: 0;
        height: 8.24588vmax;
        padding: 1.49925vmax 1.04948vmax 1.49925vmax 0;
    }

    header li {
        margin-right: 1.1994vmax;
    }

    header li.main-wallet {
        font-size: 1.94903vmax;
    }

    header li.main-wallet p {
        margin-right: 1.04948vmax;
    }

    header li.main-wallet ul {
        margin-right: 1.04948vmax;
        justify-content: flex-end;
        align-items: center;
    }

    header li.main-wallet li {
        flex: 0 0 auto;
    }

    header li.main-wallet li:first-of-type {
        margin-right: 1.7991vmax;
    }

    header a {
        height: 2.9985vmax;
        line-height: 2.9985vmax;
        border-width: 0.14993vmax;
        border-radius: 0.5997vmax;
        padding: 0.89955vmax 1.04948vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.5);
    }

    .betsbuzz365 header li.main-wallet {
        border-color: #000;
    }

    header li.main-wallet {
        flex: 1;
        font-size: 2.66667vw;
        border: 0.26667vw solid rgba(0, 0, 0, 0.3);
        border-radius: 1.06667vw;
    }


    header li.main-wallet .a-wallet {
        width: 100%;
        height: auto;
        line-height: initial;
        border: 0;
        border-radius: 0.8vw 0 0 0.8vw;
        box-shadow: inset 0 0.26667vw 0 0 rgba(255, 255, 255, 0.5);
        padding: 0;
    }

    header li.main-wallet .a-wallet ul {
        position: relative;
        flex-wrap: wrap;
        height: 8vw;
        line-height: 3.2vw;
        padding: 1.06667vw 10.66667vw 0 1.86667vw;
        border-radius: 1.06667vw 0 0 0;
    }

    header li.main-wallet li {
        font-weight: bold;
    }

    header li.main-wallet span:first-of-type {
        opacity: 0.7;
        font-weight: normal;
    }

    header li.main-wallet span:first-of-type {
        opacity: 0.7;
        font-weight: normal;
    }

    header li.main-wallet .a-wallet li:last-child {
        margin-right: 0;
    }

    .betsbuzz365 header li.main-wallet .nums {
        border-color: #000;
    }

    header li.main-wallet .nums {
        position: absolute;
        top: 2.4vw;
        right: 1.86667vw;
        height: 3.73333vw;
        font-size: 2.93333vw;
        line-height: 3.73333vw;
        border: 0.26667vw solid rgba(0, 0, 0, 0.3);
        border-radius: 0.8vw;
        padding: 0 2.13333vw;
    }

    .btn-box,
    .in-play.game-fancy pre,
    .in-play.game-sportsbook pre,
    .in-play.game-bookmaker pre,
    .in-play.game-live pre,
    header li.main-wallet .nums,
    header .badge-currency,
    header a,
    .tv-control a,
    .mob-live-number,
    .mob-live-number strong,
    .btn-minmax_bet,
    .back-gradient dd,
    .lay-gradient dd,
    .live_events .live_icon,
    .live_events .live_icon span,
    .live_events dd {
        justify-content: center;
        align-items: center;
    }

    .betsbuzz365 header li.main-wallet .a-wallet {
        background-color: rgba(255, 255, 255, .1);
    }

    .betsbuzz365 header li.main-wallet {
        border-color: #000;
    }

    header li.main-wallet {
        flex: 1;
        font-size: 2.66667vw;
        border: 0.26667vw solid rgba(0, 0, 0, 0.3);
        border-radius: 1.06667vw;
    }

    header a.mob-bet-show {
        flex: 1;
        padding: 0.89955vmax 0.89955vmax;
        border-radius: 0 0.5997vmax 0.5997vmax 0;
    }

    header img {
        width: 2.84858vmax;
        height: 2.84858vmax;
    }

    header .loading-main {
        width: 11.994vmax;
        height: 1.49925vmax;
        margin-top: 1.7991vmax;
    }

    header .live-tv-icon {
        min-width: 16.49175vmax;
        max-width: 20.98951vmax;
        margin-left: -0.14993vmax;
    }

    header .a-open_tv {
        flex: 0 0 5.997vmax;
        padding: 1.04948vmax 0 0.74963vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.4);
    }

    header .a-open_tv img {
        width: 3.14843vmax;
        height: 2.84858vmax;
    }

    header .mob-header-logo {
        width: 20.68966vmax;
        height: 4.94753vmax;
        margin-top: 0.29985vmax;
        margin: 0.14993vmax 0 0 1.04948vmax;
    }

    header .mob-login-index:before {
        width: 2.54873vmax;
        height: 2.54873vmax;
    }
}

.mob-bet-show {
    position: relative;
    flex: 1;
}

.mob-bet-show img {
    width: 5.33333vw;
    height: 5.33333vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="rgb(255,255,255)" fill-rule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"/></svg>') no-repeat;

    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-bet-show span {
        top: -1.04948vmax;
        right: -1.49925vmax;
        width: 2.9985vmax;
        height: 2.9985vmax;
        line-height: 2.9985vmax;
        font-size: 1.64918vmax;
    }

    .mob-bet-show img {
        width: 2.9985vmax;
        height: 2.9985vmax;
        margin-right: 0.74963vmax;
    }
}

.slip-note {
    background: #bb1c00;
    border: 1px solid #fff;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}

.mob-bet-show .slip-note {
    position: absolute;
    top: -2.13333vw;
    right: -2.13333vw;
    width: 4.8vw;
    height: 4.8vw;
}

.mob-bet-show .slip-note:before {
    content: "";
    width: 2.66667vw;
    height: 2.66667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.69 301.69"><path d="M119.15 0l10.45 218.4h42.46L182.54 0zM130.56 261.17h40.52v40.52h-40.52z" fill="rgb(255,255,255)" /></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-bet-show .slip-note {
        top: -1.1994vmax;
        right: -1.1994vmax;
        width: 2.69865vmax;
        height: 2.69865vmax;
    }

    .mob-bet-show .slip-note:before {
        width: 1.49925vmax;
        height: 1.49925vmax;
    }
}

.a-refresh img {
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-7 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="rgb(255,255,255)"/></g></svg>') no-repeat no-repeat;
}

.a-setting img {
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-8 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill="rgb(255,255,255)"/></g></svg>') no-repeat no-repeat;
}

.loading-bar {
    width: 21.33333vw;
    align-items: center;
}

.loading-bar span {
    width: 1.06667vw;
    height: 1.06667vw;
    border-radius: 50%;
    background-color: #b557fa;
    margin-right: 1.6vw;
    opacity: 0;
    animation: loadBar 0.8s ease infinite;
}

.loading-bar span:nth-child(1) {
    animation-delay: 0s;
}

.loading-bar span:nth-child(2) {
    animation-delay: 0.1s;
}

.loading-bar span:nth-child(3) {
    animation-delay: 0.2s;
}

.loading-bar span:nth-child(4) {
    animation-delay: 0.3s;
}

.loading-bar span:nth-child(5) {
    animation-delay: 0.4s;
}

.loading-bar span:nth-child(6) {
    animation-delay: 0.5s;
}

.loading-bar span:nth-child(7) {
    animation-delay: 0.6s;
}

.loading-bar span:nth-child(8) {
    animation-delay: 0.7s;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .loading-bar {
        width: 11.994vmax;
    }

    .loading-bar span {
        width: 0.5997vmax;
        height: 0.5997vmax;
        margin-right: 0.89955vmax;
    }
}

.message-content {
    position: absolute;
    left: 0;
    width: 100%;
    background-color: #f8e71c;
    border: 0.26667vw solid #9b9011;
    border-width: 0.26667vw 0 0.26667vw 0;
    box-shadow: 0 0.8vw 1.06667vw 0 rgba(0, 0, 0, 0.5);
    margin-top: 12vw;
    z-index: 10;
}

.message-content a {
    height: auto;
    border-width: 0;
    border-radius: 0;
    box-shadow: none;
}

.message-content.to-open_bets:before {
    position: absolute;
    content: "";
    width: 4.26667vw;
    height: 3.2vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g fill="none" fill-rule="evenodd"><path fill="rgb(155,144,17)" d="M15.333 11H16v1H0v-1h.667L8 0l7.333 11zM8 2L1 12h14L8 2z"/><path fill="rgb(248,234,18)" d="M8 2l7 10H1"/></g></svg>') no-repeat;
    background-size: contain;
    margin-top: -3.2vw;
    margin-left: 14.13333vw;
}

.message-content.success {
    background: #6bbd11;
    border-color: #43760a;
}

.message-content.success.to-open_bets:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g fill="none" fill-rule="evenodd"><path fill="rgb(67,118,10)" d="M15.333 11H16v1H0v-1h.667L8 0l7.333 11zM8 2L1 12h14L8 2z"/><path fill="rgb(107,189,17)" d="M8 2l7 10H1"/></g></svg>');
}

.message-content.error {
    color: #fff;
    background: #d0021b;
    border-color: #820110;
}

.message-content.error.to-open_bets:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g fill="none" fill-rule="evenodd"><path fill="rgb(130,1,16)" d="M15.333 11H16v1H0v-1h.667L8 0l7.333 11zM8 2L1 12h14L8 2z"/><path fill="rgb(208,2,27)" d="M8 2l7 10H1"/></g></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .message-content {
        border-width: 0.14993vmax 0 0.14993vmax 0;
        box-shadow: 0 0.44978vmax 0.5997vmax 0 rgba(0, 0, 0, 0.5);
        margin-top: 6.74663vmax;
    }

    .message-content.to-open_bets:before {
        width: 2.3988vmax;
        height: 1.7991vmax;
        margin-top: -1.7991vmax;
        margin-left: 10.1949vmax;
    }
}

.message {
    flex: 1;
    line-height: 1.4;
    padding: 1.86667vw;
}

.message .back,
.message .lay {
    font-size: 3.2vw;
    color: #1e1e1e;
    border-radius: 1.06667vw;
    padding: 0 1.86667vw;
    background-color: #b7d5eb;
    margin-right: 1.33333vw;
}

.message .lay {
    background-color: #efd3d9;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .message {
        padding: 1.04948vmax;
    }

    .message .back,
    .message .lay {
        font-size: 1.7991vmax;
        border-radius: 0.5997vmax;
        padding: 0 1.04948vmax;
        margin-right: 0.74963vmax;
    }
}

.close {
    justify-content: center;
    align-items: center;
}

.message-content .close {
    border-left: 1px solid #9b9011;
    padding: 1.86667vw 2.93333vw;
}

.success .close {
    border-left-color: #43760a;
}

.error .close {
    border-left-color: #820110;
}

.error .close:before {
    background-image: url('data:image/svg+xml,<svg width="9" height="9" xmlns="http://www.w3.org/2000/svg"><path d="M9 .91L5.41 4.5 9 8.09 8.09 9 4.5 5.41.91 9 0 8.09 3.59 4.5 0 .91.91 0 4.5 3.59 8.09 0z" fill="%23FFF" fill-rule="evenodd"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .message-content .close {
        padding: 1.04948vmax 1.64918vmax;
    }

    .close:before {
        width: 1.34933vmax;
        height: 1.34933vmax;
    }
}

.back_home {
    display: none;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 12;
    width: 100%;
    height: 12vw;
    justify-content: center;
    align-items: center;
}

.back_home h1 {
    background-repeat: no-repeat;
    background-size: contain;
}

.back_home .back-button_home {
    position: absolute;
    width: 6.66667vw;
    height: 6.66667vw;
    top: 2.66667vw;
    left: 1.86667vw;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}

.back_home .back-button_home:after {
    content: "";
    width: 4.53333vw;
    height: 4vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .back_home {
        position: relative;
        height: 6.74663vmax;
    }

    .back_home .back-button_home {
        width: 3.5982vmax;
        height: 3.5982vmax;
        top: 1.49925vmax;
        left: 1.04948vmax;
    }

    .back_home .back-button_home:after {
        width: 2.3988vmax;
        height: 2.3988vmax;
    }
}

/* .promo-banner-wrap {
    position: relative;
    width: 100vw;
    height: 18.66667vw;
}
.promo-banner-wrap.active {
    overflow: hidden;
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .promo-banner-wrap {
        height: 18.5907vmax;
    }
}
.promo-banner-loading {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 18.66667vw;
    background: #000 url('../images/loading.svg') center no-repeat;
    background-size: 10.66667vw;
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .promo-banner-loading {
        background-size: 8.3958vmax;
    }
}
.promo-banner img {
    width: 100%;
    height: 100%;
}
.promo-banner .slides {
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    z-index: 2;
}
.promo-banner .banner {
    display: none;
}
.promo-banner .promo-direction-nav {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
}
.promo-banner .promo-direction-nav li {
    opacity: 0.8;
}
.promo-banner .promo-direction-nav .promo-prev,
.promo-banner .promo-direction-nav .promo-next {
    position: absolute;
    top: 0;
    left: 0;
    width: 6.4vw;
    height: 18.66667vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="rgb(255,255,255)"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g></svg>');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
}
.promo-banner .promo-direction-nav .promo-next {
    left: calc(100vw - 6.4vw);
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="rgb(255,255,255)"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path></g></svg>');
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .promo-banner .promo-direction-nav .promo-nav-prev {
        width: 3.5982vmax;
        height: 10.49475vmax;
    }
    .promo-banner .promo-direction-nav .promo-nav-next {
        left: calc(100vw - 3.5982vmax);
    }
} */
.marquee-box {
    position: sticky;
    position: -webkit-sticky;
    width: 100%;
    top: 14.66667vw;
    z-index: 10;
    color: #fff;
    line-height: 6.66667vw;
    height: 6.66667vw;
    background-repeat: repeat-x;
    background-image: linear-gradient(-180deg, #2f424d 0%, #141e21 100%);
    border-bottom: 1px solid #fff;
}

.marquee-box h4 {
    position: relative;
    flex-basis: 19.2vw;
    justify-content: center;
    align-items: center;
}


/* @keyframes marqueeAnimation-4429646{
    100% {
      transform: translateX(-225px);
    }
    } */
.marquee-box h4:before {
    content: "";
    width: 4.53333vw;
    height: 4.53333vw;
    margin-right: 0.53333vw;
    background-image: url('data:image/svg+xml,<svg width="17" height="17" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,255,255)" fill-rule="nonzero"><path d="M8.5 10.083c1.519 0 2.75-1.195 2.75-2.669V2.67C11.25 1.195 10.019 0 8.5 0S5.75 1.195 5.75 2.67v4.744c0 1.474 1.231 2.67 2.75 2.67zM7.278 2.67c0-.654.548-1.186 1.222-1.186.674 0 1.222.532 1.222 1.186v4.745c0 .654-.548 1.186-1.222 1.186-.674 0-1.222-.532-1.222-1.186V2.67z"/><path d="M14 7.333h-1.447c0 2.36-1.818 4.278-4.053 4.278S4.447 9.692 4.447 7.333H3c0 2.942 2.085 5.374 4.776 5.75v.973h-2.46v1.527h6.368v-1.527h-2.46v-.973c2.69-.376 4.776-2.808 4.776-5.75z"/></g></svg>');
    background-repeat: no-repeat;
    background-size: contain;
}

.marquee-box h4:after {
    content: "";
    position: absolute;
    right: -1.86667vw;
    top: 0;
    z-index: 2;
    width: 2.13333vw;
    height: 6.66667vw;
    background-image: url('../images/sprite/path_arrow.svg');
    background-repeat: no-repeat;
    background-size: contain;
}

.marquee-box .marquee {
    flex: 1;
    overflow: hidden;
    z-index: 1;
}

.marquee-box .marquee a {
    height: 6.66667vw;
    line-height: 6.66667vw;
    align-items: center;
    font-weight: bold;
    color: #6ac2ff;
    margin-right: 21.33333vw;
}

.marquee-box .marquee a span {
    line-height: 4vw;
    height: 4vw;
    font-style: italic;
    font-size: 2.93333vw;
    font-weight: normal;
    color: #1c2834;
    background-color: #6ac2ff;
    border-radius: 0.53333vw;
    padding: 0 1.33333vw;
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .marquee-box {
        position: relative;
        top: 8.24588vmax;
        top: inherit;
        line-height: 3.74813vmax;
        height: 3.74813vmax;
    }

    .marquee-box h4 {
        flex-basis: 10.7946vmax;
    }

    .marquee-box h4:before {
        width: 2.54873vmax;
        height: 2.54873vmax;
        margin-right: 0.29985vmax;
    }

    .marquee-box h4:after {
        width: 1.1994vmax;
        height: 3.74813vmax;
        right: -1.04948vmax;
    }

    .marquee-box .marquee a {
        height: 3.74813vmax;
        line-height: 3.74813vmax;
        margin-right: 11.994vmax;
    }

    .marquee-box .marquee a span {
        font-size: 1.64918vmax;
        height: 2.24888vmax;
        line-height: 2.24888vmax;
        border-radius: 0.29985vmax;
        padding: 0 0.74963vmax;
        margin-right: 0.74963vmax;
    }
}

nav {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-image: linear-gradient(-180deg, #000 20%, #172732 91%);
    color: #fff;
    z-index: 20;
}

nav .select {
    background-image: linear-gradient(-180deg, #7a1bc4 20%, #9f24ff 91%);
}

nav .main-nav {
    position: relative;
}

nav .main-nav:before {
    content: "";
    position: absolute;
    top: -4.26667vw;
    width: 100%;
    height: 4.53333vw;
    background-image: url('data:image/svg+xml,<svg width="75" height="16" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="50%" y1="19.56%" x2="50%" y2="90.65%" id="a"><stop stop-color="%23243A48" offset="0%"/><stop stop-color="%23172732" offset="100%"/></linearGradient></defs><path d="M74.98 16H75v50H0V16h.02C.7 15.33 16.36.02 37.5.02v8-8C58.64.02 74.3 15.33 74.98 16z" fill="rgb(36, 58, 71)" fill-rule="evenodd"/></svg>');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
    z-index: -1;
}

nav .main-nav.select:before {
    background-image: url('data:image/svg+xml,<svg width="75" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="50%" y1="19.56%" x2="50%" y2="90.65%" id="a"><stop stop-color="%23243A48" offset="0%"/><stop stop-color="%23172732" offset="100%"/></linearGradient><path d="M74.98 16H75v50H0V16h.02C.7 15.33 16.36.02 37.5.02v8-8C58.64.02 74.3 15.33 74.98 16z" id="b"/></defs><g fill="none" fill-rule="evenodd"><use fill="rgb(124, 52, 211)" xlink:href="%23b"/><use fill-opacity=".8" fill="%23BEEBFA" style="mix-blend-mode:overlay" xlink:href="%23b"/></g></svg>');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

nav .home-nav.select:before {
    background-image: url('data:image/svg+xml,<svg width="75" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="50%" y1="19.56%" x2="50%" y2="90.65%" id="a"><stop stop-color="%23243A48" offset="0%"/><stop stop-color="%23172732" offset="100%"/></linearGradient><path d="M74.98 16H75v50H0V16h.02C.7 15.33 16.36.02 37.5.02v8-8C58.64.02 74.3 15.33 74.98 16z" id="b"/></defs><g fill="none" fill-rule="evenodd"><use fill="url(%23a)" xlink:href="%23b"/><use fill-opacity=".8" fill="%23BEEBFA" style="mix-blend-mode:overlay" xlink:href="%23b"/></g></svg>');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

nav .home-nav:before {
    content: "";
    position: absolute;
    top: -4.26667vw;
    width: 100%;
    left: 0;
    height: 4.53333vw;
    background-image: url('data:image/svg+xml,<svg width="75" height="16" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="50%" y1="19.56%" x2="50%" y2="90.65%" id="a"><stop stop-color="%23243A48" offset="0%"/><stop stop-color="%23172732" offset="100%"/></linearGradient></defs><path d="M74.98 16H75v50H0V16h.02C.7 15.33 16.36.02 37.5.02v8-8C58.64.02 74.3 15.33 74.98 16z" fill="url(%23a)" fill-rule="evenodd"/></svg>');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
    z-index: -1;
}



nav .main-nav a {
    height: 17.6vw;
    padding-top: 6.13333vw;
    margin-top: -4.26667vw;
}

nav .main-nav .icon-sports {
    width: 8.53333vw;
    height: 6.93333vw;
    margin: -2.13333vw auto 1.06667vw;
}

nav .main-nav .icon-home {
    width: 8.53333vw;
    height: 8vw;
    margin: -2.13333vw auto 0vw;
}

nav a {
    width: 20vw;
    height: 13.33333vw;
    color: #fff;
    font-size: 3.2vw;
    background-size: contain;
    line-height: 1.1;
    padding: 1.86667vw 2.66667vw 0;
}

nav img {
    width: 5.33333vw;
    height: 5.33333vw;
    margin: 0 auto 0.53333vw;
}

nav .icon-home {
    width: 6.66667vw;
}

nav .icon-sports {
    width: 5.86667vw;
    height: 4.8vw;
    margin: 0 auto 0.53333vw;
}

@media (orientation: landscape) {
    nav {
        display: none;
    }
}

.open-tv {
    top: 66.66667vw;
}

.promote .open-tv {
    top: 48vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .open-tv {
        top: 37.48126vmax;
    }

    .promote .open-tv {
        top: 18.89055vmax;
    }
}

.tv-fix {
    position: -webkit-sticky;
    position: sticky;
    top: 14.6vw;
    width: 100%;
    z-index: 10;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tv-fix {
        top: inherit;
    }
}

.tv-wrap {
    background-color: #000;
}

.tv-head {
    background: #1f1f1f linear-gradient(-180deg, #434343 0%, #1f1f1f 92%);
    height: 10.4vw;
    line-height: 10.4vw;
    border-bottom: 0.26667vw solid #343434;
}

.tv-head .close {
    border-width: 0 0.26667vw 0 0;
}

.tv-head .close:before {
    width: 3.2vw;
    height: 3.2vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>');
}

.tv-head .btn-line {
    flex-basis: 12.26667vw;
    border-width: 0 0 0 0.26667vw;
    font-size: 3.2vw;
}

.tv-head .btn-line span {
    padding-top: 2.66667vw;
}

.tv-head .btn-line:before {
    width: 4.8vw;
    height: 3.46667vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14"><path fill="%23FFF" fill-rule="evenodd" d="M3.477 7.67c1.104-1.138 2.394-1.909 3.87-2.312a8.165 8.165 0 0 1 4.326 0c1.477.403 2.76 1.174 3.85 2.312l-1.697 1.815A5.933 5.933 0 0 0 7.948 7.82a5.933 5.933 0 0 0-2.774 1.664L3.477 7.67zm3.436 3.63c.455-.476 1-.8 1.635-.973a3.561 3.561 0 0 1 1.904 0c.635.173 1.18.497 1.635.972L9.5 14l-2.587-2.7zM0 4.082a13.418 13.418 0 0 1 4.45-3.068A13.083 13.083 0 0 1 9.52 0c1.753 0 3.436.338 5.05 1.015A13.198 13.198 0 0 1 19 4.083l-1.739 1.815a10.767 10.767 0 0 0-3.622-2.506A10.498 10.498 0 0 0 9.5 2.549c-1.435 0-2.815.281-4.14.843A10.767 10.767 0 0 0 1.74 5.898L0 4.083z"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tv-head {
        height: 5.84708vmax;
        line-height: 5.84708vmax;
        border-bottom-width: 0.14993vmax;
    }

    .tv-head .close {
        border-left-width: 0.14993vmax;
    }

    .tv-head .close:before {
        width: 1.7991vmax;
        height: 1.7991vmax;
    }

    .tv-head .btn-line {
        flex-basis: 8.3958vmax;
        border-left-width: 0.14993vmax;
        font-size: 1.7991vmax;
    }

    .tv-head .btn-line span {
        padding-top: 1.49925vmax;
    }

    .tv-head .btn-line:before {
        width: 2.69865vmax;
        height: 1.94903vmax;
    }
}

.now-play {
    position: relative;
    flex: 1;
    font-size: 3.46667vw;
    line-height: 10.4vw;
    color: #fff;
    font-weight: bold;
    padding: 0 7.46667vw 0 3.2vw;
}

.now-play:after {
    position: absolute;
    right: 3.2vw;
    top: 4.53333vw;
    content: "";
    border-top: 1.86667vw solid #fff;
    border-left: 1.6vw solid transparent;
    border-right: 1.6vw solid transparent;
}

.now-play span {
    height: 5.6vw;
    line-height: 5.6vw;
    font-size: 3.2vw;
    font-weight: normal;
    background-color: #e83523;
    padding: 0 1.33333vw;
    margin: 2.4vw 1.86667vw 0 0;
    border-radius: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .now-play {
        font-size: 1.94903vmax;
        line-height: 5.84708vmax;
        padding: 0 4.1979vmax 0 1.7991vmax;
    }

    .now-play:after {
        right: 1.7991vmax;
        top: 2.54873vmax;
        border-top: 1.04948vmax solid #fff;
        border-left: 0.89955vmax solid transparent;
        border-right: 0.89955vmax solid transparent;
    }

    .now-play span {
        height: 3.14843vmax;
        line-height: 3.14843vmax;
        font-size: 1.7991vmax;
        padding: 0 0.74963vmax;
        margin: 1.34933vmax 1.04948vmax 0 0;
        border-radius: 0.5997vmax;
    }
}

.tv-box {
    height: 56vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="93" height="85"><path fill="%23FFF" fill-rule="evenodd" d="M10 0h73a10 10 0 0 1 10 10v65a10 10 0 0 1-10 10H10A10 10 0 0 1 0 75V10A10 10 0 0 1 10 0zm2 4a8 8 0 0 0-8 8v53a8 8 0 0 0 8 8h69a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8H12zm20 69v8h28v-8H32zM17 12h58a5 5 0 0 1 5 5v39a5 5 0 0 1-5 5H17a5 5 0 0 1-5-5V17a5 5 0 0 1 5-5zm47 25.1L36 21v32l28-15.9z" opacity=".21"/></svg>') no-repeat center center;
    background-size: 24.8vw 22.66667vw;
}

.tv-box:after {
    position: absolute;
    bottom: 0;
    content: "";
    width: 100%;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tv-box {
        height: 31.48426vmax;
        background-size: 13.94303vmax 12.74363vmax;
    }

    .tv-box:after {
        height: 0.14993vmax;
    }
}

.tv {
    position: relative;
    width: 100vw;
    height: 56vw;
    margin: 0 auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tv {
        width: 56.22189vmax;
        height: 31.48426vmax;
    }
}

.tv video {
    width: 100%;
    height: 100%;
    background-color: #222;
}

.tv-control {
    position: absolute;
    width: auto;
    border-radius: 1.6vw;
    border: 1px solid rgba(255, 255, 255, 0.3);
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2;
    margin: 1.86667vw;
}

.tv-control li {
    list-style: none;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.tv-control li:last-of-type {
    border-right-width: 0;
}

.tv-control a {
    width: 13.33333vw;
    height: 9.33333vw;
    color: #c8c7c7;
}

.tv-control a:before {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;
}

.tv-control .close:before {
    width: 2.73333vw;
    height: 2.73333vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(207,209,206)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>');
}

.tv-control:nth-of-type(1) {
    top: 0;
    right: 0;
    z-index: 111;
}

.tv-control:nth-of-type(2) {
    bottom: 0;
    left: 0;
}

.tv-control:nth-of-type(3) {
    bottom: 0;
    right: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tv-control {
        border-radius: 0.89955vmax;
        margin: 1.04948vmax;
    }

    .tv-control a {
        width: 7.49625vmax;
        height: 5.24738vmax;
    }

    .tv-control .close:before {
        width: 2.09895vmax;
        height: 2.09895vmax;
    }
}

.btn-line span {
    padding-top: 2.66667vw;
}

.btn-line:before {
    width: 4.8vw;
    height: 3.73333vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14"><path fill="rgb(207,209,206)" fill-rule="evenodd" d="M3.477 7.67c1.104-1.138 2.394-1.909 3.87-2.312a8.165 8.165 0 0 1 4.326 0c1.477.403 2.76 1.174 3.85 2.312l-1.697 1.815A5.933 5.933 0 0 0 7.948 7.82a5.933 5.933 0 0 0-2.774 1.664L3.477 7.67zm3.436 3.63c.455-.476 1-.8 1.635-.973a3.561 3.561 0 0 1 1.904 0c.635.173 1.18.497 1.635.972L9.5 14l-2.587-2.7zM0 4.082a13.418 13.418 0 0 1 4.45-3.068A13.083 13.083 0 0 1 9.52 0c1.753 0 3.436.338 5.05 1.015A13.198 13.198 0 0 1 19 4.083l-1.739 1.815a10.767 10.767 0 0 0-3.622-2.506A10.498 10.498 0 0 0 9.5 2.549c-1.435 0-2.815.281-4.14.843A10.767 10.767 0 0 0 1.74 5.898L0 4.083z"/></svg>');
}

.tv-control .btn-line {
    font-size: 3.2vw;
    text-indent: inherit;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-line span {
        padding-top: 1.49925vmax;
    }

    .btn-line:before {
        width: 2.69865vmax;
        height: 2.09895vmax;
    }

    .tv-control .btn-line {
        font-size: 1.7991vmax;
    }
}

.btn-volume_on:before {
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M10.8 0a8.89 8.89 0 013.699 1.75 9.204 9.204 0 012.56 3.157A9.199 9.199 0 0118 9a9.199 9.199 0 01-.94 4.093 9.204 9.204 0 01-2.561 3.156A8.89 8.89 0 0110.8 18v-2.12a6.805 6.805 0 002.647-1.43 7.164 7.164 0 001.819-2.43A7.11 7.11 0 0015.922 9a7.11 7.11 0 00-.656-3.02 7.164 7.164 0 00-1.819-2.43A6.805 6.805 0 0010.8 2.12V0zm2.7 9c0 .93-.242 1.772-.727 2.525a4.804 4.804 0 01-1.973 1.738V4.737c.83.406 1.488.985 1.973 1.738.485.753.727 1.595.727 2.525zM0 5.986h3.984L9 .947v16.106l-5.016-5.04H0V5.987z" fill="rgb(200,199,199)" fill-rule="evenodd"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-volume_on:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.btn-volume_off:before {
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M8.526.947v3.79L6.632 2.842 8.526.947zM1.272 0L18 16.728 16.728 18l-2.064-2.064c-1.2.928-2.416 1.536-3.648 1.824v-2.064a6.364 6.364 0 002.256-1.176L9 10.272v6.744L3.984 12H0V6h4.728L0 1.272 1.272 0zm14.814 8.982a7.598 7.598 0 00-.604-3.015 7.131 7.131 0 00-1.675-2.424 6.136 6.136 0 00-2.439-1.427V0a7.932 7.932 0 013.407 1.747 9.083 9.083 0 012.359 3.15A9.818 9.818 0 0118 8.982c0 .754-.084 1.496-.25 2.226a9.171 9.171 0 01-.73 2.055l-1.413-1.6c.32-.869.479-1.763.479-2.681zm-2.823-.122c0 .295-.018.5-.054.614l-2.788-2.48V4.738c.875.393 1.567.953 2.077 1.681.51.728.765 1.542.765 2.442z" fill="rgb(200,199,199)" fill-rule="evenodd"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-volume_off:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.btn-fullscreen:before {
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M18 6.402V0h-6.402v2.536h3.866v3.866H18zm-15.464 0V2.536h3.866V0H0v6.402h2.536zM18 18v-6.402h-2.536v3.866h-3.866V18H18zM6.402 18v-2.536H2.536v-3.866H0V18h6.402z" fill="rgb(200,199,199)" fill-rule="nonzero"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-fullscreen:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.btn-collapse:before {
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M18 6.402V3.866h-3.866V0h-2.536v6.402H18zm-11.598 0V0H3.866v3.866H0v2.536h6.402zM14.134 18v-3.866H18v-2.536h-6.402V18h2.536zm-7.732 0v-6.402H0v2.536h3.866V18h2.536z" fill="rgb(200,199,199)" fill-rule="nonzero"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-collapse:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.overlay.channel-popup {
    top: 32.26667vw;
    height: calc(100% - vw('$ht-head + $ht-marquee'));
}

@media (orientation: landscape) {
    .overlay.channel-popup {
        position: absolute;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .overlay.channel-popup {
        top: 18.14093vmax;
        height: calc(100% - 8.24588vmax - 5.84708vmax);
    }
}

.overlay.channel-popup:not(:target) {
    display: none;
}

.overlay.channel-popup:target {
    display: block;
}

.channel-list {
    max-height: 73%;
    background-color: #fff;
    box-shadow: 0 1.6vw 2.66667vw rgba(0, 0, 0, 0.7);
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.channel-list dt {
    background-color: #e0e6e6;
    line-height: 6.66667vw;
    color: #000;
    font-size: 3.2vw;
    font-weight: bold;
    border-bottom: 0.26667vw solid #9eb0bb;
    padding: 0 1.86667vw;
}

.channel-list dt img {
    width: 3.2vw;
    height: 3.2vw;
    margin: 1.6vw 1.33333vw 0 0;
    vertical-align: top;
}

.channel-list dd {
    font-size: 3.73333vw;
    border-bottom: 0.26667vw solid #c5d0d7;
}

.channel-list dd:last-of-type {
    border-bottom-width: 0;
}

.channel-list a {
    position: relative;
    line-height: 10.66667vw;
    font-weight: bold;
    padding: 0 8vw 0 1.86667vw;
}

.channel-list a:after {
    position: absolute;
    top: 50%;
    right: 2.66667vw;
    content: "";
    width: 4.26667vw;
    height: 4.26667vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="%232789CE" d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm3.884-6.84L5.28 11.964c-.155.087-.279.01-.279-.17V4.206c0-.18.124-.257.279-.17l6.605 3.804c.155.088.155.232 0 .32z"/></svg>');
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: -2.13333vw;
}

.channel-list a.select {
    background-color: #ecdab7;
    color: #1e1e1e;
}

.channel-list a.select:after {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="%231F72AC" fill-rule="evenodd" d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.884-7.84c.155-.088.155-.232 0-.32L5.28 4.036C5.124 3.95 5 4.026 5 4.206v7.588c0 .18.124.257.279.17l6.605-3.804z"/></svg>');
}

.channel-list .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(59,91,96)" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>') no-repeat;
}

.channel-list .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(59,91,96)" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>') no-repeat;
}

.channel-list .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(59,91,96)" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>') no-repeat;
}

.channel-list .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(59,91,96)" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.channel-list .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="rgb(59,91,96)" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.channel-list .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(59,91,96)" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.channel-list .icon-racing {
    background: url('data:image/svg+xml,<svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m104.031307 120.690196c-3.529412-1.552941-5.9999818 0-5.9999818 0v5.647059 5.983852h.7058823v-2.101481c.9882353-.352922 2.8941365-.705882 5.2941365.352923 3.529411 1.552941 5.999981 0 5.999981 0v-9.882353c-.000037 0-2.470607 1.552941-6.000018 0zm5.294099 3.882371c0-.070606-1.482335.564706-3.529412.211747v2.823529c.494136.070607.988235.141177 1.341195.141177 1.341158 0 2.188217-.42353 2.188217-.42353v2.82353s-1.270588.635275-3.247059.352922c-.141176 0-.352923-.070606-.282353-.070606v-2.82353c-.564706-.07057-1.200018-.282353-1.835294-.564706-.635313-.282353-1.200018-.423529-1.694118-.564706v2.82353c.070607 0-.070606 0-.282353 0-1.835294-.282353-3.2470584.141176-3.2470584.141176v-2.823529s1.5529414-.494099 3.5294114-.141177v-2.823529c-2.117647-.423529-3.5294114.282353-3.5294114.282353v-2.823529s1.4117644-.705883 3.5294114-.282353v2.823529c.564706.07057 1.129412.282353 1.764688.564706.635312.282353 1.200018.494136 1.764687.564706v-2.82353c2.047077.352923 3.529412-.211746 3.529412-.211746v2.823566z" fill="rgb(59,91,96)" transform="translate(-98 -120)"/></svg>') no-repeat;
}

.channel-list .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="rgb(59,91,96)" fill-rule="nonzero"/></svg>') no-repeat;
}

@media (orientation: landscape) {
    .channel-list {
        height: auto;
        max-height: inherit;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .channel-list {
        height: auto;
        max-height: inherit;
        box-shadow: 0 0.89955vmax 1.49925vmax rgba(0, 0, 0, 0.5);
    }

    .channel-list dt {
        line-height: 3.74813vmax;
        font-size: 1.7991vmax;
        border-bottom-width: 0.14993vmax;
        padding: 0 1.04948vmax;
    }

    .channel-list dt img {
        width: 1.7991vmax;
        height: 1.7991vmax;
        margin: 0.89955vmax 0.74963vmax 0 0;
    }

    .channel-list dd {
        font-size: 2.09895vmax;
        border-bottom-width: 0.14993vmax;
    }

    .channel-list a {
        line-height: 5.997vmax;
        padding: 0 4.49775vmax 0 1.04948vmax;
    }

    .channel-list a:after {
        right: 1.49925vmax;
        width: 2.3988vmax;
        height: 2.3988vmax;
        margin-top: -1.1994vmax;
    }
}

.mob-nav-highlight {
    position: relative;
    height: 12.26667vw;
    background-color: #1e1e1e;
    border-bottom: 0.7vw solid #ffa40c;
    overflow: hidden;
    overflow-x: auto
}

.mob-nav-highlight ul {
    position: absolute;
    white-space: nowrap;
    padding-right: 1.86667vw;
    bottom: 0;
}

.mob-nav-highlight li {
    position: relative;
    padding-top: 2.66667vw;
    margin-left: 1.86667vw;
}

.mob-nav-highlight a {
    font-weight: bold;
    color: #000;
    background-size: contain;
    line-height: 9.6vw;
    padding: 0 1.86667vw;
    border-radius: 1.6vw 1.6vw 0 0;
}

.mob-nav-highlight .select a {
    /* background-image: linear-gradient(-180deg, #000 15%, #000 100%); */
    color: #1e1e1e;
}

.mob-nav-highlight img {
    width: 5.33333vw;
    height: 5.33333vw;
    margin: 2.13333vw 1.6vw 0 0;
}

.mob-nav-highlight .menu-casino a {
    background-image: linear-gradient(-180deg, #3b4cf5 15%, #8e0424 100%) !important;
    color: #ffffff;
}

.mob-nav-highlight .menu-casino a:after {
    position: relative;
    top: 3.73333vw;
    left: 1.06667vw;
    width: 2.66667vw;
    height: 2.66667vw;
    margin-right: 1.06667vw;
    background: url('data:image/svg+xml,<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M8.889 8.889h-7.778v-7.778h2.889v-1.111h-2.889c-.617 0-1.111.5-1.111 1.111v7.778c0 .611.494 1.111 1.111 1.111h7.778c.611 0 1.111-.5 1.111-1.111v-2.889h-1.111v2.889zm-2.778-8.889v1.111h1.994l-5.461 5.461.783.783 5.461-5.461v1.994h1.111v-3.889h-3.889z" fill="%23CFBCC7" fill-rule="nonzero"/></svg>') no-repeat;
    background-size: cover;
}

.mob-nav-highlight .tag-new {
    top: 0.53333vw;
    right: 2.13333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-nav-highlight {
        height: 6.89655vmax;
        border-bottom-width: 0.4vmax;
    }

    .mob-nav-highlight ul {
        padding-right: 1.04948vmax;
    }

    .mob-nav-highlight li {
        padding-top: 1.49925vmax;
        margin-left: 1.04948vmax;
    }

    .mob-nav-highlight a {
        line-height: 5.3973vmax;
        padding: 0 1.04948vmax;
        border-radius: 0.89955vmax 0.89955vmax 0 0;
    }

    .mob-nav-highlight img {
        width: 2.9985vmax;
        height: 2.9985vmax;
        margin: 1.1994vmax 0.89955vmax 0 0;
    }

    .mob-nav-highlight .menu-casino a:after {
        top: 2.09895vmax;
        left: 0.5997vmax;
        width: 1.49925vmax;
        height: 1.49925vmax;
        margin-right: 0.5997vmax;
    }

    .mob-nav-highlight .tag-new {
        top: 0.29985vmax;
        right: 1.1994vmax;
    }
}

.tag-new {
    position: absolute;
    width: 8.53333vw;
    height: 4.8vw;
    background: url('data:image/svg+xml,<svg width="32" height="16" viewBox="0 0 32 16" xmlns="http://www.w3.org/2000/svg"><path d="M20 12l-7 4 1-4h-11c-1.657 0-3-1.343-3-3v-6c0-1.657 1.343-3 3-3h26c1.657 0 3 1.343 3 3v6c0 1.657-1.343 3-3 3h-9z" fill="%23D0021B"/></svg>') center no-repeat;
    background-size: contain;
    color: #ffffff;
    line-height: 4vw;
    font-size: 2.4vw;
    font-weight: bold;
    text-align: center;
    -webkit-filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
    filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
    z-index: 2;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tag-new {
        width: 4.7976vmax;
        height: 2.69865vmax;
        line-height: 2.24888vmax;
        font-size: 1.34933vmax;
    }
}

.mob-live-number {
  position: absolute;
    top: -2.93333vw;
    right: -1.66667vw;
    min-width: 9.33333vw;
    height: 3.2vw;
    border-radius: 0.8vw;
    padding-right: 1.33333vw;
    color: #ffffff;
    text-align: center;
    font-size: 2.66667vw;
    line-height: 3.2vw;
    background-image: linear-gradient(180deg, #fb3434 0%, #e80505 100%);
    box-shadow: 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
}

.mob-live-number strong {
    flex: 1;
    height: 100%;
    margin-right: 1.33333vw;
    padding: 0 0.53333vw;
    border-radius: 0.8vw 0vw 0vw 0.8vw;
    background-image: linear-gradient(180deg, #fff 0%, #eee 89%);
}

.mob-live-number strong:before {
    width: 3.73333vw;
    height: 2.13333vw;
    background: url('data:image/svg+xml,<svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,0,0)" fill-rule="evenodd"><path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z"/><circle cx="6.8" cy="4.4" r="1.6"/></g></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-live-number {
        top: 0.5997vmax;
        right: 0.74963vmax;
        min-width: 4.7976vmax;
        height: 1.7991vmax;
        border-radius: 0.44978vmax;
        padding-right: 0.74963vmax;
        font-size: 1.49925vmax;
        line-height: 1.7991vmax;
        box-shadow: 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
    }

    .mob-live-number strong {
        margin-right: 0.74963vmax;
        padding: 0 0.29985vmax;
        width: 2.69865vmax;
        border-radius: 0.44978vmax 0vmax 0vmax 0.44978vmax;
    }

    .mob-live-number strong:before {
        width: 2.09895vmax;
        height: 1.1994vmax;
    }
}

.a-tab_next,
.a-tab_prev {
    position: absolute;
    right: 0;
    width: 8vw;
    height: 12.26667vw;
    background-image: linear-gradient(90deg, transparent 0%, #000 39%);
    padding: 0;
    z-index: 2;
}

.mob-nav-highlight .a-tab_next,
.mob-nav-highlight .a-tab_prev {
    padding: 0;
    border-radius: 0;
}

.a-tab_next:after,
.a-tab_prev:after {
    content: "";
    position: absolute;
    width: 2.66667vw;
    height: 4.26667vw;
    background: url('data:image/svg+xml,<svg width="10" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M1.9 0L10 8l-8.1 8L0 14.11 6.21 8 0 1.89z" fill="%23FFF" fill-rule="evenodd"/></svg>') no-repeat;
    background-size: contain;
    margin-top: -57%;
    margin-left: 40%;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .a-tab_next,
    .a-tab_prev {
        width: 4.49775vmax;
        height: 6.89655vmax;
    }

    .a-tab_next:after,
    .a-tab_prev:after {
        width: 1.49925vmax;
        height: 2.3988vmax;
    }
}

.a-tab_prev {
    left: 0;
    background-image: linear-gradient(-90deg, transparent 0%, #000 39%);
}

.a-tab_prev:after {
    transform: rotate(180deg);
}

/*.mob-sports-highlight-list,*/
/*.inplay-list {*/
/*    border-bottom: 0.8vw solid #ffa40c;*/
/*}*/

.mob-sports-highlight-list a,
.inplay-list a {
    padding: 1.6vw 0 1.86667vw 6.66667vw;
}

.mob-sports-highlight-list a:after,
.inplay-list a:after {
    display: none;
}

.mob-sports-highlight-list dt,
.inplay-list dt {
    line-height: 4vw;
}

.mob-sports-highlight-list .inplay-on a:before,
.inplay-list .inplay-on a:before,
.mob-sports-highlight-list .inplay-off a:before,
.inplay-list .inplay-off a:before {
    position: absolute;
    top: 50%;
    left: 2.66667vw;
    margin-top: 0.26667vw;
}

.mob-sports-highlight-list .inplay-on .time,
.inplay-list .inplay-on .time,
.mob-sports-highlight-list .inplay-off .time,
.inplay-list .inplay-off .time {
    font-weight: normal;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .mob-sports-highlight-list,
    .inplay-list {
        border-bottom-width: 0.44978vmax;
    }

    .mob-sports-highlight-list a,
    .inplay-list a {
        padding: 0.89955vmax 0 1.04948vmax 3.74813vmax;
    }

    .mob-sports-highlight-list .inplay-on a:before,
    .inplay-list .inplay-on a:before,
    .mob-sports-highlight-list .inplay-off a:before,
    .inplay-list .inplay-off a:before {
        left: 1.49925vmax;
        margin-top: 0.14993vmax;
    }
}

.pin-on,
.pin-off {
    width: 6.66667vw;
    height: 6.66667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(107,189,17)"/><path fill="rgb(255,255,255)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>') no-repeat;
    background-size: contain;
    margin-right: 1.86667vw;
}

.mob-sports-highlight-list .inplay-on .pin-on,
.inplay-list .inplay-on .pin-on,
.mob-sports-highlight-list .inplay-on .pin-off,
.inplay-list .inplay-on .pin-off,
.mob-sports-highlight-list .inplay-off .pin-on,
.inplay-list .inplay-off .pin-on,
.mob-sports-highlight-list .inplay-off .pin-off,
.inplay-list .inplay-off .pin-off {
    flex: 0 1 6.66667vw;
    padding: 0;
}

.mob-sports-highlight-list .inplay-on .pin-on:before,
.inplay-list .inplay-on .pin-on:before,
.mob-sports-highlight-list .inplay-on .pin-off:before,
.inplay-list .inplay-on .pin-off:before,
.mob-sports-highlight-list .inplay-off .pin-on:before,
.inplay-list .inplay-off .pin-on:before,
.mob-sports-highlight-list .inplay-off .pin-off:before,
.inplay-list .inplay-off .pin-off:before {
    display: none;
}

.game-team .pin-on,
.game-team .pin-off {
    position: absolute;
    left: 1.86667vw;
}

.fancy_bet-head .pin-on,
.sportsbook_bet-head .pin-on,
.fancy_bet-head .pin-off,
.sportsbook_bet-head .pin-off {
    position: relative;
    width: 10.66667vw;
    height: 8vw;
    margin-right: 0;
    background: url('../images/sprite/bg-fanctbet_pin.svg'), linear-gradient(-180deg, #0a92a5 0%, #087989 82%);
    background-repeat: no-repeat, no-repeat;
    background-position: left, right;
    background-size: cover, cover;
}

.fancy_bet-head .pin-on:before,
.sportsbook_bet-head .pin-on:before,
.fancy_bet-head .pin-off:before,
.sportsbook_bet-head .pin-off:before {
    position: absolute;
    left: 1.6vw;
    top: 1.06667vw;
    display: block;
    width: 5.86667vw;
    height: 5.86667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(107,189,17)"/><path fill="rgb(255,255,255)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>') no-repeat;
    background-size: cover;
    content: "";
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .pin-on,
    .pin-off {
        width: 3.74813vmax;
        height: 3.74813vmax;
        margin-right: 1.04948vmax;
    }

    .mob-sports-highlight-list .inplay-on .pin-on,
    .inplay-list .inplay-on .pin-on,
    .mob-sports-highlight-list .inplay-on .pin-off,
    .inplay-list .inplay-on .pin-off,
    .mob-sports-highlight-list .inplay-off .pin-on,
    .inplay-list .inplay-off .pin-on,
    .mob-sports-highlight-list .inplay-off .pin-off,
    .inplay-list .inplay-off .pin-off {
        flex: 0 1 3.74813vmax;
    }

    .game-team .pin-on,
    .game-team .pin-off {
        left: 1.04948vmax;
    }

    .fancy_bet-head .pin-on,
    .sportsbook_bet-head .pin-on,
    .fancy_bet-head .pin-off,
    .sportsbook_bet-head .pin-off {
        width: 5.997vmax;
        height: 4.49775vmax;
    }

    .fancy_bet-head .pin-on:before,
    .sportsbook_bet-head .pin-on:before,
    .fancy_bet-head .pin-off:before,
    .sportsbook_bet-head .pin-off:before {
        left: 0.89955vmax;
        top: 0.5997vmax;
        width: 3.29835vmax;
        height: 3.29835vmax;
    }
}

.pin-off {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(126,151,167)" d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></svg>') no-repeat;
    background-size: contain;
}

.game-team .pin-off {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(59,81,96)"/><path fill="rgb(197,208,215)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>');
}

.fancy_bet-head .pin-off:before,
.sportsbook_bet-head .pin-off:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(59, 81, 96)"/><path fill="rgb(197,208,215)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>') no-repeat center;
    background-size: cover;
}

.sports-book .pin-off {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(3,34,55)"/><path fill="rgb(197,208,215)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>');
}

.game-low_liq {
    background-color: #d0021b;
}

.upcoming-list a {
    padding: 1.6vw 2.66667vw 1.86667vw;
}

.upcoming-list a:before {
    display: none;
}

.upcoming-list a:after {
    display: none;
}

.upcoming-list .upcoming-list-col3 {
    display: block;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .upcoming-list a {
        padding: 0.89955vmax 1.49925vmax 1.04948vmax;
    }
}

.upcoming-list-col3 h4 {
    background-color: #c5d0d8;
    font-size: 3.73333vw;
    color: #000;
    line-height: 8.53333vw;
    font-weight: normal;
}

.upcoming-list-col3 ul {
    align-items: stretch;
}

.upcoming-list-col3 li {
    flex: 1;
    align-items: flex-start;
    border-bottom-width: 0;
    border-right: 1px solid #e0e6e6;
}

.upcoming-list-col3 a {
    line-height: 1.2;
    padding: 1.33333vw 1.86667vw;
    white-space: normal;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .upcoming-list-col3 h4 {
        font-size: 2.09895vmax;
        line-height: 4.7976vmax;
    }

    .upcoming-list-col3 a {
        padding: 0.74963vmax 1.04948vmax;
    }
}

.betsbuzz365 .mob-inform-link a,
.skyinplay .mob-inform-link a,
.betsbuzz365 .mob-inform-link a,
.probetx .mob-inform-link a,
.cftbet365 .mob-inform-link a,
.crickzoom .mob-inform-link a,
.crickzoomlive .mob-inform-link a,
.probet247 .mob-inform-link a,
.goexchange .mob-inform-link a,
.wickets247 .mob-inform-link a,
.iceEX .mob-inform-link a,
.sportsexchlive .mob-inform-link a {
    color: rgba(0, 0, 0, 0.7);
}

.game-fancy {
    background-color: #0a92a5;
}

.game-fancy:after {
    background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.44 21.32l1.792-8.456h5.628l.504-2.408h-5.628l1.288-6.02h7.252L20.78 2H10.112c-.896 0-1.68.275-2.352.826-.672.55-1.11 1.283-1.316 2.198L3 21.32h6.44z" fill="%23C5F6EE" fill-rule="nonzero"/></svg>');

}

.game-sportsbook {
    background-color: #e4550f;
}

.game-sportsbook:after {
    background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.297 21l1.26-5.635 7.255.026c.876 0 1.642-.256 2.3-.77.656-.512 1.085-1.195 1.286-2.047l1.506-6.757c.2-.852.087-1.534-.342-2.047-.43-.513-1.09-.77-1.985-.77H5.997L2 21h6.297zm5.695-7.878h-3.943l1.752-7.852h3.943l-1.752 7.852z" fill="%23FCEDC0" fill-rule="nonzero"/></svg>');

}

.game-bookmaker {
    background-color: #226bc3;
}

.game-bookmaker:after {
    background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.58 21c.876 0 1.642-.257 2.3-.77.656-.513 1.085-1.195 1.286-2.047l.986-4.487c.091-.348.05-.679-.123-.992A1.722 1.722 0 0019.33 12c.365-.14.699-.365 1-.678.3-.313.497-.644.588-.992l.986-4.513c.2-.852.087-1.534-.342-2.047-.43-.513-1.09-.77-1.985-.77H5.997L2 21h13.58zm-1.096-10.122h-3.942l1.26-5.608h3.942l-1.26 5.608zm-1.752 7.879H8.79l1.26-5.635h3.942l-1.26 5.635z" fill="%23CAFCFF" fill-rule="nonzero"/></svg>');
}

.game-live {
    width: 4.53333vw;
    background-color: #1876b2;
}

.game-live:after {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g fill="none" fill-rule="evenodd"><circle cx="6" cy="6" r="6" fill="%234AA2DB"/><path fill="%23FFF" d="M6 0a6 6 0 110 12A6 6 0 016 0zm0 1a5 5 0 100 10A5 5 0 006 1z" opacity=".605"/><path fill="%23FFF" d="M4 3v6l5-3z"/></g></svg>');
    background-repeat: no-repeat;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-live {
        width: 2.54873vmax;
    }
}

.game-E {
    display: inline-flex;
    right: 0;
    height: 4vw;
    background-color: #fff;
    line-height: 4vw;
    font-size: 2.4vw;
    color: #1f5172;
    border-radius: 0.8vw;
    border: 1px solid #1f5172;
    margin-left: auto;
    margin-right: 1.33333vw;
    padding-right: 1.06667vw;
    overflow: hidden;
}

.game-E i {
    position: relative;
    width: 4.8vw;
    height: 100%;
    background-color: #1f5172;
    margin-right: 0.53333vw;
    overflow: hidden;
    align-items: center;
    justify-content: center;
}

.game-E i:before {
    content: "";
    width: 1.86667vw;
    height: 2.13333vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 15"><path fill="%23fff" d="M13 15v-4.768h-2.827v2.22H5.605V8.52h3.688V5.992H5.605V2.548h4.568v2.2H13V0H0v2.548h1.78v9.904H0V15z"/></svg>');
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: -0.8vw;
}

.game-E i:after {
    position: absolute;
    right: 0;
    content: "";
    border-left: 1.33333vw solid transparent;
    border-bottom: 3.73333vw solid #fff;
}

.mob-sports-highlight-list .inplay-on .game-E,
.inplay-list .inplay-on .game-E {
    color: #1f5172;
}

h4.game-info .game-E {
    height: 4.53333vw;
    line-height: 4.53333vw;
    border-color: rgba(255, 255, 255, 0.8);
    background-color: #1f5172;
    color: rgba(255, 255, 255, 0.8);
    font-weight: bold;
    margin-right: 0;
}

h4.game-info .game-E i {
    background-color: rgba(255, 255, 255, 0.8);
}

h4.game-info .game-E i:before {
    width: 2.4vw;
    height: 2.66667vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 15"><path fill="%231F5172" d="M13 15v-4.768h-2.827v2.22H5.605V8.52h3.688V5.992H5.605V2.548h4.568v2.2H13V0H0v2.548h1.78v9.904H0V15z"/></svg>');
}

h4.game-info .game-E i:after {
    border-bottom: 4.53333vw solid #1f5172;
}

.multi .game-E {
    display: inline-flex;
    border-color: rgba(255, 255, 255, 0.8);
    background-color: #1f5172;
    color: rgba(255, 255, 255, 0.8);
}

.multi .game-E i {
    background-color: rgba(255, 255, 255, 0.8);
}

.multi .game-E i:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 15"><path fill="%231F5172" d="M13 15v-4.768h-2.827v2.22H5.605V8.52h3.688V5.992H5.605V2.548h4.568v2.2H13V0H0v2.548h1.78v9.904H0V15z"/></svg>');
}

.multi .game-E i:after {
    border-bottom-color: #1f5172;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-E {
        height: 2.24888vmax;
        line-height: 2.24888vmax;
        font-size: 1.34933vmax;
        border-radius: 0.5997vmax;
        margin-right: 0.74963vmax;
        padding-right: 0.5997vmax;
    }

    .game-E i {
        width: 2.69865vmax;
        margin-right: 0.29985vmax;
    }

    .game-E i:before {
        width: 1.04948vmax;
        height: 1.1994vmax;
        margin-left: -0.44978vmax;
    }

    .game-E i:after {
        border-left: 0.74963vmax solid transparent;
        border-bottom: 2.09895vmax solid #fff;
    }

    h4.game-info .game-E {
        height: 2.69865vmax;
        line-height: 2.69865vmax;
    }

    h4.game-info .game-E i:before {
        width: 1.1994vmax;
        height: 1.34933vmax;
    }

    h4.game-info .game-E i:after {
        border-bottom: 2.54873vmax solid #1f5172;
    }
}

.tab-wrap {
    background-color: #172832;
    color: #fff;
    font-size: 3.73333vw;
    line-height: 8.8vw;
    font-weight: bold;

}

.tab-wrap ul {
    border: 1px solid #fff;
    border-radius: 1.6vw;
    -webkit-box-flex: 1;
    flex: 1;
    margin: 1.6vw 1.8666666667vw;
}

.tab-wrap li {
    flex: 1;
    border-right: 1px solid #fff;
}

.tab-wrap li:first-of-type {
    border-radius: 1.33333vw 0 0 1.33333vw;
}

.tab-wrap li:last-of-type {
    border-right-width: 0;
    border-radius: 0 1.33333vw 1.33333vw 0;
}

.tab-wrap li.select {
    background-color: #fff;
}

.tab-wrap li.select a {
    color: #172832;
}

.tab-wrap a {
    color: #fff;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .tab-wrap {
        font-size: 2.09895vmax;
        line-height: 4.94753vmax;
        padding: 1.04948vmax;
    }

    .tab-wrap ul {
        border-radius: 0.89955vmax;
    }

    .tab-wrap li:first-of-type {
        border-radius: 0.74963vmax 0 0 0.74963vmax;
    }

    .tab-wrap li:last-of-type {
        border-radius: 0 0.74963vmax 0.74963vmax 0;
    }
}

.inplay-list {
    border-bottom: 1px solid #7e97a7;
}

.quick_link {
    background-color: #1e1e1e;
    flex-wrap: wrap;
}

.quick_link li {
    flex: 0 1 20%;
    border: 1px solid #4b4b4b;
    border-width: 0 1px 1px 0;
}

.quick_link li:nth-of-type(5n) {
    border-right-width: 0;
}

.quick_link a {
    height: 20.8vw;
    color: #fff;
    font-size: 3.2vw;
    line-height: 1.1;
    padding: 2.93333vw 1.33333vw;
    flex-direction: column;
}

.quick_link img {
    width: 6.66667vw;
    height: 6.66667vw;
    margin: 0 auto 0.8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .quick_link a {
        height: 11.69415vmax;
        font-size: 1.7991vmax;
        padding: 1.64918vmax 0.74963vmax;
    }

    .quick_link img {
        width: 3.74813vmax;
        height: 3.74813vmax;
        margin: 0 auto 0.44978vmax;
    }
}

.sports-side-menu-list a {
    align-items: center;
}

.side-content .sports-side-menu-list a p {
    flex: 1;
}

.side-content .sports-side-menu-list a span {
    font-weight: normal;
}

.side-content .sports-side-menu-list a span.slip-note {
    display: inline-block;
    width: 2.66667vw;
    height: 2.66667vw;
    background-color: #bb1c00;
    background-image: none;
    border: 1px solid rgba(51, 51, 51, 0.4);
    margin: 0 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .side-content .sports-side-menu-list a span.slip-note {
        width: 1.49925vmax;
        height: 1.49925vmax;
    }
}

.path-wrap {
    background-color: #1e1e1e;
    color: #fff;
    font-weight: bold;
    line-height: 10.66667vw;
}

.path-wrap ul {
    display: inline;
    flex: 1;
    padding-left: 1.86667vw;
    padding-right: 1.06667vw;
}

.path-wrap li {
    position: relative;
    margin-right: 1.86667vw;
    padding-right: 3.46667vw;
}

.path-wrap li:after {
    position: absolute;
    top: 50%;
    right: 0;
    content: "";
    width: 1.6vw;
    height: 2.66667vw;
    background: url('data:image/svg+xml,<svg width="6" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M1.15 0L6 5l-4.85 5L0 8.82 3.73 5 0 1.18z" fill="%23FFF" fill-rule="evenodd" opacity=".5"/></svg>') no-repeat;
    background-size: contain;
    margin-top: -1.33333vw;
}

.path-wrap li:last-child {
    margin-right: 0;
    padding-right: 0;
}

.path-wrap li:last-child:after {
    display: none;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .path-wrap {
        line-height: 5.997vmax;
    }

    .path-wrap ul {
        padding-left: 1.04948vmax;
        padding-right: 0.5997vmax;
    }

    .path-wrap li {
        margin-right: 1.04948vmax;
        padding-right: 1.94903vmax;
    }

    .path-wrap li:after {
        width: 0.89955vmax;
        height: 1.49925vmax;
        margin-top: -0.74963vmax;
    }
}

.go_back {
    width: 10.66667vw;
    height: 10.66667vw;
    background: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M15 20l9-6v12z" fill="%23FFF" fill-rule="evenodd"/></svg>') no-repeat;
    background-size: contain;
    border-right: 1px solid #4b4b4b;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .go_back {
        width: 5.997vmax;
        height: 5.997vmax;
    }
}

.account-id {
    width: 100%;
    padding-left: 1.86667vw;
    align-items: center;
}

.account-id:before {
    content: "";
    width: 5.33333vw;
    height: 5.33333vw;
    margin-right: 1.33333vw;
    background-size: contain;
}

.account-id span {
    flex: 1;
}

.account-id .time-zone {
    flex: 0 0 auto;
    min-width: 17.33333vw;
    border-left: 1px solid #4b4b4b;
    padding: 0 1.86667vw;
    margin-left: 1.86667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .account-id {
        padding-left: 1.04948vmax;
    }

    .account-id:before {
        width: 2.9985vmax;
        height: 2.9985vmax;
        margin-right: 0.74963vmax;
    }

    .account-id .time-zone {
        min-width: 9.74513vmax;
        padding: 0 1.04948vmax;
        margin-left: 1.04948vmax;
    }
}

.game-wrap {
    background-color: #172832;
    color: #1e1e1e;
}

.game-info {
    background-color: #000;
    background-image: linear-gradient(-180deg, #2e4b5e 0%, #243a48 82%);
    color: #ffffff;
    line-height: 2.1;
    padding: 0 1.86667vw;
    justify-content: space-between;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-info {
        padding: 0 1.04948vmax;
    }
}

.info-icon li {
    margin-right: 1.86667vw;
    align-items: center;
}

.info-icon li:last-of-type {
    margin-right: 0;
}

.info-icon img {
    width: 4.8vw;
    height: 4.8vw;
    margin-right: 0.8vw;
}

h4 .info-icon {
    font-weight: normal;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .info-icon li {
        margin-right: 1.04948vmax;
    }

    .info-icon img {
        width: 2.69865vmax;
        height: 2.69865vmax;
        margin-right: 0.44978vmax;
    }
}

.fm-match-button {
    justify-content: center;
    list-style: none;
    background-color: #e0e6e6;
}

.fm-match-button li {
    position: relative;
}

.fm-match-button li:after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 0.53333vw;
    height: 7.46667vw;
    background: rgba(22, 40, 49, 0.9);
    box-shadow: -1px 0 0 0 rgba(255, 255, 255, 0.3) inset;
}

.fm-match-button li:last-of-type:after {
    display: none;
}

.fm-match-button a {
    align-items: center;
    justify-content: center;
    width: 26.66667vw;
    height: 7.46667vw;
    background-repeat: no-repeat;
    background-size: contain;
    color: #ffffff;
    font-size: 3.2vw;
    font-weight: bold;
}

.fm-match-button a:before {
    content: "";
    width: 3.73333vw;
    height: 3.73333vw;
    margin-right: 0.53333vw;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.fm-match-button .favourite-pin {
    padding-left: 2.13333vw;
    background-image: url('../images/sprite/bg-match-btn-left.png');

}

.fm-match-button .favourite-pin:before {
    background-image: url('data:image/svg+xml,<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.714 5.25c.857.321 1.286.812 1.286 1.473 0 .232-.036.384-.107.455-.071.071-.214.107-.429.107h-2.893l-.429 4.714h-.286l-.429-4.714h-2.893c-.214 0-.357-.04-.429-.121-.071-.08-.107-.228-.107-.442 0-.661.429-1.152 1.286-1.473l.143-.054c.262-.107.429-.277.5-.509l.643-3.161v-.134c0-.143-.119-.259-.357-.348l-.036-.027h-.036c-.286-.089-.429-.241-.429-.455 0-.25.048-.406.143-.469.095-.063.262-.094.5-.094h3.286c.238 0 .405.031.5.094.095.063.143.219.143.469 0 .214-.143.366-.429.455h-.036l-.036.027c-.238.089-.357.205-.357.348v.134l.643 3.161c.071.232.238.402.5.509l.143.054z" fill="rgb(255,255,255)"/></svg>');
}

.fm-match-button .favourite-pin.select {
    background-image: url('../images/sprite/bg-match-btn-left-select.png');
}

.fm-match-button .fm-refresh-button {
    padding-right: 2.13333vw;
    background-image: url('../images/sprite/bg-match-btn-right.png');

}

.fm-match-button .fm-refresh-button:before {
    background-image: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-7 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="rgb(255,255,255)"/></g></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .fm-match-button li:after {
        width: 0.29985vmax;
        height: 4.1979vmax;
    }

    .fm-match-button a {
        width: 14.9925vmax;
        height: 4.1979vmax;
        font-size: 1.7991vmax;
    }

    .fm-match-button a:before {
        width: 2.09895vmax;
        height: 2.09895vmax;
        margin-right: 0.29985vmax;
    }

    .fm-match-button .favourite-pin {
        padding-left: 1.1994vmax;
    }

    .fm-match-button .fm-refresh-button {
        padding-right: 1.1994vmax;
    }
}

.game-team {
    width: 100%;
    font-size: 4vw;
    table-layout: fixed;
}

.game-team th,
.game-team td,
.game-team .mob-announce-content table th,
.mob-announce-content table .game-team th {
    padding: 1.86667vw;
    vertical-align: top;
}

.game-team th {
    padding-left: 10.4vw;
}

.game-team td,
.game-team .mob-announce-content table th,
.mob-announce-content table .game-team th {
    border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.game-team h4 {
    line-height: 6.93333vw;
}

.game-team h4 span {
    font-size: 2.66667vw;
    font-weight: normal;
    color: #fff;
    vertical-align: middle;
}

.game-team h4:last-of-type {
    margin-right: 0;
}

.game-team span {
    font-size: 2.13333vw;
    color: #7e97a7;
}

.game-team .team-scores {
    width: 18.66667vw;
    background-color: rgba(0, 0, 0, 0.45);
}

.game-team .team-scores:first-of-type {
    border-left-width: 0;
}

.game-team .team-scores h4 {
    letter-spacing: -0.26667vw;
}

.game-team .team-other {
    display: none;
    color: #7e97a7;
}

.game-team .team-refresh {
    width: 6.66667vw;
}

.game-team .team-multi_Go {
    width: 6.66667vw;
    border-left-width: 0;
}

.game-team a {
    width: 6.66667vw;
    height: 6.66667vw;
}

.game-team .in-play {
    color: #8eea29;
}

.game-team .in-play span {
    color: #8eea29;
}

.game-team .refresh {
    width: 5.86667vw;
    height: 5.86667vw;
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-7 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="rgb(255,255,255)"/></g></svg>') no-repeat;
    background-size: contain;
    margin: 0 auto;
}

.game-team .multi-Go {
    width: 6.4vw;
    height: 6.4vw;
    background: #000 url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M9.718 5L17 12l-7.282 7L8 17.348 13.592 12 8 6.652"/></svg>') no-repeat;
    background-size: contain;
    border-radius: 1.06667vw;
    margin-top: 1px;
}

.multi .game-team .refresh {
    margin-top: 2px;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-team {
        font-size: 2.24888vmax;
    }

    .game-team th {
        padding-left: 5.84708vmax;
    }

    .game-team h4 {
        line-height: 3.89805vmax;
    }

    .game-team h4 span {
        font-size: 1.49925vmax;
    }

    .game-team .game-low_liq {
        width: auto;
        color: #fff;
        line-height: 4.8vw;
        font-size: 3.2vw;
        margin-left: 1.6vw;
        margin-right: 0;
    }

    .game-team span {
        font-size: 1.1994vmax;
    }

    .game-team .team-scores h4 {
        letter-spacing: 0;
    }

    .game-team .team-refresh {
        width: 3.74813vmax;
    }

    .game-team .team-multi_Go {
        width: 3.74813vmax;
    }

    .game-team a {
        width: 3.74813vmax;
        height: 3.74813vmax;
    }

    .game-team .pin-on,
    .game-team .pin-off {
        left: 1.04948vmax;
    }

    .game-team .refresh {
        width: 3.29835vmax;
        height: 3.29835vmax;
    }

    .game-team .multi-Go {
        width: 3.5982vmax;
        height: 3.5982vmax;
        border-radius: 0.5997vmax;
    }

    .multi .game-team h4 {
        line-height: 3.74813vmax;
    }

    .multi .game-team .game-low_liq {
        line-height: 2.69865vmax;
        font-size: 1.7991vmax;
        margin-right: 0.89955vmax;
    }
}

.game-team.tennis td,
.game-team.tennis .mob-announce-content table th,
.mob-announce-content table .game-team.tennis th {
    border-left-width: 0;
}

.game-team.tennis .team-scores {
    width: 6.66667vw;
}

.game-team.tennis .team-last_box {
    border-right: 1px solid rgba(255, 255, 255, 0.15);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-team.tennis .team-scores {
        width: 5.24738vmax;
    }

    .game-team.tennis .team-other {
        display: table-cell;
        width: 5.24738vmax;
    }
}

.game-team.soccer th {
    width: 10.4vw;
    padding: 1.86667vw 0;
    border-right: 1px solid rgba(255, 255, 255, 0.15);
}

.game-team.soccer .team-scores {
    width: 6.66667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-team.soccer th {
        width: 5.84708vmax;
        padding: 1.04948vmax 0;
    }

    .game-team.soccer .team-scores {
        width: 5.24738vmax;
    }
}

.game-team.racing h4 {
    margin-right: 3.2vw;
}

.game-team.racing h4.info-horse_race {
    width: auto;
    background-color: #fff;
    color: #000;
    font-size: 3.46667vw;
    line-height: 1.2;
    padding: 0.53333vw 0.8vw;
    border-radius: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .game-team.racing h4 {
        margin-right: 1.7991vmax;
    }

    .game-team.racing h4.info-horse_race {
        font-size: 1.94903vmax;
        padding: 0.29985vmax 0.44978vmax;
        border-radius: 0.74963vmax;
    }
}

.scores-time {
    font-size: 2.13333vw;
    color: #7e97a7;
    font-weight: normal;
    clear: left;
}

.scores-time li {
    margin-right: 1.33333vw;
}

.scores-time li:before {
    content: "";
    width: 1.06667vw;
    height: 1.06667vw;
    border-radius: 50%;
    background-color: #7e97a7;
    margin: 0.8vw 1.33333vw 0 0;
}

.scores-time li:first-of-type:before {
    display: none;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .scores-time {
        font-size: 1.1994vmax;
    }

    .scores-time li {
        margin-right: 0.74963vmax;
    }

    .scores-time li:before {
        width: 0.5997vmax;
        height: 0.5997vmax;
        margin: 0.44978vmax 0.74963vmax 0 0;
    }
}

.soccer-map {
    position: relative;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.soccer-map:after {
    position: absolute;
    content: "";
    min-width: 1px;
    width: 0.26667vw;
    height: 1.86667vw;
    background-color: #fff;
    left: 50%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .soccer-map:after {
        width: 0.14993vmax;
        height: 1.04948vmax;
    }
}

.bg-progress_bar {
    position: relative;
    height: 2.13333vw;
    background: rgba(255, 255, 255, 0.25);
    box-shadow: inset 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bg-progress_bar {
        height: 1.1994vmax;
        box-shadow: inset 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.5997vmax;
    }
}

.progress_bar {
    height: 100%;
    background: #6bbd11;
    background-image: linear-gradient(-180deg, #6bbd11 15%, #43730f 100%);
    border-radius: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .progress_bar {
        border-radius: 0.5997vmax;
    }
}

.card-yellow {
    background: #f8e71c;
}

.card-red {
    background: #fc1b1b;
}

.ball-soccer {
    position: absolute;
    width: 2.93333vw;
    height: 2.93333vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 11 11"><defs><linearGradient id="b" x1="50%" x2="50%" y1="15.436%" y2="100%"><stop offset="0%" stop-color="rgb(255,255,255)"/><stop offset="100%" stop-color="rgb(204,204,204)"/></linearGradient><circle id="a" cx="5.5" cy="5.5" r="5.5"/><linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%"><stop offset="0%" stop-color="rgb(61,96,117)"/><stop offset="100%" stop-color="rgb(27,45,56)"/></linearGradient><path id="c" d="M5.5 0c1.516 0 2.812.538 3.887 1.613C10.462 2.688 11 3.983 11 5.5c0 1.516-.538 2.812-1.613 3.887C8.312 10.462 7.017 11 5.5 11c-1.516 0-2.812-.538-3.887-1.613C.538 8.312 0 7.017 0 5.5c0-1.516.538-2.812 1.613-3.887C2.688.538 3.983 0 5.5 0zm1.084 10.418c.035 0 .07-.01.106-.026.035-.018.07-.027.106-.027l.634-1.692-.53-1.03v-.028H4.1l-.53 1.032.66 1.718c.018 0 .05.01.093.027.044.017.075.026.093.026.352.088.687.132 1.005.132.37 0 .76-.044 1.164-.132zM3.754.768c-1.004.387-1.797.995-2.38 1.823l.583 1.694.132.053 1.295.608 1.877-1.587V1.825L3.755.767zm5.87 1.823C9.01 1.73 8.215 1.12 7.245.768L5.713 1.825v1.533L7.59 4.945l1.427-.635.608-1.72zM.477 5.95c.07.9.36 1.71.873 2.432l1.85.027.555-1.033-.53-2.036-.025-.025-1.296-.582L.476 5.95zM7.8 8.41l1.85-.028c.513-.723.804-1.533.874-2.432L9.096 4.733l-1.322.608-.53 2.037L7.8 8.41z"/></defs><g fill="none" fill-rule="evenodd"><use fill="rgb(255,255,255)" xlink:href="%23a"/><use fill="url(%23b)" xlink:href="%23a"/><use fill="rgb(36,58,72)" xlink:href="%23c"/><use fill="url(%23d)" xlink:href="%23c"/></g></svg>');
    background-size: contain;
    box-shadow: 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    margin-left: -1.6vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .ball-soccer {
        width: 1.64918vmax;
        height: 1.64918vmax;
        box-shadow: 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
        margin-left: -0.89955vmax;
    }
}

.sum-status {
    position: absolute;
    width: 2.93333vw;
    height: 2.93333vw;
    line-height: 2.93333vw;
    background-image: linear-gradient(-180deg, #ffcc2f 0%, #000 71%);
    box-shadow: 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    margin-left: -1.6vw;
}

.game-team .sum-status {
    color: #1e1e1e;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .sum-status {
        width: 1.64918vmax;
        height: 1.64918vmax;
        line-height: 1.64918vmax;
        box-shadow: 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
        margin-left: -0.89955vmax;
    }
}

.team-a {
    top: -1.6vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .team-a {
        top: -0.89955vmax;
    }
}

.team-b {
    top: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .team-b {
        top: 0.5997vmax;
    }
}

.mob-market-type {
    position: relative;
    height: 9.6vw;
    background-color: #e0e6e6;
    padding: 1.86667vw;
    overflow: hidden;
    overflow-x: auto;
}

.mob-market-type ul {
    position: absolute;
    white-space: nowrap;
    padding-right: 0.53333vw;
}

.mob-market-type li {
    margin-right: 1.33333vw;
}

.mob-market-type a {
    color: #fff;
    line-height: 9.06667vw;
    font-weight: bold;
    background: linear-gradient(180deg, #000 1%, #370008 100%);
    border: 1px solid #000;
    border-radius: 4.8vw;
    padding: 0 2.4vw;


}

.fancy_bet_tab-wrap {
    background-color: #087989;
}

.fancy_bet_tab-wrap {
    font-weight: bold;
}

.special_bets-tab-wrap,
.fancy_bet_tab-wrap {
    padding-bottom: 1.33333vw;
}

.special_bets-tab-wrap,
.fancy_bet_tab-wrap {
    padding-bottom: 1.33333vw;
}

.mob-market-type .select a {
    color: #000;
    background-image: linear-gradient(-180deg, #ffb80c 15%, #ffa00c 100%);
    border-color: rgba(51, 51, 51, 0.3);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-market-type {
        height: 5.3973vmax;
        padding: 1.04948vmax;
    }

    .mob-market-type ul {
        padding-right: 0.29985vmax;
    }

    .mob-market-type li {
        margin-right: 0.74963vmax;
    }

    .mob-market-type a {
        line-height: 5.09745vmax;
        border-radius: 2.69865vmax;
        padding: 0 1.34933vmax;
    }
}

.bets-wrap {
    position: relative;
    background-color: #fff;
    border-bottom: 1px solid #7e97a7;
    margin-bottom: 0;
}

.bets-wrap:last-of-type {
    margin-bottom: 2.66667vw;
}

.bets-wrap.multi {
    margin-bottom: 5.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-wrap:last-of-type {
        margin-bottom: 1.49925vmax;
    }

    .bets-wrap.multi {
        margin-bottom: 2.9985vmax;
    }

    .bets-wrap.multi:last-of-type {
        margin-bottom: 2.9985vmax;
    }
}

.no-game {
    padding: 2.66667vw 1.86667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .no-game {
        padding: 1.49925vmax 1.04948vmax;
    }
}

.suspend-full {
    position: absolute;
    right: 0;
    width: 37.33333vw;
    height: calc(100% - 9.33vw);
}

@media (orientation: landscape) {
    .suspend-full {
        width: 107.2vw;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .suspend-full {
        width: 60.26987vmax;
        height: calc(100% - 5.24vmax);
    }
}

.bets-selections dt {
    padding: 1.33333vw 1.86667vw;
}

.bets-selections>dd {
    width: 18.66667vw;
}

.bets-selections h4 {
    width: 100%;
    line-height: 1.2;
}

.bets-selections .suspend {
    position: absolute;
    right: 0;
    width: 37.33333vw;
    height: 100%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-selections dt {
        padding: 0.74963vmax 1.04948vmax;
    }

    .bets-selections>dd {
        width: 10.04498vmax;
    }

    .bets-selections a {
        padding: 0.89955vmax 0.44978vmax;
    }

    .bets-selections .suspend {
        width: 60.26987vmax;
    }
}

.win,
.to-win {
    color: #508d0e;
}

.lose,
.to-lose {
    color: #d0021b;
}

.to-win:before {
    background-image: url('data:image/svg+xml,<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z" fill="%23508E0D" fill-rule="evenodd"/></svg>');
}

.to-lose:before {
    background-image: url('data:image/svg+xml,<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z" fill="%23D0021B" fill-rule="evenodd"/></svg>');
}

.disabled dd a {
    position: relative;
    cursor: not-allowed;
}

.disabled dd a:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(51, 51, 51, 0.2) url('../images/sprite/bg-disabled.png');
    width: 100%;
    height: 100%;
}

.cooldown dd a {
    position: relative;
}

.cooldown dd a:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.06667vw;
    opacity: 0;
}

.cooldown .back-1:after {
    background-color: rgba(0, 46, 85, 0.4);
}

.cooldown .back-2:after {
    background-color: rgba(0, 46, 85, 0.4);
}

.cooldown .back-3:after {
    background-color: rgba(0, 46, 85, 0.4);
}

.cooldown .lay-1:after {
    background-color: rgba(89, 10, 21, 0.4);
}

.cooldown .lay-2:after {
    background-color: rgba(89, 10, 21, 0.4);
}

.cooldown .lay-3:after {
    background-color: rgba(89, 10, 21, 0.4);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .cooldown dd a:after {
        height: 0.5997vmax;
    }
}

.horse-info {
    width: 100%;
    align-items: center;
    margin-bottom: 0.53333vw;
}

.horse-info:last-child {
    margin-bottom: 0;
}

.bets-selections .horse-info>ul {
    display: block;
    line-height: 1.1;
    font-size: 3.2vw;
}

.bets-selections .horse-info>ul li {
    margin: 0;
}

.horse-box {
    width: 6.13333vw;
}

.uniform {
    width: 6.93333vw;
    height: 5.6vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 26 21"><defs><path id="a" d="M0 0h26v21H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="%23fff"><use xlink:href="%23a"/></mask><use fill="%23FFF" xlink:href="%23a"/><path fill="%23C5D0D7" fill-rule="nonzero" d="M22.16 11.15L25 8.33l-5.36-5.6-2.55-.6-.13-.33c0-.04-.03-.06-.05-.09L15.48.11a.32.32 0 0 0-.31-.1l-.31.07a.32.32 0 0 0-.2.15.3.3 0 0 0-.03.19A9.07 9.07 0 0 1 11.4.36l-.44-.24-1.5 1.62-.06.1-.12.31-2.56.62L1 7.6l2.96 3.13 2.52-1.8-.41 13.75h14.45l-.96-13.21 2.6 1.68zM11.22 3.9l-.25-.07-1.75.4.45-2.3L10.94.62c.06 1.72.84 3.42 2.06 4.14a4.15 4.15 0 0 1-1.78-.85zm4.5.04a.31.31 0 0 0-.2.02l-1.99.82-.18-.12c.58-.66 2.14-1.3 1.58-4.3l.37-.14 1.43 1.7.4 2.32-1.42-.3z" mask="url(%23b)"/></g></svg>') no-repeat center;
    margin-right: 1.86667vw;
}

.uniform img {
    width: 6.93333vw;
    height: 5.6vw;
}

.horse-name {
    flex: 1;
    min-width: 0;
}

.horse-name li:first-of-type {
    font-size: 3.73333vw;
    font-weight: bold;
    margin-bottom: 0.53333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .horse-info {
        margin-bottom: 0.29985vmax;
    }

    .bets-selections .horse-info>ul {
        font-size: 1.7991vmax;
    }

    .horse-box {
        width: 3.44828vmax;
    }

    .uniform {
        width: 3.89805vmax;
        height: 3.14843vmax;
        margin-right: 1.04948vmax;
    }

    .uniform img {
        width: 3.89805vmax;
        height: 3.14843vmax;
    }

    .horse-name li:first-of-type {
        font-size: 2.09895vmax;
        margin-bottom: 0.29985vmax;
    }
}

.back-1 {
    background-color: #72bbef;
}

.back-1.select {
    background-color: #1a8ee1;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.back-1.select a {
    color: #fff;
}

.disable .back-1 {
    background-color: #ddd;
    color: #999;
}

.back-2 {
    background-color: #b7d5eb;
}

.back-2.select {
    background-color: #67a6d5;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.back-2.select a {
    color: #fff;
}

.disable .back-2 {
    background-color: #ddd;
    color: #999;
}

.back-3 {
    background-color: #d7e8f4;
}

.back-3.select {
    background-color: #87bade;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.back-3.select a {
    color: #fff;
}

.disable .back-3 {
    background-color: #ddd;
    color: #999;
}

.lay-1 {
    background-color: #faa9ba;
}

.lay-1.select {
    background-color: #f4496d;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.lay-1.select a {
    color: #fff;
}

.disable .lay-1 {
    background-color: #ddd;
    color: #999;
}

.lay-2 {
    background-color: #efd3d9;
}

.lay-2.select {
    background-color: #d48898;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.lay-2.select a {
    color: #fff;
}

.disable .lay-2 {
    background-color: #ddd;
    color: #999;
}

.lay-3 {
    background-color: #f6e6ea;
}

.lay-3.select {
    background-color: #db9bab;
    color: #fff;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.5);
}

.lay-3.select a {
    color: #fff;
}

.disable .lay-3 {
    background-color: #ddd;
    color: #999;
}

.bets-selections-head {
    min-height: auto;
    line-height: 1.1;
}

.special_bets-tab {
    line-height: 6.93333vw;
    align-items: center;
    padding: 0 1.86667vw;
    white-space: nowrap;
}

.bets-selections-head dt {
    font-size: 2.93333vw;
    padding: 1.86667vw 1.86667vw 0.8vw;
    align-items: center;
}

.bets-selections-head dd {
    width: 18.66667vw;
    font-weight: bold;
    padding: 1.86667vw 1.86667vw 0.8vw;
    justify-content: center;
    align-items: flex-end;
}

.bets-selections-head .a-depth {
    width: 6.66667vw;
    height: 6.66667vw;
    background: url('data:image/svg+xml,<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx="12.5" cy="12.5" r="12.5"/></defs><g fill="none" fill-rule="evenodd"><g><use fill="%23FFF" xlink:href="%23a"/><circle stroke="%237E97A7" cx="12.5" cy="12.5" r="12"/></g><path d="M10 12H8v5h2v-5zm3-4h-2v9h2V8zm7 10H7V6H6v13h14v-1zm-4-8h-2v7h2v-7zm3-3h-2v10h2V7z" fill="%237E97A7"/></g></svg>') no-repeat;
    background-size: contain;
    padding: 0;
    margin-right: 1.86667vw;
}

.multi .bets-selections-head dt {
    color: #000;
    align-items: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-selections-head {
        min-height: auto;
    }

    .bets-selections-head dt {
        font-size: 1.64918vmax;
        padding: 1.04948vmax 1.04948vmax 0.44978vmax;
    }

    .bets-selections-head dd {
        width: 10.04498vmax;
        padding: 1.04948vmax 1.04948vmax 0.44978vmax;
    }

    .bets-selections-head .a-depth {
        width: 3.74813vmax;
        height: 3.74813vmax;
        margin-right: 1.04948vmax;
    }
}

.bet_slipbar-content {
    border-bottom: 1px solid #7e97a7;
    padding-top: 2.66667vw;
}

.bet_slipbar-content.back {
    background-color: #dceaf4;
}

.bet_slipbar-content.lay {
    background-color: #f2e5e8;
}

.bet_slipbar-content.book {
    background-color: #d3edd0;
}

.bet_slipbar-content .message-content {
    position: relative;
    margin: -2.66667vw 0 3.73333vw;
    border-top-width: 0;
    z-index: auto;
    color: #1e1e1e;
}

.bet_slipbar-content:last-child {
    border-bottom-width: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bet_slipbar-content {
        padding-top: 1.49925vmax;
    }

    .bet_slipbar-content .message-content {
        margin: -1.49925vmax 0 2.09895vmax;
    }
}

.btn-list {
    padding: 0 1.86667vw 1.86667vw;
}

.btn-list li {
    flex: 1 1 47.2vw;
    margin-right: 1.86667vw;
    overflow: hidden;
}

.btn-list li:last-of-type {
    margin-right: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-list {
        padding: 0 1.04948vmax 1.04948vmax;
    }

    .btn-list li {
        flex: 1 1 26.53673vmax;
        margin-right: 1.04948vmax;
    }
}

.input-num {
    font-size: 4vw;
    line-height: 10.13333vw;
    font-weight: bold;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.1);
    border-radius: 1.6vw;
    cursor: text;
    overflow: hidden;
}

.input-num a {
    width: 12vw;
    height: 10.66667vw;
    background-image: linear-gradient(-180deg, #fff 0%, #eee 89%);
    justify-content: center;
    align-items: center;
}

.input-num a:before {
    content: "";
    background-repeat: no-repeat;
    background-size: contain;
}

.input-num span {
    position: relative;
    flex: 1;
    color: #7e97a7;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.input-num .typed {
    color: #1e1e1e;
}

.input-num .typed:before {
    display: none;
}

.input-num .typeing:before {
    display: none;
}

.input-num .typeing:after {
    content: "";
    width: 0.66667vw;
    height: 5.33333vw;
    background-color: #1f72ac;
    animation: typeing 1s infinite;
}

.input-num.error .typed {
    color: #d0021b;
}

.input-num.disable .typed {
    color: #999;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .input-num {
        font-size: 2.24888vmax;
        line-height: 5.69715vmax;
        box-shadow: inset 0 0.29985vmax 0 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.89955vmax;
    }

    .input-num a {
        width: 6.74663vmax;
        height: 5.997vmax;
    }

    .input-num .typeing:after {
        width: 0.37481vmax;
        height: 2.9985vmax;
    }
}

.input-stake span:before {
    content: "Stake";
}

.input-odds span:before {
    content: "Odds";
}

.icon-minus {
    border-radius: 1.6vw 0 0 1.6vw;
    border-right: 1px solid #aaa;
}

.icon-minus:before {
    width: 4.53333vw;
    height: 1.06667vw;
    background-image: url('data:image/svg+xml,<svg width="17" height="4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="b" width="17" height="3" rx="1.5"/><filter x="-2.9%" y="-16.7%" width="105.9%" height="166.7%" filterUnits="objectBoundingBox" id="a"><feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowOffsetOuter1"/></filter></defs><g fill="none" fill-rule="evenodd"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><use fill="%231F72AC" xlink:href="%23b"/></g></svg>');
}

.disable .icon-minus {
    background: #fff;
}

.disable .icon-minus:before {
    background-image: url('data:image/svg+xml,<svg width="17" height="4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="b" width="17" height="3" rx="1.5"/><filter x="-2.9%" y="-16.7%" width="105.9%" height="166.7%" filterUnits="objectBoundingBox" id="a"><feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowOffsetOuter1"/></filter></defs><g fill="none" fill-rule="evenodd"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><use fill="%23999" xlink:href="%23b"/></g></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .icon-minus {
        border-radius: 0.89955vmax 0 0 0.89955vmax;
    }

    .icon-minus:before {
        width: 2.54873vmax;
        height: 0.5997vmax;
    }
}

.icon-plus {
    border-radius: 0 1.6vw 1.6vw 0;
    border-left: 1px solid #aaa;
}

.icon-plus:before {
    width: 4.53333vw;
    height: 4.8vw;
    background-image: url('data:image/svg+xml,<svg width="17" height="18" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M7.16 7.16H1.33a1.34 1.34 0 0 0 0 2.68h5.83v5.83a1.34 1.34 0 0 0 2.68 0V9.84h5.83a1.34 1.34 0 0 0 0-2.68H9.84V1.33a1.34 1.34 0 0 0-2.68 0v5.83z" id="b"/><filter x="-2.9%" y="-2.9%" width="105.9%" height="111.8%" filterUnits="objectBoundingBox" id="a"><feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowOffsetOuter1"/></filter></defs><g fill="none" fill-rule="evenodd"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><use fill="%231F72AC" xlink:href="%23b"/></g></svg>');
}

.disable .icon-plus {
    background: #fff;
}

.disable .icon-plus:before {
    background-image: url('data:image/svg+xml,<svg width="17" height="18" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M7.16 7.16H1.33a1.34 1.34 0 0 0 0 2.68h5.83v5.83a1.34 1.34 0 0 0 2.68 0V9.84h5.83a1.34 1.34 0 0 0 0-2.68H9.84V1.33a1.34 1.34 0 0 0-2.68 0v5.83z" id="b"/><filter x="-2.9%" y="-2.9%" width="105.9%" height="111.8%" filterUnits="objectBoundingBox" id="a"><feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowOffsetOuter1"/></filter></defs><g fill="none" fill-rule="evenodd"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><use fill="%23999" xlink:href="%23b"/></g></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .icon-plus {
        border-radius: 0 0.89955vmax 0.89955vmax 0;
    }

    .icon-plus:before {
        width: 2.54873vmax;
        height: 2.69865vmax;
    }
}

.coin-list {
    margin-bottom: 1.86667vw;
    background-image: linear-gradient(-180deg, #ffffff 20%, #ffffff 91%);
}

.coin-list li {
    flex: 1;
    border-right: 1px solid rgba(255, 255, 255, 0.15);
}

.coin-list li:last-child {
    border-right-width: 0;
}

.coin-list a {
    color: #fff;
    line-height: 2.46;
    background-image: linear-gradient(-180deg, #000000 20%, #000000 91%);
}

.coin-list.disable {
    background: #9ab0bb;
}

.coin-list.disable a {
    background: #9ab0bb;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .coin-list {
        margin-bottom: 1.04948vmax;
    }
}

.keyboard-wrap {
    border-top: 1px solid #aaa;
    margin-bottom: 1.86667vw;
}

.keyboard-wrap ul {
    flex: 1;
    flex-wrap: wrap;
}

.keyboard-wrap li {
    flex: 1 1 16.66667%;
}

.keyboard-wrap a {
    font-size: 4vw;
    color: #1e1e1e;
    line-height: 10.4vw;
    background-color: #fff;
    border: 1px solid #aaa;
    border-width: 0 0 1px 1px;
}

.keyboard-wrap .btn-delete {
    flex: 0 1 14.66667vw;
    justify-content: center;
    align-items: center;
}

.keyboard-wrap .btn-delete:before {
    content: "";
    width: 4.8vw;
    height: 3.2vw;
    background: url('data:image/svg+xml,<svg width="18" height="12" xmlns="http://www.w3.org/2000/svg"><path d="M14.52 8.6c.07.06.1.13.1.2 0 .06-.03.13-.1.2l-.74.75c-.05.05-.12.07-.21.07-.1 0-.16-.02-.21-.07l-2.67-2.63-2.67 2.63c-.05.05-.12.07-.22.07-.09 0-.16-.02-.2-.07L6.85 9c-.07-.07-.11-.14-.11-.2 0-.07.04-.14.1-.2L9.54 6 6.82 3.4c-.14-.13-.14-.26 0-.4l.77-.75c.05-.05.12-.07.21-.07.1 0 .17.02.22.07l2.67 2.6 2.67-2.6c.05-.05.12-.07.21-.07.1 0 .16.02.21.07l.77.75c.15.14.15.27 0 .4L11.85 6l2.67 2.6zM17.54.47c.3.3.46.67.46 1.12v8.73c0 .45-.16.85-.47 1.18-.32.33-.7.49-1.15.49H5.91a2.52 2.52 0 0 1-2-.99l-.04-.03L0 6 3.87.95C4.36.32 5.04 0 5.9 0h10.47c.45 0 .83.16 1.16.48zm-.66 9.93V1.52c0-.35-.17-.52-.5-.52H5.91c-.47 0-.85.19-1.13.56L1.41 6l3.37 4.44c.3.37.68.56 1.13.56h10.47c.33 0 .5-.2.5-.59z" fill="%231E1E1E" fill-rule="evenodd"/></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .keyboard-wrap {
        margin-bottom: 1.04948vmax;
    }

    .keyboard-wrap li {
        flex: 1;
    }

    .side-content .keyboard-wrap li {
        flex: 1 1 16.66667%;
    }

    .keyboard-wrap a {
        font-size: 2.24888vmax;
        line-height: 5.84708vmax;
    }

    .keyboard-wrap .btn-delete {
        flex: 0 1 8.24588vmax;
    }

    .keyboard-wrap .btn-delete:before {
        width: 2.69865vmax;
        height: 1.7991vmax;
    }
}

.info-other,
.info-rotate {
    color: #7e97a7;
    font-size: 3.2vw;
    padding: 0 1.86667vw;
    margin-bottom: 5.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .info-other,
    .info-rotate {
        font-size: 1.7991vmax;
        padding: 0 1.04948vmax;
        margin-bottom: 2.9985vmax;
    }
}

.info-rotate:before {
    content: "";
    width: 9.33333vw;
    height: 8.53333vw;
    background: url('data:image/svg+xml,<svg width="35" height="32" xmlns="http://www.w3.org/2000/svg"><g fill="%237E97A7" fill-rule="evenodd"><path d="M17 15v-5c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-7c0-1.1.9-2 2-2h8zm-7 10h7v-9h-7v9zm8-14v12h9V11h-9z"/><path d="M11.4 6.18a5.36 5.36 0 0 1 4.33-1.58c.8.06 1.57.27 2.3.64l-.61 1.19a4.27 4.27 0 0 0-3.5-.25 4.09 4.09 0 0 0-2.4 2.23c-.21.46-.33.95-.36 1.45l2.8.03-3.42 3.42L7 9.78l2.77.06a5.52 5.52 0 0 1 1.64-3.66z"/></g></svg>') no-repeat;
    background-size: contain;
    border: 1px solid #7e97a7;
    border-radius: 1.06667vw;
    margin-right: 1.86667vw;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

@media (orientation: landscape) {
    .info-rotate {
        display: none;
    }
}

.no-data {
    background: #ffffff;
    border: 1px solid #7e97a7;
    border-radius: 1.6vw;
    color: #7e97a7;
    font-size: 4.26667vw;
    margin: 5.33333vw 2.66667vw;
    padding: 2.66667vw 1.86667vw 5.33333vw;
}

.no-data h3 {
    background-image: none;
    font-size: 5.33333vw;
    color: #7e97a7;
    border-bottom: 1px solid #e0e6e6;
    margin-bottom: 1.33333vw;
    padding: 1.86667vw 0;
    align-items: center;
    justify-content: center;
}

.no-data h3:before {
    content: "";
    width: 8.26667vw;
    height: 8.53333vw;
    background: url('../images/sprite/icon-nodata.svg') no-repeat;
    background-size: contain;
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .no-data {
        border-radius: 0.89955vmax;
        font-size: 2.3988vmax;
        margin: 2.9985vmax 1.49925vmax;
        padding: 1.49925vmax 1.04948vmax 2.9985vmax;
    }

    .no-data h3 {
        font-size: 2.9985vmax;
        margin-bottom: 0.74963vmax;
        padding: 1.04948vmax 0;
    }

    .no-data h3:before {
        width: 4.64768vmax;
        height: 4.7976vmax;
        margin-right: 0.74963vmax;
    }
}

.line_market-head {
    line-height: 8vw;
    border-bottom: 1.06667vw solid #e4550f;
    margin-top: 5.33333vw;
}

.line_market-head h4 {
    color: #fff;
    font-size: 3.73333vw;
    z-index: 1;
}

.line_market-head h4:after {
    content: "";
    width: 3.73333vw;
    height: 8vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMax" width="14" height="30"><defs><linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="81.78%"><stop offset="0%" stop-color="%23EF6C2C"/><stop offset="100%" stop-color="%23E4550F"/></linearGradient></defs><path fill="url(%23a)" fill-rule="evenodd" d="M0 0h96.85a8 8 0 0 1 7.73 5.94L111 30H0V0z" transform="translate(-97)"/></svg>') no-repeat;
    background-size: cover;
}

.line_market-head h4 span {
    padding-left: 1.86667vw;
    background-image: linear-gradient(-180deg, #ef6c2c 0%, #e4550f 82%);
}

.line_market-head .btn-rules {
    margin-right: 1.86667vw;
    background-color: #c5d0d7;
    border-radius: 1.6vw 1.6vw 0 0;
    padding: 0 1.86667vw;
    font-weight: bold;
    color: #1f72ac;
    align-items: center;
}

.line_market-head .btn-rules:before {
    content: "";
    width: 2.66667vw;
    height: 2.4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9"><path fill="rgb(31,114,172)" fill-rule="evenodd" d="M2.668.317H10v1.18H2.668V.318zm0 4.78v-1.18H10v1.18H2.668zm0 3.6v-1.18H10v1.18H2.668zM.885 7.2c.247 0 .458.09.634.274.175.182.263.393.263.633s-.09.45-.27.627c-.18.177-.39.266-.628.266s-.445-.09-.62-.266C.087 8.556 0 8.347 0 8.107s.086-.45.257-.633c.17-.183.38-.274.628-.274zm0-7.2c.247 0 .458.09.634.266.175.178.263.392.263.64 0 .25-.088.462-.264.635-.177.174-.388.26-.635.26-.248 0-.457-.086-.628-.26C.087 1.37 0 1.158 0 .908S.086.444.257.267C.427.088.637 0 .885 0zm0 3.6c.247 0 .458.09.634.266.175.178.263.392.263.64 0 .25-.088.462-.264.635-.177.174-.388.26-.635.26-.248 0-.457-.086-.628-.26C.087 4.97 0 4.758 0 4.508s.086-.463.257-.64c.17-.178.38-.267.628-.267z"/></svg>') no-repeat;
    background-size: contain;
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .line_market-head {
        line-height: 4.49775vmax;
        border-bottom-width: 0.44978vmax;
        margin-top: 2.9985vmax;
    }

    .line_market-head h4 {
        font-size: 2.09895vmax;
    }

    .line_market-head h4:after {
        width: 2.09895vmax;
        height: 4.49775vmax;
    }

    .line_market-head h4 span {
        min-width: 14.9925vmax;
        padding-left: 1.04948vmax;
    }

    .line_market-head .btn-rules {
        margin-right: 1.04948vmax;
        border-radius: 0.89955vmax 0.89955vmax 0 0;
        padding: 0 1.04948vmax;
    }

    .line_market-head .btn-rules:before {
        width: 1.49925vmax;
        height: 1.34933vmax;
        margin-right: 0.74963vmax;
    }
}

.line_market-selection {
    position: relative;
}

.line_market-selection h4 {
    width: 100%;
    padding-right: 10.66667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .line_market-selection h4 {
        padding-right: 5.997vmax;
    }
}

.btn-book {
    background: #ffcc51;
    border: 0.26667vw solid #cf9a47;
    border-radius: 1.33333vw;
    font-size: 3.2vw;
}

.line_market-selection .btn-book {
    position: absolute;
    top: 1.6vw;
    right: 1.33333vw;
    width: 10.66667vw;
    font-weight: normal;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-book {
        border-width: 0.14993vmax;
        border-radius: 0.74963vmax;
        font-size: 1.7991vmax;
    }

    .line_market-selection .btn-book {
        top: 0.89955vmax;
        right: 0.74963vmax;
        width: 5.997vmax;
    }
}

.rules-content {
    line-height: 5.86667vw;
    font-size: 3.73333vw;
    padding: 2.13333vw 1.86667vw;
    color: rgba(30, 30, 30, 0.8);
}

.rules-content p {
    margin-bottom: 1.86667vw;
}

.rules-content p:last-of-type {
    margin-bottom: 0;
}

.rules-content ol {
    margin: 0 1.33333vw 1.86667vw 6.66667vw;
}

.rules-content ol li {
    margin-bottom: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .rules-content {
        line-height: 3.29835vmax;
        font-size: 2.09895vmax;
        padding: 1.1994vmax 1.04948vmax;
    }

    .rules-content p {
        margin-bottom: 1.04948vmax;
    }

    .rules-content ol {
        margin: 0 0.74963vmax 1.04948vmax 3.74813vmax;
    }

    .rules-content ol li {
        margin-bottom: 0.5997vmax;
    }
}

.download-list {
    display: flex;
    justify-content: space-between;
    height: 14.66667vw;
    line-height: 14.66667vw;
    border-bottom: 0.26667vw solid #ccc;
}

.download-list dt {
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: bold;
    padding: 0 2.66667vw;
}

.download-list dt:before {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;
}

.download-list dt a {
    display: flex;
    flex: 1;
}

.download-list dd {
    display: flex;
    flex: 0 0 13.33333vw;
}

.download-list dd a {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 0 2.66667vw;
}

.download-list dd a:before {
    content: "";
    width: 4.8vw;
    height: 5.86667vw;
    background-image: url('../images/sprite/icon-download.png');
    background-repeat: no-repeat;
    background-size: contain;
}

.download-list .icon-pdf:before {
    width: 6.4vw;
    height: 7.73333vw;
    background-image: url('../images/sprite/icon-pdf.png');
    margin-right: 2.66667vw;
}

.download-list:hover {
    background-color: #f7f7f7;
}

.download-list a:hover {
    text-decoration: none;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .download-list {
        height: 8.24588vmax;
        line-height: 8.24588vmax;
        border-bottom: 0.14993vmax solid #ccc;
    }

    .download-list dt {
        padding: 0 1.49925vmax;
    }

    .download-list dd {
        flex: 0 0 7.49625vmax;
    }

    .download-list dd a {
        padding: 0 1.49925vmax;
    }

    .download-list dd a:before {
        width: 2.69865vmax;
        height: 3.29835vmax;
    }

    .download-list .icon-pdf:before {
        width: 3.5982vmax;
        height: 4.34783vmax;
        margin-right: 1.49925vmax;
    }
}

.support-wrap {
    background-color: rgba(255, 255, 255, 0.5);
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 8vw;
}

.support-wrap .support-service {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 13.33333vw;
    /* border-bottom: 0.26667vw solid rgba(0, 0, 0, 0.2);*/
}

.support-wrap .support-service a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 13.33333vw;
}

.support-wrap .support-service a::before,
.support-wrap .support-service a::after {
    content: "";
    position: absolute;
    top: 13.33333vw;
    display: none;
    width: 0;
    height: 0;
    /*  border-style: solid;
    border-width: 1.6vw 1.6vw 0 1.6vw;
    border-color: #f6f6f6 transparent transparent transparent;*/
}

.support-wrap .support-service a::before {
    border-width: 1.86667vw 1.86667vw 0 1.86667vw;
    border-color: #c5c5c5 transparent transparent transparent;
}

.support-wrap .support-service a::after {
    content: '';
    position: absolute;
    top: 100%;
    display: block;
    width: 13.33333vw;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
}

.support-wrap .support-service a::after {
    content: '';
    position: absolute;
    top: 100%;
    display: block;
    width: 13.33333vw;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
}

.support-wrap .support-service a::after {
    content: '';
    position: absolute;
    top: 100%;
    display: block;
    width: 13.33333vw;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
}

.support-wrap .support-service a::after {
    content: '';
    position: absolute;
    top: 100%;
    display: block;
    width: 13.33333vw;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
}

.support-wrap .support-service a.open::before,
.support-wrap .support-service a.open::after {
    display: block;
    width: 13.33333vw;
}

.support-wrap .support-service img {
    width: 6.66667vw;
    height: 100%;
}

.support-wrap .support-info {

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3.46667vw 0 2.66667vw;
}

.support-wrap .support-detail {
    display: none;
}

.support-wrap .support-detail.open {
    display: block;
}

.support-wrap .support-detail a {
    display: block;
    line-height: 8vw;
    color: #666;
}

/*
.support-wrap .support-detail a span {
    display: block;
    max-width: 90%;
    margin: 0 auto;
    text-decoration: underline;
}*/
@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet .nums {
        top: 0.89955vmax;
        right: 1.04948vmax;
        height: 2.09895vmax;
        font-size: 1.64918vmax;
        line-height: 2.09895vmax;
        border: 0.14993vmax solid rgba(0, 0, 0, 0.3);
        border-radius: 0.44978vmax;
        padding: 0 1.1994vmax;
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li {
        margin-right: 1.1994vmax;
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet {
        font-size: 1.7991vmax;
        border: 0.14993vmax solid rgba(0, 0, 0, 0.3);
        border-radius: 0.5997vmax;
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet .a-wallet {
        border-radius: 0.44978vmax 0 0 0.44978vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.5);
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet .nums span {
        font-size: 1.49925vmax;
        margin-left: 0.14993vmax;
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet .a-wallet ul {
        display: flex;
        justify-content: flex-start;
        height: 4.1979vmax;
        line-height: 1.7991vmax;
        padding: 0 5.997vmax 0 1.04948vmax;
        border-radius: 0.5997vmax 0 0 0;
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header .live-tv-icon {
        min-width: 16.49175vmax;
        max-width: 20.98951vmax;
        margin-left: -0.14993vmax;
    }
}


@media screen and (min-aspect-ratio: 16/9) {
    header .a-open_tv {
        flex: 0 0 5.997vmax;
        padding: 1.04948vmax 0 0.74963vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.4);
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header a {
        height: 2.9985vmax;
        line-height: 2.9985vmax;
        border-width: 0.14993vmax;
        border-radius: 0.5997vmax;
        padding: 0.89955vmax 1.04948vmax;
        box-shadow: inset 0 0.14993vmax 0 0 rgba(255, 255, 255, 0.5);
    }
}

@media screen and (min-aspect-ratio: 16/9) {
    header li.main-wallet .a-wallet ul {
        display: flex;
        justify-content: flex-start;
        height: 4.1979vmax;
        line-height: 1.7991vmax;
        padding: 0 5.997vmax 0 1.04948vmax;
        border-radius: 0.5997vmax 0 0 0;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .support-wrap {
        margin-bottom: 4.49775vmax;
    }

    .support-wrap .support-service {
        height: 7.49625vmax;
        border-bottom: 0.14993vmax solid rgba(0, 0, 0, 0.2);
    }

    .support-wrap .support-service a {
        width: 7.49625vmax;
    }

    .support-wrap .support-service a::before,
    .support-wrap .support-service a::after {
        top: 7.49625vmax;
        width: 7.5333vw;
        border-width: 0.89955vmax 0.89955vmax 0 0.89955vmax;
    }

    .support-wrap .support-service a::before {
        border-width: 1.04948vmax 1.04948vmax 0 1.04948vmax;
    }

    .support-wrap .support-service img {
        width: 3.74813vmax;
    }

    .support-wrap .support-info {
        padding: 1.94903vmax 0 1.49925vmax;
    }

    .bet_slipbar-content.back {
        background-color: #DCEAF4;
    }

    .bet_slipbar-content.lay {
        background-color: #F2E5E8;
    }

    .support-wrap .support-detail a {
        display: inline-block;
        max-width: 95%;
        line-height: 4.49775vmax;
    }

    .support-wrap .support-detail a span {
        display: inline-block;
        max-width: 100%;
        vertical-align: middle;
    }

    .support-wrap .support-detail a:nth-child(2n) span:before,
    .support-wrap .support-detail a:nth-child(2n) span:after {
        display: inline-block;
        content: "|";
        margin: 0 1.1994vmax 0 1.1994vmax;
        color: #bbb;
        text-decoration: none;
        vertical-align: middle;
    }

    .support-wrap .support-detail a:last-child span:after {
        display: none;
    }
}

[class^="support-"] img {
    background-size: contain;
    background-repeat: no-repeat;
}

.support-fb img,
.support-ig img {
    width: 5.86667vw !important;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .support-fb img,
    .support-ig img {
        width: 3.29835vmax !important;
    }
}

.support-mail img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(166,166,166)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}

.support-whatsapp img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-whatsapp.open img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>');
}

.support-telegram img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-telegram.open img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>');
}

.support-skype img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-skype.open img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>');
}

.support-fb img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.925 0 0 4.946 0 11.046a11.026 11.026 0 009.165 10.88v-8.575H6.512v-3.086h2.653V7.989c0-2.64 1.606-4.079 3.952-4.079 1.124 0 2.09.084 2.37.121v2.76h-1.628c-1.275 0-1.52.61-1.52 1.502v1.97h3.043l-.397 3.086h-2.647V22C17.781 21.335 22 16.688 22 11.043 22 4.946 17.075 0 11 0z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-fb.open img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.925 0 0 4.946 0 11.046a11.026 11.026 0 009.165 10.88v-8.575H6.512v-3.086h2.653V7.989c0-2.64 1.606-4.079 3.952-4.079 1.124 0 2.09.084 2.37.121v2.76h-1.628c-1.275 0-1.52.61-1.52 1.502v1.97h3.043l-.397 3.086h-2.647V22C17.781 21.335 22 16.688 22 11.043 22 4.946 17.075 0 11 0z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>');
}

.support-ig img {
    background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-ig.open img {
    background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>');
}

.mob-inform-link {
    width: 100vw;
    margin: 3.2vw auto 8vw;
    padding: 0 1.86667vw;
    text-align: center;
    color: #bbb;
}

.mob-inform-link a {
    color: #666;
    text-decoration: underline;
}

.mob-inform-link li:before {
    margin: 0 0.4vw;
    content: "|";
}

.mob-inform-link li:first-child:before {
    display: none;
}



@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-inform-link {
        margin: 1.7991vmax auto 1.7991vmax;
        padding: 0 1.04948vmax;
    }

    .mob-inform-link li:nth-child(even):before {
        margin: 0 0.89955vmax;
    }
}

.RnR-link a {
    color: #666;
    text-decoration: underline;
}

.declared {
    background-color: #aed5f5;
    font-size: 3.46667vw;
    line-height: 1.3;
    padding: 2.66667vw;
    margin-bottom: 2.66667vw;
    border-radius: 2.13333vw;
}

.declared p:last-of-type {
    margin-bottom: 0;
}

.login-policy .declared p {
    margin-top: 0;
}

.tc-wrap .declared p {
    margin-bottom: 2.66667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .declared {
        font-size: 1.94903vmax;
        padding: 1.49925vmax;
        margin-bottom: 1.49925vmax;
        border-radius: 1.1994vmax;
    }

    .tc-wrap .declared p {
        margin-bottom: 1.49925vmax;
    }
}

.extra-wrap {
    justify-content: center;
}

.extra-wrap div {
    margin-right: 2.66667vw;
}

.extra-wrap div:last-of-type {
    margin-right: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .extra-wrap div {
        margin-right: 1.49925vmax;
    }
}

.power-content-b {
    display: none;
    background-color: rgba(255, 255, 255, 0.3);
    border-color: rgba(0, 0, 0, 0.3);
    color: rgba(0, 0, 0, 0.5);
}

.appdl-link-android,
.appdl-link-ios {
    display: none;
    margin-bottom: 8vw;
    color: #666;
    font-size: 2.66667vw;
    text-align: center;
}

.appdl-link-android img,
.appdl-link-ios img {
    width: 41.33333vw;
    height: auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .appdl-link-android,
    .appdl-link-ios {
        margin-bottom: 0;
        font-size: 1.49925vmax;
    }

    .appdl-link-android img,
    .appdl-link-ios img {
        width: 23.23838vmax;
    }
}

.appdl-link-ios img {
    width: 32vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .appdl-link-ios img {
        width: 17.991vmax;
    }
}

.bet-limit {
    position: absolute;
    z-index: 1;
    width: 10.4vw;
    height: 9.33333vw;
    background: #e0e6e6;
}

.bet-limit:before {
    content: "";
    width: 6.66667vw;
    height: 6.66667vw;
    background: url('data:image/svg+xml,<svg height="25" viewBox="0 0 25 25" width="25" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform=""><circle cx="12.5" cy="12.5" fill="%237e97a7" fill-rule="evenodd" r="12.5"/><circle cx="12.5" cy="12.5" r="12" stroke="%237e97a7"/><path d="m8 14h6v2h-6v3l-4-4 4-4zm9 0v-3h-6v-2h6v-3l4 4z" fill="%23e0e6e6" fill-rule="nonzero" transform="matrix(0 1 -1 0 25 0)"/></g></svg>') no-repeat;
    background-size: contain;
    margin: 2.13333vw 1.86667vw 0.53333vw 1.86667vw;
}

.bet-limit:after {
    position: absolute;
    left: 10.4vw;
    content: "";
    width: 0;
    height: 0;
    border-top: 0px solid transparent;
    border-bottom: 9.33333vw solid transparent;
    border-left: 1.86667vw solid #e0e6e6;
}

.bet-limit+.bets-selections-head {
    padding-left: 12.26667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bet-limit {
        width: 5.84708vmax;
        height: 5.24738vmax;
    }

    .bet-limit:before {
        width: 3.74813vmax;
        height: 3.74813vmax;
        margin: 1.1994vmax 1.04948vmax 0.29985vmax 1.04948vmax;
    }

    .bet-limit:after {
        left: 5.84708vmax;
        border-bottom: 5.24738vmax solid transparent;
        border-left: 1.04948vmax solid #e0e6e6;
    }

    .bet-limit+.bets-selections-head {
        padding-left: 6.89655vmax;
    }
}

.limit_info-popup {
    right: auto !important;
}

.limit_info-popup dl {
    padding: 0 1.86667vw 1.86667vw;
}

.limit_info-popup dl:first-of-type {
    border-left: 0.26667vw solid #e0e6e6;
}

.limit_info-popup dl:last-of-type {
    border-right: none;
}

.limit_info-popup .close {
    line-height: 8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .limit_info-popup dl {
        padding: 0 1.04948vmax 1.04948vmax;
    }

    .limit_info-popup dl:first-of-type {
        border-left: 0.14993vmax solid #e0e6e6;
    }

    .limit_info-popup .close {
        line-height: 4.49775vmax;
    }
}

.limit_info-popup:not(:target) {
    display: none;
}

.limit_info-popup:target {
    display: flex;
}

.saddle_1 {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1:before {
    content: "1";
}

.saddle_1A {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1A:before {
    content: "1A";
}

.saddle_1B {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1B:before {
    content: "1B";
}

.saddle_1C {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1C:before {
    content: "1C";
}

.saddle_1D {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1D:before {
    content: "1D";
}

.saddle_1X {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1X:before {
    content: "1X";
}

.saddle_1Y {
    background-color: #bc0000;
    color: #fff;
}

.saddle_1Y:before {
    content: "1Y";
}

.saddle_2 {
    content: "2";
    background-color: #fff;
    border-color: #dfdfdf;
    color: #000;
}

.saddle_2:before {
    content: "2";
}

.saddle_2B {
    content: "2B";
    background-color: #fff;
    border-color: #dfdfdf;
    color: #000;
}

.saddle_2B:before {
    content: "2B";
}

.saddle_2C {
    content: "2C";
    background-color: #fff;
    border-color: #dfdfdf;
    color: #000;
}

.saddle_2C:before {
    content: "2C";
}

.saddle_2X {
    content: "2X";
    background-color: #fff;
    border-color: #dfdfdf;
    color: #000;
}

.saddle_2X:before {
    content: "2X";
}

.saddle_3 {
    background-color: #243b84;
    color: #fff;
}

.saddle_3:before {
    content: "3";
}

.saddle_3C {
    background-color: #243b84;
    color: #fff;
}

.saddle_3C:before {
    content: "3C";
}

.saddle_3D {
    background-color: #243b84;
    color: #fff;
}

.saddle_3D:before {
    content: "3D";
}

.saddle_3E {
    background-color: #243b84;
    color: #fff;
}

.saddle_3E:before {
    content: "3E";
}

.saddle_3X {
    background-color: #243b84;
    color: #fff;
}

.saddle_3X:before {
    content: "3X";
}

.saddle_4 {
    background-color: #c1a800;
    color: #000;
}

.saddle_4:before {
    content: "4";
}

.saddle_4D {
    background-color: #c1a800;
    color: #000;
}

.saddle_4D:before {
    content: "4D";
}

.saddle_4X {
    background-color: #c1a800;
    color: #000;
}

.saddle_4X:before {
    content: "4X";
}

.saddle_5 {
    background-color: #1c5b1b;
    color: #fff;
}

.saddle_5:before {
    content: "5";
}

.saddle_6 {
    background-color: #252525;
    color: #fff;
}

.saddle_6:before {
    content: "6";
}

.saddle_7 {
    background-color: #b63d13;
    color: #000;
}

.saddle_7:before {
    content: "7";
}

.saddle_8 {
    background-color: #b27692;
    color: #000;
}

.saddle_8:before {
    content: "8";
}

.saddle_9 {
    background-color: #14a19c;
    color: #000;
}

.saddle_9:before {
    content: "9";
}

.saddle_10 {
    background-color: #610f9a;
    color: #fff;
}

.saddle_10:before {
    content: "10";
}

.saddle_11 {
    background-color: #6b6b6b;
    color: #fff;
}

.saddle_11:before {
    content: "11";
}

.saddle_11F {
    background-color: #6b6b6b;
    color: #fff;
}

.saddle_11F:before {
    content: "11F";
}

.saddle_12 {
    background-color: #2e9a3b;
    color: #fff;
}

.saddle_12:before {
    content: "12";
}

.saddle_12F {
    background-color: #2e9a3b;
    color: #fff;
}

.saddle_12F:before {
    content: "12F";
}

.saddle_13 {
    background-color: #413733;
    color: #fff;
}

.saddle_13:before {
    content: "13";
}

.saddle_13F {
    background-color: #413733;
    color: #fff;
}

.saddle_13F:before {
    content: "13F";
}

.saddle_14 {
    background-color: #790031;
    color: #fff;
}

.saddle_14:before {
    content: "14";
}

.saddle_14F {
    background-color: #790031;
    color: #fff;
}

.saddle_14F:before {
    content: "14F";
}

.saddle_15 {
    background-color: #715933;
    color: #fff;
}

.saddle_15:before {
    content: "15";
}

.saddle_15F {
    background-color: #715933;
    color: #fff;
}

.saddle_15F:before {
    content: "15F";
}

.saddle_16 {
    background-color: #3b5d8f;
    color: #fff;
}

.saddle_16:before {
    content: "16";
}

.saddle_16F {
    background-color: #3b5d8f;
    color: #fff;
}

.saddle_16F:before {
    content: "16F";
}

.saddle_17 {
    background-color: #191986;
    color: #fff;
}

.saddle_17:before {
    content: "17";
}

.saddle_17F {
    background-color: #191986;
    color: #fff;
}

.saddle_17F:before {
    content: "17F";
}

.saddle_18 {
    background-color: #0d4507;
    color: #fff;
}

.saddle_18:before {
    content: "18";
}

.saddle_18F {
    background-color: #0d4507;
    color: #fff;
}

.saddle_18F:before {
    content: "18F";
}

.saddle_19 {
    background-color: #283f62;
    color: #fff;
}

.saddle_19:before {
    content: "19";
}

.saddle_19F {
    background-color: #283f62;
    color: #fff;
}

.saddle_19F:before {
    content: "19F";
}

.saddle_20 {
    background-color: #45001b;
    color: #fff;
}

.saddle_20:before {
    content: "20";
}

.saddle_20F {
    background-color: #45001b;
    color: #fff;
}

.saddle_20F:before {
    content: "20F";
}

.saddle_21 {
    background-color: #45001b;
    color: #fff;
}

.saddle_21:before {
    content: "21";
}

.saddle_21F {
    background-color: #45001b;
    color: #fff;
}

.saddle_21F:before {
    content: "21F";
}

.saddle_22 {
    background-color: #45001b;
    color: #fff;
}

.saddle_22:before {
    content: "22";
}

.saddle_22F {
    background-color: #45001b;
    color: #fff;
}

.saddle_22F:before {
    content: "22F";
}

.saddle_23 {
    background-color: #45001b;
    color: #fff;
}

.saddle_23:before {
    content: "23";
}

.saddle_23F {
    background-color: #45001b;
    color: #fff;
}

.saddle_23F:before {
    content: "23F";
}

.saddle_24 {
    background-color: #45001b;
    color: #fff;
}

.saddle_24:before {
    content: "24";
}

.saddle_24F {
    background-color: #45001b;
    color: #fff;
}

.saddle_24F:before {
    content: "24F";
}

.saddle_25 {
    background-color: #45001b;
    color: #fff;
}

.saddle_25:before {
    content: "25";
}

.saddle_25F {
    background-color: #45001b;
    color: #fff;
}

.saddle_25F:before {
    content: "25F";
}

.saddle_26 {
    background-color: #45001b;
    color: #fff;
}

.saddle_26:before {
    content: "26";
}

.saddle_26F {
    background-color: #45001b;
    color: #fff;
}

.saddle_26F:before {
    content: "26F";
}

.saddle_27 {
    background-color: #45001b;
    color: #fff;
}

.saddle_27:before {
    content: "27";
}

.saddle_27F {
    background-color: #45001b;
    color: #fff;
}

.saddle_27F:before {
    content: "27F";
}

.saddle_28 {
    background-color: #45001b;
    color: #fff;
}

.saddle_28:before {
    content: "28";
}

.saddle_28F {
    background-color: #45001b;
    color: #fff;
}

.saddle_28F:before {
    content: "28F";
}

.saddle_29 {
    background-color: #45001b;
    color: #fff;
}

.saddle_29:before {
    content: "29";
}

.saddle_29F {
    background-color: #45001b;
    color: #fff;
}

.saddle_29F:before {
    content: "29F";
}

.saddle_30 {
    background-color: #45001b;
    color: #fff;
}

.saddle_30:before {
    content: "30";
}

.saddle_30F {
    background-color: #45001b;
    color: #fff;
}

.saddle_30F:before {
    content: "30F";
}

.fancy_bet-head {
    border-bottom-color: #087989;
}

.fancy_bet-head h4 span {
    padding-right: 1.86667vw;
    background-image: linear-gradient(-180deg, #0a92a5 0%, #087989 82%);
}

.betsbuzz365 .mob-inform-link,
.skyinplay .mob-inform-link,
.betsbuzz365 .mob-inform-link,
.probetx .mob-inform-link,
.cftbet365 .mob-inform-link,
.crickzoom .mob-inform-link,
.crickzoomlive .mob-inform-link,
.probet247 .mob-inform-link,
.goexchange .mob-inform-link,
.wickets247 .mob-inform-link,
.iceEX .mob-inform-link,
.sportsexchlive .mob-inform-link {
    color: rgba(0, 0, 0, 0.5);
}

.mob-inform-link {
    width: 100vw;
    margin: 4.26667vw auto 5.86667vw;
    padding: 0 1.86667vw;
    text-align: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .fancy_bet-head h4 {
        margin-right: 1.49925vmax;
    }

    .fancy_bet-head h4 span {
        padding-right: 1.49925vmax;
    }

    .fancy_bet-head .in-play pre {
        width: 2.69865vmax;
        height: 2.69865vmax;
        border-radius: 0.5997vmax;
        margin-right: 1.1994vmax;
    }

    .fancy_bet-head .in-play pre:before {
        width: 1.7991vmax;
        height: 1.7991vmax;
    }
}

.fancy_bet-head .pin-on,
.fancy_bet-head .pin-off {
    position: relative;
    width: 10.66667vw;
    height: 8vw;
    margin-right: 0;
    background: url('data:image/svg+xml,<svg viewBox="0 0 40 30" preserveAspectRatio="xMinYMax" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h32l8 30H0z" fill="%23182832"/></svg>'), linear-gradient(-180deg, #0a92a5 0%, #087989 82%);
    background-repeat: no-repeat, no-repeat;
    background-position: left, right;
    background-size: cover, cover;
}

.fancy_bet-head .pin-on:before,
.fancy_bet-head .pin-off:before {
    position: absolute;
    left: 1.6vw;
    top: 1.06667vw;
    display: block;
    width: 5.86667vw;
    height: 5.86667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(107,189,17)"/><path fill="rgb(255,255,255)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>') no-repeat;
    background-size: cover;
    content: "";
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .fancy_bet-head .pin-on,
    .fancy_bet-head .pin-off {
        width: 5.997vmax;
        height: 4.49775vmax;
    }

    .fancy_bet-head .pin-on:before,
    .fancy_bet-head .pin-off:before {
        left: 0.89955vmax;
        top: 0.5997vmax;
        width: 3.29835vmax;
        height: 3.29835vmax;
    }
}

.fancy_bet-head .pin-off:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none" fill-rule="evenodd"><circle cx="12.5" cy="12.5" r="12.5" fill="rgb(59, 81, 96)"/><path fill="rgb(197,208,215)" d="M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"/></g></svg>') no-repeat center;
    background-size: cover;
}

.btn-head_rules {
    width: 10.93333vw;
    height: 100%;
    background-size: 101% 101%;
    /* background-repeat: no-repeat; */
    align-items: center;
    justify-content: center;
    vertical-align: bottom;
}

.btn-head_rules:before {
    content: "";
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M6.35 10.9h1.3V9.6h-1.3v1.3zM7 .5A6.502 6.502 0 00.5 7c0 3.588 2.912 6.5 6.5 6.5s6.5-2.912 6.5-6.5S10.588.5 7 .5zm0 11.7A5.207 5.207 0 011.8 7c0-2.867 2.333-5.2 5.2-5.2s5.2 2.333 5.2 5.2-2.333 5.2-5.2 5.2zm0-9.1a2.6 2.6 0 00-2.6 2.6h1.3c0-.715.585-1.3 1.3-1.3.715 0 1.3.585 1.3 1.3 0 1.3-1.95 1.138-1.95 3.25h1.3c0-1.462 1.95-1.625 1.95-3.25A2.6 2.6 0 007 3.1z" fill="%23FFF" fill-rule="evenodd"/></svg>');
    background-repeat: no-repeat;
    background-size: contain;
}

.fancy_bet-head .btn-head_rules {
    background-image: url(../images/sprite/bg-fanctbet_rules.svg);
}

/*
.sportsbook_bet-head .btn-head_rules {
    background-image: url('../images/bg-sportsbook_rules.svg');
} */
@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-head_rules {
        width: 6.14693vmax;
    }

    .btn-head_rules:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
    }
}

.other-tab {
    position: relative;
    height: 8vw;
    line-height: 8vw;
    color: #c5d0d7;
    font-size: 3.73333vw;
    font-weight: bold;
    background-color: #000;
    padding: 0 0.8vw;
}

.other-tab:before,
.other-tab:after {
    content: "";
    position: absolute;
    top: 0;
    left: -4.53333vw;
    width: 4.53333vw;
    height: 8vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 31"><path fill="rgb(0, 0, 0)" fill-rule="evenodd" d="M42 0h66.637a8 8 0 0 1 7.595 5.488L125 32H0L8.768 5.488A8 8 0 0 1 16.363 0H42z"/></svg>');
    background-repeat: no-repeat;
    background-size: 101% 101%;
}

.other-tab:after {
    left: inherit;
    right: -4.53333vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 31"><path fill="rgb(0, 0, 0)" fill-rule="evenodd" d="M-66 0H.637a8 8 0 0 1 7.595 5.488L17 32h-125l8.768-26.512A8 8 0 0 1-91.637 0H-66z"/></svg>');
}

.other-tab .tag-new {
    top: -1.6vw;
    right: -4vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .other-tab {
        height: 4.49775vmax;
        line-height: 4.49775vmax;
        font-size: 2.09895vmax;
        padding: 0 0.44978vmax;
    }

    .other-tab:before,
    .other-tab:after {
        left: -2.54873vmax;
        width: 2.54873vmax;
        height: 4.49775vmax;
    }

    .other-tab:after {
        left: inherit;
        right: -2.54873vmax;
    }

    .other-tab .tag-new {
        top: -0.89955vmax;
        right: -2.24888vmax;
    }
}

.fancy-bet .bets-selections-head {
    line-height: 5.86667vw;
    border-bottom-width: 0;
    color: #1e1e1e;
}

.fancy-bet .bets-selections-head dt {
    padding: 0 1.86667vw;
}

.fancy-bet .bets-selections-head dd {
    padding: 0;
}

.fancy-bet .bets-selections dt {
    padding: 0 1.86667vw;
}

.fancy-bet .bets-selections dt ul {
    width: 100%;
    font-size: 2.93333vw;
}

.fancy-bet .bets-selections dt li {
    margin-right: 0;
}

.fancy-bet .bets-selections dt li:before {
    content: "";
    width: 1.06667vw;
    height: 1.06667vw;
    background-color: #7e97a7;
    border-radius: 50%;
    vertical-align: middle;
    margin: 0 1.33333vw;
}

.fancy-bet .bets-selections dl.tips {
    width: 100%;
    font-size: 2.93333vw;
    list-style-type: none;
    font-weight: normal;
}

.fancy-bet .bets-selections dl.tips dt {
    padding-left: 0;
}

.fancy-bet .bets-selections dl.tips dd {
    color: #1e1e1e;
}

.fancy-bet .bets-selections dl.tips .win,
.fancy-bet .bets-selections dl.tips .to-win {
    padding-right: 1.33333vw;
}

.multi .fancy-bet:last-of-type {
    margin-bottom: 5.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .fancy-bet .bets-selections-head {
        line-height: 3.29835vmax;
    }

    .fancy-bet .bets-selections-head dt {
        padding: 0 1.04948vmax;
    }

    .fancy-bet .bets-selections dt {
        padding: 0 1.04948vmax;
    }

    .fancy-bet .bets-selections dt ul {
        font-size: 1.64918vmax;
    }

    .fancy-bet .bets-selections dt li:before {
        width: 0.5997vmax;
        height: 0.5997vmax;
        margin: 0 0.74963vmax;
    }

    .fancy-bet .bets-selections dl.tips {
        width: 100%;
        font-size: 1.64918vmax;
    }

    .fancy-bet .bets-selections dl.tips .win,
    .fancy-bet .bets-selections dl.tips .to-win {
        padding-right: 0.74963vmax;
    }

    .multi .fancy-bet:last-of-type {
        margin-bottom: 2.9985vmax;
    }
}

.fancy-wrap.multi {
    margin-bottom: 5.33333vw;
}

.fancy-wrap .bet_slipbar-content:last-child {
    border-bottom-width: 1px;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .fancy-wrap.multi {
        margin-bottom: 2.9985vmax;
    }

    .fancy-wrap.multi:last-of-type {
        margin-bottom: 2.9985vmax;
    }
}

.btn-fancy_info {
    height: 6.4vw;
    padding: 0 1.6vw;
    margin-right: 1.86667vw;
    background-color: #bed5d8;
    color: #000;
    font-size: 3.46667vw;
    line-height: 6.4vw;
    border-radius: 1.06667vw;
}

.btn-fancy_info:before {
    content: "";
    width: 3.46667vw;
    height: 3.46667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="%23243A48" fill-rule="evenodd" d="M6.5 13a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm0-1a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm-.667-3.714v-.638c0-.188.021-.356.064-.505.046-.143.138-.286.274-.429l1.169-1.21c.217-.228.325-.442.325-.642a.767.767 0 0 0-.357-.643 1.398 1.398 0 0 0-.766-.224c-.341 0-.62.078-.837.234-.247.161-.37.438-.37.828H4v-.195c.009-.54.258-.983.747-1.329.481-.349 1.056-.527 1.724-.533.681.006 1.267.171 1.756.495.507.34.764.799.773 1.376-.009.41-.149.751-.421 1.024L7.39 7.115a.82.82 0 0 0-.224.614v.557H5.833zm0 1.714v-.995h1.334V10H5.833z"/></svg>') no-repeat;
    background-size: contain;
    margin: 1.33333vw 0.8vw 0 0;
}

.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info {
    flex-basis: 8vw;
}

.fancy-bet .btn-fancy_info:before,
.sports-book .btn-fancy_info:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%23ffffff" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat;
    background-size: contain;
}

.fancy-bet h5 .btn-fancy_info:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%233B5160" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-fancy_info {
        height: 3.5982vmax;
        padding: 0 0.89955vmax;
        margin-right: 1.04948vmax;
        font-size: 1.94903vmax;
        line-height: 3.5982vmax;
        border-radius: 0.5997vmax;
    }

    .btn-fancy_info:before {
        width: 1.94903vmax;
        height: 1.94903vmax;
        margin: 0.74963vmax 0.74963vmax 0 0;
    }

    .fancy-bet .btn-fancy_info {
        flex-basis: 4.49775vmax;
    }
}

.support-wrap .support-service::before,
.support-wrap .support-service::after {
    content: "";
    display: block;
    flex: 1;
    align-self: flex-end;
    height: 0.26667vw;
    background-color: rgba(255, 255, 255, 0.3);
    margin-bottom: -0.26667vw;
}

.support-wrap .support-service a.open::after {
    content: '';
    position: absolute;
    top: 100%;
    height: 7.2vw;
    background-image: url('../images/sprite/support_arrow.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-color: initial;
}

.fancy_info-popup,
.limit_info-popup {

    position: absolute;
    top: 0;
    right: 1.86667vw;
    background-color: #fff;
    border-radius: 1.06667vw;
    align-items: flex-start;
    z-index: 9;
}

.fancy_info-popup dl,
.limit_info-popup dl {
    padding: 0 1.86667vw 1.86667vw;
}

.fancy_info-popup dl:last-of-type,
.limit_info-popup dl:last-of-type {
    border-right: 0.26667vw solid #e0e6e6;
}

.fancy_info-popup dt,
.limit_info-popup dt {
    height: 3.2vw;
    color: #577c94;
    font-size: 2.66667vw;
    line-height: 3.2vw;
    padding: 0.8vw 0 1.06667vw;
}

.fancy_info-popup dd,
.limit_info-popup dd {
    line-height: 3.73333vw;
    padding-bottom: 1.33333vw;
}

.fancy_info-popup dd:last-of-type,
.limit_info-popup dd:last-of-type {
    padding-bottom: 0;
}

.fancy_info-popup .close,
.limit_info-popup .close {
    width: 6.66667vw;
    height: 6.66667vw;
}

.mode-land .fancy_info-popup,
.mode-land .limit_info-popup {
    align-items: center;
}

.mode-land .fancy_info-popup dt,
.mode-land .limit_info-popup dt {
    height: 5.06667vw;
    font-weight: normal;
    line-height: 5.06667vw;
}

.mode-land .fancy_info-popup dd,
.mode-land .limit_info-popup dd {
    line-height: 4vw;
}

.fancy-bet .fancy_info-popup,
.fancy-bet .limit_info-popup {
    color: #1e1e1e;
    font-weight: normal;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .fancy_info-popup,
    .limit_info-popup {
        right: 1.04948vmax;
        border-radius: 0.5997vmax;
    }

    .fancy_info-popup dl,
    .limit_info-popup dl {
        padding: 0 1.04948vmax 1.04948vmax;
    }

    .fancy_info-popup dl:last-of-type,
    .limit_info-popup dl:last-of-type {
        border-right-width: 0.14993vmax;
    }

    .fancy_info-popup dt,
    .limit_info-popup dt {
        height: 1.7991vmax;
        font-size: 1.49925vmax;
        line-height: 1.7991vmax;
        padding: 0.44978vmax 0 0.5997vmax;
    }

    .fancy_info-popup dd,
    .limit_info-popup dd {
        line-height: 2.09895vmax;
        padding-bottom: 0.74963vmax;
    }

    .fancy_info-popup .close,
    .limit_info-popup .close {
        width: 3.74813vmax;
        height: 3.74813vmax;
    }

    .mode-land .fancy_info-popup,
    .mode-land .limit_info-popup {
        display: flex;
        position: relative;
        width: 100%;
        right: 0;
        box-shadow: none;
        border-radius: 0;
    }

    .mode-land .fancy_info-popup dl,
    .mode-land .limit_info-popup dl {
        padding: 0 0 0 0.44978vmax;
    }

    .mode-land .fancy_info-popup dl:last-of-type,
    .mode-land .limit_info-popup dl:last-of-type {
        border-right-width: 0;
    }

    .mode-land .fancy_info-popup dt,
    .mode-land .limit_info-popup dt {
        height: 2.24888vmax;
        line-height: 2.24888vmax;
    }

    .mode-land .fancy_info-popup dd,
    .mode-land .limit_info-popup dd {
        line-height: 2.24888vmax;
        font-size: 1.64918vmax;
    }

    .mode-land .fancy_info-popup .close,
    .mode-land .limit_info-popup .close {
        display: none;
    }
}

.btn-minmax_bet {
    position: absolute;
    top: 0;
    right: 0;
    width: 8vw;
    height: 8.53333vw;
}

.btn-minmax_bet:before {
    width: 4.26667vw;
    height: 4.26667vw;
    background: url('data:image/svg+xml,<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M6.35 10.9h1.3V9.6h-1.3v1.3zM7 .5A6.502 6.502 0 00.5 7c0 3.588 2.912 6.5 6.5 6.5s6.5-2.912 6.5-6.5S10.588.5 7 .5zm0 11.7A5.207 5.207 0 011.8 7c0-2.867 2.333-5.2 5.2-5.2s5.2 2.333 5.2 5.2-2.333 5.2-5.2 5.2zm0-9.1a2.6 2.6 0 00-2.6 2.6h1.3c0-.715.585-1.3 1.3-1.3.715 0 1.3.585 1.3 1.3 0 1.3-1.95 1.138-1.95 3.25h1.3c0-1.462 1.95-1.625 1.95-3.25A2.6 2.6 0 007 3.1z" fill="%23FFF" fill-rule="evenodd"/></svg>') center no-repeat;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-minmax_bet {
        width: 4.49775vmax;
        height: 4.7976vmax;
    }

    .btn-minmax_bet:before {
        width: 2.3988vmax;
        height: 2.3988vmax;
    }
}

.suspend-fancy {
    position: absolute;
    right: 0;
    width: 37.33333vw;
    height: 100%;
}

.suspend-fancy p {
    opacity: 0.8;
}

.bets-selections .suspend-fancy {
    width: 37.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .suspend-fancy {
        right: 20.08996vmax;
        width: 20.08996vmax;
    }

    .bets-selections .suspend-fancy {
        width: 20.08996vmax;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .fancy-bet .suspend {
        right: 20.08996vmax;
        width: 20.08996vmax;
    }
}

.bet-setting {
    padding: 0 1.86667vw;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

.back .bet-setting {
    background: #c7dbe9;
}

.lay .bet-setting {
    background: #ebd5db;
}

.book .bet-setting {
    background: #b7e2b2;
}

.bet-setting .bet-check {
    height: 8.53333vw;
    align-items: center;
    font-size: 3.46667vw;
    color: #1e1e1e;
    margin-right: 1.86667vw;
}

.bet-setting .bet-check:before {
    width: 4.8vw;
    height: 4.8vw;
    background-color: #fff;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.4);
    border-radius: 1.06667vw;
    margin-right: 1.86667vw;
    content: "";
}

.bet-setting .max-bet {
    display: inline-block;
    width: 13.33333vw;
    height: 5.33333vw;
    background-color: rgba(0, 0, 0, 0.1);
    font-size: 3.46667vw;
    font-weight: bold;
    color: #1e1e1e;
    line-height: 5.33333vw;
    text-align: center;
    margin-right: 1.33333vw;
    border-radius: 0.8vw;
}

.bet-setting .checked:before {
    background: #000 url('data:image/svg+xml,<svg width="18" height="17" xmlns="http://www.w3.org/2000/svg"><path d="M17.28.34c.37.3.6.69.69 1.18.09.48-.01.93-.3 1.35L8.73 16.26c-.3.38-.66.62-1.1.7-.45.1-.86 0-1.24-.3-.23-.18-.83-.8-1.81-1.89-.98-1.07-1.9-2.12-2.77-3.12l-1.33-1.5A1.86 1.86 0 0 1 0 8.84c0-.5.17-.93.52-1.28.34-.36.75-.53 1.2-.51.47.01.86.21 1.17.6l4.28 4.74L14.95.74c.28-.38.65-.62 1.1-.7.44-.1.85 0 1.23.3z" fill="%231E1E1E" fill-rule="evenodd"/></svg>') no-repeat;
    background-size: 2.93333vw 2.93333vw;
    background-position: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bet-setting {
        padding: 0 1.04948vmax;
    }

    .bet-setting .bet-check {
        height: 4.7976vmax;
        font-size: 1.94903vmax;
    }

    .bet-setting .bet-check:before {
        width: 2.69865vmax;
        height: 2.69865vmax;
        box-shadow: inset 0 0.29985vmax 0.29985vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.5997vmax;
        margin-right: 1.04948vmax;
    }

    .bet-setting .checked:before {
        background-size: 1.64918vmax 1.64918vmax;
    }

    .bet-setting .max-bet {
        width: 7.49625vmax;
        height: 2.9985vmax;
        font-size: 1.94903vmax;
        line-height: 2.9985vmax;
        margin-right: 0.74963vmax;
        border-radius: 0.44978vmax;
    }
}

.sportsbook_bet-head {
    position: relative;
    border-bottom-color: #e4550f;
}

.sportsbook_bet-head h4 span {
    padding-right: 1.86667vw;
    background-image: linear-gradient(180deg, #ef6c2c 0%, #e4550f 82%);
}

.sportsbook_bet-head .btn-fancy_info {
    position: absolute;
    right: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .sportsbook_bet-head h4 span {
        padding-right: 1.04948vmax;
    }
}

.special_bets-tab-wrap {
    background-color: #e4550f;
    overflow: hidden;
    padding-bottom: 1.33333vw;
    color: #fff;
    font-size: 3.2vw;
    font-weight: bold;
    overflow-x: auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .special_bets-tab-wrap {
        padding-bottom: 0.74963vmax;
        font-size: 1.7991vmax;
    }
}

.special_bets-tab {
    line-height: 6.93333vw;
    align-items: center;
    padding: 0 1.86667vw;
}

.special_bets-tab li {
    position: relative;
    /* min-width: 22.13333vw; */
    list-style: none;
}

.special_bets-tab li:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 1px;
    height: 5.33333vw;
    background-color: rgba(255, 255, 255, 0.4);
    transform: translate(-50%, -50%);
}

.special_bets-tab li:last-of-type:after {
    display: none;
}

.special_bets-tab-wrap,
.fancy_bet_tab-wrap {

    color: #fff;
    font-size: 3.2vw;
    font-weight: bold;
}

.special_bets-tab a {
    color: #fff;
    padding: 0 2.66667vw;
    height: 100%;
    border-radius: 1.06667vw;
}

.special_bets-tab .select a {
    background-color: #fff;
    color: #000;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .special_bets-tab {
        line-height: 3.89805vmax;
        padding: 0 1.04948vmax;
    }

    .special_bets-tab li {
        min-width: 12.44378vmax;
    }

    .special_bets-tab li:after {
        height: 2.9985vmax;
    }

    .special_bets-tab a {
        border-radius: 0.5997vmax;
    }
}

/* .sports-book dd {
    width: 37.33333vw;
}
.sports-book .back-1 {
    background-color: #72e3a0;
}
.sports-book .back-1.select {
    background-color: #16a660;
}
.sports-book.close {
    font-size: inherit;
    text-indent: 0;
    border-bottom-width: 0;
    margin-bottom: 0.26667vw;
}
.sports-book.close:before {
    display: none;
}
.sports-book.close:last-of-type {
    margin-bottom: 2.66667vw;
}
.sports-book.close .bets-selections,
.sports-book.close .bet_slipbar-content {
    display: none;
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .sports-book dd {
        width: 20.08996vmax;
    }
    .sports-book.close {
        margin-bottom: 0.14993vmax;
    }
    .sports-book.close:last-of-type {
        margin-bottom: 1.49925vmax;
    }
} */
.suspend-spb {
    position: absolute;
    right: 0;
    width: 37.33333vw;
    height: 100%;
}

.suspend-spb p {
    opacity: 0.8;
}

.bets-selections .suspend-spb {
    width: 37.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .suspend-spb {
        right: 20.08996vmax;
        width: 20.08996vmax;
    }

    .bets-selections .suspend-spb {
        width: 20.08996vmax;
    }
}

.to-expand {
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.to-expand:after {
    content: "";
    width: 4vw;
    height: 4vw;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path fill="%23FFF" fill-rule="evenodd" d="M3 0h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3zm9 5.617v1.766H3V6.617h9z"/></svg>');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 1.86667vw;
}

.close .to-expand:after {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path fill="%23FFF" fill-rule="evenodd" d="M3 0h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3zm5.383 2v3.617H12v1.766H8.383V12H6.617V8.383H3V6.617h3.617V3h1.766z"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .to-expand:after {
        width: 2.24888vmax;
        height: 2.24888vmax;
        margin-right: 1.04948vmax;
    }
}

.bets-bookmaker {
    background-color: #f8f6e1;
}

.bets-bookmaker>h4 {
    justify-content: flex-start;
}

.bets-bookmaker>h4 span {
    flex: none;
}

.bets-bookmaker>h4 p {
    font-weight: normal;
    margin-left: 1.86667vw;
    opacity: 0.7;
}

.bets-bookmaker .bets-selections-head dd {
    border-right: none;
}

.bets-bookmaker .backlay_box {
    display: flex;
    width: 37.33333vw;
}

.bets-bookmaker .backlay_box dl {
    flex: 1;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-bookmaker .backlay_box {
        width: 60.26987vmax;
    }
}

.bets-bookmaker .fancy_info-popup,
.bets-bookmaker .limit_info-popup {
    font-weight: normal;
}

.bets-bookmaker .fancy_info-popup dd,
.bets-bookmaker .limit_info-popup dd {
    color: #1e1e1e;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-bookmaker>h4 p {
        margin-left: 1.04948vmax;
    }
}

.back-gradient,
.lay-gradient {
    justify-content: center;
    width: 18.66667vw;
    background-image: linear-gradient(90deg, rgba(151, 199, 234, 0.7) 0%, #97c7ea 65%);
}

.back-gradient dd,
.lay-gradient dd {
    flex: 1;
    border-right: none;
    color: #59708d;
    width: 17.6vw;
    padding: 0.8vw;
}

.back-gradient dd.mode-land,
.lay-gradient dd.mode-land {
    display: none;
}

.back-gradient dd a,
.lay-gradient dd a {
    height: 100%;
    width: 100%;
    border-radius: 1.06667vw;
    border: 0.26667vw solid #fff;
    background-color: #72bbef;
}

.back-gradient dd.select a,
.lay-gradient dd.select a,
.back-gradient dd.select a:hover,
.lay-gradient dd.select a:hover {
    color: #fff;
    background: #2395e6;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
}

.back-gradient dd p,
.lay-gradient dd p {
    width: 100%;
    text-align: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .back-gradient,
    .lay-gradient {
        background-image: linear-gradient(90deg, rgba(151, 199, 234, 0.15) 0%, #97c7ea 65%);
    }

    .back-gradient dd,
    .lay-gradient dd {
        width: 9.89505vmax;
        padding: 0.44978vmax;
    }

    .back-gradient dd.mode-land,
    .lay-gradient dd.mode-land {
        display: flex;
    }

    .back-gradient dd a,
    .lay-gradient dd a {
        border-radius: 0.5997vmax;
        border: 0.14993vmax solid #fff;
    }
}

.lay-gradient {
    background-image: linear-gradient(270deg, rgba(247, 205, 214, 0.75) 5%, #f0c0cb 60%);
}

.lay-gradient dd {
    color: #a9616d;
}

.lay-gradient dd.mode-land {
    display: none;
}

.lay-gradient dd a {
    background-color: #faa9ba;
}

.lay-gradient dd.select a,
.lay-gradient dd.select a:hover {
    color: #fff;
    background: #f4496d;
    border: 1px solid #ffffff;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .lay-gradient {
        background-image: linear-gradient(270deg, rgba(247, 205, 214, 0.46) 5%, #f0c0cb 60%);
    }

    .lay-gradient dd.mode-land {
        display: flex;
    }
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgb(0 0 0 / 22%);
    z-index: 99;
    justify-content: center;
    align-items: center;
    animation: fadeIn 0.5s ease;
}

.overlay:target {
    display: flex;
}

.pop-wrap,
.select-list {
    width: 84vw;
    background: #fff;
    font-size: 4vw;
    box-shadow: 0 0.8vw 2.66667vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 1.33333vw;
}

.pop-wrap h3,
.select-list h3 {
    font-size: 4vw;
    line-height: 1.2;
    color: #1e1e1e;
    background-image: linear-gradient(-180deg, #ffcc2e 0%, #000 58%);
    border-radius: 1.33333vw 1.33333vw 0 0;
    padding: 2.4vw 1.86667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .pop-wrap,
    .select-list {
        width: 47.22639vmax;
        font-size: 2.24888vmax;
        box-shadow: 0 0.44978vmax 1.49925vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.74963vmax;
    }

    .pop-wrap h3,
    .select-list h3 {
        font-size: 2.24888vmax;
        border-radius: 0.74963vmax 0.74963vmax 0 0;
        padding: 1.34933vmax 1.04948vmax;
    }
}

.transfer-wrap {
    color: #000;
}

.transfer-wrap .available-wrap {
    display: flex;
    justify-content: center;
}

.transfer-wrap .available-wrap h4 {
    font-size: 4.26667vw;
    line-height: 5.33333vw;
    width: 50%;
    padding: 1.33333vw 3.2vw 1.33333vw 3.2vw;
}

.transfer-wrap .available-wrap h4 span {
    display: block;
    font-size: 3.2vw;
    font-weight: normal;
}

.transfer-wrap .error {
    text-indent: 2.66667vw;
    line-height: 4vw;
    margin-bottom: 4vw;
    color: #d0021b;
    font-size: 3.2vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .transfer-wrap {
        width: 71.96402vmax;
    }

    .transfer-wrap .available-wrap {
        display: flex;
        justify-content: center;
    }

    .transfer-wrap .available-wrap h4 {
        font-size: 2.3988vmax;
        line-height: 2.9985vmax;
        width: 50%;
        padding: 0.89955vmax 2.54873vmax 0.89955vmax 2.9985vmax;
    }

    .transfer-wrap .available-wrap h4 span {
        font-size: 1.7991vmax;
    }

    .transfer-wrap .error {
        text-indent: 1.49925vmax;
        line-height: 2.24888vmax;
        margin-bottom: 2.24888vmax;
        font-size: 1.7991vmax;
    }
}

.transfer-content {
    border-top: 0.26667vw solid #8fa6b5;
    border-bottom: 0.26667vw solid #8fa6b5;
    width: 100%;
    margin-bottom: 2.66667vw;
}

.transfer-content dl {
    background-color: #cde3f0;
    padding: 3.73333vw 3.2vw 1.6vw 3.2vw;
}

.transfer-content dl:nth-child(even) {
    background-color: #fff;
}

.transfer-content dl:first-child {
    position: relative;
}

.transfer-content dl:first-child:before {
    position: absolute;
    display: block;
    content: "";
    width: 4vw;
    height: 4vw;
    background-color: #cde3f0;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.transfer-content dd {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.33333vw;
    width: 100%;
}

.transfer-content dd strong {
    font-size: 5.33333vw;
    line-height: 5.33333vw;
    margin-right: 1.33333vw;
}

.transfer-content dd input {
    width: calc(100% - 4.8vw);
    box-shadow: none;
    margin-bottom: 0;
}

.transfer-content dd input::placeholder {
    color: #989ea1;
}

.transfer-content dd.quick_stake {
    display: flex;
}

.transfer-content dd.quick_stake a {
    flex: 1;
    flex-direction: row;
    margin-right: 1.33333vw;
    line-height: 2.2;
}

.transfer-content dd.quick_stake a:last-child {
    margin-right: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .transfer-content {
        display: flex;
        justify-content: center;
        border-top: 0.14993vmax solid #8fa6b5;
        border-bottom: 0.14993vmax solid #8fa6b5;
        margin-bottom: 1.49925vmax;
    }

    .transfer-content dl {
        width: calc(100% - 1.7991vmax);
        padding: 0.89955vmax 2.54873vmax 0.89955vmax 2.9985vmax;
    }

    .transfer-content dl:before {
        top: 50%;
        left: calc(100% - 1.49925vmax);
        width: 2.24888vmax;
        height: 2.24888vmax;
    }

    .transfer-content dl:first-child:before {
        width: 2.24888vmax;
        height: 2.24888vmax;
        top: 50%;
        left: 100%;
    }

    .transfer-content dd {
        font-size: 2.09895vmax;
        line-height: 2.9985vmax;
        margin-bottom: 0.74963vmax;
    }

    .transfer-content dd strong {
        font-size: 2.9985vmax;
        line-height: 2.9985vmax;
        margin-right: 0.74963vmax;
    }

    .transfer-content dd input {
        width: calc(100% - 2.09895vmax);
        border: 0.14993vmax solid #8fa6b5;
    }

    .transfer-content dd.quick_stake a {
        margin-right: 0.74963vmax;
    }
}

.info-bet,
.info-matched {
    margin-bottom: 1.86667vw;
    flex-wrap: wrap;
    line-height: 1.2;
}

.info-bet dt,
.info-matched dt,
.info-bet dd,
.info-matched dd {
    padding: 1.86667vw;
    border-bottom: 1px solid #e0e6e6;
}

.info-bet dt,
.info-matched dt {
    flex: 0 0 100%;
    line-height: 8.53333vw;
}

.info-bet dd,
.info-matched dd {
    flex: 1.7;
    color: #1b2d38;
    font-size: 4.53333vw;
    border-right: 1px solid #e0e6e6;
}

.info-bet dd span,
.info-matched dd span {
    font-size: 4vw;
}

.info-bet dd:first-of-type,
.info-matched dd:first-of-type {
    flex: 1;
}

.info-bet dd:last-of-type,
.info-matched dd:last-of-type {
    border-right-width: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .info-bet,
    .info-matched {
        margin-bottom: 1.04948vmax;
    }

    .info-bet dt,
    .info-matched dt,
    .info-bet dd,
    .info-matched dd {
        padding: 1.04948vmax;
    }

    .info-bet dt,
    .info-matched dt {
        line-height: 4.7976vmax;
    }

    .info-bet dd,
    .info-matched dd {
        font-size: 2.54873vmax;
    }

    .info-bet dd span,
    .info-matched dd span {
        font-size: 2.24888vmax;
    }
}

.left-side {
    justify-content: flex-start;
    align-items: flex-start;
}

.right-side {
    justify-content: flex-end;
    align-items: flex-start;
}

.side-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: #eee;
    box-shadow: 0.53333vw 0 1.6vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 0 1.6vw 1.6vw 0;
    flex-direction: column;
}

.right-side .side-wrap {
    border-radius: 1.6vw 0 0 1.6vw;
}

.right-side .side-wrap .side-head {
    border-radius: 1.6vw 0 0 0;
}

.side-wrap .btn-list {
    flex: 0 0 12.8vw;
    margin-top: 1.86667vw;
}

.side-wrap .message-content {
    margin-top: 0;
}

.side-wrap .message-content .close {
    padding: 0 3.46667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .side-wrap {
        width: 74.96252vmax;
        box-shadow: 0.29985vmax 0 0.89955vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0 0.89955vmax 0.89955vmax 0;
    }

    .right-side .side-wrap {
        border-radius: 0.89955vmax 0 0 0.89955vmax;
    }

    .right-side .side-wrap .side-head {
        border-radius: 0.89955vmax 0 0 0;
    }

    .side-wrap .btn-list {
        flex: 0 0 7.1964vmax;
        margin-top: 1.04948vmax;
    }

    .side-wrap .message-content .close {
        padding: 0 1.94903vmax;
    }
}

.setting-tab {
    background-color: #fff;
    height: 85%;
}

@media (orientation: landscape) {
    .setting-tab {
        height: 100%;
    }
}

.full-pop,
.rules-pop,
.rules-download,
.login-pop {
    width: 100vw;
    background-color: #fff;
    border-radius: 1.6vw;
    height: 95%;
    overflow: auto;
    overflow-y: hidden;
}

.full-pop .side-head,
.rules-pop .side-head,
.rules-download .side-head,
.login-pop .side-head {
    border-radius: 1.6vw 1.6vw 0 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .full-pop,
    .rules-pop,
    .rules-download,
    .login-pop {
        width: 56.22189vmax;
        border-radius: 0.89955vmax;
    }

    .full-pop .side-head,
    .rules-pop .side-head,
    .rules-download .side-head,
    .login-pop .side-head {
        border-radius: 0.89955vmax 0.89955vmax 0 0;
    }
}

.rules-pop,
.rules-download {
    max-height: 95%;
}

.rules-download {
    width: 89.33333vw;
    height: auto;
}

.rules-download .side-content {
    border-radius: 0;
}

.rules-download .rules-content {
    padding: 0;
}

.rules-download .btn-list {
    padding-bottom: 0;
}

.rules-download .btn-list a {
    width: 45.33333vw;
    margin: 0 auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .rules-download {
        width: 50.22489vmax;
    }

    .rules-download .btn-list a {
        width: 25.48726vmax;
    }
}

.login-pop {
    height: 95%;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background-color: #1d2c38;
    background-image: linear-gradient(56deg, #3a5870 4%, #1d2c38 42%);
}

.login-pop .close {
    position: fixed;
    right: 1.86667vw;
    width: 9.33333vw;
    height: 9.33333vw;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    margin-top: 1.86667vw;
    z-index: 2;
}

.login-pop .close:before {
    width: 3.46667vw;
    height: 3.46667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>') no-repeat;
    background-size: contain;
}

.login-pop .login-head {
    border-radius: 1.6vw 1.6vw 0 0;
}

.login-pop .form-login {
    margin-bottom: 13.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .login-pop .close {
        position: absolute;
        right: 1.04948vmax;
        width: 4.49775vmax;
        height: 4.49775vmax;
        margin-top: 1.04948vmax;
    }

    .login-pop .close:before {
        width: 1.49925vmax;
        height: 1.49925vmax;
    }

    .login-pop .login-head {
        border-radius: 0.89955vmax 0.89955vmax 0 0;
    }

    .login-pop .form-login {
        margin-bottom: 7.49625vmax;
    }
}

.side-head {
    flex: 0 0 10.4vw;
    background: #000;
    border-radius: 0 1.6vw 0 0;
}

.side-head h3 {
    flex: 1;
    background: transparent;
    font-size: 4vw;
    color: #d0021b;
    line-height: 2.6;
    padding: 0 1.86667vw;
    align-items: center;
}

.side-head h3 img {
    width: 5.33333vw;
    height: 5.33333vw;
    vertical-align: middle;
    margin-right: 1.33333vw;
}

.side-head .close {
    padding: 0 3.46667vw;
    border-left: 1px solid #be7809;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .side-head {
        flex: 0 0 5.84708vmax;
        border-radius: 0 0.89955vmax 0 0;
    }

    .side-head h3 {
        font-size: 2.24888vmax;
        padding: 0 1.04948vmax;
    }

    .side-head h3 img {
        width: 2.9985vmax;
        height: 2.9985vmax;
        margin-right: 0.74963vmax;
    }

    .side-head .close {
        padding: 0 1.94903vmax;
    }
}

.side-content {
    flex: 1;
    border-radius: 0 0 1.6vw 0;
}

.side-content h3 {
    padding: 0 1.86667vw;
    justify-content: space-between;
    align-items: center;
}

.bets-bookmaker .btn-fancy_info {
    position: absolute;
    right: 0;
}

.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info,
.bets-wrap .btn-fancy_info {
    flex-basis: 8vw;
}

.mode-land .btn-fancy_info,
.fancy-bet .btn-fancy_info,
.sports-book .btn-fancy_info,
.bets-wrap .btn-fancy_info {
    width: 8vw;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: transparent;
    line-height: inherit;
    align-items: center;
    justify-content: center;
}

.bets-wrap .btn-fancy_info {
    display: flex;
}

.mode-land .btn-fancy_info:before,
.fancy-bet .btn-fancy_info:before,
.sports-book .btn-fancy_info:before,
.bets-wrap .btn-fancy_info:before {
    width: 4vw;
    height: 4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%233B5160" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat;
    background-size: contain;
    float: none;
    margin: 0;
}

.fancy-bet .btn-fancy_info:before,
.sports-book .btn-fancy_info:before,
.bets-wrap .btn-fancy_info:before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%23ffffff" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat;
    background-size: contain;
}

.side-content .bet_slipbar-content.back {
    border-bottom-color: #7da7c6;
}

.side-content .bet_slipbar-content.lay {
    border-bottom-color: #d38e9c;
}

.right-side .side-content {
    border-radius: 0 0 0 1.6vw;
}

.support-wrap {
    background-color: rgba(0, 0, 0, 0.6);
}

.align-C,
h3,
.btn,
.btn-send,
.login,
.form-select,
.pages a,
.logout,
.trade p,
.trade-2 p,
.info-bet dt span,
.info-matched dt span,
.bets-back dt span,
.bets-lay dt span,
.bets-book dt span,
.bets-head dt span,
.stake-setting input,
.col-stake_edit a,
.loading-wrap p,
.form-login dt,
.support-wrap,
footer,
.article-date {
    text-align: center;
}


.support-wrap .support-detail a {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8vw;
    color: #fff;
    text-decoration: underline;
}

.support-wrap .support-detail.open {
    display: block;
}

.transfer-wrap-slider .slider-bar_handle,
.a-edit,
.login-head h1,
.pass-head h1,
.login-head .close,
.pass-head .close {
    font-size: 0;
    text-indent: -99999px;
}

.betsbuzz365 .form-login dt {
    color: #000;
}

.betsbuzz365 .txt-wrap {
    background: rgba(0, 0, 0, 0.8);
    color: rgba(255, 255, 255, 0.6);
}

.txt-wrap {
    width: 84vw;
    margin: 0 auto;
    color: #7E97A7;
    line-height: 4.8vw;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 1.6vw;
    padding: 2.66667vw 1.86667vw;
}

.border-box,
.trade dt,
.trade-2 dt,
.trade dd,
.trade-2 dd,
.trade p,
.trade-2 p,
.info-bet dt,
.info-matched dt,
.info-bet dd,
.info-matched dd,
.a-edit,
.check-list a:before,
.setting-block dt,
.setting-block dd,
.stake-setting input,
.txt-wrap,
.mob-inform-link,
.announce-header,
footer,
footer .confirm-checkbox:before,
footer .btn,
footer .btn-send,
footer .login,
footer .form-select,
footer .pages a,
.pages footer a {
    box-sizing: border-box;
}

.txt-wrap ul {
    margin-left: 4.26667vw;
}

@media screen and (min-aspect-ratio: 16/9) {
    .pass-wrap {
        display: flex;
        padding: 0 1.49925vmax;
    }
}

@media (orientation: landscape) {
    .pass-wrap {
        padding: 0 2.66667vw;
        align-items: center;
    }

    .pass-wrap {
        padding-bottom: 5.33333vw;
    }
}

* {
    margin: 0;
    padding: 0;
}

user agent stylesheet div {
    display: block;
}

@media screen and (min-aspect-ratio: 16/9) {

    html,
    body {
        font-size: 1.94903vmax;
    }
}

.betsbuzz365 .login-head h1 {
    top: 43.66667vw;
    width: 67.86667vw;
    height: 27.13333vw;
    margin-left: -36.06667vw;
    background-image: url(../images/headerlogo.png);
    background-repeat: no-repeat;
}

@media (orientation: landscape) {

    .betsbuzz365 .login-head,
    .betsbuzz365 .pass-head {
        height: 21.333vw;
        background-image: linear-gradient(-180deg, #414141 0%, #000 100%);
    }

    .betsbuzz365 .login-head h1,
    .betsbuzz365 .pass-head h1 {
        top: 9.46667vw;
        width: 34.46667vw;
        height: 15.33333vw;
        /* background-image: url(/static/media/mobile-logo.199069b1.png); */
        margin-left: -18.06667vw;
    }
}


.betsbuzz365 .login-head,
.betsbuzz365 .pass-head {
    background-image: url('../images/kv/mobile-login.png');
}

.login-head,
.pass-head {
    position: relative;
    height: 74.66667vw;

    background-size: 100% 100%;
    margin-bottom: 12vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .side-content {
        border-radius: 0 0 0.89955vmax 0;
    }

    .side-content h3 {
        padding: 0 1.04948vmax;
    }

    .right-side .side-content {
        border-radius: 0 0 0 0.89955vmax;
    }
}

.slip-list {
    background-color: #fff;
}

.trashcan {
    color: #fff;
    font-size: 3.2vw;
    line-height: 8vw;
    background: #d0021b;
    border-radius: 1.06667vw;
    padding: 0 2.66667vw;
    justify-content: center;
    align-items: center;
    margin: 1.33333vw;
    margin-right: 0;
}

.trashcan:before {
    content: "";
    width: 2.93333vw;
    height: 3.46667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M8.278.71H11v1.457H0V.71h2.74L3.554 0h3.913l.812.71zM2.703 6.397l1.682 1.56L2.74 9.48l1.097 1.007L5.5 8.98l1.663 1.507L8.278 9.48 6.615 7.957l1.663-1.56-1.115-1.023L5.5 6.933l-1.663-1.56-1.134 1.023zM.775 11.544V2.877h9.45v8.667c0 .393-.157.734-.472 1.023-.315.29-.687.433-1.116.433H2.363c-.43 0-.8-.144-1.116-.433-.315-.29-.472-.63-.472-1.023z"/></svg>') no-repeat;
    background-size: contain;
    margin-right: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .trashcan {
        font-size: 1.7991vmax;
        line-height: 4.49775vmax;
        border-radius: 0.5997vmax;
        padding: 0 1.49925vmax;
        margin: 0.74963vmax;
    }

    .trashcan:before {
        width: 1.64918vmax;
        height: 1.94903vmax;
        margin-right: 0.74963vmax;
    }
}

.bets-back,
.bets-lay,
.bets-book,
.bets-head {
    background-color: #beddf4;
    border-bottom: 1px solid #7da7c6;
    align-items: stretch;
    flex-wrap: wrap;
}

.bets-back dt,
.bets-lay dt,
.bets-book dt,
.bets-head dt,
.bets-back dd,
.bets-lay dd,
.bets-book dd,
.bets-head dd {
    align-items: center;
    padding: 1.33333vw 1.86667vw;
}

.bets-back dt,
.bets-lay dt,
.bets-book dt,
.bets-head dt {
    flex: 1;
}

.bets-back dt span,
.bets-lay dt span,
.bets-book dt span,
.bets-head dt span {
    width: 12vw;
    line-height: 8vw;
}

.bets-back h4,
.bets-lay h4,
.bets-book h4,
.bets-head h4 {
    flex: 1;
}

.bets-back dd,
.bets-lay dd,
.bets-book dd,
.bets-head dd {
    color: #1b2d38;
}

.bets-back dd span,
.bets-lay dd span,
.bets-book dd span,
.bets-head dd span {
    flex: 1;
}

.bets-back .col-odds,
.bets-lay .col-odds,
.bets-book .col-odds,
.bets-head .col-odds {
    flex: 0 1 9.6vw;
    padding-right: 0;
}

.bets-back .col-stake,
.bets-lay .col-stake,
.bets-book .col-stake,
.bets-head .col-stake {
    flex: 0 0 14.66667vw;
    padding-right: 0;
}

.bets-back .col-profit,
.bets-lay .col-profit,
.bets-book .col-profit,
.bets-head .col-profit {
    flex: 0 1 13.33333vw;
}

.bets-back .col-delete,
.bets-lay .col-delete,
.bets-book .col-delete,
.bets-head .col-delete {
    flex: 0 1 8vw;
    padding-left: 0;
}

.bets-back .trashcan,
.bets-lay .trashcan,
.bets-book .trashcan,
.bets-head .trashcan {
    height: 8vw;
    margin: 0;
}

.bets-back .trashcan:before,
.bets-lay .trashcan:before,
.bets-book .trashcan:before,
.bets-head .trashcan:before {
    margin-right: 0;
}

.bets-back .info-keep,
.bets-lay .info-keep,
.bets-book .info-keep,
.bets-head .info-keep,
.bets-back .col-ref,
.bets-lay .col-ref,
.bets-book .col-ref,
.bets-head .col-ref {
    flex: 1 1 100%;
    border-top: 1px solid #9dc2dc;
    font-size: 2.93333vw;
    line-height: 1.1;
    padding: 1.06667vw 1.86667vw;
}

.bets-back .info-keep strong,
.bets-lay .info-keep strong,
.bets-book .info-keep strong,
.bets-head .info-keep strong,
.bets-back .col-ref strong,
.bets-lay .col-ref strong,
.bets-book .col-ref strong,
.bets-head .col-ref strong {
    color: #2789ce;
    margin: 0 1.33333vw;
}

.bets-back .info-keep.edit,
.bets-lay .info-keep.edit,
.bets-book .info-keep.edit,
.bets-head .info-keep.edit,
.bets-back .edit.col-ref,
.bets-lay .edit.col-ref,
.bets-book .edit.col-ref,
.bets-head .edit.col-ref {
    font-size: 3.46667vw;
    padding: 0 1.86667vw;
}

.bets-back .col-ref,
.bets-lay .col-ref,
.bets-book .col-ref,
.bets-head .col-ref {
    order: -1;
    color: #000;
    background-color: rgba(255, 255, 255, 0.3);
    border-top-width: 0;
}

.bets-back .col-ref li,
.bets-lay .col-ref li,
.bets-book .col-ref li,
.bets-head .col-ref li {
    margin-right: 2.66667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .bets-back dt,
    .bets-lay dt,
    .bets-book dt,
    .bets-head dt,
    .bets-back dd,
    .bets-lay dd,
    .bets-book dd,
    .bets-head dd {
        padding: 0.74963vmax 1.04948vmax;
    }

    .bets-back dt span,
    .bets-lay dt span,
    .bets-book dt span,
    .bets-head dt span {
        width: 6.74663vmax;
        line-height: 4.49775vmax;
    }

    .bets-back .col-odds,
    .bets-lay .col-odds,
    .bets-book .col-odds,
    .bets-head .col-odds {
        flex: 0 1 8.3958vmax;
    }

    .bets-back .col-stake,
    .bets-lay .col-stake,
    .bets-book .col-stake,
    .bets-head .col-stake {
        flex: 0 0 12.74363vmax;
    }

    .bets-back .col-profit,
    .bets-lay .col-profit,
    .bets-book .col-profit,
    .bets-head .col-profit {
        flex: 0 1 11.54423vmax;
    }

    .bets-back .col-delete,
    .bets-lay .col-delete,
    .bets-book .col-delete,
    .bets-head .col-delete {
        flex: 0 1 4.49775vmax;
    }

    .bets-back .trashcan,
    .bets-lay .trashcan,
    .bets-book .trashcan,
    .bets-head .trashcan {
        height: 4.49775vmax;
    }

    .bets-back .info-keep,
    .bets-lay .info-keep,
    .bets-book .info-keep,
    .bets-head .info-keep,
    .bets-back .col-ref,
    .bets-lay .col-ref,
    .bets-book .col-ref,
    .bets-head .col-ref {
        font-size: 1.64918vmax;
        padding: 0.5997vmax 1.04948vmax;
    }

    .bets-back .info-keep strong,
    .bets-lay .info-keep strong,
    .bets-book .info-keep strong,
    .bets-head .info-keep strong,
    .bets-back .col-ref strong,
    .bets-lay .col-ref strong,
    .bets-book .col-ref strong,
    .bets-head .col-ref strong {
        margin: 0 0.74963vmax;
    }

    .bets-back .info-keep.edit,
    .bets-lay .info-keep.edit,
    .bets-book .info-keep.edit,
    .bets-head .info-keep.edit,
    .bets-back .edit.col-ref,
    .bets-lay .edit.col-ref,
    .bets-book .edit.col-ref,
    .bets-head .edit.col-ref {
        font-size: 1.94903vmax;
        padding: 0 1.04948vmax;
    }

    .bets-back .col-ref li,
    .bets-lay .col-ref li,
    .bets-book .col-ref li,
    .bets-head .col-ref li {
        margin-right: 1.49925vmax;
    }
}

.bets-lay {
    background-color: #f3dce2;
    border-bottom: 1px solid #d38e9c;
}

.bets-lay .info-keep,
.bets-lay .col-ref {
    border-top-color: #e5bdc5;
}

.bets-book {
    background-color: #d3edd0;
    border-bottom: 1px solid #9fd899;
}

.bets-book .info-keep,
.bets-book .col-ref {
    border-top-color: #9fd899;
}

.bets-book dt span.back {
    background-color: #72e3a0;
}

.a-edit {
    flex: 0 0 8vw;
    height: 8vw;
    background: rgba(255, 255, 255, 0.31);
    border: 1px solid #ccc;
    border-radius: 1.06667vw;
    margin-right: 1.86667vw;
    justify-content: center;
    align-items: center;
}

.a-edit:before {
    content: "";
    width: 3.46667vw;
    height: 3.46667vw;
    background-repeat: no-repeat;
    background-size: contain;
}

.bets-back .a-edit,
.bets-lay .a-edit,
.bets-book .a-edit,
.bets-head .a-edit {
    border-color: #1f72ac;
}

.bets-back .a-edit:before,
.bets-lay .a-edit:before,
.bets-book .a-edit:before,
.bets-head .a-edit:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="rgb(31,114,172)" fill-rule="evenodd" d="M3.115 11.902l.78-.78L1.88 9.103l-.782.78v.92h1.1V11.9h.917zM7.603 3.94c0-.113-.078-.19-.19-.19-.05 0-.102.017-.145.06l-4.65 4.65c-.044.044-.06.095-.06.147 0 .11.076.188.188.188.05 0 .103-.017.146-.06l4.65-4.65c.043-.043.06-.095.06-.146zM7.14 2.29l3.57 3.57L3.57 13H0V9.43l7.14-7.14zm5.86.825c0 .292-.12.575-.317.772l-1.425 1.425-3.57-3.57L9.113.326C9.31.12 9.593 0 9.885 0c.292 0 .575.12.78.326l2.018 2.008c.197.206.317.49.317.78z"/></svg>');
}

.bets-lay .a-edit {
    border-color: #e43a5e;
}

.bets-lay .a-edit:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="rgb(227,58,94)" fill-rule="evenodd" d="M3.115 11.902l.78-.78L1.88 9.103l-.782.78v.92h1.1V11.9h.917zM7.603 3.94c0-.113-.078-.19-.19-.19-.05 0-.102.017-.145.06l-4.65 4.65c-.044.044-.06.095-.06.147 0 .11.076.188.188.188.05 0 .103-.017.146-.06l4.65-4.65c.043-.043.06-.095.06-.146zM7.14 2.29l3.57 3.57L3.57 13H0V9.43l7.14-7.14zm5.86.825c0 .292-.12.575-.317.772l-1.425 1.425-3.57-3.57L9.113.326C9.31.12 9.593 0 9.885 0c.292 0 .575.12.78.326l2.018 2.008c.197.206.317.49.317.78z"/></svg>');
}

.bets-back .a-edit.select,
.bets-lay .a-edit.select,
.bets-book .a-edit.select,
.bets-head .a-edit.select {
    background-color: #1f72ac;
}

.bets-back .a-edit.select:before,
.bets-lay .a-edit.select:before,
.bets-book .a-edit.select:before,
.bets-head .a-edit.select:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M3.115 11.902l.78-.78L1.88 9.103l-.782.78v.92h1.1V11.9h.917zM7.603 3.94c0-.113-.078-.19-.19-.19-.05 0-.102.017-.145.06l-4.65 4.65c-.044.044-.06.095-.06.147 0 .11.076.188.188.188.05 0 .103-.017.146-.06l4.65-4.65c.043-.043.06-.095.06-.146zM7.14 2.29l3.57 3.57L3.57 13H0V9.43l7.14-7.14zm5.86.825c0 .292-.12.575-.317.772l-1.425 1.425-3.57-3.57L9.113.326C9.31.12 9.593 0 9.885 0c.292 0 .575.12.78.326l2.018 2.008c.197.206.317.49.317.78z"/></svg>');
}

.bets-lay .a-edit.select {
    background-color: #e43a5e;
}

.bets-lay .a-edit.select:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M3.115 11.902l.78-.78L1.88 9.103l-.782.78v.92h1.1V11.9h.917zM7.603 3.94c0-.113-.078-.19-.19-.19-.05 0-.102.017-.145.06l-4.65 4.65c-.044.044-.06.095-.06.147 0 .11.076.188.188.188.05 0 .103-.017.146-.06l4.65-4.65c.043-.043.06-.095.06-.146zM7.14 2.29l3.57 3.57L3.57 13H0V9.43l7.14-7.14zm5.86.825c0 .292-.12.575-.317.772l-1.425 1.425-3.57-3.57L9.113.326C9.31.12 9.593 0 9.885 0c.292 0 .575.12.78.326l2.018 2.008c.197.206.317.49.317.78z"/></svg>');
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .a-edit {
        flex: 0 0 4.49775vmax;
        height: 4.49775vmax;
        border-radius: 0.5997vmax;
        margin-right: 1.04948vmax;
    }

    .a-edit:before {
        width: 1.94903vmax;
        height: 1.94903vmax;
    }
}

.bets-head {
    background-color: #fff;
    font-size: 2.93333vw;
    border-bottom-width: 0;
}

.bets-head dt,
.bets-head dd {
    padding: 0.8vw 1.86667vw;
}

.bets-head .col-odds {
    flex: 0 0 auto;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .bets-head {
        font-size: 1.64918vmax;
    }

    .bets-head dt,
    .bets-head dd {
        padding: 0.44978vmax 1.04948vmax;
    }
}

.check-list li {
    margin-left: 2.66667vw;
}

.check-list a {
    color: #1b2d38;
    font-weight: normal;
    height: 9.6vw;
    align-items: center;
}

.check-list a:before {
    content: "";
    width: 5.33333vw;
    height: 5.33333vw;
    background: #fff;
    border: 0.26667vw solid #2789ce;
    margin-right: 1.33333vw;
    box-shadow: inset 0 0.53333vw 0 0 rgba(0, 0, 0, 0.2);
    border-radius: 50%;
}

.check-list a.checked:before {
    border-width: 0;
    box-shadow: none;
    background: #2789ce url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M14.6 5.18c.2.16.34.36.38.62a.9.9 0 0 1-.16.72L9.85 13.6a1 1 0 0 1-.61.37.83.83 0 0 1-.69-.16 83.7 83.7 0 0 1-2.54-2.65l-.75-.8A.96.96 0 0 1 5 9.69c0-.27.1-.5.29-.68a.89.89 0 0 1 1.32.04l2.37 2.52 4.32-6.18a1 1 0 0 1 .62-.37c.24-.05.47 0 .68.16z" id="b"/><filter x="-20%" y="-11.1%" width="140%" height="144.4%" filterUnits="objectBoundingBox" id="a"><feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1"/></filter></defs><g fill="none" fill-rule="evenodd"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><use fill="%23FFF" xlink:href="%23b"/></g></svg>') no-repeat;
    background-size: contain;
}

.check-list a.disable {
    color: #7e97a7;
}

.check-list a.disable:before {
    background-color: rgba(0, 0, 0, 0.2);
    border-width: 0;
}

h3 .check-list a {
    color: #fff;
}

h3 .check-list a:before {
    border-width: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .check-list li {
        margin-left: 1.49925vmax;
    }

    .check-list a {
        height: 5.3973vmax;
    }

    .check-list a:before {
        width: 2.9985vmax;
        height: 2.9985vmax;
        border: 0.14993vmax solid #2789ce;
        margin-right: 0.74963vmax;
        box-shadow: inset 0 0.29985vmax 0 0 rgba(0, 0, 0, 0.2);
    }
}

.setting-block {
    font-size: 4vw;
    color: #000;
    border-bottom: 1px solid #e0e6e6;
    padding: 1.86667vw 0 0 1.86667vw;
    flex-wrap: wrap;
}

.setting-block dt,
.setting-block dd {
    flex: 1;
    padding: 0 1.86667vw 1.86667vw 0;
    align-items: center;
}

.setting-block dd {
    flex: 0 1 9.33333vw;
}

.setting-block input {
    width: 26.66667vw;
    margin: 0 0 0 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .setting-block {
        font-size: 2.24888vmax;
        padding: 1.04948vmax 0 0 1.04948vmax;
    }

    .setting-block dt,
    .setting-block dd {
        padding: 0 1.04948vmax 1.04948vmax 0;
    }

    .setting-block dd {
        flex: 0 1 5.24738vmax;
    }

    .setting-block input {
        width: 14.9925vmax;
        margin: 0 0 0 0.74963vmax;
    }
}

.stake-setting dt {
    flex: 1 1 100%;
}

.stake-setting dd {
    flex: 1 1 25%;
}

.stake-setting .btn,
.stake-setting .btn-send,
.stake-setting .login,
.stake-setting .form-select,
.stake-setting .pages a,
.pages .stake-setting a {
    flex: 1;
    line-height: 2.2;
}

.stake-setting input {
    width: 100%;
    margin: 0;
}

.col-stake_edit a {
    width: 100%;
    line-height: 2.6;
    font-weight: bold;
}

.col-stake_edit .btn-send,
.col-stake_edit .login {
    line-height: 2.6;
}

.btn-edit {
    color: #000;
    background: rgba(197, 208, 215, 0.4);
    border: 0.26667vw solid #7e97a7;
    box-shadow: inset 0 0.53333vw 0 0 rgba(255, 255, 255, 0.8);
    border-radius: 1.6vw;
}

.btn-edit:after {
    content: "";
    width: 4vw;
    height: 4vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="rgb(59,81,96)" fill-rule="evenodd" d="M3.115 11.902l.78-.78L1.88 9.103l-.782.78v.92h1.1V11.9h.917zM7.603 3.94c0-.113-.078-.19-.19-.19-.05 0-.102.017-.145.06l-4.65 4.65c-.044.044-.06.095-.06.147 0 .11.076.188.188.188.05 0 .103-.017.146-.06l4.65-4.65c.043-.043.06-.095.06-.146zM7.14 2.29l3.57 3.57L3.57 13H0V9.43l7.14-7.14zm5.86.825c0 .292-.12.575-.317.772l-1.425 1.425-3.57-3.57L9.113.326C9.31.12 9.593 0 9.885 0c.292 0 .575.12.78.326l2.018 2.008c.197.206.317.49.317.78z"/></svg>') no-repeat;
    background-size: contain;
    vertical-align: top;
    margin-top: 2.66667vw;
    margin-left: 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .btn-edit {
        border-width: 0.14993vmax;
        box-shadow: inset 0 0.29985vmax 0 0 rgba(255, 255, 255, 0.8);
        border-radius: 0.89955vmax;
    }

    .btn-edit:after {
        width: 2.24888vmax;
        height: 2.24888vmax;
        margin-top: 1.49925vmax;
        margin-left: 0.74963vmax;
    }
}

.switch_on,
.switch_off {
    position: relative;
    width: 9.33333vw;
    height: 9.33333vw;
    background: #6bbd11;
    box-shadow: inset 0 0.26667vw 0.8vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 1.6vw;
    overflow: hidden;
}

.switch_on span,
.switch_off span {
    position: absolute;
    right: 1.06667vw;
    top: 1.06667vw;
    width: 2.66667vw;
    height: 7.2vw;
    background: #fff;
    box-shadow: 0 0.53333vw 1.06667vw 0 rgba(0, 0, 0, 0.5), inset 0 -0.8vw 0 0 #cad5d5;
    border-radius: 1.06667vw;
    justify-content: center;
    align-items: center;
}

.switch_on span:after,
.switch_off span:after {
    content: "";
    width: 1.06667vw;
    height: 1.33333vw;
    background: #e0e6e6;
    box-shadow: inset 0 0.26667vw 0.26667vw 0 rgba(0, 0, 0, 0.26);
    border-radius: 0.53333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .switch_on,
    .switch_off {
        width: 5.24738vmax;
        height: 5.24738vmax;
        box-shadow: inset 0 0.14993vmax 0.44978vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.89955vmax;
    }

    .switch_on span,
    .switch_off span {
        right: 0.5997vmax;
        top: 0.5997vmax;
        width: 1.49925vmax;
        height: 4.04798vmax;
        box-shadow: 0 0.29985vmax 0.5997vmax 0 rgba(0, 0, 0, 0.5), inset 0 -0.44978vmax 0 0 #cad5d5;
        border-radius: 0.5997vmax;
    }

    .switch_on span:after,
    .switch_off span:after {
        width: 0.5997vmax;
        height: 0.74963vmax;
        box-shadow: inset 0 0.14993vmax 0.14993vmax 0 rgba(0, 0, 0, 0.26);
        border-radius: 0.29985vmax;
    }
}

.switch_off {
    background-color: #a2b1ba;
}

.switch_off span {
    left: 1.06667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .switch_off span {
        left: 0.5997vmax;
    }
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: transparent;
    z-index: 99;
    justify-content: center;
    align-items: center;
}

.loading-wrap {
    width: 40vw;
    height: 24vw;
    background: #fff;
    font-size: 3.2vw;
    color: #000;
    box-shadow: 0 0.8vw 2.66667vw 0 rgba(0, 0, 0, 0.5);
    border-radius: 1.33333vw;
    padding: 1.86667vw 0;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.loading-wrap p {
    flex: 0 0 100%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .loading-wrap {
        width: 22.48876vmax;
        height: 13.49325vmax;
        font-size: 1.7991vmax;
        box-shadow: 0 0.44978vmax 1.49925vmax 0 rgba(0, 0, 0, 0.5);
        border-radius: 0.74963vmax;
        padding: 1.04948vmax 0;
    }
}

.loading {
    position: relative;
    width: 18.66667vw;
    height: 9.33333vw;
}

.loading>div {
    position: absolute;
    width: 50%;
    height: 100%;
    border-radius: 50%;
}

.loading>div:nth-of-type(1) {
    left: 0;
    background: linear-gradient(90deg, rgb(208 2 27) 0%, #ffea21 100%, #ff9e2c);
    animation: loading-1 0.6s ease infinite;
    z-index: 5;
}

.loading>div:nth-of-type(2) {
    left: 50%;
    background: linear-gradient(180deg, #474747 0%, #070707 100%);
    animation: loading-2 0.6s ease infinite;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .loading {
        width: 10.49475vmax;
        height: 5.24738vmax;
    }
}

.a-depth img {
    width: 5.33333vw;
    height: 5.33333vw;
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle stroke="%231E1E1E" cx="10" cy="10" r="9.5"/><path d="M8 9H7v4h1V9zm2-3H9v7h1V6zm6 8H6V5H5v10h11v-1zm-4-7h-1v6h1V7zm2-2h-1v8h1V5z" fill="%231E1E1E"/></g></svg>') no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .a-depth img {
        width: 2.9985vmax;
        height: 2.9985vmax;
    }
}

.function-wrap {
    position: relative;
    padding: 1.33333vw 1.86667vw;
    background-color: #e0e6e6;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .function-wrap {
        padding: 0.74963vmax 1.04948vmax;
    }
}

.form-select {
    position: relative;
    line-height: 2.2;
    text-align: left;
    color: #2789ce;
    padding: 0 1.86667vw;
}

.form-select:after {
    position: absolute;
    right: 2.66667vw;
    top: 3.46667vw;
    content: "";
    border-top: 2.13333vw solid #1e1e1e;
    border-left: 1.6vw solid transparent;
    border-right: 1.6vw solid transparent;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .form-select {
        padding: 0 1.04948vmax;
    }

    .form-select:after {
        right: 1.49925vmax;
        top: 1.94903vmax;
        border-top-width: 1.1994vmax;
        border-left-width: 0.89955vmax;
        border-right-width: 0.89955vmax;
    }
}

.select-list {
    position: absolute;
    width: 96.26667vw;
    max-height: 58.66667vw;
    overflow: auto;
    overflow-x: hidden;
    z-index: 1;
}

.select-list li {
    border-bottom: 1px solid #e0e6e6;
}

.select-list li:last-child {
    border-bottom-width: 0;
}

.select-list a {
    line-height: 2.2;
    font-weight: bold;
    padding: 1.33333vw 1.86667vw;
}

.select-list:not(:target) {
    display: none;
}

.select-list:target {
    display: block;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .select-list {
        width: 54.12294vmax;
        max-height: 32.98351vmax;
    }

    .select-list a {
        padding: 0.74963vmax 1.04948vmax;
    }
}

.chart-wrap h3 {
    background: transparent;
    color: #1e1e1e;
    justify-content: center;
}

.chart {
    position: relative;
    width: 74.13333vw;
    height: 56.8vw;
    margin-left: 9.33333vw;
    overflow: hidden;
}

.chart img {
    position: absolute;
    width: 93.33333vw;
    height: 68vw;
    top: -8.53333vw;
    clip: rect 8.53333vw, 74.13333vw, 65.33333vw, 0px;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .chart {
        width: 41.67916vmax;
        height: 31.93403vmax;
        margin-left: 5.24738vmax;
    }

    .chart img {
        width: 52.47376vmax;
        height: 38.23088vmax;
        top: -4.7976vmax;
        clip: rect 4.7976vmax, 41.67916vmax, 36.73163vmax, 0px;
    }
}

.info-matched {
    font-size: 4vw;
    border-top: 1px solid #e0e6e6;
    margin-bottom: 0;
}

.info-matched dd {
    border-bottom-width: 0;
    padding-bottom: 4vw;
}

.info-matched dd span {
    font-size: 3.46667vw;
    margin-bottom: 0.8vw;
}

.info-matched dd:nth-of-type(1) {
    flex: 1.75;
}

.info-matched dd:nth-of-type(2) {
    flex: 1.5;
}

.info-matched dd:nth-of-type(3) {
    flex: 1;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .info-matched {
        font-size: 2.24888vmax;
    }

    .info-matched dd {
        padding-bottom: 2.24888vmax;
    }

    .info-matched dd span {
        font-size: 1.94903vmax;
        margin-bottom: 0.44978vmax;
    }
}

.to-BackLay {
    justify-content: space-between;
}

.to-BackLay li {
    position: relative;
    padding: 1.86667vw 1.86667vw 1.33333vw;
}

.to-BackLay li:after {
    position: absolute;
    top: 0;
    right: 0;
    content: "";
    border-top: 7.46667vw solid #fff;
}

.to-BackLay li:nth-of-type(1) {
    padding-right: 4vw;
    background-color: #72bbef;
}

.to-BackLay li:nth-of-type(1):after {
    border-left: 1.33333vw solid transparent;
}

.to-BackLay li:nth-of-type(2) {
    padding-left: 4vw;
    background-color: #faa9ba;
}

.to-BackLay li:nth-of-type(2):after {
    left: 0;
    right: auto;
    border-right: 1.06667vw solid transparent;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .to-BackLay li {
        padding: 1.04948vmax 1.04948vmax 0.74963vmax;
    }

    .to-BackLay li:after {
        border-top-width: 4.1979vmax;
    }

    .to-BackLay li:nth-of-type(1) {
        padding-right: 2.24888vmax;
    }

    .to-BackLay li:nth-of-type(1):after {
        border-left-width: 0.74963vmax;
    }

    .to-BackLay li:nth-of-type(2) {
        padding-left: 2.24888vmax;
    }

    .to-BackLay li:nth-of-type(2):after {
        border-right-width: 0.5997vmax;
    }
}

.trade-wrap {
    width: 100%;
    overflow: auto;
    overflow-y: hidden;
    border: 1px solid #7e97a7;
    border-width: 1px 0 1px 0;
    margin-bottom: 2.66667vw;
    flex-wrap: wrap;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .trade-wrap {
        margin-bottom: 1.49925vmax;
    }
}

.trade,
.trade-2 {
    flex: 0 0 100%;
}

.trade dd,
.trade-2 dd {
    width: 20vw;
}

.trade p,
.trade-2 p {
    padding: 1.6vw 0.8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .trade dd,
    .trade-2 dd {
        width: 11.24438vmax;
    }

    .trade p,
    .trade-2 p {
        padding: 0.89955vmax 0.44978vmax;
    }
}

.trade-2 {
    height: 7.46667vw;
}

.trade-2 dd {
    border-color: #e0e6e6;
}

.trade-2 p {
    font-weight: normal;
    font-size: 2.93333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .trade-2 {
        height: 4.1979vmax;
    }

    .trade-2 p {
        font-size: 1.64918vmax;
    }
}

.table-fancy .col-lay {
    background-color: #fae5eb;
    border-color: #fff;
}

.table-fancy .col-back {
    background-color: #cde8fd;
    border-color: #fff;
}

.announce-header {
    position: sticky;
    position: -webkit-sticky;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.announce-header h1 {
    color: #1e1e1e;
    font-size: 4.8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .announce-header {
        position: relative;
        top: 0;
        left: 0;
    }

    .announce-header h1 {
        font-size: 2.69865vmax;
    }
}

footer {
    position: sticky;
    position: -webkit-sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e0e6e6;
    padding: 2.13333vw 0;
    background: #fff;
}

footer .confirm-checkbox {
    margin-bottom: 3.2vw;
}

footer .confirm-checkbox:before {
    width: 4.26667vw;
    height: 4.26667vw;
    margin-right: 1.06667vw;
    border: 1px solid #aaa;
    background: #fff;
    content: "";
    vertical-align: bottom;
}

footer .confirm-checkbox.checked:before {
    border: 1px solid #666;
    background: #333 url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="rgb(225,225,225)"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></g></svg>') center no-repeat;
    background-size: contain;
}

footer .btn,
footer .btn-send,
footer .login,
footer .form-select,
footer .pages a,
.pages footer a,
footer .btn-send,
footer .login {
    width: 45.33333vw;
    height: 10.66667vw;
    margin: 0 1.06667vw 0 0;
    font-size: 4vw;
    line-height: 10.66667vw;
}

footer .btn-send,
footer .login {
    margin: 0 auto;
}

@media (orientation: landscape) {
    footer {
        position: fixed;
        padding: 0;
        height: 0;
        border: 0;
    }

    footer .confirm-checkbox {
        display: none;
    }

    footer .btn,
    footer .btn-send,
    footer .login,
    footer .form-select,
    footer .pages a,
    .pages footer a {
        position: absolute;
        z-index: 10;
        right: 1.86667vw;
        bottom: 22.93333vw;
        width: 10.66667vw;
        height: 10.66667vw;
        font-size: 0;
        margin: 0;
        border-radius: 26.66667vw;
    }

    footer .btn:before,
    footer .btn-send:before,
    footer .login:before,
    footer .form-select:before,
    footer .pages a:before,
    .pages footer a:before {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 100%;
        border-radius: 26.66667vw;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="rgb(50,50,50)"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g></svg>') center no-repeat;
        background-size: contain;
        content: "";
    }

    footer .btn-send,
    footer .login {
        bottom: 6.4vw;
    }

    footer .btn-send:before,
    footer .login:before {
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="rgb(255,255,255)"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path></g></svg>') center no-repeat;
        background-size: contain;
    }

    footer .age_box .btn:before,
    footer .age_box .btn-send:before,
    footer .age_box .login:before,
    footer .age_box .form-select:before,
    footer .age_box .pages a:before,
    .pages footer .age_box a:before {
        background: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h40v40H0z"/><path fill="rgb(50,50,50)" d="M31.667 10.683l-2.35-2.35L20 17.65l-9.317-9.317-2.35 2.35L17.65 20l-9.317 9.317 2.35 2.35L20 22.35l9.317 9.317 2.35-2.35L22.35 20z"/></g></svg>') center no-repeat;
        background-size: contain;
    }

    footer .age_box .btn-send:before,
    footer .age_box .login:before {
        background: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h40v40H0z"/><path fill="rgb(255,255,255)" d="M15 26.95L8.05 20l-2.367 2.35L15 31.667l20-20-2.35-2.35z"/></g></svg>') center no-repeat;
        background-size: contain;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {

    footer .btn,
    footer .btn-send,
    footer .login,
    footer .form-select,
    footer .pages a,
    .pages footer a {
        right: 1.04948vmax;
        bottom: 12.89355vmax;
        width: 7.1964vmax;
        height: 7.1964vmax;
    }

    footer .btn-send,
    footer .login {
        bottom: 3.5982vmax;
    }
}

/* .mob-announce-content table {
    margin: 2.13333vw 0 4.26667vw 0;
    width: 100%;
    border-top: 2px solid #7e97a7;
    border-bottom: 2px solid #7e97a7;
    font-size: 3.46667vw;
}
.mob-announce-content table th {
    border-right: 1px solid #e0e6e6;
    color: #000;
    font-weight: normal;
}
.mob-announce-content table tr {
    border-bottom: 1px solid #e0e6e6;
}
.mob-announce-content table tr:first-of-type {
    border-top: 1px solid #7e97a7;
}
.mob-announce-content table tr:last-of-type {
    border-bottom: 1px solid #7e97a7;
}
.mob-announce-content table td,
.mob-announce-content table th {
    padding: 1.06667vw 0 1.06667vw 2.13333vw;
}
.mob-announce-content .nofound_box {
    display: none;
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-announce-content {
        padding-top: 2.3988vmax;
        padding-bottom: 2.3988vmax;
    }
    .mob-announce-content table {
        margin: 1.1994vmax 0 2.3988vmax 0;
        font-size: 1.94903vmax;
    }
    .mob-announce-content table td,
    .mob-announce-content table th {
        padding: 0.5997vmax 0 0.5997vmax 1.1994vmax;
    }
} */
.mob-news-popup {
    position: relative;
    flex-direction: column;
    width: 89.33333vw;
    height: 90%;
    border-radius: 1.33333vw;
    background: #fff;
}

.mob-news-popup .side-head {
    flex: 0 0 12.8vw;
    border-radius: 1.6vw 1.6vw 0 0;
}

.mob-news-popup .side-head h3 {
    font-size: 4.3vw;
    line-height: 1;
    justify-content: center;
}

.mob-news-popup .mob-announce-content {
    flex: 1;
    padding-top: 4.26667vw;
    padding-bottom: 0;
}

.mob-news-popup footer {
    position: relative;
    border-radius: 0 0 1.33333vw 1.33333vw;
}

.mob-news-popup.mob-news-popup-frame {
    position: relative;
    width: 100%;
    height: 85vh;
}

.mob-news-popup.mob-news-popup-frame .side-head,
.mob-news-popup.mob-news-popup-frame footer {
    position: sticky;
    position: -webkit-sticky;
}

.mob-news-popup.mob-news-popup-frame .side-head {
    top: auto;
    z-index: 2;
    border-radius: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-news-popup {
        width: 100%;
        height: 100%;
        border-radius: 0;
    }

    .mob-news-popup .side-head {
        flex: 0 0 7.1964vmax;
        border-radius: 0.74963vmax 0.74963vmax 0 0;
    }

    .mob-news-popup .side-head h3 {
        font-size: 2.69865vmax;
    }

    .mob-news-popup .mob-announce-content {
        padding-top: 2.3988vmax;
        padding-bottom: 3.5982vmax;
    }

    .mob-news-popup .btn-send,
    .mob-news-popup .login {
        position: fixed;
    }
}

.overlay .mob-pop-about {
    width: 89.33333vw;
    height: 90%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .overlay .mob-pop-about {
        width: 100%;
        height: 100%;
    }
}

.marquee-pop .side-head {
    flex: 0 0 10.66667vw;
}

.marquee-pop .side-head h3 {
    font-size: 4vw;
    line-height: 1;
    justify-content: flex-start;
}

.marquee-pop .function-wrap {
    background-color: #e0e6e6;
    margin-bottom: 0;
}

.marquee-pop .function-wrap label {
    position: relative;
}

.marquee-pop .function-wrap label span {
    position: absolute;
    z-index: 10;
    left: 0;
    height: 9.33333vw;
    width: 8vw;
    background: #888;
    border-radius: 1.33333vw 0vw 0vw 1.33333vw;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.marquee-pop .function-wrap label span:before {
    content: "";
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    height: 4.26667vw;
    width: 4.26667vw;
    background-image: url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M9.792 10.417v1.573h-6.251v-1.573h6.251zm4.416 3.971v-8.767h-12.416v8.767h12.416zm0-12.777c.484 0 .903.16 1.259.48.356.32.533.697.533 1.132v11.165c0 .435-.178.812-.533 1.132-.356.32-.775.48-1.259.48h-12.416c-.498 0-.921-.16-1.269-.48-.348-.32-.523-.697-.523-1.132v-11.165c0-.435.174-.812.523-1.132.348-.32.772-.48 1.269-.48h.875v-1.612h1.792v1.612h7.083v-1.612h1.792v1.612h.875zm-1.749 5.583v1.612h-8.917v-1.612h8.917z" fill="%23FFFFFF"/></svg>');
}

.marquee-pop .function-wrap label input {
    padding: 0 1.86667vw;
    height: 8.8vw;
    width: 48vw;
    line-height: 2.2;
    text-indent: 8vw;
    margin-bottom: inherit;
    margin-right: 1.33333vw;
}

.marquee-pop .function-wrap .btn-send,
.marquee-pop .function-wrap .login {
    line-height: 2.2;
    min-width: 26.66667vw;
}

.marquee-pop .mob-announce-content {
    flex: 1;
    border-radius: 0 0 1.33333vw 1.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .marquee-pop {
        width: 96%;
        height: 90%;
        border-radius: 1.49925vmax;
    }

    .marquee-pop .side-head {
        flex: 0 0 5.997vmax;
    }

    .marquee-pop .side-head h3 {
        font-size: 2.24888vmax;
    }

    .marquee-pop .function-wrap {
        padding: 0.74963vmax 1.04948vmax;
    }

    .marquee-pop .function-wrap label span {
        height: 5.09745vmax;
        width: 4.49775vmax;
        border-radius: 0.74963vmax 0vmax 0vmax 0.74963vmax;
    }

    .marquee-pop .function-wrap label span:before {
        height: 2.3988vmax;
        width: 2.3988vmax;
    }

    .marquee-pop .function-wrap label input {
        width: 26.98651vmax;
        padding: 0 1.04948vmax;
        height: 4.7976vmax;
        text-indent: 4.49775vmax;
        margin-right: 0.74963vmax;
    }

    .marquee-pop .function-wrap .btn-send,
    .marquee-pop .function-wrap .login {
        min-width: 14.9925vmax;
        position: inherit;
    }

    .marquee-pop .mob-announce-content {
        border-radius: 0 0 0.74963vmax 0.74963vmax;
    }
}

.nofound {
    display: flex;
    align-items: center;
    justify-content: center;
}

.nofound .nofound_box {
    display: flex;
    align-items: center;
    vertical-align: top;
    flex-direction: column;
    margin-bottom: 0vw;
    max-width: 80vw;
}

.nofound .nofound_box dt {
    width: 26.93333vw;
    height: 25.86667vw;
    margin-bottom: 5.33333vw;
    background: url('../images/sprite/ic-search.svg') no-repeat;
    background-size: contain;
}

.nofound .nofound_box dd {
    margin-bottom: 1.33333vw;
    text-align: center;
    font-weight: bold;
    flex: 1;
}

.nofound .article-wrap {
    display: none;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .nofound .nofound_box {
        max-width: 44.97751vmax;
    }

    .nofound .nofound_box dt {
        width: 15.14243vmax;
        height: 14.54273vmax;
        margin-bottom: 2.9985vmax;
    }

    .nofound .nofound_box dd {
        margin-bottom: 0.74963vmax;
    }
}

.pages {
    display: flex;
    justify-content: center;
    margin: 2.66667vw 0;
}

.pages li {
    list-style: none;
    margin-right: 0.8vw;
    margin-left: 0.8vw;
}

.pages a {
    font-weight: normal;
    margin: 0;
    line-height: 9.33333vw;
    padding: 0vw 3.2vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .pages {
        margin: 0.74963vmax 0;
    }

    .pages li {
        margin-right: 0.44978vmax;
        margin-left: 0.44978vmax;
    }

    .pages a {
        line-height: 4.7976vmax;
        padding: 0vmax 1.7991vmax;
    }
}

.article-wrap {
    border-bottom: 1px solid #e0e6e6;
    padding-top: 5.33333vw;
    padding-bottom: 6.66667vw;
}

.article-wrap:first-of-type {
    padding-top: 0;
}

.article-wrap:last-of-type {
    border-bottom: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .article-wrap {
        padding-top: 2.9985vmax;
        padding-bottom: 3.74813vmax;
    }
}

.article-date {
    width: 18.66667vw;
    margin-bottom: 4.26667vw;
    border-top: 1.06667vw solid #4a4a4a;
    padding-top: 1.06667vw;
    color: #4a4a4a;
}

.article-date dt {
    margin-right: 0.53333vw;
    font-size: 8vw;
    line-height: 8.53333vw;
}

.article-date dd {
    font-size: 3.73333vw;
    line-height: 4.26667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .article-date {
        width: 10.49475vmax;
        margin-bottom: 2.3988vmax;
        border-top: 0.5997vmax solid #4a4a4a;
        padding-top: 0.5997vmax;
    }

    .article-date dt {
        margin-right: 0.29985vmax;
        font-size: 4.49775vmax;
        line-height: 4.7976vmax;
    }

    .article-date dd {
        font-size: 2.09895vmax;
        line-height: 2.3988vmax;
    }
}

/* .mysports247 .announce-header h1 {
    color: #1e1e1e;
}
.mysports247 .mob-news-popup .announce-header {
    background: url('../images/popup-header-mysports247.png') center no-repeat;
    background-size: cover;
} */
.betsbuzz365 .announce-header h1 {
    color: #fff;
}

/* .mazaplay .announce-header h1 {
    color: #fff;
}
  .announce-header {
    background: url('../images/popup-header-mazaplay.png') center no-repeat;
    background-size: cover;
}
.maruti .announce-header h1 {
    color: #fff;
}

.betsbuzz365 .announce-header h1 {
    color: #000;
} */


.select .icon-kabaddi {
    background: url('data:image/svg+xml,<svg width="33" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M5.877 11.527a4.294 4.294 0 118.589 0 4.294 4.294 0 01-8.59 0zm11.95 5.78a1.97 1.97 0 012.86.068 2.155 2.155 0 01-.066 2.967l-.454.453-2.989-2.842.65-.646zm4.55-10.074a4.294 4.294 0 110 8.589 4.294 4.294 0 010-8.59zm2.513 16.152c-.627 1.081-1.21 2.082-1.789 3.087-.26.452-.56.832-1.094 1.014-.687.234-1.283.129-1.817-.217-.406-.224-.88-.615-1.454-1.21l-6.287-5.794a2.03 2.03 0 012.747-2.99l1.614 1.5c1.219 1.104 2.58 2.367 3.614 3.29.103.092.213.179.351.295.094-.132.18-.235.246-.35a852.85 852.85 0 001.885-3.32c.078-.138.157-.28.203-.43.616-2.014 2.173-3.055 4.017-3.661 1.678-.552 3.421.24 4.368 1.8.456.753.911 1.507 1.365 2.26.093-.706.141-1.427.141-2.159C33 7.387 25.613 0 16.5 0S0 7.387 0 16.5c0 .733.048 1.455.141 2.163l1.28-2.126c1.263-2.104 3.536-2.658 5.675-1.436a7.85 7.85 0 012.059 1.708c.226.261.39.582.55.892.8 1.546 1.59 3.098 2.424 4.728l.716-.686 3.007 2.754-.123.109-1.616 1.544a2.04 2.04 0 01-.364.275c-.332.294-.678.582-1.057.866-.74.552-2.078.476-2.74-.7-.579-1.03-1.164-2.057-1.8-3.178-1.032 1.705-2.03 3.35-3.042 5.025A16.444 16.444 0 0016.5 33c4.427 0 8.446-1.744 11.41-4.581l-3.02-5.034z" fill="%23ffb200" fill-rule="evenodd"/></svg>') no-repeat;
}

.app-wrap {
    margin-top: 32vw;
}

.app-wrap .btn-send,
.app-wrap .login {
    border-width: 0px;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .app-wrap {
        margin-top: 3.5982vmax;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .app-qrcode {
        width: 21.58921vmax;
        height: 21.58921vmax;
        margin: 0 auto 1.7991vmax;
        border-radius: 2.9985vmax;
        box-shadow: 0 0.5997vmax 0.89955vmax rgba(0, 0, 0, 0.4);
    }
}

.appdl-link-android,
.appdl-link-ios {
    margin-bottom: 3.2vw;
}

.appdl-link-android .btn-app,
.appdl-link-ios .btn-app {
    position: relative;
    width: 72.53333vw;
    height: 12.8vw;
    padding-left: 12.26667vw;
    margin: 0 auto 3.2vw;
    line-height: 12.8vw;
    box-sizing: border-box;
}

.appdl-link-android .btn-app:before,
.appdl-link-ios .btn-app:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 12.8vw;
    height: 100%;
    background: rgba(0, 0, 0, 0.8) url('data:image/svg+xml,<svg width="24" height="28" viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg"><g fill="%23FFFFFF" fill-rule="nonzero"><path d="M1.779 9.054c-.488 0-.901.168-1.241.504-.34.336-.51.739-.51 1.209v7.223c0 .482.17.89.51 1.226.34.336.754.504 1.241.504.487 0 .898-.168 1.233-.504.334-.336.502-.744.502-1.226v-7.223c0-.47-.17-.874-.51-1.209-.34-.336-.749-.504-1.225-.504zM15.862 2.57l1.208-2.2c.079-.146.051-.257-.085-.336-.148-.068-.261-.033-.34.101l-1.224 2.218c-1.077-.47-2.217-.706-3.419-.706s-2.342.236-3.419.706l-1.225-2.218c-.08-.134-.193-.168-.34-.101-.136.079-.164.19-.085.336l1.208 2.2c-1.225.617-2.2 1.476-2.925 2.579-.726 1.104-1.089 2.31-1.089 3.62h15.732c0-1.31-.363-2.516-1.089-3.62-.726-1.103-1.695-1.962-2.908-2.579zm-6.982 3.2c-.131.129-.287.194-.468.194-.182 0-.334-.064-.459-.194-.125-.129-.187-.282-.187-.462 0-.179.062-.333.187-.462s.278-.193.459-.193.337.064.468.193c.13.129.196.283.196.462 0 .179-.066.333-.196.462zm7.169 0c-.125.129-.278.194-.459.194-.182 0-.338-.064-.468-.194-.131-.129-.196-.282-.196-.462 0-.179.065-.333.196-.462.13-.129.286-.193.468-.193.181 0 .334.064.459.193s.187.283.187.462c0 .179-.062.333-.187.462zM4.195 20.56c0 .516.181.952.544 1.31.363.358.805.537 1.327.537h1.259l.017 3.814c0 .482.17.89.51 1.226.34.336.749.504 1.225.504.487 0 .901-.168 1.241-.504.34-.336.51-.745.51-1.226v-3.813h2.347v3.813c0 .482.17.89.51 1.226.34.336.754.504 1.241.504.487 0 .901-.168 1.241-.504.34-.336.51-.745.51-1.226v-3.813h1.276c.51 0 .946-.179 1.31-.537.363-.358.544-.795.544-1.31v-11.188h-15.612v11.188zM22.223 9.054c-.476 0-.884.165-1.225.496-.34.331-.51.737-.51 1.218v7.223c0 .482.17.89.51 1.226.34.336.749.504 1.225.504.487 0 .901-.168 1.241-.504.34-.336.51-.744.51-1.226v-7.223c0-.481-.17-.887-.51-1.218-.34-.33-.754-.496-1.241-.496z"/></g></svg>') no-repeat center;
    background-size: 6.4vw;
    border-top-left-radius: 1.6vw;
    border-bottom-left-radius: 1.6vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .appdl-link-android .btn-app,
    .appdl-link-ios .btn-app {
        width: 40.77961vmax;
        height: 7.1964vmax;
        padding-left: 6.89655vmax;
        line-height: 7.1964vmax;
    }

    .appdl-link-android .btn-app:before,
    .appdl-link-ios .btn-app:before {
        width: 7.1964vmax;
        height: 100%;
        background-size: 3.5982vmax;
        border-top-left-radius: 0.89955vmax;
        border-bottom-left-radius: 0.89955vmax;
    }
}

.appdl-link-android .app-ver,
.appdl-link-ios .app-ver {
    font-size: 4vw;
    text-align: center;
    color: #fff;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .appdl-link-android .app-ver,
    .appdl-link-ios .app-ver {
        margin-top: 1.7991vmax;
        font-size: 2.24888vmax;
    }
}

.appdl-link-ios .btn-app:before {
    background-image: url('data:image/svg+xml,<svg width="23" height="28" xmlns="http://www.w3.org/2000/svg"><path d="M7.57 27.24h-.75a4.54 4.54 0 0 1-2.58-1.67 17.32 17.32 0 0 1-3.5-6.23 13.69 13.69 0 0 1-.5-6.85A7.23 7.23 0 0 1 3.5 7.57a5.8 5.8 0 0 1 4.87-.8c.72.21 1.42.5 2.12.77.51.19 1.02.22 1.53.01l1.07-.4a7.6 7.6 0 0 1 3.49-.67c1.94.18 3.56.94 4.76 2.51.3.4.3.42-.1.7a5.71 5.71 0 0 0-2.13 7 5.69 5.69 0 0 0 2.84 2.9c.19.1.36.17.27.43a15.85 15.85 0 0 1-3.64 6.03 3.42 3.42 0 0 1-3.36 1.07c-.58-.14-1.14-.38-1.7-.6a4.86 4.86 0 0 0-3.38-.15l-2.58.87zm3.27-21.4A6.12 6.12 0 0 1 13.77.91a5.77 5.77 0 0 1 2.45-.9c.39-.04.46.01.49.4.15 2.6-1.74 5.64-4.68 6.16-.27.05-.55.04-.82.05-.23.01-.35-.1-.35-.33l-.02-.45z" fill="%23FFFFFF" fill-rule="evenodd"/></svg>');
}

.urgent-notice {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 100%;
    opacity: 0;
    background: #ffffff;
    animation: urgent-notice 0.3s ease 1s 1 alternate forwards;
}

.urgent-notice header {
    height: 17.06667vw;
    color: #000;
    background-image: -webkit-linear-gradient(#414141 0%, #000 100%);
    background-image: -o-linear-gradient(#414141 0%, #000 100%);
    background-image: linear-gradient(#414141 0%, #000 100%);
}

.urgent-notice header h1 {
    color: #f8d61c;
    font-size: 6.4vw;
    letter-spacing: 0.26667vw;
    text-align: center;
    text-transform: uppercase;
    text-shadow: 0 0.53333vw 1.06667vw rgba(0, 0, 0, 0.6);
}

.urgent-notice .notice-content {
    padding: 3.2vw 4.26667vw 22.93333vw 4.26667vw;
    font-size: 4.26667vw;
    line-height: 5.86667vw;
}

.urgent-notice .notice-img {
    margin-top: 1.06667vw;
    text-align: center;
}

.urgent-notice .notice-img img {
    width: 100%;
}

.urgent-notice .notice-img .img-fake {
    margin-top: 3.2vw;
    height: 12.8vw;
    width: auto;
}

.urgent-notice .hilight {
    font-weight: bold;
    text-decoration: underline;
}

@media (orientation: landscape) {
    .urgent-notice header {
        justify-content: flex-start;
        padding-left: 6.4vw;
    }

    .urgent-notice .notice-content {
        padding-bottom: 8.53333vw;
    }

    .urgent-notice .announce-footer {
        position: absolute;
        top: 0;
        background: transparent;
    }

    .urgent-notice .btn-send,
    .urgent-notice .login {
        top: 0;
        right: 0;
        margin: 0;
        width: 17.06667vw;
        height: 17.06667vw;
        background: transparent;
        background-image: none !important;
        border-left: 0.26667vw solid rgba(255, 255, 255, 0.6) !important;
        border-radius: 0;
        box-shadow: none;
    }

    .urgent-notice .btn-send:before,
    .urgent-notice .login:before {
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>') center no-repeat;
        background-size: 50%;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .urgent-notice {
        height: auto;
    }

    .urgent-notice header {
        justify-content: center;
        height: 9.5952vmax;
        padding: 0;
    }

    .urgent-notice header h1 {
        font-size: 3.5982vmax;
        letter-spacing: 0.14993vmax;
        text-shadow: 0 0.29985vmax 0.5997vmax rgba(0, 0, 0, 0.6);
    }

    .urgent-notice .notice-content {
        padding: 2.3988vmax 2.3988vmax 4.7976vmax 2.3988vmax;
        font-size: 2.3988vmax;
        line-height: 3.29835vmax;
    }

    .urgent-notice .notice-img {
        margin-top: 0.5997vmax;
    }

    .urgent-notice .notice-img img {
        width: 80%;
    }

    .urgent-notice .notice-img .img-fake {
        margin-top: 2.3988vmax;
        height: 8.9955vmax;
        width: auto;
    }

    .urgent-notice .btn-send,
    .urgent-notice .login {
        width: 9.5952vmax;
        height: 9.5952vmax;
        border-left: 0.14993vmax solid rgba(255, 255, 255, 0.6) !important;
    }
}

.a-search {
    position: absolute;
    z-index: 2;
    right: 0;
    width: 12.8vw;
    height: 12.2666666667vw;
    padding: 0;
    background-image: linear-gradient(180deg, #525252 0%, #2d2d2d 100%);
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 0;
}

/*.a-search:before {*/
/*    content: "";*/
/*    position: absolute;*/
/*    z-index: -1;*/
/*    right: 13.06667vw;*/
/*    width: 8.26667vw;*/
/*    height: 12.26667vw;*/
/*    background-image: linear-gradient(90deg, transparent 0%, #000 110%);*/
/*}*/

.a-search:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5.86667vw;
    height: 5.86667vw;
    background: url('data:image/svg+xml,<svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m29.6697865 25.8286042h-1.0026615l-.3764635-.3143021c1.191151-1.4455833 1.9434479-3.2687188 1.9434479-5.342849-.0000573-4.5258698-3.6359011-8.1714531-8.14825-8.1714531-4.4505886 0-8.0858594 3.6455833-8.0858594 8.1714531s3.6352708 8.1713959 8.1483073 8.1713959c2.0058385 0 3.886151-.7543594 5.3276094-1.948375l.3758906.3143593v1.0055261l6.2678802 6.2856406 1.8803125-1.8856979zm-7.5214792 0c-3.1339688 0-5.6411094-2.5143594-5.6411094-5.6571511 0-3.1429062 2.5071406-5.6570937 5.6411094-5.6570937 3.1338542 0 5.6410521 2.5141875 5.6410521 5.6570937 0 3.1427917-2.5071979 5.6571511-5.6410521 5.6571511z" fill="rgb(255,255,255)" transform="translate(-14 -12)"/></svg>') center no-repeat;
    background-size: cover;
}

.a-search+.mob-nav-highlight ul {
    padding-right: 21.33333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .a-search {
        width: 7.1964vmax;
        height: 6.89655vmax;
    }

    .a-search:before {
        right: 7.34633vmax;
        width: 4.64768vmax;
        height: 6.89655vmax;
    }

    .a-search:after {
        width: 3.29835vmax;
        height: 3.29835vmax;
    }

    .a-search+.mob-nav-highlight ul {
        padding-right: 1.04948vmax;
    }
}

.search-pop {
    width: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: #fff;
}

.main-input-search {
    width: calc(100% - 32vw);
    height: 17.06667vw;
    margin: 0;
    padding: 0 21.33333vw 0 10.66667vw;
    border-color: transparent;
    border-radius: 0;
    box-shadow: none;
}

.main-input-search::placeholder {
    color: #9b9b9b;
}

.main-input-search:focus {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
}

.main-input-search:focus::placeholder {
    color: transparent;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .main-input-search {
        width: calc(100% - 17.991vmax);
        height: 8.3958vmax;
        padding: 0 11.994vmax 0 5.997vmax;
    }
}

.search-back,
.search-clear,
.search-collapse {
    position: absolute;
    z-index: 2;
    display: block;
    width: 10.66667vw;
    height: 17.06667vw;
    background: url('data:image/svg+xml,<svg height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform=""><path d="m0 0h40v40h-40z"/><path d="m16.9093851 12 8.0906149 8-8.0906149 8-1.9093851-1.888 6.2135922-6.112-6.2135922-6.112z" fill="rgb(74,74,74)" transform="matrix(-1 0 0 1 40 0)"/></g></svg>') center no-repeat;
    background-size: contain;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .search-back,
    .search-clear,
    .search-collapse {
        width: 5.997vmax;
        height: 8.3958vmax;
    }
}

.search-clear,
.search-collapse {
    top: 0;
    right: 10.66667vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(74,74,74)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>') center no-repeat;
    background-size: 4.26667vw;
    border: 0;
}

@media screen and (min-aspect-ratio: 16 / 9) {

    .search-clear,
    .search-collapse {
        right: 5.997vmax;
        background-size: 2.3988vmax;
    }
}

.search-collapse {
    right: 0;
    background: url('data:image/svg+xml,<svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m29.6697865 25.8286042h-1.0026615l-.3764635-.3143021c1.191151-1.4455833 1.9434479-3.2687188 1.9434479-5.342849-.0000573-4.5258698-3.6359011-8.1714531-8.14825-8.1714531-4.4505886 0-8.0858594 3.6455833-8.0858594 8.1714531s3.6352708 8.1713959 8.1483073 8.1713959c2.0058385 0 3.886151-.7543594 5.3276094-1.948375l.3758906.3143593v1.0055261l6.2678802 6.2856406 1.8803125-1.8856979zm-7.5214792 0c-3.1339688 0-5.6411094-2.5143594-5.6411094-5.6571511 0-3.1429062 2.5071406-5.6570937 5.6411094-5.6570937 3.1338542 0 5.6410521 2.5141875 5.6410521 5.6570937 0 3.1427917-2.5071979 5.6571511-5.6410521 5.6571511z" fill="rgb(74,74,74)" transform="translate(-14 -12)"/></svg>') center no-repeat;
    background-size: 5.86667vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .search-collapse {
        right: 0;
        background-size: 3.29835vmax;
    }
}

.no-matching {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 6.4vw 0;
}

.no-matching dt {
    flex: 0 0 100%;
    width: 6.4vw;
    height: 6.4vw;
    margin-bottom: 2.13333vw;
    background: url('data:image/svg+xml,<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m12 0c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm.8 17.6h-1.6v-1.6h1.6zm0-4h-1.6v-7.2h1.6z" fill="rgb(155,155,155)" transform=""/></svg>') center no-repeat;
    background-size: contain;
}

.no-matching dd {
    flex: 0 0 100%;
    color: #9b9b9b;
    font-size: 4.53333vw;
    text-align: center;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .no-matching {
        padding: 3.5982vmax 0;
    }

    .no-matching dt {
        width: 3.5982vmax;
        height: 3.5982vmax;
        margin-bottom: 1.1994vmax;
    }

    .no-matching dd {
        font-size: 2.54873vmax;
    }
}

.suggestion-wrap {
    max-height: 46.66667vw;
    border-top: 1px solid #d8d8d8;
    overflow: scroll;
}

.suggestion-wrap ul {
    padding-bottom: 2.13333vw;
}

.suggestion-wrap li {
    height: 11.73333vw;
    line-height: 11.73333vw;
    list-style: none;
    text-indent: 3.73333vw;
}

.suggestion-wrap li p,
.suggestion-wrap li a {
    display: block;
    height: 100%;
    color: #2789ce;
    font-size: 4vw;
    font-weight: bold;
}

.suggestion-wrap li p:active,
.suggestion-wrap li p:hover,
.suggestion-wrap li p.hover,
.suggestion-wrap li a:active,
.suggestion-wrap li a:hover,
.suggestion-wrap li a.hover {
    background-color: #e2e8ed;
}

.suggestion-wrap li .time {
    margin-right: 1.86667vw;
    font-weight: normal;
    color: #777777;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .suggestion-wrap {
        max-height: calc(100vh - 8.3958vmax);
    }

    .suggestion-wrap ul {
        padding-bottom: 9.5952vmax;
    }

    @supports (-webkit-overflow-scrolling: touch) {
        .suggestion-wrap ul {
            padding-bottom: 3.5982vmax;
        }
    }

    .suggestion-wrap li {
        height: 6.5967vmax;
        line-height: 6.5967vmax;
        text-indent: 2.09895vmax;
    }

    .suggestion-wrap li>p,
    .suggestion-wrap li a {
        font-size: 2.24888vmax;
    }

    .suggestion-wrap li .time {
        margin-right: 1.04948vmax;
    }
}

.expand .suggestion-wrap {
    max-height: calc(100vh - 17.06667vw);
}

.expand .suggestion-wrap ul {
    padding-bottom: 17.06667vw;
}

@supports (-webkit-overflow-scrolling: touch) {
    .expand .suggestion-wrap ul {
        padding-bottom: 6.4vw;
    }
}

.expand .main-input-search {
    width: calc(100% - 21.33333vw);
    padding: 0 10.66667vw;
}

.expand .search-clear,
.expand .search-collapse {
    display: none;
}

.expand .search-collapse {
    display: block;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .expand .suggestion-wrap {
        max-height: calc(100vh - 8.3958vmax);
    }

    .expand .suggestion-wrap ul {
        padding-bottom: 9.5952vmax;
    }

    @supports (-webkit-overflow-scrolling: touch) {
        .expand .suggestion-wrap ul {
            padding-bottom: 3.5982vmax;
        }
    }

    .expand .main-input-search {
        width: calc(100% - 11.994vmax);
        padding: 0 5.997vmax;
    }
}

.closed-next {
    width: 93.33333vw;
    margin: 0 auto;
    background: rgba(91, 103, 111, 0.9);
    padding: 0 1.6vw;
    color: #fff;
}

.closed-next h2 {
    font-size: 6.66667vw;
    line-height: 8.8vw;
    border-bottom: 0.26667vw solid rgba(255, 255, 255, 0.3);
    margin: 0;
    padding: 2.4vw 0;
}

.closed-next p {
    font-size: 4vw;
    line-height: 5.33333vw;
    margin-bottom: 0;
    padding: 2.4vw 8vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .closed-next {
        width: 56.22189vmax;
        margin: 0 auto;
    }

    .closed-next h2 {
        font-size: 3.74813vmax;
        line-height: 4.94753vmax;
        border-bottom: 0.14993vmax solid rgba(255, 255, 255, 0.3);
    }

    .closed-next p {
        font-size: 2.24888vmax;
        line-height: 2.9985vmax;
        padding: 1.34933vmax 0;
    }
}

.mob-main-content .casinozone {
 display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.6vw 0.6vw;
    width: calc(100% - 2.2vw);
    padding: 1.2vw;
}

.mob-main-content .casinozone .mob-casino-half {
    grid-column: span 1;
}

.mob-main-content .casinozone a {
    position: relative;
}

.mob-main-content .casinozone .mob-casino-half:before {
    content: '';
    padding-top: 77.77778%;
    float: left;
}

.casino-title {
    position: absolute;
    z-index: 4;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 6.4vw;
    background-image:linear-gradient(270deg, rgb(0 0 0 / 0%) 4%, #000000 97%);
    // border-bottom: 1.12vw solid #FFB80C;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}


casino-title dt {
    flex: 1;
    font-size: 3.73333vw;
    text-indent: 1.33333vw;
    color: #fff;
    font-weight: bold;
}

.casino-title dd {
      position: absolute;
    padding: 0px 6px;
    color: #000;
    text-decoration: none;
    overflow: hidden;
    border-radius: 4px;
    background: #fff;
    right: 5px;
    bottom: 2px;
    font-size: 12px;
    animation: zoom-in-zoom-out 1s ease-out infinite;
}

 @keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}

 .category-box .animated-slot{
          animation: zoom-in-out 1s ease-out infinite;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
  }


@keyframes zoom-in-out {
  0% {
    transform: scale(1, 1);
    background: yellow;
  }
  50% {
    transform: scale(1.1, 1.1);
    background: darkred;
    color: #fff;
    box-shadow: inset 0px 2px 4px 0px #1b00ff;
  }
  100% {
    transform: scale(1, 1);
    background: blue;
  }
}

.mob-main-content .casinozone a img {
    position: relative;
    z-index: 2;
    display: block;
    width: 100%;
    cursor: pointer;
}

.mob-main-content .casinozone a:after {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.loading-shimmer,
.mob-main-content .casinozone a:after {
    animation: placeHolderShimmer 1.25s infinite linear;
    background: #CED5DA linear-gradient(to right, #CED5DA 8%, #D8DFE4 18%, #CED5DA 33%);
    background-size: 213.33333vw 27.73333vw;
    height: auto;
}

.mob-nav-highlight .menu-casino a:after,
.mob-main-content .casinozone a:after {
    content: "";
    display: block;
}

.clear,
.mob-main-content .casinozone a:after {
    clear: both;
}

// .casino-title dd:after {
//     position: absolute;
//     z-index: -1;
//     bottom: 0;
//     right: 0;
//     width: 14.93333vw;
//     height: 6.4vw;
//     background-color: #FFB80C;
//     content: "";
// }

.casino-title dt {
    flex: 1;
    font-size: 3.73333vw;
    height: 8vw;
    text-indent: 1.33333vw;
    color: #fff;
    font-weight: bold;
    font-family: emoji;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 500;
}

mob-main-content .casinozone a {
    position: relative;
    grid-column: span 2;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .casino-title {
        line-height: 3.5982vmax;
        border-bottom: 0.62969vmax solid #000;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .mob-main-content .casinozone {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 0.89955vmax;
        width: calc(100% - 1.7991vmax);
        padding: 0.89955vmax;
    }
}

.mob-main-content .casinozone a {
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-bottom: 0.33333vw;
}

.mob-main-content .casinozone a img {
    position: relative;
    z-index: 2;
    height: 36vw;
    display: block;
    width: 100%;
    cursor: pointer;
}

.mob-main-content .casinozone a:before {
    content: "";
    padding-top: 38.35616%;
    float: left;
}

.mob-main-content .casinozone a:after {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .casino-title dt {
        font-size: 2.09895vmax;
        text-indent: 0.74963vmax;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .casino-title dd {
        width: 10.1949vmax;
        line-height: 4.1979vmax;
        height: 3.5982vmax;
        text-indent: 2.09895vmax;
        font-size: 1.64918vmax;
    }
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .casino-title dd:after {
        width: 8.3958vmax;
        height: 3.5982vmax;
    }
}

.mob-sports-highlight-list a,
.inplay-list a,
.upcoming-list a,
.sports-side-menu-list a,
.mob-sports-highlight-list dd,
.inplay-list dd,
.upcoming-list dd,
.sports-side-menu-list dd,
.bets-selections a span,
.trade p span,
.trade-2 p span,
.fancy-bet>h5 span,
.bets-wrap>h4 span,
.fancy-bet>h4 span,
.sports-book>h4 span,
.bets-bookmaker>h4 span,
nav a,
.now-play,
.channel-list a,
.side-content .sports-side-menu-list a p,
.path-wrap ul,
.account-id span:first-of-type,
.game-team h4,
.scores-time,
.bets-selections h4,
.horse-name li,
.support-wrap .support-detail a span,
.fancy-bet .bets-selections dt li,
.bets-back dt,
.bets-lay dt,
.bets-book dt,
.bets-head dt,
.bets-back dd,
.bets-lay dd,
.bets-book dd,
.bets-head dd,
.bets-back h4,
.bets-lay h4,
.bets-book h4,
.bets-head h4,
.bets-back dd span,
.bets-lay dd span,
.bets-book dd span,
.bets-head dd span,
.select-list a,
.suggestion-wrap li p,
.suggestion-wrap li a,
.live_events dd p,
.casino-title dt,
.result-wrap h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.live_events {
    position: absolute;
    z-index: 3;
    right: 0;
    width: 23%;
    background-image: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.7) 82%, transparent 100%);
    padding: 1.33333vw;
}

.live_events dt {
    margin-bottom: 1.6vw;
}

.live_events .live_icon {
    height: 4.26667vw;
    line-height: 4.26667vw;
    font-weight: bold;
    color: #fff;
    padding-right: 1.33333vw;
    background-image: linear-gradient(180deg, #fb3434 0%, #e80505 100%);
    border-radius: 0.8vw;
    display: inline-flex;
}

.live_events .live_icon span {
    height: 4.26667vw;
    padding: 0 0.8vw;
    margin-right: 1.33333vw;
    background-image: linear-gradient(180deg, #fff 0%, #e8e8e8 100%);
    border-radius: 0.8vw 0 0 0.8vw;
}

.live_events .live_icon span:before {
    width: 4.26667vw;
    height: 2.66667vw;
    background: url('data:image/svg+xml,<svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,0,0)" fill-rule="evenodd"><path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z"/><circle cx="6.8" cy="4.4" r="1.6"/></g></svg>') no-repeat;
    background-size: contain;
}

.live_events dd {
    color: #fff;
    font-size: 2.66667vw;
    line-height: 3.73333vw;
    margin-bottom: 1.06667vw;
    vertical-align: top;
    flex-wrap: wrap;
}

.live_events dd p {
    flex: 1;
}

.live_events dd span {
    color: #333333;
    background: #ffffff;
    text-align: center;
    border-radius: 0.53333vw;
    min-width: 3.73333vw;
    height: 3.73333vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .live_events {
        padding: 0.74963vmax;
    }

    .live_events dt {
        margin-bottom: 0.74963vmax;
    }

    .live_events .live_icon {
        height: 2.3988vmax;
        line-height: 2.3988vmax;
        padding-right: 0.74963vmax;
        border-radius: 0.44978vmax;
    }

    .live_events .live_icon span {
        padding: 0 0.44978vmax;
        margin-right: 0.74963vmax;
        height: 2.3988vmax;
        border-radius: 0.44978vmax 0 0 0.44978vmax;
    }

    .live_events .live_icon span:before {
        width: 2.3988vmax;
        height: 1.49925vmax;
    }

    .live_events dd {
        font-size: 1.49925vmax;
        line-height: 2.09895vmax;
        margin-bottom: 0.44978vmax;
    }

    .live_events dd span {
        border-radius: 0.29985vmax;
        min-width: 2.09895vmax;
        height: 2.09895vmax;
    }
}

.result .tab-wrap ul {
    margin-bottom: 1.86667vw;
}

.result select {
    font-size: 4.26667vw;
    line-height: 8.8vw;
    font-weight: bold;
    padding: 1.86667vw;
    border: none;
    border-radius: 1.6vw;
    background-color: #fff;
    width: 100%;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .result .tab-wrap ul {
        margin-bottom: 1.04948vmax;
    }

    .result select {
        font-size: 2.3988vmax;
        line-height: 4.94753vmax;
        padding: 1.04948vmax;
        border-radius: 0.89955vmax;
    }
}

.result-wrap {
    margin-bottom: 2.66667vw;
}

.result-wrap h3 {
    padding: 0 1.6vw;
}

.result-wrap dl {
    align-items: stretch;
    min-height: 17.33333vw;
    background: #fff;
    border-bottom: solid 1px #7e97a7;
    color: #666666;
}

.result-wrap dt,
.result-wrap dd {
    position: relative;
    justify-content: flex-start;
    align-items: center;
    padding: 6.66667vw 1.6vw 1.6vw 1.6vw;
}

.result-wrap dt {
    flex: 2;
    font-size: 4.26667vw;
    line-height: 5.33333vw;
}

.result-wrap dt p {
    left: 1.6vw;
}

.result-wrap dd {
    flex: 1;
    text-align: center;
    font-size: 5.33333vw;
    border-left: solid 1px #e0e6e6;
}

.result-wrap dd strong {
    color: #000;
    width: 100%;
}

.result-wrap p {
    position: absolute;
    width: 100%;
    top: 1.6vw;
    left: 0;
    font-size: 2.93333vw;
    line-height: 3.73333vw;
}

.result-wrap span {
    color: #508d0e;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .result-wrap {
        margin-bottom: 1.49925vmax;
    }

    .result-wrap h3 {
        padding: 0 0.89955vmax;
    }

    .result-wrap dl {
        min-height: 9.74513vmax;
    }

    .result-wrap dt,
    .result-wrap dd {
        padding: 2.9985vmax 0.89955vmax 0.89955vmax 0.89955vmax;
    }

    .result-wrap dt {
        font-size: 2.3988vmax;
        line-height: 2.9985vmax;
    }

    .result-wrap dt p {
        left: 0.89955vmax;
    }

    .result-wrap dd {
        font-size: 2.9985vmax;
    }

    .result-wrap p {
        top: 0.89955vmax;
        font-size: 1.64918vmax;
        line-height: 2.09895vmax;
    }
}

.custom-select {
    position: relative;
    width: 100%;
    height: 10.66667vw;
    margin: 0;
    margin-bottom: 2rem;
    background-color: #fff;
    border: 1px solid #1e1e1e;
    border: none;
    border-radius: 1.6vw;
    color: #1e1e1e;
}

.custom-select select {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: transparent;
    border: 0;
    color: #1e1e1e;
    font-weight: lighter;
    cursor: pointer;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.custom-select:last-child {
    margin-bottom: 0;
}

.custom-select:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 2.13333vw;
    transform: translate(0, -50%);
    border-top: 2.13333vw solid #1e1e1e;
    border-left: 2.13333vw solid transparent;
    border-right: 2.13333vw solid transparent;
}

.custom-select:hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .custom-select {
        height: 5.997vmax;
        border-radius: 0.89955vmax;
    }

    .custom-select:after {
        right: 1.1994vmax;
        border-top: 1.1994vmax solid #1e1e1e;
        border-left: 1.1994vmax solid transparent;
        border-right: 1.1994vmax solid transparent;
    }
}

/* .mysports247 .btn.select,
.mysports247 .select.btn-send,
.mysports247 .select.login,
.mysports247 .select.form-select,
.mysports247 .pages a.select,
.pages .mysports247 a.select {
    background: #f2d65d;
    border-color: #8f8017;
}
.mysports247 .btn-send,
.mysports247 .login {
    background-image: linear-gradient(-180deg, #eccb4b 0%, #ae8903 100%);
    border-color: #998a27;
}
.mysports247 .btn-send.disable,
.mysports247 .disable.login {
    background-image: linear-gradient(-180deg, #f6ecc6 0%, #e7dcb4 100%);
    border-color: #dbd39f;
    color: #999;
}
.mysports247 header {
    background-image: linear-gradient(-180deg, #e4c93c 0%, #c9a21b 77%);
}
.mysports247 header a {
    border-color: #8f8017;
}
.mysports247 header .mob-header-logo {
    height: 10.93333vw;
    margin-top: -0.53333vw;
    background-image: url('../images/logo-mysports247-black.png');
}
.mysports247 header .mob-login-index {
    background-image: linear-gradient(-180deg, #b83a08 0%, #912b06 100%);
    border-color: #621f04;
}
.mysports247 header .a-open_tv {
    border-color: #0f476a;
}
@media screen and (min-aspect-ratio: 16 / 9) {
    .mysports247 header .mob-header-logo {
        height: 6.14693vmax;
        margin-top: -0.29985vmax;
    }
}


.mysports247 .mob-nav-highlight {
    border-bottom-color: #ae8a04;
}
.mysports247 .mob-nav-highlight .select a {
    background-image: linear-gradient(-180deg, #eccb4b 0%, #ae8903 100%);
}
.mysports247 .mob-sports-highlight-list,
.mysports247 .inplay-list {
    border-bottom-color: #ae8a04;
}
.mysports247 .a-search:before {
    background-image: linear-gradient(90deg, rgba(30, 30, 30, 0) 0%, #1e1e1e 110%);
}
.mysports247 .mob-market-type .select a {
    background-image: linear-gradient(-180deg, #eccb4b 0%, #ae8903 100%);
}
.mysports247 .pop-wrap h3,
.mysports247 .select-list h3 {
    background-image: linear-gradient(-180deg, #e4c93c 0%, #c9a21b 77%);
}
.mysports247 .login-pop {
    background-color: #11151a;
    background-image: linear-gradient(56deg, #212932 4%, #11151a 42%);
}
.mysports247 .side-head {
    background: #dbba28;
}
.mysports247 .side-head .close {
    border-color: #9b8921;
}
.mysports247 .login-RnR .policy-header,
.mysports247 .login-policy .policy-header {
    background-image: linear-gradient(-180deg, #e4c93c 0%, #c9a21b 77%);
}
.mysports247 .login-RnR .policy-header h1,
.mysports247 .login-policy .policy-header h1 {
    color: #1e1e1e;
}
.mysports247 .login-RnR .btn-send,
.mysports247 .login-RnR .login,
.mysports247 .login-policy .btn-send,
.mysports247 .login-policy .login {
    background-image: linear-gradient(-180deg, #eccb4b 0%, #ae8903 100%);
    border-color: #998a27;
    color: #1e1e1e;
}
.mysports247 .inplay-list {
    border-bottom-color: #7e97a7;
} */
html.betsbuzz365,
body.betsbuzz365 {
    background-color: #eee;
}

.betsbuzz365 .btn.select,
.betsbuzz365 .select.btn-send,
.betsbuzz365 .select.login,
.betsbuzz365 .select.form-select,
.betsbuzz365 .pages a.select,
.pages .betsbuzz365 a.select {
    background: #fff;
    border-color: #000;
    color: #000;
}

.betsbuzz365 .btn-send,
.betsbuzz365 .login {
    color: #ffb80c;
    background-image: linear-gradient(-180deg, #464646 15%, #121212 100%);
    border: 0.2666666667vw solid #222;
}

.betsbuzz365 .btn-send.disable,
.betsbuzz365 .disable.login {
    background-image: linear-gradient(-180deg, #b4b4b4 0%, #a1a1a1 100%);
    border-color: #aaa;
    color: #ffb80c;
}

.betsbuzz365 header {
    color: #000;
    background-image: linear-gradient(
            -180deg, #414141 0%, #000 100%);
}

.betsbuzz365 header .sky-logo {
    flex: 1;
    width: 34.13333vw;
    height: 11.46667vw;
    /* background-image: url('../images/newlogo.png'); */
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: -1.33333vw;
}

.betsbuzz365 header a {
    color: #ffffff;
    border-color: #000;
    background-color: rgba(255, 255, 255, .1);

}

.betsbuzz365 header li.main-wallet span.red {
    display: inline-block;
    padding: 0 1.33333vw;
    background-color: #bf0000;
    color: #f2e9cf !important;
    border-radius: 1.33333vw;
}

.betsbuzz365 header .mob-header-logo {
    height: 14.2667vw;
    background-image: url(../images/headerlogo.png);
    margin-top: 1.66667vw;
}

.betsbuzz365 header .mob-login-index {
    color: #fff;
}

.betsbuzz365 header .btn-signup {
    display: block;
    width: 19.2vw;
    margin-right: 1.06667vw;
    background-image: linear-gradient(-180deg, #666 0%, #333 100%);
    border-color: #000;
}

.betsbuzz365 header .a-open_tv {
    border-color: #062a2e;
    background-color: #0a7b89;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .betsbuzz365 header .mob-header-logo {
        height: 6.44678vmax;
        margin-top: -0.74963vmax;
    }

    .betsbuzz365 header .sky-logo {
        width: 19.1904vmax;
        height: 6.44678vmax;
        margin-top: -0.74963vmax;
    }

    .betsbuzz365 header li.main-wallet span.red {
        padding: 0 0.74963vmax;
        border-radius: 0.74963vmax;
    }

    .betsbuzz365 header .btn-signup {
        width: 10.7946vmax;
        margin-right: 0.5997vmax;
    }
}

/* .a-setting img {
    background: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-8 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill="rgb(30,30,30)"/></g></svg>') no-repeat;
    filter: invert(0.8);
} */
/* .betsbuzz365 .mob-bet-show img {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="rgb(255,184,12)" fill-rule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"/></svg>');
} */
/* .betsbuzz365 .a-refresh img {
    background-image: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-7 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="rgb(255,184,12)"/></g></svg>');
} */
/* .betsbuzz365 .a-setting img {
    background-image: url('data:image/svg+xml,<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b"/><filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-8 -6)"><use fill="%23000" filter="url(%23a)" xlink:href="%23b"/><path stroke="%23BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square"/></g><path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill="rgb(255,184,12)"/></g></svg>');
} */
.betsbuzz365 .loading-bar span {
    background-color: #b557fa;
}

.betsbuzz365 .message-content {
    color: #1e1e1e;
}

.betsbuzz365 .message-content a {
    background-color: transparent;
    box-shadow: none;
}

.betsbuzz365 .message-content.error {
    color: #fff;
}

.betsbuzz365 .mob-nav-highlight {
    background-image: linear-gradient(-180deg, #ffcc2e 0%, #ffb80c 71%);
    border-bottom-color: #000;
}

.video-react-big-play-button {
    display: none !important;
}

.betsbuzz365 .mob-nav-highlight .select a {
    color: #ffbf0a;
    background-image: linear-gradient(180deg, #474747 0%, #070707 100%);
}

.betsbuzz365 .mob-nav-highlight .menu-casino a {
    color: #ffffff;
}

/*.betsbuzz365 .mob-sports-highlight-list,*/
/*.betsbuzz365 .inplay-list {*/
/*    border-bottom-color: #000;*/
/*}*/

/*.betsbuzz365 .a-search:before {*/
/*    content: "";*/
/*    position: absolute;*/
/*    z-index: -1;*/
/*    right: 13.0666666667vw;*/
/*    width: 8.2666666667vw;*/
/*    height: 12.2666666667vw;*/
/*    background-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #000000 110%);*/
/*}*/

.betsbuzz365 .mob-market-type a {
    background-color: black;
}

.betsbuzz365 .a-depth img {
    background: url('data:image/svg+xml,<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx="12.5" cy="12.5" r="12.5"/></defs><g fill="none"><g transform="translate(-7 -230) translate(7 230)"><circle stroke="%23FFB80C" cx="12.5" cy="12.5" r="12"/></g><path d="M10 12h-2v5h2v-5zm3-4h-2v9h2v-9zm7 10h-13v-12h-1v13h14v-1zm-4-8h-2v7h2v-7zm3-3h-2v10h2v-10z" fill="%23FFB80C"/></g></svg>') center no-repeat;
    background-size: contain;
}

.betsbuzz365 .pop-wrap h3,
.betsbuzz365 .select-list h3 {
    background-image: linear-gradient(-180deg, #000000 0%, #000000 58%);
    color: #fff;
}

.betsbuzz365 .login-pop {
    background-color: #000;
    background-image: linear-gradient(56deg, #ffcc2e 4%, #000 42%);
}

.betsbuzz365 .login-pop input {
    border: 1px solid #666;
}

.betsbuzz365 .login-pop .login:after {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="rgb(255,184,12" fill-rule="evenodd" d="M5.672 11.238l2.066-2.355H0V7.117h7.776L5.672 4.762 6.8 3.5 10.82 8 6.8 12.5 5.67 11.238zM13.348 0c.435 0 .82.17 1.153.508.334.338.5.73.5 1.172v11.64c0 .443-.166.834-.5 1.172-.332.34-.717.508-1.152.508H1.898c-.434 0-.818-.17-1.15-.508-.334-.338-.5-.73-.5-1.172V10h1.65v3.32h11.45V1.68H1.898V5H.25V1.68c0-.443.166-.834.5-1.172C1.08.168 1.463 0 1.897 0h11.45z"/></svg>');
}

.betsbuzz365 .login-pop .state {
    color: #222;
}

.betsbuzz365 .side-head {
    background-image: linear-gradient(180deg, #474747 0%, #070707 100%);
}

.betsbuzz365 .side-head h3 {
    color: #fff;
}

.betsbuzz365 .side-head .close {
    border-color: #444;
}

/* .betsbuzz365 .side-head .close:before {
    background-image: url('../images/icon-close-yellow.svg');
} */
.betsbuzz365 .login-RnR .policy-header {
    background: linear-gradient(-180deg, #414141 0%, #000 100%);
}

@media (orientation: landscape) {

    .betsbuzz365 .login-head,
    .betsbuzz365 .pass-head {
        background-image: linear-gradient(-180deg, #414141 0%, #000 100%);
    }

    .betsbuzz365 .login-head h1,
    .betsbuzz365 .pass-head h1 {
        top: 9.46667vw;
        width: 34.46667vw;
        height: 15.33333vw;
        /* background-image: url(/static/media/mobile-logo.199069b1.png); */
        margin-left: -18.06667vw;
    }
}

.betsbuzz365 .login-RnR .policy-header h1 {
    color: #000;
}

@media (orientation: landscape) {

    .betsbuzz365 .login-RnR .btn-send:before,
    .betsbuzz365 .login-RnR .login:before {
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>') center no-repeat;
    }
}

.betsbuzz365 .inplay-list {
    border-bottom-color: #7e97a7;
}

.betsbuzz365 .quick_link {
    background-color: #000;
}

.betsbuzz365 .support-wrap {
    margin-bottom: 6.4vw;
}

@media screen and (min-aspect-ratio: 16 / 9) {
    .betsbuzz365 .support-wrap {
        margin-bottom: 2.9985vmax;
    }
}

/* .betsbuzz365 .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>')
        no-repeat;
} */
/* .betsbuzz365 .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>')
        no-repeat;
} */
/* .betsbuzz365 .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>')
        no-repeat;
} */
.betsbuzz365 .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.betsbuzz365 .icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

/* .betsbuzz365 .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="%23000000" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>')
        no-repeat;
}
.betsbuzz365 .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23000000" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>')
        no-repeat;
} */
.betsbuzz365 .icon-racing {
    background: url('data:image/svg+xml,<svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m104.031307 120.690196c-3.529412-1.552941-5.9999818 0-5.9999818 0v5.647059 5.983852h.7058823v-2.101481c.9882353-.352922 2.8941365-.705882 5.2941365.352923 3.529411 1.552941 5.999981 0 5.999981 0v-9.882353c-.000037 0-2.470607 1.552941-6.000018 0zm5.294099 3.882371c0-.070606-1.482335.564706-3.529412.211747v2.823529c.494136.070607.988235.141177 1.341195.141177 1.341158 0 2.188217-.42353 2.188217-.42353v2.82353s-1.270588.635275-3.247059.352922c-.141176 0-.352923-.070606-.282353-.070606v-2.82353c-.564706-.07057-1.200018-.282353-1.835294-.564706-.635313-.282353-1.200018-.423529-1.694118-.564706v2.82353c.070607 0-.070606 0-.282353 0-1.835294-.282353-3.2470584.141176-3.2470584.141176v-2.823529s1.5529414-.494099 3.5294114-.141177v-2.823529c-2.117647-.423529-3.5294114.282353-3.5294114.282353v-2.823529s1.4117644-.705883 3.5294114-.282353v2.823529c.564706.07057 1.129412.282353 1.764688.564706.635312.282353 1.200018.494136 1.764687.564706v-2.82353c2.047077.352923 3.529412-.211746 3.529412-.211746v2.823566z" fill="%23000000" transform="translate(-98 -120)"/></svg>') no-repeat;
}


/* .betsbuzz365 .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="%23000000" fill-rule="nonzero"/></svg>')
        no-repeat;
} */
/* .betsbuzz365 .select .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>')
        no-repeat;
} */
/* .betsbuzz365 .select .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>')
        no-repeat;
} */
/* .betsbuzz365 .select .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>')
        no-repeat;
} */
.betsbuzz365 .select .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.betsbuzz365 .select .icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

.betsbuzz365 .select .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="rgb(255,184,12)" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.betsbuzz365 .select .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="rgb(255,184,12)" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.betsbuzz365 .select .icon-racing {
    background: url('data:image/svg+xml,<svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m104.031307 120.690196c-3.529412-1.552941-5.9999818 0-5.9999818 0v5.647059 5.983852h.7058823v-2.101481c.9882353-.352922 2.8941365-.705882 5.2941365.352923 3.529411 1.552941 5.999981 0 5.999981 0v-9.882353c-.000037 0-2.470607 1.552941-6.000018 0zm5.294099 3.882371c0-.070606-1.482335.564706-3.529412.211747v2.823529c.494136.070607.988235.141177 1.341195.141177 1.341158 0 2.188217-.42353 2.188217-.42353v2.82353s-1.270588.635275-3.247059.352922c-.141176 0-.352923-.070606-.282353-.070606v-2.82353c-.564706-.07057-1.200018-.282353-1.835294-.564706-.635313-.282353-1.200018-.423529-1.694118-.564706v2.82353c.070607 0-.070606 0-.282353 0-1.835294-.282353-3.2470584.141176-3.2470584.141176v-2.823529s1.5529414-.494099 3.5294114-.141177v-2.823529c-2.117647-.423529-3.5294114.282353-3.5294114.282353v-2.823529s1.4117644-.705883 3.5294114-.282353v2.823529c.564706.07057 1.129412.282353 1.764688.564706.635312.282353 1.200018.494136 1.764687.564706v-2.82353c2.047077.352923 3.529412-.211746 3.529412-.211746v2.823566z" fill="rgb(255,184,12)" transform="translate(-98 -120)"/></svg>') no-repeat;
}

.betsbuzz365 .select .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="rgb(255,255,255)" fill-rule="nonzero"/></svg>') no-repeat;
}

.icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="rgb(0,0,0)" fill-rule="nonzero"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="%23FFFFFF" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-racing {
    background: url('data:image/svg+xml,<svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m104.031307 120.690196c-3.529412-1.552941-5.9999818 0-5.9999818 0v5.647059 5.983852h.7058823v-2.101481c.9882353-.352922 2.8941365-.705882 5.2941365.352923 3.529411 1.552941 5.999981 0 5.999981 0v-9.882353c-.000037 0-2.470607 1.552941-6.000018 0zm5.294099 3.882371c0-.070606-1.482335.564706-3.529412.211747v2.823529c.494136.070607.988235.141177 1.341195.141177 1.341158 0 2.188217-.42353 2.188217-.42353v2.82353s-1.270588.635275-3.247059.352922c-.141176 0-.352923-.070606-.282353-.070606v-2.82353c-.564706-.07057-1.200018-.282353-1.835294-.564706-.635313-.282353-1.200018-.423529-1.694118-.564706v2.82353c.070607 0-.070606 0-.282353 0-1.835294-.282353-3.2470584.141176-3.2470584.141176v-2.823529s1.5529414-.494099 3.5294114-.141177v-2.823529c-2.117647-.423529-3.5294114.282353-3.5294114.282353v-2.823529s1.4117644-.705883 3.5294114-.282353v2.823529c.564706.07057 1.129412.282353 1.764688.564706.635312.282353 1.200018.494136 1.764687.564706v-2.82353c2.047077.352923 3.529412-.211746 3.529412-.211746v2.823566z" fill="%23FFFFFF" transform="translate(-98 -120)"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="%23FFFFFF" fill-rule="nonzero"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-inplay {
    background: url('data:image/svg+xml,<svg width="20" height="21" xmlns="http://www.w3.org/2000/svg"><path d="M10 18.944c1.94 0 3.592-.718 4.953-2.154 1.362-1.436 2.042-3.165 2.042-5.189 0-2.023-.68-3.744-2.042-5.164-1.361-1.42-3.012-2.13-4.953-2.13-1.94 0-3.592.71-4.953 2.13-1.362 1.42-2.042 3.141-2.042 5.164 0 2.024.68 3.753 2.042 5.19 1.361 1.435 3.012 2.153 4.953 2.153zm0-16.741c2.504 0 4.632.922 6.385 2.766 1.753 1.843 2.63 4.054 2.63 6.632 0 2.579-.877 4.79-2.63 6.633C14.632 20.078 12.504 21 10 21s-4.632-.922-6.385-2.766C1.862 16.39.985 14.18.985 11.601c0-2.578.877-4.789 2.63-6.632C5.368 3.125 7.496 2.203 10 2.203zm.516 4.21v5.482l3.991 2.448-.751 1.272-4.742-2.937V6.413h1.502zM5.87 1.566L1.268 5.58 0 4.014 4.6 0 5.87 1.566zM20 4.014l-1.268 1.615-4.6-4.063L15.398 0 20 4.014z" fill="%23FFFFFF" fill-rule="evenodd"/></svg>') no-repeat;
}

.betsbuzz365 .quick_link .icon-pin {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%23FFFFFF" fill-rule="evenodd" d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm5.09-13.203c-.09 0-.18-.032-.27-.095-.49-.19-.802-.49-.936-.9L15.18 5.203v-.237c0-.253.222-.46.668-.617l.067-.048h.067c.536-.158.804-.426.804-.806 0-.443-.09-.72-.268-.83-.18-.11-.49-.166-.938-.166H9.42c-.447 0-.76.055-.938.166-.178.11-.268.387-.268.83 0 .38.268.648.804.806h.067l.067.048c.446.158.67.364.67.617v.237L8.615 10.8c-.134.412-.446.712-.937.902-.09.063-.18.095-.27.095-1.606.57-2.41 1.44-2.41 2.61 0 .378.067.64.2.78.135.144.403.215.804.215h5.425l.802 8.348h.536l.803-8.348h5.426c.4 0 .67-.063.803-.19.133-.126.2-.395.2-.806 0-1.17-.804-2.04-2.41-2.61z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-cricket {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="evenodd" d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806l15.522 18.93C16.565 24.487 14.592 25 12.5 25 5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636C9.797.222 11.122 0 12.5 0 19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-soccer {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="evenodd" d="M19.63 2.945c-.77-.574-1.602-1.052-2.492-1.43-.49-.205-.987-.378-1.495-.516-.4.162-.892.472-1.714 1.174-.687-.073-1.38-.076-2.076-.01-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093-1.02 1.02-1.835 2.197-2.428 3.5-.074.785-.037 1.595.018 2.21-.294.738-.505 1.508-.628 2.3-.128.827-.18 2.328-.12 3.223.15.625.352 1.237.605 1.835.6 1.42 1.46 2.695 2.554 3.79.304.302.62.587.95.853-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19 1.608 0 3.17-.315 4.64-.936.786-.333 1.528-.745 2.22-1.232-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3.368-.57.686-1.174.953-1.805.62-1.47.937-3.03.937-4.64 0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444-.544-.727-1.19-1.396-1.923-1.992-.133-.664-.5-1.707-1.484-2.803zm1.707.715c1.147 1.15 2.048 2.484 2.68 3.976.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867-.63 1.49-1.53 2.825-2.68 3.973-1.146 1.147-2.483 2.048-3.972 2.678-1.54.65-3.18.982-4.866.982-1.69 0-3.325-.33-4.866-.982-1.49-.63-2.826-1.53-3.973-2.678-1.147-1.148-2.048-2.484-2.678-3.973C.332 15.827 0 14.187 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973C4.807 2.515 6.144 1.615 7.633.985 9.174.33 10.81.003 12.497 0c1.69 0 3.325.33 4.866.982 1.49.63 2.826 1.53 3.974 2.678zm-4.37 2.287l-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557.688-.063 1.373-.052 2.05.03l2.97 2.97zM2.07 16.63c-.12-.445-.263-1.09-.334-1.865-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19c.643.54 1.213 1.138 1.696 1.784.604.81 1.074 1.7 1.395 2.643-.336 2.92-1.17 4.38-1.502 4.887z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-tennis {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="nonzero" d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606-.26 2.8-1.46 5.53-3.605 7.674-2.148 2.143-4.87 3.347-7.676 3.607-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673C5.8 1.513 8.53.31 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0c3.076.095 6.126 1.308 8.47 3.655C23.693 6.002 24.91 9.048 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957-3.075-.09-6.12-1.308-8.466-3.652C1.308 19.002.09 15.955 0 12.88z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-basketball {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="nonzero" d="M13.37 2.004c-.23.312-.646.765-1.198 1.257C10.552 2.073 9.094 1.27 8.152.8c1.32-.516 2.75-.8 4.245-.8.39 0 .776.02 1.156.058l.005.09c.04.695.083 1.484-.19 1.856zm6.64 7.247c1.72-.197 3.583 2.04 4.99 3.8-.123 3.168-1.42 6.03-3.46 8.146-.197-3.35-1-7.976-3.062-11.636.43-.14.935-.24 1.533-.31zM7.33 6.13c-.512.105-1.042.203-1.554.297-1.585.292-3.2.592-4.69 1.182 1.147-2.553 3.118-4.658 5.58-5.98.394.16 2.374 1.003 4.747 2.626-1.138.8-2.565 1.56-4.083 1.874zm8.43.283c1.303-.77 2.398-1.295 3.086-1.49 1.05-.293 2.078-.47 3-.575C23.54 6.125 24.674 8.378 25 10.87c-1.527-1.643-3.307-3.135-5.308-2.922-.85.09-1.56.242-2.162.456-.414-.568-.865-1.106-1.363-1.598-.134-.133-.27-.264-.406-.393zm-1.686 6.43c-.204.7-.45 1.778-.737 3.028-.595 2.603-1.597 6.978-2.66 9.13-2.923-.41-5.52-1.856-7.416-3.964.57-5.02 6.82-10.816 11.38-13.97.188.185.374.375.558.57.398.426.765.893 1.106 1.39-1.137.816-1.724 2.073-2.23 3.817zm-5.26-2.836C6.176 12.464 3.097 15.97 2.2 19.565.816 17.555 0 15.11 0 12.475c0-1.18.166-2.32.47-3.4 1.557-.878 3.41-1.23 5.34-1.592.5-.094 1.018-.19 1.524-.298 1.806-.38 3.466-1.33 4.733-2.294.5.386 1.01.806 1.52 1.26-1.526 1.063-3.195 2.384-4.774 3.857zm5.904-4.572c-.56-.52-1.122-1-1.675-1.44.565-.517 1-.993 1.255-1.34.54-.732.518-1.738.47-2.655 2.222.455 4.236 1.497 5.884 2.96-.713.125-1.466.296-2.233.53-.856.26-2.174.95-3.702 1.945zm.564 7.498c.448-1.534.897-2.522 1.733-3.15 2.154 3.79 3.01 8.895 3.094 12.504C17.973 23.985 15.284 25 12.36 25c-.136 0-.27-.006-.403-.01.943-2.098 1.75-5.388 2.596-9.065.286-1.245.533-2.32.73-2.992z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-rugby {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="nonzero" d="M1.762 23.238C.14 21.615-.346 18.866.238 15.793l8.97 8.97c-3.074.584-5.822.098-7.446-1.525zM5.79 5.788c2.12-2.12 4.534-3.66 6.905-4.62l11.138 11.137c-.96 2.372-2.5 4.785-4.622 6.907-2.12 2.12-4.534 3.66-6.905 4.62L1.168 12.696c.96-2.37 2.5-4.785 4.62-6.906zm8.088 3.494c-.34-.337-.887-.337-1.223 0-.34.34-.34.89-.005 1.227l.31.307-.46.46-.31-.308c-.336-.34-.885-.34-1.22 0-.34.335-.34.883 0 1.22l.308.31-.46.46-.31-.31c-.337-.336-.885-.336-1.226.005-.336.336-.336.884 0 1.223l.31.308-.46.46-.31-.308C8.485 14 7.938 14 7.6 14.336c-.34.34-.34.89-.005 1.227l1.842 1.84c.338.338.886.337 1.227-.003.336-.337.336-.884-.002-1.223l-.31-.308.462-.462.308.31c.338.336.886.336 1.222 0 .342-.34.342-.888.006-1.227l-.31-.307.46-.46.31.307c.336.338.884.338 1.22 0 .34-.336.34-.884 0-1.222l-.308-.308.46-.46.31.31c.338.336.885.336 1.226-.006.336-.336.336-.883 0-1.222l-.31-.308.46-.46.31.308c.337.338.885.338 1.222 0 .34-.34.34-.887.004-1.225l-1.84-1.842c-.34-.336-.887-.336-1.226.005-.338.337-.338.884 0 1.222l.31.31-.462.46-.308-.31zm9.36-7.52c1.623 1.623 2.11 4.372 1.524 7.445l-8.97-8.97c3.074-.583 5.822-.098 7.446 1.525z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-HR {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="%233B5160" fill-rule="nonzero" d="M21.51 19.133S27.72 0 11.92 0h-.095C-3.915 0 2.326 19.133 2.326 19.133L0 20.753l1.794 4.156 7.236-2.752C2.155 8.02 10.608 7.224 11.918 7.185c1.31.04 9.764.836 2.888 14.974l7.236 2.75 1.794-4.156-2.325-1.62zm-18.496-7.17c0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.148 4.814c-.458 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83zM4.76 8.81c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.457 0 .83.372.83.83 0 .458-.373.83-.83.83zm13.54-.83c0-.46.37-.83.83-.83.458 0 .83.37.83.83 0 .458-.372.83-.83.83-.46 0-.83-.372-.83-.83zm1.427 8.797c-.457 0-.83-.37-.83-.83 0-.458.372-.83.83-.83.46 0 .83.372.83.83 0 .458-.37.83-.83.83zm.32-3.984c-.46 0-.83-.37-.83-.83 0-.458.37-.83.83-.83.458 0 .83.372.83.83 0 .458-.372.83-.83.83z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-dog {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="%233B5160" fill-rule="evenodd" d="M7.957 1.797C7.903 1.042 8.937.457 9.775 0c.99.78.34 2.384-1.818 1.797zm5.883.045c-.063-.578-.27-1.294-.182-1.842.71.044 2.01 2.384.182 1.842zm2.645 9.645c2.016-.34 2.912-2.517 2.828-4.462-.08-1.85-1.926-3.54-3.417-4.11-.05-.02-.143.01-.197.002-2.42-.39-2.112 2.832-1.967 4.9.142 2.035.344 4.074 2.752 3.67zM9 11.537c.91-.008 1.895-.304 2.173-.855.38-.756.087-2.314.013-3.516-.124-2.033-.313-3.524-1.89-4.166-.248-.1-.556-.142-1.17-.098-1.5.568-2.77 2.05-3.367 3.49-.957 2.315 1.45 5.174 4.24 5.146zM20.585 6.21c.583.213 1.22.65 2.143.484-.243-.88-1.042-1.41-1.927-1.886-.463.285-.38 1.016-.216 1.402zm-18.31.42c.365.217.972.055 1.135-.21-.005-.575-.038-1.12-.126-1.612-.426.525-.915.994-1.01 1.82zm17.77 8.41c.586.444 1.26 1.42 2.443 1.295 1.033-.107 2.417-2.123 2.503-3.48.12-1.906-.886-4.49-1.975-5.16-1.44-.068-2.274 1.38-2.98 2.336-.372.507-.676.934-1.024 1.508-.297.493-.86 1.228-.827 1.68.06.788 1.355 1.436 1.86 1.82zM3.104 8.665C1.255 8.443-.19 11.38.022 13.528c.193 1.925 1.895 3.823 3.636 3.78.755-.02 1.386-.487 1.878-.916.44-.384 1.115-.93 1.24-1.445.262-1.073-.726-2.61-1.245-3.564-.525-.963-1.153-2.564-2.425-2.717zm6.866 5.408c-1.7 1.512-4.124 3.677-5.028 5.48-1.64 3.27 2.094 6.137 5.9 5.298.48-.103.956-.39 1.412-.616.37-.184.91-.58 1.41-.618.63-.05 1.47.404 2.208.58 1.255.294 3.015.607 4.333.133 1.213-.437 2.41-1.702 2.512-2.92.096-1.168-.485-2.03-1.11-2.943-1.383-2.017-2.578-2.937-4.893-4.284-1.045-.608-2.522-1.48-3.643-1.648-1.553-.234-2.217.756-3.1 1.54z"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-racing {
    background: url('data:image/svg+xml,<svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m104.031307 120.690196c-3.529412-1.552941-5.9999818 0-5.9999818 0v5.647059 5.983852h.7058823v-2.101481c.9882353-.352922 2.8941365-.705882 5.2941365.352923 3.529411 1.552941 5.999981 0 5.999981 0v-9.882353c-.000037 0-2.470607 1.552941-6.000018 0zm5.294099 3.882371c0-.070606-1.482335.564706-3.529412.211747v2.823529c.494136.070607.988235.141177 1.341195.141177 1.341158 0 2.188217-.42353 2.188217-.42353v2.82353s-1.270588.635275-3.247059.352922c-.141176 0-.352923-.070606-.282353-.070606v-2.82353c-.564706-.07057-1.200018-.282353-1.835294-.564706-.635313-.282353-1.200018-.423529-1.694118-.564706v2.82353c.070607 0-.070606 0-.282353 0-1.835294-.282353-3.2470584.141176-3.2470584.141176v-2.823529s1.5529414-.494099 3.5294114-.141177v-2.823529c-2.117647-.423529-3.5294114.282353-3.5294114.282353v-2.823529s1.4117644-.705883 3.5294114-.282353v2.823529c.564706.07057 1.129412.282353 1.764688.564706.635312.282353 1.200018.494136 1.764687.564706v-2.82353c2.047077.352923 3.529412-.211746 3.529412-.211746v2.823566z" fill="%233B5160" transform="translate(-98 -120)"/></svg>') no-repeat;
}

.betsbuzz365 .channel-list .icon-election {
    background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 0h-6.4l-1.865 2.236c-.078.098-.108.226-.082.349.025.116.101.212.205.269l-5.222 1.959c-.438.165-.813.476-1.054.877l-1.727 2.878c-.368.613-.397 1.361-.077 1.999l.122.245h-1.822c-.23 0-.416.186-.416.416v7.171h-.863c-.23 0-.8 0-.8.8s.57.8.8.8h16.4c.23 0 .8 0 .8-.8s-.57-.8-.8-.8h-3.893v-3.52c0-.142-.073-.275-.193-.351-.12-.076-.271-.086-.4-.025-.303.143-1.556.823-3.758 2.039-.432.259-.924.397-1.424.397-.92 0-1.778-.456-2.305-1.237-.417-.625-.561-1.375-.405-2.109.156-.734.589-1.361 1.223-1.764l.393-.249.77-.481c.161-.1.235-.294.179-.476-.102-.334-.273-.63-.435-.859.435-.165 2.004-1.765 2.004-1.765.101.059.225.231 1.025.8.8.569 1.215.711 1.673.8-.454.381-1.254.968-2.054 1.98-.344.155-.8.42-2.4 1.22-.47.235-1.156.8-.8 1.6.356.8.974.8 1.6.8.533 0 1.6-.533 3.2-1.6 1.6-.8 3.2-.8 4.542-2.984 1.314-2.139 2.063-3.855 2.369-4.63.223.111.411.156.604.156.32 0 .636-.128.868-.352.245-.236.417-.635.417-.977v-4.814z" fill="%233B5160" fill-rule="nonzero"/></svg>') no-repeat;
}

.support-mail.openn img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(97,97,97)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>')
}

.support-whatsapp.openn img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>')
}

.support-telegram.openn img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>')
}

.support-ig.openn img {
    background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>')
}

.support-skype.openn img {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>')
}

/* .betsbuzz365 .icon-Kabaddi {
    background: url('../images/kabaddi.svg') no-repeat
} */

/* .betsbuzz365 .select .icon-Kabaddi {
    background: url('../images/kabbaddi.png') no-repeat
} */

.betsbuzz365 .icon-bet-game {
    background: url('../images/sprite/slots.png') no-repeat
}




/* Progressbar */


.meter {

    box-sizing: content-box;
    height: 10px;
    position: relative;
    margin: 10px;
    background: transparent;
    border-radius: 25px;
    padding: 5px;
    box-shadow: inset 0 0px 1px rgb(0 0 0);

}

.meter>span {
    display: block;
    height: 100%;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background-color: rgb(43, 194, 83);
    background-image: linear-gradient(center bottom,
            rgb(43, 194, 83) 37%,
            rgb(84, 240, 84) 69%);
    box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
        inset 0 -2px 6px rgba(0, 0, 0, 0.4);
    position: relative;
    overflow: hidden;
}

.meter>span:after,
.animate>span>span {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(-45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent);
    z-index: 1;
    background-size: 50px 50px;
    animation: move 2s linear infinite;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    overflow: hidden;
}

.animate>span:after {
    display: none;
}

@keyframes move {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: 50px 50px;
    }
}

.orange>span {
    background-image: linear-gradient(#f1a165, #f36d0a);
}

.red>span {
    background-image: linear-gradient(#000, #f42323);
}


#page-wrap {
    width: 370px;

}




.bl-Preloader_Spinner {
    box-sizing: border-box;
    width: 45px;
    height: 45px;
    margin: 0 auto;
    border: 2px solid #757575;
    border-left: 3px solid #000;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-animation: bl-Spinner .6s linear infinite;
    animation: bl-Spinner .6s linear infinite;
}

@keyframes bl-Spinner {
    0% {
        transform: translateX(-50%) translateY(-50%) rotate(0deg);
    }

    100% {
        transform: translateX(-50%) translateY(-50%) rotate(360deg);
    }
}

.bl-Preloader {

    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: #000000e0;
    z-index: 99;
    justify-content: center;
    align-items: center;
}




.mob-main-content .casinozone a img:hover {
    -webkit-transform: scale3d(1.1, 1.1, 1);
    transform: scale3d(1.1, 1.1, 1);
}

.mob-main-content .casinozone img {
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
}

.casino-title dd span:nth-child(1) {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 4px;
    border-radisu: 10px;
    background: linear-gradient(to right, #ea4335, #4285f4);
    animation: animate1 2s linear infinite;
}

@keyframes animate1 {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

    .casino-title dd span:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 4px;
    background: linear-gradient(to bottom, #fbbc05, #34a853);
    animation: animate2 2s linear infinite;
    animation-delay: 1s;
}
    @keyframes animate2 {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
}
     .casino-title dd span:nth-child(3) {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(to left, #ea4335, #4285f4);
    animation: animate3 2s linear infinite;
}

@keyframes animate3 {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

  .casino-title dd span:nth-child(4) {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 4px;
    background: linear-gradient(to top, #fbbc05, #34a853);
    animation: animate4 2s linear infinite;
    animation-delay: 1s;
}
    @keyframes animate4 {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(-100%);
  }
}

// @keyframes twinkling {


//     0% {
//         color: red;
//     }

//     50% {
//         color: #ff0;
//     }

//     100% {
//         color: #000;
//     }
// }

.promo-banner-wrap.active {
    overflow: hidden;
}

.promo-banner-wrap {
    position: relative;
    width: 100vw;
    height: 18.66667vw;
}



.btn-head_rules {
    background: url("../images/sprite/bg-sportsbook_rules.9a2177b3.svg");
}


.btn-head_rules {
    width: 10.93333vw;
    height: 100%;
    background-size: 100% 100%;
    /* background-repeat: no-repeat; */
    align-items: center;
    justify-content: center;
    vertical-align: bottom;
}


.sports-book dd {
    width: 37.33333vw !important;
}

.bets-selections>dd {
    width: 18.66667vw;
}


.sports-book .back-1 {
    background-color: #72e3a0 !important;
}


.bets-selections a,
.trade p,
.trade-2 p {
    width: 100%;
    font-weight: bold;
    color: #1e1e1e;
    padding: 1.6vw;
    flex-direction: column;
    justify-content: center;
}

.icon-mt5 {
    filter: invert(1) !important;
}



.icon-kabaddi {
    background: url('data:image/svg+xml,<svg width="33" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M5.877 11.527a4.294 4.294 0 118.589 0 4.294 4.294 0 01-8.59 0zm11.95 5.78a1.97 1.97 0 012.86.068 2.155 2.155 0 01-.066 2.967l-.454.453-2.989-2.842.65-.646zm4.55-10.074a4.294 4.294 0 110 8.589 4.294 4.294 0 010-8.59zm2.513 16.152c-.627 1.081-1.21 2.082-1.789 3.087-.26.452-.56.832-1.094 1.014-.687.234-1.283.129-1.817-.217-.406-.224-.88-.615-1.454-1.21l-6.287-5.794a2.03 2.03 0 012.747-2.99l1.614 1.5c1.219 1.104 2.58 2.367 3.614 3.29.103.092.213.179.351.295.094-.132.18-.235.246-.35a852.85 852.85 0 001.885-3.32c.078-.138.157-.28.203-.43.616-2.014 2.173-3.055 4.017-3.661 1.678-.552 3.421.24 4.368 1.8.456.753.911 1.507 1.365 2.26.093-.706.141-1.427.141-2.159C33 7.387 25.613 0 16.5 0S0 7.387 0 16.5c0 .733.048 1.455.141 2.163l1.28-2.126c1.263-2.104 3.536-2.658 5.675-1.436a7.85 7.85 0 012.059 1.708c.226.261.39.582.55.892.8 1.546 1.59 3.098 2.424 4.728l.716-.686 3.007 2.754-.123.109-1.616 1.544a2.04 2.04 0 01-.364.275c-.332.294-.678.582-1.057.866-.74.552-2.078.476-2.74-.7-.579-1.03-1.164-2.057-1.8-3.178-1.032 1.705-2.03 3.35-3.042 5.025A16.444 16.444 0 0016.5 33c4.427 0 8.446-1.744 11.41-4.581l-3.02-5.034z" fill="rgb(0,0,0)" fill-rule="evenodd"/></svg>') no-repeat;
}






.game-wrap-horse.closer {
    display: block;
}

.closer.game-wrap-horse {
    border-bottom-color: #eee;
}

.closer.game-wrap-horse {
    height: 6.66667vw;
    overflow: hidden;
}

.game-wrap-horse {
    background-color: #fff;
    margin-bottom: 1.33333vw;
}

.closer {
    justify-content: center;
    align-items: center;
}

.game-wrap-horse {
    border-bottom: 0.26667vw solid #7e97a7;
    /* margin-bottom: 4vw; */
}

.closer {
    font-size: 0;
    text-indent: -99999px;

}

.closer.game-wrap-horse .to-expand.close {
    justify-content: initial;
    font-size: inherit;
    text-indent: initial;
}

.to-expand {
    align-items: center;
    display: flex;
}

.closer.game-wrap-horse .to-expand .close-info {
    flex: 1;
    text-align: left;
}

.game-wrap-horse .close-info {
    padding-left: 2.66667vw;
    color: #000;
}

.closer.game-wrap-horse .to-expand.closer {
    justify-content: initial;
    font-size: inherit;
    text-indent: initial;
}

.game-wrap-horse h3 {
    padding-left: 2.13333vw;
}

.clearfix:after,
.game-wrap-horse .hs-time:after,
.game-wrap-horse:after,
.sportsgame-list-content:after,
.sportsgame-list-content dd:after,
.now-play:after,
.info-rotate:after {
    content: "";
    display: block;
    clear: both;
}

.game-wrap-horse .hs-time li {
    display: block;
    float: left;
}

.game-wrap-horse .hs-time .in-play {
    background-color: #6bbd11;
    color: #fff;
    border-color: #6bbd11;
}

.game-wrap-horse .hs-time dd a {
    width: 10.66667vw;
    font-size: 3.46667vw;
    line-height: 5.06667vw;
    border: 0.26667vw solid transparent;
    border-radius: 0.8vw;
    margin-right: 2.13333vw;
}

.game-wrap-horse h3 {
    background: #000;
}

.game-wrap-horse h3 {
    color: #fff;
    font-size: 3.73333vw;
    line-height: 6.66667vw;
    font-weight: normal;
    padding-left: 2.66667vw;
    background-repeat: repeat-x;
}

.game-wrap-horse h3 a {
    color: #fff;
}

div::-webkit-scrollbar {
    display: none;
}

.special_bets-tab::-webkit-scrollbar {
    display: none;
}

.centar-content #centerColumn {
    margin-left: 0px !important;
}

.main-content .centar-content1 {
    height: 100%;
    overflow: hidden;
}

.centar-content1 {
    zoom: 1;
}


@keyframes marqueeAnimation-4429646 {
    100% {
        transform: translateX(-1825px);
    }
}

.select .icon-esoccer {
    background: url('data:image/svg+xml,<svg width="26" height="24" xmlns="http://www.w3.org/2000/svg"><path fill="%23000000" fill-rule="evenodd" d="M12.75 9 17 16.5 12.75 24h-8.5L0 16.5 4.25 9h8.5Zm1.903 4.8H7.09l-1.041 1.8h8.148l-.34.587-.702 1.213H5.007l-1.042 1.8h8.147L11.071 21H3.367l1.292 2.278h7.682l3.841-6.778-1.529-2.7ZM14.596 0l.397.008a10.86 10.86 0 0 1 4.061.965 10.86 10.86 0 0 1 5.698 6.084 10.86 10.86 0 0 1-.272 8.33 10.86 10.86 0 0 1-6.083 5.698 10.839 10.839 0 0 1-3.41.693l-.437.008.556-.963c.204-.087.395-.175.565-.257a9.242 9.242 0 0 0 2.069-.194c.716-.15 1.964-.57 2.674-.895a10.356 10.356 0 0 0 4.01-5.331c-.198.083-.893.408-1.268.559l-.112.043-2.378-2.928.217-4.495c.755-.518 1.275-.873 1.56-1.063l.132-.088.11-.07c.73.533 1.737 2.144 2.095 2.935a10.45 10.45 0 0 0-.501-1.804 10.337 10.337 0 0 0-3.89-4.938c.65.574 1.047 1.395 1.482 2.148.034.062.418.896.455 1.038l.002.02-1.857 1.273-3.857-1.655-1.65-3.404c.53-.26 1.278-.736 1.776-.983a10.66 10.66 0 0 0-1.767-.22 10.326 10.326 0 0 0-4.071.66c-.93.35-1.793.823-2.576 1.41a.045.045 0 0 0 .018-.005c-.33.366-.63.763-.899 1.184a9.835 9.835 0 0 0-1.035 2.18c-.498.311-1.234.928-1.824 2.06l-.078.282-.07.284h-.52a10.914 10.914 0 0 1 3.14-5.574A10.838 10.838 0 0 1 10.724.7 10.842 10.842 0 0 1 14.2.005L14.596 0Zm5.86 12.755 2.002 2.492c-.27.96-.676 1.939-1.185 2.663a8.52 8.52 0 0 1-1.263.752 8.161 8.161 0 0 1-1.891.649c-.49.102-.985.155-1.478.158l-.092-.054-.091-.056 1.676-2.903-1.378-2.387.162-.343 3.538-.97ZM12.34 9.722H4.66L.818 16.5l1.298 2.292.893-1.55.951-1.643h.005L6.048 12h7.584l-1.29-2.278Zm1.547-7.841c.016.002.04.019.062.03l.031.01 1.443 2.981-2.336 2.822-3.951.035h-.831L7.628 5.54A8.171 8.171 0 0 1 8.45 3.84a7.371 7.371 0 0 1 1.522-1.717c2.189-.548 3.463-.343 3.916-.242Z"/></svg>') no-repeat;
}

.icon-esoccer {
    background: url('data:image/svg+xml,<svg width="26" height="24" xmlns="http://www.w3.org/2000/svg"><path fill="rgb(255,255,255)" fill-rule="evenodd" d="M12.75 9 17 16.5 12.75 24h-8.5L0 16.5 4.25 9h8.5Zm1.903 4.8H7.09l-1.041 1.8h8.148l-.34.587-.702 1.213H5.007l-1.042 1.8h8.147L11.071 21H3.367l1.292 2.278h7.682l3.841-6.778-1.529-2.7ZM14.596 0l.397.008a10.86 10.86 0 0 1 4.061.965 10.86 10.86 0 0 1 5.698 6.084 10.86 10.86 0 0 1-.272 8.33 10.86 10.86 0 0 1-6.083 5.698 10.839 10.839 0 0 1-3.41.693l-.437.008.556-.963c.204-.087.395-.175.565-.257a9.242 9.242 0 0 0 2.069-.194c.716-.15 1.964-.57 2.674-.895a10.356 10.356 0 0 0 4.01-5.331c-.198.083-.893.408-1.268.559l-.112.043-2.378-2.928.217-4.495c.755-.518 1.275-.873 1.56-1.063l.132-.088.11-.07c.73.533 1.737 2.144 2.095 2.935a10.45 10.45 0 0 0-.501-1.804 10.337 10.337 0 0 0-3.89-4.938c.65.574 1.047 1.395 1.482 2.148.034.062.418.896.455 1.038l.002.02-1.857 1.273-3.857-1.655-1.65-3.404c.53-.26 1.278-.736 1.776-.983a10.66 10.66 0 0 0-1.767-.22 10.326 10.326 0 0 0-4.071.66c-.93.35-1.793.823-2.576 1.41a.045.045 0 0 0 .018-.005c-.33.366-.63.763-.899 1.184a9.835 9.835 0 0 0-1.035 2.18c-.498.311-1.234.928-1.824 2.06l-.078.282-.07.284h-.52a10.914 10.914 0 0 1 3.14-5.574A10.838 10.838 0 0 1 10.724.7 10.842 10.842 0 0 1 14.2.005L14.596 0Zm5.86 12.755 2.002 2.492c-.27.96-.676 1.939-1.185 2.663a8.52 8.52 0 0 1-1.263.752 8.161 8.161 0 0 1-1.891.649c-.49.102-.985.155-1.478.158l-.092-.054-.091-.056 1.676-2.903-1.378-2.387.162-.343 3.538-.97ZM12.34 9.722H4.66L.818 16.5l1.298 2.292.893-1.55.951-1.643h.005L6.048 12h7.584l-1.29-2.278Zm1.547-7.841c.016.002.04.019.062.03l.031.01 1.443 2.981-2.336 2.822-3.951.035h-.831L7.628 5.54A8.171 8.171 0 0 1 8.45 3.84a7.371 7.371 0 0 1 1.522-1.717c2.189-.548 3.463-.343 3.916-.242Z"/></svg>') no-repeat;
}

.extend-support {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2.6666666667vw;
    width: 84vw;
    margin: 0 auto;
    background-color: transparent;
    margin-top: 20px;
}

.extend-btn {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    padding: 8px 0;
    border-radius: 8px;
    font-size: 3.4666666667vw;
    text-align: left;
}

.extend-btn img {
    width: 8vw;
    height: 8vw;
    margin-right: 1.0666666667vw;
    vertical-align: middle;
    margin-left: 12%;
}

/* .support-customer {
    background-image: url('data:image/svg+xml,<svg width="159" height="159" xmlns="http://www.w3.org/2000/svg"><path d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0" fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"/></svg>');
}
.support-whatsapp {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"/></svg>');
}
 .support-telegram {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"/></svg>');
}
.support-mail {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}
.support-ig {
    background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"/></svg>');
}
.support-skype {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgba(0, 0, 0, 0.7)" fill-rule="nonzero"/></svg>');
} */
.extend-btn a {
    color: rgba(0, 0, 0, 0.7);
    line-height: 6.6666666667vw;
    padding-right: 1.6vw;
    text-align: left;
}

.support-social {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 8px;
    width: 84vw;
    margin: 0 auto;
    margin-bottom: 5.3333333333vw;
    background-color: transparent;
}

.social-btn {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    padding: 8px 0;
    border-radius: 8px;
    text-align: center;
}

.social-btn img {
    width: 5.8666666667vw;
    height: 5.8666666667vw;
    margin-right: 0.5333333333vw;
    vertical-align: middle;
}

.social-btn a {
    color: rgba(0, 0, 0, 0.7);
    line-height: 6.6666666667vw;
    font-size: 2.9333333333vw;
}

.extend-btn a.split-line {
    border-left: 0.2666666667vw solid rgba(0, 0, 0, 0.7);
    padding-left: 2.1333333333vw;
}

.mob-inform-link li {
    margin-bottom: 1.3333333333vw;
}

.tab-wrap .a-search {
    /* -webkit-box-flex: 0; */
    /* flex: 0 1 12.5333333333vw; */
    position: relative;
}

.tab-wrap .a-search {
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.15)), to(rgba(0, 0, 0, 0.15))) !important;
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%) !important;
    background: linear-gradient(-180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%) !important;
}


header .wallet-detail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 3.2vw;
    color: #3b5160;
    background-color: #e0e6e6;
    box-shadow: 0 0.8vw 2.6666666667vw 0 rgb(0 0 0 / 50%);
}


header .wallet-detail-group {
    margin: 3.2vw 1.8666666667vw;
    background-color: #fff;
    border-radius: 0.8vw;
    box-shadow: 0 0.2666666667vw 0.2666666667vw 0 rgb(0 0 0 / 30%);
}

header .wallet-detail-group .wallet-detail-content {
    padding: 2.6666666667vw 1.8666666667vw 0;
}

header .wallet-detail-group .wallet-detail-content dt {
    line-height: 1.6;
    margin-bottom: 0.8vw;
}


header .wallet-detail-group .wallet-detail-content dd {
    padding-bottom: 2.6666666667vw;
}

header .wallet-detail-group .wallet-balance-num {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    font-size: 4.5333333333vw;
    line-height: 1.2;
    font-weight: bold;
    padding-right: 21.3333333333vw;
    color: #1e1e1e;
}

header .badge-currency {
    margin-right: 0.8vw;
    padding: 0 1.3333333333vw;
    line-height: 4.2666666667vw;
    font-size: 2.6666666667vw;
    font-weight: bold !important;
    color: #fff;
    background-color: #5f849d;
    border-radius: 0.8vw;
}

header .wallet-detail-group .wallet-detail-content dd {
    padding-bottom: 2.6666666667vw;
}

header .wallet-detail-group .wallet-exposure {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-weight: normal !important;
    padding: 1.8666666667vw 0;
    border-top: 0.4vw solid #e0e6e6;
}

header .wallet-detail-group .wallet-exposure span {
    color: #1e1e1e;
}

header .wallet-detail-group:nth-child(2) .wallet-detail-content {
    position: relative;
    border-bottom: 0.4vw solid #ccc;
}

header .wallet-detail-group:nth-child(2) .wallet-detail-content:last-child {
    border-bottom: none;
}

header .wallet-detail .btn,
header .wallet-detail .btn-send,
header .wallet-detail .login,
header .wallet-detail .form-select,
header .wallet-detail .pages a,
.pages header .wallet-detail a {
    width: 50%;
}

header .overlay {
    top: 14.6666666667vw;
    height: calc(100% - 14.6666666667vw);
}

.btn-box,
.in-play.game-fancy pre,
.in-play.game-sportsbook pre,
.in-play.game-bookmaker pre,
.in-play.game-live pre,
header li.main-wallet .nums,
header .badge-currency,
header a,
.tv-control a,
.tag-live,
.tag-live strong,
.btn-minmax_bet,
.back-gradient dd,
.lay-gradient dd,
.on_live .live_icon,
.on_live .live_icon span,
.on_live dd {
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}

.btn-box {
    padding: 0 1.8666666667vw 2.6666666667vw;
    display: flex;
}

header .wallet-detail-group:nth-child(2) .wallet-detail-content .wallet-recall {
    position: absolute;
    top: 50%;
    right: 1.8666666667vw;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: right;
    padding: 0;
}

header .btn-recall {
    color: #3b5160;
    font-size: 4vw;
    font-weight: bold;
    line-height: 2.2;
    padding: 0 2.1333333333vw;
    background-color: rgba(94, 190, 255, 0.15);
    border-radius: 1.0666666667vw;
    border: 0.4vw solid #7e97a7;
    cursor: pointer;
}



.pop-wrap,
.select-list {
    width: 84vw;
    background: #fff;
    font-size: 4vw;
    box-shadow: 0 0.8vw 2.6666666667vw 0 rgb(0 0 0 / 50%);
    border-radius: 1.3333333333vw;
}

.noyabet .pop-wrap h3,
.noyabet .select-list h3 {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#414141), to(#000));
    background-image: -webkit-linear-gradient(top, #414141 0%, #000 100%);
    background-image: linear-gradient(-180deg, #3752d9 0%, #3752d9 100%);
    color: #fff;
}

.pop-wrap h3,
.select-list h3 {
    font-size: 4vw;
    line-height: 1.2;
    color: #1e1e1e;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#ccc), color-stop(58%, #e8e8e8));
    background-image: -webkit-linear-gradient(top, #ccc 0%, #e8e8e8 58%);
    background-image: linear-gradient(-180deg, #ccc 0%, #e8e8e8 58%);
    border-radius: 1.3333333333vw 1.3333333333vw 0 0;
    padding: 2.4vw 1.8666666667vw;
}

.transfer-wrap-slider .available-wrap {
    position: relative;
    height: 22.6666666667vw;
}

.transfer-wrap .available-wrap,
.transfer-wrap-slider .available-wrap {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
}

.transfer-wrap,
.transfer-wrap-slider {
    color: #3752d9;
}

.pop-wrap,
.select-list {
    width: 84vw;
    background: #fff;
    font-size: 4vw;
    box-shadow: 0 0.8vw 2.6666666667vw 0 rgb(0 0 0 / 50%);
    border-radius: 1.3333333333vw;
}


.transfer-wrap-slider .available-wrap h4:first-child {
    border-right: 0.2666666667vw solid #c3d5e0;
}

.transfer-wrap .available-wrap h4,
.transfer-wrap-slider .available-wrap h4 {
    font-size: 4.2666666667vw;
    line-height: 5.3333333333vw;
    width: 50%;
    padding: 1.3333333333vw 3.2vw 1.3333333333vw 3.2vw;
}

.transfer-wrap .available-wrap h4 span,
.transfer-wrap-slider .available-wrap h4 span {
    display: block;
    font-size: 3.2vw;
    font-weight: normal;
}

.transfer-wrap-slider .available-wrap h4:last-child {
    text-align: right;
}

.transfer-wrap .available-wrap h4,
.transfer-wrap-slider .available-wrap h4 {
    font-size: 4.2666666667vw;
    line-height: 5.3333333333vw;
    width: 50%;
    padding: 1.3333333333vw 3.2vw 1.3333333333vw 3.2vw;
}


.transfer-wrap-slider .transfer-content {
    position: relative;
    background-color: #cde3f0;
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    height: 21.3333333333vw;
    border: 0;
}

.transfer-content {
    border-top: 0.2666666667vw solid #8fa6b5;
    border-bottom: 0.2666666667vw solid #8fa6b5;
    width: 100%;
    margin-bottom: 2.6666666667vw;
}


.transfer-wrap-slider .amount-input {
    position: absolute;
    top: -10.4vw;
    left: 50%;
    z-index: 1;
    width: -webkit-min-content;
    width: -moz-min-content;
    width: min-content;
    line-height: 5.3333333333vw;
    background: #ffffff;
    border: 0.2666666667vw solid #da8700;
    box-shadow: inset 0 0.5333333333vw 0.5333333333vw 0 rgb(0 0 0 / 27%);
    border-radius: 1.0666666667vw;
    font-size: 5.8666666667vw;
    text-indent: 0;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

.transfer-wrap-slider .amount-input.typeing:before {
    background: #fff0ca;
}

.transfer-wrap-slider .amount-input:before {
    position: absolute;
    content: "";
    left: 50%;
    bottom: -3.2vw;
    width: 2.6666666667vw;
    height: 2.6666666667vw;
    background: #ffffff;
    border-bottom: 0.2666666667vw solid #da8700;
    border-right: 0.2666666667vw solid #da8700;
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
    transform: translate(-50%, -50%) rotate(45deg);
}


.transfer-wrap-slider .amount-input input {
    line-height: 5.3333333333vw;
    border: 0;
    box-shadow: none;
    margin-bottom: 0;
    padding: 1.3333333333vw;
    color: #2963a7;
    font-weight: bold;
    border-radius: 0.8vw;
    text-align: center;
    box-shadow: inset 0 2px 2px 0 rgb(0 0 0 / 27%);
    margin-bottom: 0.2666666667vw;
}

input {
    position: relative;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: inset 0 0.5333333333vw 0 0 rgb(0 0 0 / 10%);
    border-radius: 1.6vw;
    color: #1e1e1e;
    font-size: 4vw;
    font-family: Helvetica, Tahoma, sans-serif;
    padding: 2.6666666667vw 1.8666666667vw;
    margin-bottom: 1.8666666667vw;
    /* -webkit-appearance: none; */
}

.transfer-wrap-slider .slider {
    display: -webkit-box;
    display: flex;
    width: 100%;
    height: 14.6666666667vw;
}


.transfer-wrap-slider .slider li:first-child {
    border: 0.2666666667vw solid #bbb;
    border-radius: 1.3333333333vw 0 0 1.3333333333vw;
    border-radius: 0;
}

.transfer-wrap-slider .slider li:first-child,
.transfer-wrap-slider .slider li:last-child {
    font-size: 4vw;
    line-height: 16vw;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
}

.transfer-wrap-slider .slider li {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    list-style: none;
    width: 14.6666666667vw;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(15%, #fdfdfd), to(#eee));
    background-image: -webkit-linear-gradient(top, #fdfdfd 15%, #eee 100%);
    background-image: linear-gradient(180deg, #fdfdfd 15%, #eee 100%);
}


.transfer-wrap-slider .slider li.col-slider {
    -webkit-box-flex: 1;
    flex: 1;
    border-top: 0.2666666667vw solid #bbb;
    border-bottom: 0.2666666667vw solid #bbb;
}

.transfer-wrap-slider .slider li {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    list-style: none;
    width: 14.6666666667vw;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(15%, #fdfdfd), to(#eee));
    background-image: -webkit-linear-gradient(top, #fdfdfd 15%, #eee 100%);
    background-image: linear-gradient(180deg, #fdfdfd 15%, #eee 100%);
}

.transfer-wrap-slider .col-slider {
    position: relative;
}

.transfer-wrap-slider .balance-percent {
    position: absolute;
    display: -webkit-box;
    display: flex;
    top: 0;
    width: 90%;
    -webkit-box-pack: justify;
    justify-content: space-between;
}


.transfer-wrap-slider .balance-percent div:first-child,
.transfer-wrap-slider .balance-percent div:last-child {
    background-color: rgba(199, 212, 227, 0);
}

.transfer-wrap-slider .balance-percent div {
    display: block;
    width: 0.8vw;
    height: 1.6vw;
    background-color: rgba(199, 212, 227, 0.8);
}


.transfer-wrap-slider .balance-percent div {
    display: block;
    width: 0.8vw;
    height: 1.6vw;
    background-color: rgba(199, 212, 227, 0.8);
}

.transfer-wrap-slider .balance-percent div:first-child,
.transfer-wrap-slider .balance-percent div:last-child {
    background-color: rgba(199, 212, 227, 0);
}

.transfer-wrap-slider .balance-percent div {
    display: block;
    width: 0.8vw;
    height: 1.6vw;
    background-color: rgba(199, 212, 227, 0.8);
}


.transfer-wrap-slider .slider-bar {
    position: relative;
    width: 90%;
    height: 3.2vw;
    background: #d1dde5;
    box-shadow: inset 0 0.2666666667vw 0.2666666667vw 0 rgb(0 0 0 / 30%);
    border-radius: 1.6vw;
    margin: 0;
}


.transfer-wrap-slider .slider-bar_fill {
    position: absolute;
    top: 0;
    height: 2.6666666667vw;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(15%, #ffb80c), to(#ffa00c));
    background-image: -webkit-linear-gradient(top, #ffb80c 15%, #ffa00c 100%);
    background-image: linear-gradient(180deg, #ffb80c 15%, #ffa00c 100%);
    border: 0.2666666667vw solid #cb8009;
    border-radius: 1.3333333333vw;
    background-position: inherit;
}


.transfer-wrap-slider .slider-bar_handle {
    position: absolute;
    z-index: 2;
    display: block;
    top: -2.6666666667vw;
    width: 8vw;
    height: 8vw;
    border-radius: 4.2666666667vw;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(15%, #ffb80c), to(#ffa00c));
    background-image: -webkit-linear-gradient(top, #ffb80c 15%, #ffa00c 100%);
    background-image: linear-gradient(-180deg, #3752d9 0%, #3752d9 58%);
    border: 0.2666666667vw solid #cb8009;
    box-shadow: inset 0 0.2666666667vw 0 0 rgb(255 255 255 / 50%);
}

.transfer-wrap-slider .slider li:last-child {
    border: 0.2666666667vw solid #bbb;
    border-radius: 0 1.3333333333vw 1.3333333333vw 0;
    border-radius: 0;
}

.transfer-wrap-slider .slider li:first-child,
.transfer-wrap-slider .slider li:last-child {
    font-size: 4vw;
    line-height: 16vw;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
}


.transfer-wrap .error,
.transfer-wrap-slider .error {
    text-indent: 2.6666666667vw;
    line-height: 4vw;
    color: #d0021b;
    font-size: 3.2vw;
}


.btn-list {
    padding: 0 1.6vw 2.6666666667vw;
    flex-wrap: wrap;
}

.btn-list li:nth-child(1) {
    -webkit-box-flex: 1;
    flex: 1;
}

.btn-list li {
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    margin: 1.6vw 0.8vw 0 0.8vw;
    overflow: hidden;
}

.sports-book .back-1.select {
    background-color: #16a660 !important;
}

.btn-list li a {
    height: 10.9333333333vw;
    line-height: 10.9333333333vw;
}

.btn,
.btn-send,
.login,
.form-select,
.pages a,
.wickets .btn-send,
.wickets .login,
.wicketslive .btn-send,
.wicketslive .login,
.yabo101sport .btn-send,
.yabo101sport .login,
.wicketspro .btn-send,
.wicketspro .login,
.aecricket888 .btn-send,
.aecricket888 .login {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), color-stop(89%, #eee));
    background-image: -webkit-linear-gradient(top, #fff 0%, #eee 89%);
    background-image: linear-gradient(-180deg, #fff 0%, #eee 89%);
    border: 1px solid #aaa;
    border-radius: 1.6vw;
    font-size: 4vw;
    font-weight: bold;
    line-height: 2.6;
    color: #1e1e1e;
}


.skyfair .btn-send,
.skyfair .login {
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(15%, #464646), to(#121212));
    background-image: -webkit-linear-gradient(top, #464646 15%, #121212 100%);
    background-image: linear-gradient(-180deg, #464646 15%, #121212 100%);
    border-color: #000;
    color: #ffb80c;
}

.btn-list li a {
    height: 10.9333333333vw;
    line-height: 10.9333333333vw;
}


.btn-list li:nth-child(3) {
    width: 100%;
}

.btn-list li {
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    margin: 1.6vw 0.8vw 0 0.8vw;
    overflow: hidden;
}


.betsbuzz365 .message-wrap {
    color: #1e1e1e;
}

.message-wrap.success {
    background: #6bbd11;
    border-color: #43760a;
}


.message-wrap {
    position: absolute;
    left: 0;
    display: flex;
    width: 100%;
    background-color: #f8e71c;
    border: 0.26667vw solid #9b9011;
    border-width: 0.26667vw 0 0.26667vw 0;
    box-shadow: 0 0.8vw 1.06667vw 0 rgb(0 0 0 / 50%);
    margin-top: 12vw;
    z-index: 10;
}

.message-wrap.success.to-open_bets:before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g fill="none" fill-rule="evenodd"><path fill="rgb(67,118,10)" d="M15.333 11H16v1H0v-1h.667L8 0l7.333 11zM8 2L1 12h14L8 2z"/><path fill="rgb(107,189,17)" d="M8 2l7 10H1"/></g></svg>');
}


.message-wrap.to-open_bets:before {
    position: absolute;
    content: "";
    width: 4.26667vw;
    height: 3.2vw;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g fill="none" fill-rule="evenodd"><path fill="rgb(155,144,17)" d="M15.333 11H16v1H0v-1h.667L8 0l7.333 11zM8 2L1 12h14L8 2z"/><path fill="rgb(248,234,18)" d="M8 2l7 10H1"/></g></svg>') no-repeat;
    background-size: contain;
    margin-top: -3.2vw;
    margin-left: 14.13333vw;
}

.betsbuzz365 .message-wrap a {
    background-color: transparent;
    box-shadow: none;
}

.message-wrap .close {
    border-left: 1px solid #9b9011;
    padding: 1.86667vw 2.93333vw;
}

.message-wrap a {
    height: auto;
    border-width: 0;
    border-radius: 0;
    box-shadow: none;
}

.close {
    justify-content: center;
    align-items: center;
}

#poster img {
    background-image: url(../images/sprite/cover-live.png) !important;
}

.slick-prev:before {
    background-image: url('../images/sprite/arrowleft.svg') !important;
}

.slick-prev {
    left: 10px !important;
    z-index: 8 !important;
}

.slick-prev:before,
.slick-next:before {
    color: transparent !important;
}

.slick-next:before {
    background-image: url(../images/sprite/bannerright.svg);
    background-size: 27px;
}

.slick-next {
    right: 10px !important;
    transform: rotate(181deg) !important;
}


.icon-promote {
    width: 17.8666666667vw;
    height: 16.2666666667vw;
    margin: 0 auto;
    margin-left: -1.8666666667vw;
    z-index: 99;
}

img {
    background-size: contain !important;
        filter: saturate(0.5);
}

nav .mini-lobby a {
    width: 16.8vw;
}

nav .mini-lobby .main-nav a {
    height: 16.8vw;
    padding-top: 1.3333333333vw;
    margin-top: -4.5333333333vw;
}

nav .mini-lobby .main-nav:before {
    top: -4.5333333333vw;
    width: 110%;
    height: 5.3333333333vw;
    margin-left: -0.2666666667vw;
}

nav .main-nav:before {
    content: "";
    position: absolute;
    top: -4.2666666667vw;
    width: 100%;
    height: 4.5333333333vw;
    background-image: url('data:image/svg+xml,<svg width="75" height="16" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="50%" y1="19.56%" x2="50%" y2="90.65%" id="a"><stop stop-color="%23243A48" offset="0%"/><stop stop-color="%23172732" offset="100%"/></linearGradient></defs><path d="M74.98 16H75v50H0V16h.02C.7 15.33 16.36.02 37.5.02v8-8C58.64.02 74.3 15.33 74.98 16z" fill="url(%23a)" fill-rule="evenodd"/></svg>');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
    z-index: -1;
}

header .a-open_tv.close_tv {
    background-color: #df4000;
    border-color: rgba(0, 0, 0, .6);
}

header .a-open_tv.close_tv img {
    background: url(../images/sprite/icon-TV_close.svg);
}

.match-tracker-wrap {
    background-color: #1E1E1E;
}

.ptr,
.ptr__children {
    /*display: contents;*/
    overflow: visible !important;
}
.top-header-nav{
    background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.7) 82%, #000000c9 100%);            
    overflow: hidden;
}

.top-header-nav .layer {
    /* background-image: url(../images/money-flying.png); */
    background-size: contain;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 9rem;
    z-index: -2;
    -webkit-animation: kenburns-top 5s ease-out infinite alternate both;
    animation: kenburns-top 5s ease-out infinite alternate both;
}
.top-header-nav .layer2 {
    background-color: #e8b82eba;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}

 /* @-webkit-keyframes kenburns-top {
    0% {
      -webkit-transform: scale(1) translateY(0);
              transform: scale(1) translateY(0);
      -webkit-transform-origin: 50% 16%;
              transform-origin: 50% 16%;
    }
    100% {
      -webkit-transform: scale(1.25) translateY(-15px);
              transform: scale(1.25) translateY(-15px);
      -webkit-transform-origin: top;
              transform-origin: top;
    }
  } */
  /* @keyframes kenburns-top {
    0% {
        background-size: 100%;
    }
    100% {
        background-size: 150%;
    }
  } */

  @keyframes kenburns-top {
    0% {
      -webkit-transform: scale(1) translateY(0);
              transform: scale(1) translateY(0);
      -webkit-transform-origin: 50% 16%;
              transform-origin: 50% 16%;
    }
    100% {
      -webkit-transform: scale(1.25) translateY(-15px);
              transform: scale(1.25) translateY(-15px);
      -webkit-transform-origin: top;
              transform-origin: top;
    }
  }
  

  .deposit-money-btn{
    position: fixed;
    bottom: 4rem;
    filter: drop-shadow(2px 4px 6px black);
    right: 0.5rem;
    z-index: 100;
    animation: moneyBtnAnimation 2s both infinite;
  }


  @keyframes moneyBtnAnimation {
    20% {
        transform: rotate(15deg);
    }
    40% {
        transform: rotate(-10deg);
    }
    60% {
        transform: rotate(5deg);
    }
    80% {
        transform: rotate(-5deg);
    }
    100% {
        transform: rotate(0);
    }
  }</style>`;


export const desktopStyle = `<style>.betsbuzz365 .btn-send:hover {
  background: #ffc338 url('../images/betsbuzz365/bg-send_hover-skyEX.png') repeat-x;
}

@media screen and (max-height: 700px) {

  .tc-content,
  .mob-news-popup .announce-content {

    min-height: 200px;
  }
}

.tc-content,
.tc-content_few,
.announce-content {
  overflow-y: scroll;
  height: calc(580px - 56px - 72px);
  padding: 16px 24px;
  font-size: 14px;
  line-height: 24px;
}

p {
  margin-bottom: 7px;
}

#root {
  height: 100%
}


.delete,
.close-button,
.header h1,
.maxinplay .header h1,
.betsbuzz365 .header h1,
.skyfair .header h1,
.mcwex .header h1,
.dollarexc .header h1,
.shambhu9 .header h1,
.sairamexch .header h1,
.goexch365 .header h1,
.suninplay .header h1,
.betbhai247 .header h1,
.oxyinplay .header h1,
.iceEX .header h1,
.dafabet .header h1,
.probetx .header h1,
.sevenexch .header h1,
.sharet365 .header h1,
.jua247 .header h1,
.sprintersky .header h1,
.kanhasky .header h1,
.betsky .header h1,
.baazi365 .header h1,
.lionexch .header h1,
.iceinplay .header h1,
.regalexch365 .header h1,
.khelexch .header h1,
.betsbuzz365 .header h1,
.betsbuzz365com .header h1,
.oceanexch1 .header h1,
.oceanbook1 .header h1,
.wicketslive .header h1,
.wicketspro .header h1,
.yabo101sport .header h1,
.aecricket888 .header h1,
.betbarter .header h1,
.wickets247 .header h1,
.crickex .header h1,
.hmsbet .header h1,
.cricfair .header h1,
.nova88exch .header h1,
.jeetbuzz .header h1,
.enterfair .header h1,
.srexch .header h1,
.smash .header h1,
.slipbar-content .slip_set,
.slip_refresh,
.tv_popup,
.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live,
.language,
.sports-side-menu-list .Go,
.path .path-back,
.odd-add a,
.slider-bar a,
.favor,
.mob-live-number strong,
.transfer-wrap .close,
.transfer-wrap-slider .close,
.transferId-con dd .copy-but,
.transferId-con .mainBalance dd .refresh-but,
.login-pg-go .close,
.sportsgame-list-content dd .info,
.game-head .favor,
.game-head .refresh,
.tv-control a,
.fm-bets .special_bet .btn-fancy_info,
.bets-HS .special_bet .btn-fancy_info,
.bets-GH .special_bet .btn-fancy_info,
.add-favourite,
.delete-pin,
.multi_refresh,
.btn-fancybet_rules,
.btn-sportsbook_rules,
.download-list dd a,
.special_bets-tab .more_drop>a,
.close_pop,
.live_events .live_icon span {
  font-size: 0;
  text-indent: -99999px
}

.game-fancy:after {
  background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.44 21.32l1.792-8.456h5.628l.504-2.408h-5.628l1.288-6.02h7.252L20.78 2H10.112c-.896 0-1.68.275-2.352.826-.672.55-1.11 1.283-1.316 2.198L3 21.32h6.44z" fill="%23C5F6EE" fill-rule="nonzero"/></svg>');
  margin-top: 2.4px;
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after {
  content: "";
  background-size: cover;
  width: 12px;
  height: 12px;
}

.tc-content h1 {
  margin: 40px 0 24px 0;
  font-size: 22px;
  color: #000;
  text-decoration: underline;
}

.tc-content h2 {
  margin: 16px 0;
  padding: 0;
  font-size: 20px;
  color: #1B2D38;
  border-bottom: 1px dotted #ccc;
  padding-bottom: 8px;
}

.tc-content h3 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 18px;
  color: rgba(30, 30, 30, 0.9);
}

.announce-footer {
  max-height: 73px;
  padding: 12px 0;
  background: #ffffff;
  border-top: 1px solid #E0E6E6;
  font-size: 16px;
  border-radius: 0 0 8px 8px;
}

.align-C,
.loading li,
.btn,
.btn-send,
.marquee-pop .pages a,
.maintain-content,
.change_pass,
.browser-footer-content,
.mob-inform-link,
.support-wrap,
.announce-footer,
.urgent-notice .announce-header h1,
.announce-content table,
.article-date,
.mob-news-popup .announce-header,
.apk-img,
.marquee-pop .nofound .nofound_box dd {
  text-align: center;
}

.tc-content ul,
.tc-content ol {
  margin-left: 32px;
  margin-bottom: 16px;
}

@media screen and (max-height: 700px) {
  .mob-announce-content {
    top: 24px;
    height: calc(100% - 24px - 24px);
    min-height: 298px;
  }
}

.mob-announce-content {
  position: relative;
  top: 12%;
  width: 720px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}


.betsbuzz365 .announce-header {
  background-image: linear-gradient(-180deg, #7730cf 0%, #b556fa 58%);
}

.announce-header {
  height: 56px;
  padding-left: 24px;
  border-bottom: 1px solid #E0E6E6;
}

.betsbuzz365 .announce-header h1 {
  color: #fff;
}

.announce-header h1 {
  color: #000000;
  font-size: 20px;
  line-height: 56px;
}


.betsbuzz365 .announce-header h1:before {
  background: #fff;
}

.announce-header h1:before {
  position: relative;
  top: 4px;
  width: 6px;
  height: 24px;
  margin-right: 8px;
  content: "";
  background: #000;
  border-radius: 100px;
}

.displayIB,
.mob-inform-link li,
.announce-header h1:before,
.announce-footer li {
  display: inline-block;
}

.tc-content_few {
  height: auto;
}

.tc-content,
.tc-content_few,
.announce-content {
  overflow-y: scroll;

  padding: 16px 24px;
  font-size: 14px;
  line-height: 24px;
}

p {
  margin-bottom: 7px;
}

.age_box li .secondary,
.age_box li .btn-send {
  justify-content: center;
  align-items: center;
}

.displayF,
.age_box li .secondary,
.age_box li .btn-send,
.power-content,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages,
.agexch247 .maintain-footer {
  display: flex;
}

.announce-footer a {
  width: 240px;
  height: 40px;
  margin: 0 16px 0 0;
  color: #1E1E1E;
  font-size: 16px;
  line-height: 40px;
}

.secondary {
  background-image: linear-gradient(180deg, #D6D6D6 0%, #B2B2B2 89%);
  border: 1px solid #969696;
}

.announce-footer .confirm-checkbox {
  margin-bottom: 12px;
}

.displayB,
.delete,
.btn,
.btn-send,
.marquee-pop .pages a,
.marquee-pop .input-list,
.marquee-pop .input-list li,
.age_box li .secondary:before,
.age_box li .btn-send:before,
.power-content h3 img,
.power-content-w img,
.power-content-b img,
.announce-footer .confirm-checkbox,
body.baji:before {
  display: block;
}

.displayIB,
.mob-inform-link li,
.announce-header h1:before,
.announce-footer li {
  display: inline-block;
}


.age_box li .btn-send:before {
  width: 25px;
  height: 25px;
  background: rgba(255, 255, 255, 0.7) url('data:image/svg+xml,<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h25v25H0z"/><path fill="rgb(0, 129, 43)" d="M9.375 16.844L5.031 12.5l-1.479 1.469 5.823 5.823 12.5-12.5-1.469-1.47z"/></g></svg>') center no-repeat;
  margin-right: 8px;
  border-radius: 13px;
}

.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.displayB,
.delete,
.btn,
.btn-send,
.marquee-pop .pages a,
.marquee-pop .input-list,
.marquee-pop .input-list li,
.age_box li .secondary:before,
.age_box li .btn-send:before,
.power-content h3 img,
.power-content-w img,
.power-content-b img,
.announce-footer .confirm-checkbox {
  display: block;
}

.age_box li .secondary,
.age_box li .btn-send {
  justify-content: center;
  align-items: center;
}

.displayF,
.age_box li .secondary,
.age_box li .btn-send,
.power-content,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages,
.agexch247 .maintain-footer {
  display: flex;
}

.age_box li .secondary:before {
  width: 25px;
  height: 25px;
  background: rgba(255, 255, 255, 0.7) url('data:image/svg+xml,<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h25v25H0z"/><path fill="rgb(230,0,0)" d="M19.792 6.677l-1.47-1.469-5.822 5.823-5.823-5.823-1.469 1.47 5.823 5.822-5.823 5.823 1.47 1.469 5.822-5.823 5.823 5.823 1.469-1.47-5.823-5.822z"/></g></svg>') center no-repeat;
  margin-right: 8px;
  border-radius: 13px;
}

.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.displayB,
.delete,
.btn,
.btn-send,
.marquee-pop .pages a,
.marquee-pop .input-list,
.marquee-pop .input-list li,
.age_box li .secondary:before,
.age_box li .btn-send:before,
.power-content h3 img,
.power-content-w img,
.power-content-b img,
.announce-footer .confirm-checkbox {
  display: block;
}

.displayIB,
.mob-inform-link li,
.announce-header h1:before,
.announce-footer li {
  display: inline-block;
}

.age_box li .secondary,
.age_box li .btn-send {
  justify-content: center;
  align-items: center;
}

.displayF,
.age_box li .secondary,
.age_box li .btn-send,
.power-content,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages,
.agexch247 .maintain-footer {
  display: flex;
}

.betsbuzz365 .btn-send {

  background-image: linear-gradient(180deg, #474747 0%, #070707 100%);
  color: #fff !important;
  border-color: #222;
}

.announce-footer a {
  width: 240px;
  height: 40px;
  margin: 0 16px 0 0;
  color: #1E1E1E;
  font-size: 16px;
  line-height: 40px;
}

.btn-send {
  background: #000 url('../images/sprite/bg-send.gif') repeat-x;
  border-color: #CB8009;
}

.btn,
.btn-send,
.marquee-pop .pages a {

  border: 1px solid #bbb;
  border-radius: 4px;
  color: #1E1E1E;
  font-weight: bold;
  line-height: 23px;
  font-size: 12px;
  margin: 0 5px 10px 0;
}


.announce-footer {
  max-height: 73px;
  padding: 12px 0;
  background: #ffffff;
  border-top: 1px solid #E0E6E6;
  font-size: 16px;
  border-radius: 0 0 8px 8px;
}

.align-C,
.loading li,
.btn,
.btn-send,
.marquee-pop .pages a,
.maintain-content,
.change_pass,
.browser-footer-content,
.mob-inform-link,
.support-wrap,
.announce-footer,
.urgent-notice .announce-header h1,
.announce-content table,
.article-date,
.mob-news-popup .announce-header,
.apk-img,
.marquee-pop .nofound .nofound_box dd {
  text-align: center;
}

/* firsttimeLogin*/

.disable .sport-odds a:before,
.disable .last-col a:before,
.disable .col-draw a:before,
.disable.sport-odds a:before,
.disable.last-col a:before,
.disable.col-draw a:before {
  content: '';
  position: absolute;
  top: 0;
  background: rgba(189, 184, 184, 0) url(../images/sprite/bg-disabled.png);
  width: 100%;
  height: 100%;
}

.disabled td a {
  cursor: not-allowed;
  background: rgba(51, 51, 51, 0.2) url('../images/sprite/bg-disabled.png')
}

.disabled .back-all img,
.disabled .back-all:hover img {
  background: url('../images/sprite/bg-backall-disabled.png');
}

.disabled .lay-all img,
.disabled .lay-all:hover img {
  background: url('../images/sprite/bg-layall-disabled.png');
}



.rowdisabled td a {
  cursor: not-allowed;
  background: rgba(51, 51, 51, 0.2) url('../images/sprite/bg-backall-disabled.png')
}

.fm-bets .back-all,
.disabled .back-all {
  background-image: url('../images/sprite/main-s1aea395e8c.png');
  background-repeat: no-repeat;
}








.back-button.spark,
.spark.lay-button,
.fm-bets .back-1.spark a,
.bets-HS .back-1.spark a,
.bets-GH .back-1.spark a,
.back-gradient dd.spark a,
.lay-gradient dd.spark a {
  animation: sparkBack 0.5s ease;
}

.fm-bets .back-3.spark a,
.bets-HS .back-3.spark a,
.bets-GH .back-3.spark a {
  animation: sparkBack_2 0.5s ease;
}

.lay-button.spark,
.fm-bets .lay-1.spark a,
.bets-HS .lay-1.spark a,
.bets-GH .lay-1.spark a {
  animation: sparkLay .5s ease;
}


.fm-bets .lay-2.spark a,
.bets-HS .lay-2.spark a,
.bets-GH .lay-2.spark a {
  animation: sparkBack .5s ease;
}

.top-sprite,
.login-clientform li.user,
.login-clientform .btn-login img,
.account-wrap .head-refresh a,
.account-wrap .account,
.account-wrap .account.select,
.account-wrap ul .logout img,
.language,
.navbar-content a.menu-drop,
.live-menu img,
.setting img,

.one_click.select img,
.col-edit img,
ð .main-input-search,
.search-clear,




.betsbuzz365 .login-clientform li.user,
.betsbuzz365 .account-wrap .head-refresh a,
.betsbuzz365 .account-wrap .account,
.betsbuzz365 .setting img,

.betsbuzz365 .one_click.select img {
  background-image: url('../images/sprite/top-s027a1c2cc6.png');
  background-repeat: no-repeat
}

.top-sprite,
.login-clientform li.user,
.account-wrap .account,
.account-wrap .account.select,
.language,
.menu .casino:after,
.setting-tab .casino:after,
.menu .bet-game:after,
.setting-tab .bet-game:after,
.menu .tag-new:before,
.setting-tab .tag-new:before,
.live-menu img,
.one_click img,
.one_click.select img,
.col-edit img {
  background-image: url('../images/sprite/top-s5f29df32a5.png');
  background-repeat: no-repeat;
}

.left-sprite,
.slipbar-content .to-expand,
.matched-wrap .to-expand,
.live-wrap .to-expand,
.tv-wrap .to-expand,
.game-wrap .to-expand,
.highlight-edge-content .to-expand,
.game-wrap-horse .to-expand,
.favor-wrap .to-expand,
.sub_path .to-expand,
.close.slipbar-content .to-expand,
.close.matched-wrap .to-expand,
.close.live-wrap .to-expand,
.close.tv-wrap .to-expand,
.close.game-wrap .to-expand,
.close.highlight-edge-content .to-expand,
.close.game-wrap-horse .to-expand,
.close.favor-wrap .to-expand,
.close.sub_path .to-expand,
.sports-side-menu-list .Go,
.star,
.favor-wrap h3 .star,
.favor-wrap .sports-side-menu-list a.btn-star,
.favor-set,
.path li,
.path .path-back,
.path .path-back.select,
.sports-path-popup a,
.to-go,


.betsbuzz365 .sports-side-menu-list .Go,
.betsbuzz365 .path .path-back,
.betsbuzz365 .path .path-back.select,

.skyinplay .sports-side-menu-list .Go,
.skyinplay .path .path-back,
.skyinplay .path .path-back.select,
.lucky7 .sports-side-menu-list .Go,
.lucky7 .path .path-back,
.lucky7 .path .path-back.select {
  background-image: url('../images/sprite/left-s71761d14ca.webp');
  background-repeat: no-repeat
}

.right-sprite,
.loading img,
.delete,
.slipbar-content .to-expand,
.matched-wrap .to-expand,
.live-wrap .to-expand,
.tv-wrap .to-expand,
.close.slipbar-content .to-expand,
.close.matched-wrap .to-expand,
.close.live-wrap .to-expand,
.close.tv-wrap .to-expand,
.slip_set-pop .slip_set,
.oneclick_set-pop .slip_set,
.slipbar-content .slip_set,
.odd-add .up,
.odd-add .down,
.odd-add.disable .up,
.odd-add.disable .down,
.slip_refresh,
.live:before,
.tv_popup,
.icon-TV,
.multi_refresh,

.o_dafabet .slipbar-content .to-expand,
.o_dafabet .slipbar-content.close .to-expand,
.o_dafabet .matched-wrap .to-expand,
.o_dafabet .matched-wrap.close .to-expand,
.o_dafabet .slip_refresh {
  background-image: url('../images/sprite/right-s96d53b4782.webp');
  background-repeat: no-repeat
}

.main-sprite,
.close-button,
.icon-time,
.icon-live,
.icon-irun,
.icon-predict,
.icon-cashout,
.inplay-icon,
.icon-no_play,
.icon-cricket,
.icon-type_soccer,
.icon-tennis,
.icon-basketball,
.icon-dog,
.icon-HR,
.icon-racing,
.game-wrap .to-expand,
.highlight-edge-content .to-expand,
.game-wrap-horse .to-expand,
.close.game-wrap .to-expand,
.close.highlight-edge-content .to-expand,
.close.game-wrap-horse .to-expand,

.favor,
.favor.select,
.marquee-wrap:before,
.upcome-head dt,
.tab-highlight a,
.tab-markets a,
.tab-highlight a.select,
.tab-markets a.select,
.login-pg-go .close,
.support-mail img,
.support-app img,
.support-telegram img,
.live-list a:after,
.icon-TV_head,
.sportsgame-list-content:hover .to-win,
.sportsgame-list-content:hover .to-lose,
.sportsgame-list-content dd .info,
.sportsgame-list-content .sport-odds,
.sportsgame-list-content .last-col,
.sportsgame-list-content .col-draw,
.game-head .favor,
.game-head .favor.select,
.game-head .refresh,
.game-team .game-visit span,
.game-scores .game-visit span,
.game-team .game-home span,
.game-scores .game-home span,
.game-scores ul .scores-box,
.its_turn,
.icon-card-yellow,
.icon-card-red,
.icon-soccer,
.score-pop:before,
.score-pop-last:before,
.scores-event img,
.scores-line img,
.tab-HS .more_drop,
.tab-HS .more_drop.select,
.for-agent .fancy-head h4:after,
.for-agent .fancy-head .tc-content h5:after,
.tc-content .for-agent .fancy-head h5:after,
.fm-bets tr:hover .to-win,
.bets-HS tr:hover .to-win,
.bets-GH tr:hover .to-win,
.fm-bets tr:hover .to-lose,
.bets-HS tr:hover .to-lose,
.bets-GH tr:hover .to-lose,
.fm-bets .back-all,
.bets-HS .back-all,
.bets-GH .back-all,
.fm-bets .lay-all,
.bets-HS .lay-all,
.bets-GH .lay-all,
.bets.disable .back-all,
.disable.bets-HS .back-all,
.disable.bets-GH .back-all,
.bets.disable .lay-all,
.disable.bets-HS .lay-all,
.disable.bets-GH .lay-all,
.uniform,
.to-win,
.to-lose,
.more,
.line_markets-team .game-visit span,
.line_markets-team .game-home span,
.line_markets-team .game-vs div:before,
.line_markets-team .game-vs div:after,
.btn-rules img,
.line_market-name,
.add-favourite,
.delete-pin,
.info-icon .add-favourite,
.info-icon .delete-pin,
h3 .add-favourite,
h3 .delete-pin,
h4 .add-favourite,
.tc-content h5 .add-favourite,
h4 .delete-pin,
.tc-content h5 .delete-pin,
.arrow-dialog,
.one_click-setting .a-edit img,
.one_click-stake,
.quick_bet-wrap .odd-add .up,
.quick_bet-wrap .odd-add .down,
.quick_bet-wrap .odd-add.disable .up,
.quick_bet-wrap .odd-add.disable .down,
.edit img,
.game-fancy .info-inplay,
.game-fancy.in-play:before,
.fancy-head .in-play span:before,
.btn-fancybet_rules,
.sportsbook-head h4:after,
.sportsbook-head .tc-content h5:after,
.tc-content .sportsbook-head h5:after,



.betsbuzz365 .login-pg-go .close,
.betsbuzz365 .one_click-setting .a-edit img,
.betsbuzz365 .one_click-stake,

.skyinplay .one_click-setting .a-edit img,
.skyinplay .one_click-stake {
  background-image: url('../images/sprite/main-se21de741bc.png');
  background-repeat: no-repeat
}

.report-sprite,
.cal-input,
.upcome dd,
.game-scores .scores-time li,
.filter-list .filter-content span,
.filter-list.golf-list .compt img,
.filter-list.golf-list .compt:hover img,
.expand-close,
.expand-open,
.align-L .expand-close,
.table01 caption .expand-close,
.table-s caption .expand-close,
.slip-back .refer .expand-close,
.slip-lay .refer .expand-close,
.slip-back .keep-option .expand-close,
.slip-lay .keep-option .expand-close,
.sports-header .col-bet .expand-close,
.matched-head .col-bet .expand-close,
.tips-popup .expand-close,
.full-amount .expand-close,
.no-data .expand-close,
.event-left .col-game .expand-close,
.event-right .col-game .expand-close,
.event-left .sportsgame-list-content dt .expand-close,
.sportsgame-list-content .event-left dt .expand-close,
.event-right .sportsgame-list-content dt .expand-close,
.sportsgame-list-content .event-right dt .expand-close,
.fm-bets th .expand-close,
.bets-HS th .expand-close,
.bets-GH th .expand-close,
.fm-bets .refer-bet .expand-close,
.bets-HS .refer-bet .expand-close,
.bets-GH .refer-bet .expand-close,
.fm-bets .refer-book .expand-close,
.bets-HS .refer-book .expand-close,
.bets-GH .refer-book .expand-close,
.align-L .expand-open,
.table01 caption .expand-open,
.table-s caption .expand-open,
.slip-back .refer .expand-open,
.slip-lay .refer .expand-open,
.slip-back .keep-option .expand-open,
.slip-lay .keep-option .expand-open,
.sports-header .col-bet .expand-open,
.matched-head .col-bet .expand-open,
.tips-popup .expand-open,
.full-amount .expand-open,
.no-data .expand-open,
.event-left .col-game .expand-open,
.event-right .col-game .expand-open,
.event-left .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-left dt .expand-open,
.event-right .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-right dt .expand-open,
.fm-bets th .expand-open,
.bets-HS th .expand-open,
.bets-GH th .expand-open,
.fm-bets .refer-bet .expand-open,
.bets-HS .refer-bet .expand-open,
.bets-GH .refer-bet .expand-open,
.fm-bets .refer-book .expand-open,
.bets-HS .refer-book .expand-open,
.bets-GH .refer-book .expand-open,
.expand-arrow,
.expand-arrow-R,
.acc-info .user,
.acc-info .time,
.fromto,
.prevMonth,
.nextMonth,
.selection {
  background-image: url('../images/sprite/report-s44f5ff12b4.webp');
  background-repeat: no-repeat
}

.bg-sprite,
.slipbar-content h3,
.matched-wrap h3,
.live-wrap h3,
.tv-wrap h3,
.game-wrap h3,
.highlight-edge-content h3,
.game-wrap-horse h3,
.favor-wrap h3,
.sub_path h3,
.one_click,
.one_click.select,
.path,
.slider-bar,
.slider-bar span,
.upcome-head,
.tab-highlight,
.tab-markets,
.live-head h3,
.live-channel,
.game-wrap-horse dt .game-list-place,
.progress-bar,
.progress-now,
.scores-event,
.scores-line,
.tab-HS,
.fm-bets .back-all img,
.bets-HS .back-all img,
.bets-GH .back-all img,
.fm-bets .back-all:hover img,
.bets-HS .back-all:hover img,
.bets-GH .back-all:hover img,
.fm-bets .lay-all img,
.bets-HS .lay-all img,
.bets-GH .lay-all img,
.fm-bets .lay-all:hover img,
.bets-HS .lay-all:hover img,
.bets-GH .lay-all:hover img,
.bets.disable .back-all img,
.disable.bets-HS .back-all img,
.disable.bets-GH .back-all img,
.bets.disable .lay-all img,
.disable.bets-HS .lay-all img,
.disable.bets-GH .lay-all img,
.line_markets-team,
.line_markets-team .game-vs div,
.line_market-name span,
.one_click-setting,
.fancy-head h4 span,
.fancy-head .tc-content h5 span,
.tc-content .fancy-head h5 span,
.sportsbook-head h4 span,
.sportsbook-head .tc-content h5 span,
.tc-content .sportsbook-head h5 span,



.betsbuzz365 .navbar-content,
.betsbuzz365 .menu .select,
.betsbuzz365 .setting-tab .select,
.betsbuzz365 .one_click,
.betsbuzz365 .one_click.select,
.betsbuzz365 .one_click-setting,

.skyinplay .navbar-content,
.skyinplay .menu .select,
.skyinplay .setting-tab .select,
.skyinplay .one_click,
.skyinplay .one_click.select,
.skyinplay .path,
.skyinplay .tab-highlight,
.skyinplay .tab-markets,
.skyinplay .one_click-setting {
  background-image: url('../images/sprite/bg-sdfd3971a83.webp');
  background-repeat: no-repeat
}

.login-sprite,
.power-content h3 img,
.power-content-b img,
.icon-login,
.browser-footer-content img,



.betsbuzz365 .icon-login,
.betsbuzz365 .menu .logout img,
.betsbuzz365 .setting-tab .logout img,

.skyinplay .icon-login,
.skyinplay .menu .logout img,
.skyinplay .setting-tab .logout img,



.fairenter .icon-login,
.lucky7 .icon-login,
.lucky7 .menu .logout img,
.lucky7 .setting-tab .logout img {
  background-image: url('../images/sprite/login-s43e1ddf31a.png');
  background-repeat: no-repeat
}

.agent-sprite,
.agent .marquee-wrap:before,
.report .marquee-wrap:before,
.close_pop,
.go-back img,
.pop-close img {
  background-image: url('../images/sprite/agent-sf42eb279ae.webp');
  background-repeat: no-repeat
}

* {
  margin: 0;
  padding: 0
}

html,
body {
  height: 100%;
  font-family: Tahoma, Helvetica, sans-serif;
  color: #1e1e1e;
  font-size: 12px;
  line-height: 15px;
  background-color: #eee
}

a {
  text-decoration: none;
  color: #000;
  outline: 0;
}

a:hover {
  text-decoration: underline;
  cursor: pointer
}

table {
  border-collapse: collapse
}

input,
textarea {
  font-family: Tahoma, Helvetica, sans-serif;
  color: #1e1e1e;
  font-size: 12px;
  border: 0 #aaa solid;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(0, 0, 0, .5);
  border-radius: 4px;
  padding: 5px;
  margin: 0 5px 5px 0;
  box-sizing: border-box
}

input:focus,
textarea:focus {
  padding: 4px
}

input.disable,
textarea.disable {
  background-color: #dcdcdc;
  color: #666;
  box-shadow: none;
  border: 1px solid #bbb
}

label {
  cursor: pointer
}

select {
  width: 120px;
  height: 25px;
  line-height: 25px;
  cursor: pointer;
  margin: 0 5px 5px 0
}

option {
  padding: 3px
}

h2 {
  font-size: 13px;
  line-height: 20px;
  padding-top: 6px;
  margin-bottom: 6px
}

a img {
  border: 0 solid #fff
}

p {
  margin-bottom: 7px
}

.clearfix:after,
.lit-content-center:after,
.pop-warp:after,
.log-wrap:after,
.streaming-pop:after,
.centar-content:after,
.slip-back .col-stake_list ul:after,
.slip-lay .col-stake_list ul:after,
.login-clientform:after,
.account-wrap:after,
.menu:after,
.setting-tab:after,
.sports-header:after,
.matched-head:after,
.stake-popup:after,
.btn-wrap:after,
.slip-option:after,
.cashout-wrap:after,
.slider:after,
.tab-highlight:after,
.tab-markets:after,
.game-wrap-horse .hs-time:after,
.game-scores .scores-time:after,
.game-scores ul:after,
.tab-HS:after,
.game-info:after,
.tab:after,
.input-list:after,
.filter-list:after,
.filter-pop ul:after,
.acc-info:after,
.total-show:after,
.change_pass:after,
.game-wrap:after,
.highlight-edge-content:after,
.game-wrap-horse:after,
.slip-back:after,
.slip-lay:after,
.power-content:after,
.navbar-content:after,
.stake-set:after,
.odds-set:after,
.slip-list:after,
.full_btn:after,
.sum:after,
.upcome:after,
.sportsgame-list-content:after,
.sportsgame-list-content dd:after,
.game-head:after,
.head-bets-agent:after,
.line_market-name:after,
.one_click-setting:after,
.quick_bet-wrap:after,
.quick_bet-wrap .col-stake_list:after,
.game-fancy.in-play:after,
.fancy-head:after,
.fancy-head h4:after,
.fancy-head .tc-content h5:after,
.tc-content .fancy-head h5:after,
.sportsbook-head:after,
.sportsbook-head h4:after,
.sportsbook-head .tc-content h5:after,
.tc-content .sportsbook-head h5:after,
.form_list dd:after,
.white-wrap:after,
.pop-left dl:after,
.pop-left dd:after,
.initial-balance:after,
.final-balance:after {
  content: "";
  display: block;
  clear: both
}

.clearfix,
.lit-content-center,
.pop-warp,
.log-wrap,
.streaming-pop,
.centar-content,
.slip-back .col-stake_list ul,
.slip-lay .col-stake_list ul,
.login-clientform,
.account-wrap,
.menu,
.setting-tab,
.sports-header,
.matched-head,
.stake-popup,
.btn-wrap,
.slip-option,
.cashout-wrap,
.slider,
.tab-highlight,
.tab-markets,
.game-wrap-horse .hs-time,
.game-scores .scores-time,
.game-scores ul,
.tab-HS,
.game-info,
.tab,
.input-list,
.filter-list,
.filter-pop ul,
.acc-info,
.total-show,
.change_pass,
.game-wrap,
.highlight-edge-content,
.game-wrap-horse,
.slip-back,
.slip-lay,
.power-content,
.navbar-content,
.stake-set,
.odds-set,
.slip-list,
.full_btn,
.sum,
.upcome,
.sportsgame-list-content,
.sportsgame-list-content dd,
.game-head,
.head-bets-agent,
.line_market-name,
.one_click-setting,
.quick_bet-wrap,
.quick_bet-wrap .col-stake_list,
.game-fancy.in-play,
.fancy-head,
.fancy-head h4,
.fancy-head .tc-content h5,
.tc-content .fancy-head h5,
.sportsbook-head,
.sportsbook-head h4,
.sportsbook-head .tc-content h5,
.tc-content .sportsbook-head h5,
.form_list dd,
.white-wrap,
.pop-left dl,
.pop-left dd,
.initial-balance,
.final-balance {
  zoom: 1
}

.clear,
.set-content,
.btn-wrap {
  clear: both
}

.float-L,
.delete,
.login-box-content,
.change_pass .login-box-content,
.change_pass .note,
.slipbar-content .slip_set,
.slip_refresh,
.tv_popup,
.slip-back dt,
.slip-lay dt,
.slip-back dt .slip-type,
.slip-lay dt .slip-type,
.slip-back dd,
.slip-lay dd,
.power-content h3,
.login-clientform .btn-login,
.betsbuzz365 .login-clientform .btn-signup,
.kv,
.header h1,
.login-clientform input,
.login-clientform textarea,
.menu,
.setting-tab,
.stake-set dd,
.odds-set dd,
.sum dt,
.sum dd,
.slider,
.favor,
.event-left,
.event-right,
.event-left .sports-header span,
.event-right .sports-header span,
.event-left .matched-head span,
.event-right .matched-head span,
.support-wrap dt,
.live-left,
.live-right,
.live-channel span,
.sportsgame-list-content dt,
.sportsgame-list-content dd,
.sportsgame-list-content dd a,
.scores-event,
.scores-line,
.game-info,
.head-bets-agent .game-low_liq,
.head-bets-agent .game-fancy,
.head-bets-agent .game-sportsbook,
.fm-bets .fm-bet-zone a,
.bets-HS .fm-bet-zone a,
.bets-GH .fm-bet-zone a,
.horse-box,
.uniform,
.horse_info-hover dt,
.horse_info-hover dd,
.line_market-name span,
h3 .add-favourite,
h3 .delete-pin,
h4 .add-favourite,
.tc-content h5 .add-favourite,
h4 .delete-pin,
.tc-content h5 .delete-pin,
.one_click-setting h4,
.one_click-setting .tc-content h5,
.tc-content .one_click-setting h5,
.quick_bet-wrap dt,
.quick_bet-wrap dd,
.game-fancy .info-inplay,
.game-fancy.in-play:before,
.fancy-head h4,
.fancy-head .tc-content h5,
.tc-content .fancy-head h5,
.fancy-head .in-play span:before,
.sportsbook-head h4,
.sportsbook-head .tc-content h5,
.tc-content .sportsbook-head h5,
.profile-wrap dt,
.form_list dt,
.filter-pop .btn-wrap .btn,
.filter-pop .btn-wrap .btn-send,
.filter-pop .btn-wrap .pages a,
.pages .filter-pop .btn-wrap a,
.filter-pop .btn-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .filter-pop .btn-wrap input,
.filter-pop .btn-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .filter-pop .btn-wrap textarea,
.market-float,
.sum-pl dt,
.head-balance,
.pop-left,
.pop-left dt,
.select-betting .selection,
.pop-right,
.initial-balance dt,
.final-balance dt,
.initial-balance dd,
.final-balance dd,
.initial-balance dt span,
.final-balance dt span,
.searchbar-header {
  float: left
}

.float-R,
.close-button,
.login-clientform,
.account-wrap,
.language,
.setting-tab,
.time_zone,
.gmt,
.sports-side-menu-list .Go,
.favor-set,
.sum,
.btn-wrap .btn-send,
.btn-wrap .edit-function .btn,
.btn-wrap .edit-function .btn-send,
.btn-wrap .edit-function .pages a,
.pages .btn-wrap .edit-function a,
.btn-wrap .edit-function .calendarTable_inputBox input,
.calendarTable_inputBox .btn-wrap .edit-function input,
.btn-wrap .edit-function .calendarTable_inputBox textarea,
.calendarTable_inputBox .btn-wrap .edit-function textarea,
.cashout-wrap dl,
.event-right,
.live-head h3 span,
.game-head .game-low_liq,
.game-head .game-fancy,
.game-head .game-sportsbook,
.game-matched,
.head-bets-agent .game-info,
.more,
.multi_refresh,
.one_click-setting .a-edit,
.one_click-setting .btn-send,
.quick_bet-wrap .col-stake_list ul,
.game-fancy,
.fancy_bet .td-fancy_merge .btn-book,
.sportsbook_bet .td-fancy_merge .btn-book,
.fancy-info,
.game-sportsbook,
.sportsbook-head h4:after,
.sportsbook-head .tc-content h5:after,
.tc-content .sportsbook-head h5:after,
.total-show .sports-switch {
  float: right
}

.align-L,
.table01 caption,
.table-s caption,
.slip-back .refer,
.slip-lay .refer,
.slip-back .keep-option,
.slip-lay .keep-option,
.sports-header .col-bet,
.matched-head .col-bet,
.tips-popup,
.full-amount,
.no-data,
.event-left .col-game,
.event-right .col-game,
.event-left .sportsgame-list-content dt,
.sportsgame-list-content .event-left dt,
.event-right .sportsgame-list-content dt,
.sportsgame-list-content .event-right dt,
.fm-bets th,
.bets-HS th,
.bets-GH th,
.fm-bets .refer-bet,
.bets-HS .refer-bet,
.bets-GH .refer-bet,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book {
  text-align: left
}

.align-R,
.table01,
.table-s,
.slip-back input,
.slip-lay input,
.slip-back textarea,
.slip-lay textarea,
.slip-back .col-profit,
.slip-lay .col-profit,
.slip-back .inn_runs dd,
.slip-lay .inn_runs dd,
.time_zone,
.path ul,
.sports-header .col-profit,
.matched-head .col-profit,
.cashout-wrap dl,
.game-team .game-visit,
.game-scores .game-visit,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book,
.quick-bet-confirm li {
  text-align: right
}

.align-C,
.loading li,
.btn,
.btn-send,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea,
.change_pass,
.slip-back dd,
.slip-lay dd,
.btn-live,
.btn-book,
.fancy-suspend span,
.fancy-suspend-white span,
.browser-footer-content,
.saddle_1,
.saddle_1A,
.saddle_1B,
.saddle_1C,
.saddle_1D,
.saddle_1X,
.saddle_1Y,
.saddle_2,
.saddle_2B,
.saddle_2C,
.saddle_2X,
.saddle_3,
.saddle_3C,
.saddle_3D,
.saddle_3E,
.saddle_3X,
.saddle_4,
.saddle_4D,
.saddle_4X,
.saddle_5,
.saddle_6,
.saddle_7,
.saddle_8,
.saddle_9,
.saddle_10,
.saddle_11,
.saddle_11F,
.saddle_12,
.saddle_12F,
.saddle_13,
.saddle_13F,
.saddle_14,
.saddle_14F,
.saddle_15,
.saddle_15F,
.saddle_16,
.saddle_16F,
.saddle_17,
.saddle_17F,
.saddle_18,
.saddle_18F,
.saddle_19,
.saddle_19F,
.saddle_20,
.saddle_20F,
.saddle_21,
.saddle_21F,
.saddle_22,
.saddle_22F,
.saddle_23,
.saddle_23F,
.saddle_24,
.saddle_24F,
.saddle_25,
.saddle_25F,
.saddle_26,
.saddle_26F,
.saddle_27,
.saddle_27F,
.saddle_28,
.saddle_28F,
.saddle_29,
.saddle_29F,
.saddle_30,
.saddle_30F,
.login-clientform .btn-login,
.betsbuzz365 .login-clientform .btn-signup,
.account-wrap ul .logout a,
.stake-set .stake_edit-input,
.odds-set .stake_edit-input,
.col-edit a,
.slipbar-content p,
.sports-header li,
.matched-head li,
.stake-popup a,
.load-pending,
.tab-highlight li,
.tab-markets li,
.message-content p,
.dialog-wrap h4,
.dialog-wrap-w h4,
.dialog-wrap .tc-content h5,
.tc-content .dialog-wrap h5,
.dialog-wrap-w .tc-content h5,
.tc-content .dialog-wrap-w h5,
.dialog-wrap .break li,
.dialog-wrap-w .break li,
.support-wrap,
.sportsgame-list-content dd a,
.game-team .game-vs,
.game-scores .game-vs,
.game-scores ul .scores-box,
.tennis .scores-box,
.sum-status,
.tab-HS a,
.fm-bets td,
.bets-HS td,
.bets-GH td,
.horse-box li,
.suspend,
.btn-rules,
.rules-wrap h3,
.closed-next,
.one_click-setting a,
.one_click-stake,
.one_click-stake input,
.one_click-stake textarea,
.quick_bet-progress .progress-bar-txt,
.quick_bet-message dd,
.fancy-info dt span,
.confirm_box .white-wrap,
.go-back,
.pop-close,
.tab a,
.pages,
.chart-wrap,
.initial-balance dt span,
.final-balance dt span,
.announce-footer,
.announce-content table,
.article-date,
.mob-news-popup h2 {
  text-align: center
}

.displayB,
.delete,
.btn,
.btn-send,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea,
.slipbar-content h3 a,
.matched-wrap h3 a,
.live-wrap h3 a,
.tv-wrap h3 a,
.game-wrap h3 a,
.highlight-edge-content h3 a,
.game-wrap-horse h3 a,
.favor-wrap h3 a,
.sub_path h3 a,
.slip-back dt:hover .full-amount,
.slip-lay dt:hover .full-amount,
.slip-back dd:hover .full-amount,
.slip-lay dd:hover .full-amount,
.btn-live,
.btn-book,
.account-wrap ul a,
.more_drop-list a,
.selection-list a,
.fancy-suspend span,
.fancy-suspend-white span,
.power-content h3 img,
.power-content-b img,
.login-clientform .btn-login,
.betsbuzz365 .login-clientform .btn-signup,
.header a,
.account-wrap li .refresh-bar,
.account-wrap a,
.language,
.flag,
.navbar-content a,
.menu li:hover ul,
.setting-tab li:hover ul,
.sports-side-menu-list a,
.sports-side-menu-list .Go,
.favor-set,
.path .path-back,
.sports-path-popup a,
.short-amount,
.odd-add a,
.stake-popup a,
.slider-bar span,
.slider-bar a,
.live:before,
.load-pending strong,
.favor,
.images-grid a,
.marquee-list li a,
.tab-highlight a,
.tab-markets a,
.event-left .sports-header span,
.event-right .sports-header span,
.event-left .matched-head span,
.event-right .matched-head span,
.live-list a,
.live-list a:after,
.sportsgame-list-content dd a,
.sportsgame-list-content dd a span,
.sportsgame-list-content dd .info,
.game-head a,
.game-team .game-visit span,
.game-scores .game-visit span,
.game-team .game-home span,
.game-scores .game-home span,
.game-team .game-vs span,
.game-scores .game-vs span,
.game-scores ul .scores-box span,
.game-progress:after,
.sum-status,
.score-pop:before,
.score-pop-last:before,
.tab-HS a,
.fm-bets td a,
.bets-HS td a,
.bets-GH td a,
.fm-bets td span,
.bets-HS td span,
.bets-GH td span,
.more,
.suspend span,
.fm-bets .suspend span,
.bets-HS .suspend span,
.bets-GH .suspend span,
.line_markets-team .game-vs div:before,
.line_markets-team .game-vs div:after,
.line_market-name span,
.quick_bet-wrap .btn span,
.quick_bet-wrap .btn-send span,
.quick_bet-wrap .pages a span,
.pages .quick_bet-wrap a span,
.quick_bet-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .quick_bet-wrap input span,
.quick_bet-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .quick_bet-wrap textarea span,
.game-fancy .info-inplay,
.game-fancy.in-play:before,
.fancy-head .in-play span:before,
.fancy-info dt span,
.sportsbook-head h4:after,
.sportsbook-head .tc-content h5:after,
.tc-content .sportsbook-head h5:after,
.close_pop,
.error-text,
.go-back,
.pop-close,
.tab a,
.expand-close,
.expand-open,
.selection,
.initial-balance dt span,
.final-balance dt span,
.announce-footer .confirm-checkbox,
.betsbuzz365 .support-wrap,
.betsbuzz365 .power-content,
.betsbuzz365 .mob-inform-link,
.betsbuzz365 .RnR-link {
  display: block
}

.displayI,
.sport_list-wrap .sportsgame-list-content dd a,
.pages li {
  display: inline
}

.displayIB,
.saddle_1:before,
.saddle_1A:before,
.saddle_1B:before,
.saddle_1C:before,
.saddle_1D:before,
.saddle_1X:before,
.saddle_1Y:before,
.saddle_2:before,
.saddle_2B:before,
.saddle_2C:before,
.saddle_2X:before,
.saddle_3:before,
.saddle_3C:before,
.saddle_3D:before,
.saddle_3E:before,
.saddle_3X:before,
.saddle_4:before,
.saddle_4D:before,
.saddle_4X:before,
.saddle_5:before,
.saddle_6:before,
.saddle_7:before,
.saddle_8:before,
.saddle_9:before,
.saddle_10:before,
.saddle_11:before,
.saddle_11F:before,
.saddle_12:before,
.saddle_12F:before,
.saddle_13:before,
.saddle_13F:before,
.saddle_14:before,
.saddle_14F:before,
.saddle_15:before,
.saddle_15F:before,
.saddle_16:before,
.saddle_16F:before,
.saddle_17:before,
.saddle_17F:before,
.saddle_18:before,
.saddle_18F:before,
.saddle_19:before,
.saddle_19F:before,
.saddle_20:before,
.saddle_20F:before,
.saddle_21:before,
.saddle_21F:before,
.saddle_22:before,
.saddle_22F:before,
.saddle_23:before,
.saddle_23F:before,
.saddle_24:before,
.saddle_24F:before,
.saddle_25:before,
.saddle_25F:before,
.saddle_26:before,
.saddle_26F:before,
.saddle_27:before,
.saddle_27F:before,
.saddle_28:before,
.saddle_28F:before,
.saddle_29:before,
.saddle_29F:before,
.saddle_30:before,
.saddle_30F:before,
.mob-inform-link li,
.RnR-link li,
.favor-wrap .sports-side-menu-list a,
.upcome-wrap dt,
.upcome-wrap dd,
.support-wrap h3,
.support-wrap dl,
.apkdl-link a,
.game-low_liq,
.game-fancy,
.game-sportsbook,
.game-matched dt,
.game-matched dd,
.for-agent .fancy-head h4:after,
.for-agent .fancy-head .tc-content h5:after,
.tc-content .for-agent .fancy-head h5:after,
.game-wrap h3 .multi_name,
.one_click-stake li,
.fancy_bet .fancy-quick-tr .progress-bar-txt span,
.sportsbook_bet .fancy-quick-tr .progress-bar-txt span,
.fancy-head h4 span,
.fancy-head .tc-content h5 span,
.tc-content .fancy-head h5 span,
.btn-fancybet_rules,
.fancy-info dt,
.fancy-info dd,
.sportsbook-head h4 span,
.sportsbook-head .tc-content h5 span,
.tc-content .sportsbook-head h5 span,
.announce-header h1:before,
.announce-footer li,
.marquee-pop .btn-send {
  display: inline-block
}

.displayF,
.horse-info,
.dog-info,
.horse-info>dt,
.dog-info>dt,
.horse-info>dd,
.dog-info>dd {
  display: flex
}

.main_wrap,
.header {
  position: relative;
  width: 1349px;
  margin: 0 auto
}

.main-content {
  position: relative;
  min-width: 1350px;
  max-width: calc(100% - 40px);
  height: calc(100% - 105px);
  margin: 0 auto
}

.lit-content-center {
  overflow: hidden;
  overflow-y: auto
}

.pop-warp,
.log-wrap,
.streaming-pop {
  width: 920px;
  height: 600px;
  overflow: hidden;
  margin: 0 auto;
  background-color: #fff
}

.log-wrap {
  width: 1100px;
  height: 650px
}

.col-left {
  position: absolute;
  left: 0;
  top: 0;
  width: 17.36111%
}

.main-content .col-left {
  height: 100%;
  overflow: hidden
}

.centar-content {
  position: relative;
  margin-left: 17.999999%;
  margin-right: 26.74167%;
  padding: 0 5px
}

.main-content .centar-content {
  height: 100%;
  overflow: hidden
}

.fm-match-odds img,
.open-tv-wrap:before {
  background-image: url('../images/sprite/main-s1aea395e8c.png');
}

.centar-content.player {
  height: 100%;
  padding: 0 5px
}

.report-tab-wrap {
  position: relative;
  margin-top: 16px;
  list-style-type: none;
}

.report-tab-wrap .report-tab.select {
  background-color: #000;
  color: #FFFFFF;
}

.report-tab-wrap .report-tab {
  display: inline-block;
  padding: 5px 24px 9px;
  margin-right: 2px;
  background-color: #FFFFFF;
  border: 1px solid #000;
  border-radius: 3px 3px 0 0;
  color: #000;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.report-tab-wrap .report-tab.select:before {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #000;
}

.report-tab-wrap .report-tab {
  display: inline-block;
  padding: 5px 24px 9px;
  margin-right: 2px;
  background-color: #FFFFFF;
  border: 1px solid #000;
  border-radius: 3px 3px 0 0;
  color: #000;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.react-datepicker-wrapper {
  /*background-image: url('../images/download.png');*/
  background-repeat: no-repeat;
}

.float-R,
.pop-warp.no-match_odds .pop-left .select-betting .selection,
.no-match_odds.log-wrap .pop-left .select-betting .selection,
.no-match_odds.streaming-pop .pop-left .select-betting .selection,
.close-button,
.sportsgame-list-content .game-fancy,
.sportsgame-list-content .game-sportsbook,
.sportsgame-list-content .game-bookmaker,
.sportsgame-list-content .game-live,
.login-clientform,
.account-wrap,
.language,
.setting-tab,
.time_zone,
.gmt,
.sports-side-menu-list .Go,
.favor-set,
.sum,
.btn-wrap .btn-send,
.btn-wrap .edit-function .btn,
.btn-wrap .edit-function .btn-send,
.btn-wrap .edit-function .pages a,
.pages .btn-wrap .edit-function a,
.btn-wrap .edit-function .calendarTable_inputBox input,
.calendarTable_inputBox .btn-wrap .edit-function input,
.btn-wrap .edit-function .calendarTable_inputBox textarea,
.calendarTable_inputBox .btn-wrap .edit-function textarea,
.cashout-wrap dl,
.event-right,
.live-head h3 span,
.game-matched,
.open-tv-wrap,
.head-bets-agent .game-info,
.more,
.one_click-setting .a-edit,
.one_click-setting .btn-send,
.quick_bet-wrap dt .bet-check,
.quick_bet-wrap .max-bet,
.quick_bet-wrap .col-stake_list ul,
.game-head .ico_rules,
.fancy-info,
.total-show .sports-switch,
.result-search select {
  float: right;
}

a {
  text-decoration: none;
}

.game-streaming-wrap {
  height: 270px;
  background-image: linear-gradient(90deg, #222 0%, #000 20%, #000 81%, #222 100%);
}

.open-tv-wrap:hover {
  text-decoration: none;
  background-image: linear-gradient(180deg, #194F72 0%, #1E5F89 100%)
}

.tv {
  position: relative;
  width: 480px;
  height: 270px;
  background-color: #000;
  margin: 0 auto;
}

.tv-control:nth-of-type(1) {
  top: 0;
  right: 0;
}

.tv-control {
  position: absolute;
  width: auto;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
  margin: 7px;

}

.tv-control a {
  width: 50px;
  height: 35px;
  color: #C8C7C7;
  text-decoration: none;
}

.tv-control a:before {
  content: "";
  background-size: contain;
  background-repeat: no-repeat;
}

.tv-control .btn-line {
  font-size: 11px;
  text-indent: inherit;
}

.btn-line span {
  padding-top: 10px;
}

.tv-control li {
  list-style: none;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.tv-control .close:before {
  width: 14px;
  height: 14px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="rgb(207,209,206)" fill-rule="evenodd" d="M9 .912L5.412 4.5 9 8.088 8.088 9 4.5 5.412.912 9 0 8.088 3.588 4.5 0 .912.912 0 4.5 3.588 8.088 0z"/></svg>');
}


.btn-line:before {
  width: 18px;
  height: 14px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14"><path fill="rgb(207,209,206)" fill-rule="evenodd" d="M3.477 7.67c1.104-1.138 2.394-1.909 3.87-2.312a8.165 8.165 0 0 1 4.326 0c1.477.403 2.76 1.174 3.85 2.312l-1.697 1.815A5.933 5.933 0 0 0 7.948 7.82a5.933 5.933 0 0 0-2.774 1.664L3.477 7.67zm3.436 3.63c.455-.476 1-.8 1.635-.973a3.561 3.561 0 0 1 1.904 0c.635.173 1.18.497 1.635.972L9.5 14l-2.587-2.7zM0 4.082a13.418 13.418 0 0 1 4.45-3.068A13.083 13.083 0 0 1 9.52 0c1.753 0 3.436.338 5.05 1.015A13.198 13.198 0 0 1 19 4.083l-1.739 1.815a10.767 10.767 0 0 0-3.622-2.506A10.498 10.498 0 0 0 9.5 2.549c-1.435 0-2.815.281-4.14.843A10.767 10.767 0 0 0 1.74 5.898L0 4.083z"/></svg>');
}

.btn-fullscreen:before {
  width: 15px;
  height: 15px;
  background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M18 6.402V0h-6.402v2.536h3.866v3.866H18zm-15.464 0V2.536h3.866V0H0v6.402h2.536zM18 18v-6.402h-2.536v3.866h-3.866V18H18zM6.402 18v-2.536H2.536v-3.866H0V18h6.402z" fill="rgb(200,199,199)" fill-rule="nonzero"/></svg>')
}

.centar-content.markets {
  padding: 0 5px
}

.btn-volume_off:before {
  width: 15px;
  height: 15px;
  background-image: url('data:image/svg+xml,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M8.526.947v3.79L6.632 2.842 8.526.947zM1.272 0L18 16.728 16.728 18l-2.064-2.064c-1.2.928-2.416 1.536-3.648 1.824v-2.064a6.364 6.364 0 002.256-1.176L9 10.272v6.744L3.984 12H0V6h4.728L0 1.272 1.272 0zm14.814 8.982a7.598 7.598 0 00-.604-3.015 7.131 7.131 0 00-1.675-2.424 6.136 6.136 0 00-2.439-1.427V0a7.932 7.932 0 013.407 1.747 9.083 9.083 0 012.359 3.15A9.818 9.818 0 0118 8.982c0 .754-.084 1.496-.25 2.226a9.171 9.171 0 01-.73 2.055l-1.413-1.6c.32-.869.479-1.763.479-2.681zm-2.823-.122c0 .295-.018.5-.054.614l-2.788-2.48V4.738c.875.393 1.567.953 2.077 1.681.51.728.765 1.542.765 2.442z" fill="rgb(200,199,199)" fill-rule="evenodd"/></svg>');
}

.centar-content.inplay {
  height: calc(100% - 10px);
  padding-left: 0;
  padding-top: 10px;
  margin-left: 0
}

.centar-content.report {
  padding-right: 0;
  margin-right: 0
}

.col-right {
  position: absolute;
  width: 26.04167%;
  top: 0;
  right: 0
}

.main-content .col-right {
  height: 100%;
  overflow: hidden
}

.loading-wrap {
  display: inherit;
  top: 334px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .5);
  padding-top: 25px;
  z-index: 50;
  position: absolute;
  left: 622px;
  width: 152px;
  margin-left: -95px;
}

.loading-wrap.multi-load {
  padding-top: 15px;
  height: 66px;
  top: 10%;
  margin-top: -10px
}

.loading {
  padding: 5% 0
}

.loading li {
  list-style: none;
  font-size: 11px;
  color: #000;
  margin-bottom: 3x
}

.loading img {
  background-position: -42px -365px;
  height: 22px;
  width: 38px
}

.table01,
.table-s {
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 15px
}

.table01 caption,
.table-s caption {
  background-color: #000;
  border-bottom: 1px solid #7e97a7;
  color: #fff;
  line-height: 24px;
  font-weight: 700;
  padding: 0 10px
}

.table01 th,
.table-s th {
  color: #000;
  background-color: #e4e4e4;
  border: 1px solid #7e97a7;
  border-width: 1px 0 1px 0;
  padding: 8px 10px
}

.table01 td,
.table-s td {
  border-top: 1px solid #eee;
  padding: 8px 10px;
  vertical-align: middle
}

.table01 a,
.table-s a {
  text-decoration: underline
}

.table01 .btn,
.table-s .btn,
.table01 .btn-send,
.table-s .btn-send,
.table01 .pages a,
.pages .table01 a,
.table-s .pages a,
.pages .table-s a,
.table01 .calendarTable_inputBox input,
.calendarTable_inputBox .table01 input,
.table-s .calendarTable_inputBox input,
.calendarTable_inputBox .table-s input,
.table01 .calendarTable_inputBox textarea,
.calendarTable_inputBox .table01 textarea,
.table-s .calendarTable_inputBox textarea,
.calendarTable_inputBox .table-s textarea {
  text-decoration: none
}

.lit-content-center .table01:last-of-type,
.lit-content-center .table-s:last-of-type {
  margin-bottom: 0
}

.cal-input {
  width: 130px;
  cursor: pointer;
  background-position: 100% -24px
}

.time-input {
  width: 45px
}

.delete {
  background-position: -63px -110px;
  height: 32px;
  width: 17px
}

.delete:hover,
.delete.del-hover {
  background-position: -63px -142px
}

.close-button {
  background-position: -404px -1029px;
  height: 10px !important;
  width: 10px
}

.close-button:hover,
.close-button.close-black-hover {
  background-position: -404px -1039px
}

.btn,
.btn-send,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea {
  /*background: #eee url('../images/sprite/bg-btn-gif') repeat-x; */
  border: 1px solid #bbb;
  border-radius: 4px;
  color: #1e1e1e;
  font-weight: 700;
  line-height: 23px;
  font-size: 12px;
  margin: 0 5px 10px 0;
}




.mob-live-number strong {
  flex: 1;
  height: 100%;
  margin-right: 3px;
  padding: 0 2px;
  border-radius: 3px 0px 0px 3px;
  background-image: linear-gradient(180deg, #fff 0%, #eee 89%);

}


.marquee-box {
  color: #fff;
  line-height: 25px;
  height: 25px;
  margin-bottom: 1px;
  background-repeat: repeat-x;
  background-image: linear-gradient(rgb(42, 58, 67) 27%, rgb(28, 40, 45) 83%);
}

.marquee-box h4,
.marquee-box .tc-content h5,
.tc-content .marquee-box h5 {
  position: relative;
  flex-basis: 72px;
  justify-content: center;
  align-items: center;
}

.marquee-box h4:before,
.marquee-box .tc-content h5:before,
.tc-content .marquee-box h5:before {
  content: '';
  height: 17px;
  width: 17px;
  margin-right: 2px;
  background-position: 100% -2560px;
}

.marquee-box h4:after,
.marquee-box .tc-content h5:after,
.tc-content .marquee-box h5:after {
  content: '';
  position: absolute;
  right: -7px;
  top: 0;
  z-index: 2;
  width: 7px;
  height: 25px;
  background-position: 100% -3365px;
}

.marquee-box .marquee {
  flex: 1;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.marquee-box .marquee a {
  height: 25px;
  line-height: 25px;
  font-weight: bold;
  color: #6AC2FF;
  margin-right: 100px;
  align-items: center;
}

.marquee-box .marquee a span {
  height: 15px;
  line-height: 15px;
  font-size: 11px;
  font-style: italic;
  font-weight: normal;
  color: #1C2834;
  background-color: #6AC2FF;
  border-radius: 2px;
  padding: 0 5px;
  margin-right: 5px;
}

.js-marquee-wrapper {
  width: 100000px;
  transform: translateX(662px);
  animation: 100.354s linear 0s infinite normal none running marqueeAnimation-6864042;
}

@keyframes marqueeAnimation-6864042 {
  100% {
    transform: translateX(-1800px);
  }
}

.marquee-box .marquee a span {
  display: block;
}

.fa-chrome:before {
  content: "\\f268";
}

.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fa-2x {
  font-size: 2em;
}

.marquee-box {
  color: #fff;
  line-height: 25px;
  height: 25px;
  margin-bottom: 1px;
  background-repeat: repeat-x;
  background-image: linear-gradient(rgb(42, 58, 67) 27%, rgb(28, 40, 45) 83%);
}

.marquee-box .marquee a {
  display: flex;
}

.marquee-box .marquee a {
  float: left;
}

.marquee-box h4:before {
  display: block;
}

.marquee-box h4:before {
  background-image: url('../images/sprite/main-s1aea395e8c.png');
  background-repeat: no-repeat;
}

.marquee-box h4::after {
  background-image: url('../images/sprite/main-s1aea395e8c.png');
  background-repeat: no-repeat;
}

.mob-live-number strong:before {
  width: 14px;
  height: 8px;
  background: url('data:image/svg+xml,<svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,0,0)" fill-rule="evenodd"><path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z"/><circle cx="6.8" cy="4.4" r="1.6"/></g></svg>') no-repeat;
  background-size: contain;
}

.mob-live-number strong:before,
.live_events .live_icon span:before {
  animation: twinkling 1.4s infinite ease;
}

.mob-live-number strong:before {
  content: "";
}

.btn:hover {
  background: #fff url('../images/sprite/bg-btn_hover.gif') repeat-x
}

.btn,
.btn-send,
.pages a,
.calendarTable_inputBox input,
.btn:hover,
.btn-send:hover,
.pages a:hover,
.calendarTable_inputBox input:hover,
.calendarTable_inputBox textarea:hover {

  border-radius: 4px;
  text-decoration: none;

}

.btn.select,
.select.btn-send,
.pages a.select,
.calendarTable_inputBox input.select,
.calendarTable_inputBox textarea.select.btn.disable,
.disable.btn-send,
.pages a.disable,
.calendarTable_inputBox input.disable,
.calendarTable_inputBox textarea.disable {
  background: #dfdfdf;
  color: #999;
  cursor: not-allowed
}

table .btn,
table .btn-send,
table .pages a,
.pages table a,
table .calendarTable_inputBox input,
.calendarTable_inputBox table input,
table .calendarTable_inputBox textarea,
.calendarTable_inputBox table textarea {
  margin: 0
}

.back-button,
.lay-button {
  color: #1e1e1e;
  font-weight: 700;
  margin-right: 1%;
  background-color: #72bbef;
  border-left-color: #fff
}

.back-button:hover,
.lay-button:hover {
  background-color: #80c2f1
}

.back-button.select,
.select.lay-button {
  background-color: #1a8ee1;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.back-button.select a,
.select.lay-button a {
  color: #fff
}

.back-button:hover,
.lay-button:hover {
  text-decoration: none
}

.disable .back-button,
.disable .lay-button {
  cursor: not-allowed
}

.lay-button {
  background-color: #faa9ba;
  border-left-color: #fff
}

.lay-button:hover {
  background-color: #fbb7c6
}

.lay-button.select {
  background-color: #f4496d;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.lay-button.select a {
  color: #fff
}

.icon-time {
  background-position: -399px -2035px
}

.icon-live {
  background-position: -399px -1834px
}

.icon-irun {
  background-position: -399px -1797px
}

.icon-predict {
  background-position: -398px -1562px;
  height: 16px;
  width: 16px
}

.icon-cashout {
  background-position: -399px -1547px;
  height: 15px;
  width: 15px
}

.inplay-icon {
  margin-right: 5px;
  background-position: -406px -1759px;
  height: 8px;
  width: 8px
}

.sports-side-menu-list .inplay-icon {
  margin-right: 9px
}

.icon-no_play {
  margin-right: 5px;
  background-position: -406px -1897px;
  height: 8px;
  width: 8px
}

.sports-side-menu-list .icon-no_play {
  margin-right: 9px
}

.icon-cricket {
  background-position: -402px -1578px;
  height: 12px;
  width: 12px
}

.icon-type_soccer {
  background-position: -402px -2050px;
  height: 12px;
  width: 12px
}

.icon-tennis {
  background-position: -402px -2023px;
  height: 12px;
  width: 12px
}

.icon-basketball {
  background-position: -402px -1408px;
  height: 12px;
  width: 12px
}

.icon-dog {
  background-position: -402px -1590px;
  height: 12px;
  width: 12px
}

.icon-HR {
  background-position: -402px -1746px;
  height: 13px;
  width: 12px
}

.icon-racing {
  background-position: -401px -1905px;
  height: 13px;
  width: 13px
}

.lay {
  color: #e33a5e !important
}

.back {
  color: #1f72ac !important
}

.red {
  color: #d0021b !important
}

.green {
  color: #508d0e !important
}

.bg-back {
  background-color: #beddf4 !important
}

.bg-lay {
  background-color: #f3dce2 !important
}

.delete,
.close-button,
.header h1,


.betsbuzz365 .header h1,



.skyinplay .header h1,





.slipbar-content .slip_set,
.slip_refresh,
.tv_popup,
.account-wrap .head-refresh a,
.language,
.sports-side-menu-list .Go,
.path .path-back,
.odd-add a,
.slider-bar a,
.favor,
.login-pg-go .close,
.sportsgame-list-content dd .info,
.game-head .favor,
.game-head .refresh,
.add-favourite,
.delete-pin,
.multi_refresh,
.btn-fancybet_rules,
.close_pop {
  font-size: 0;
  text-indent: -99999px
}

.sports-side-menu-list a,
.sports-path-popup a,
.short-amount,
.marquee-list li a,
.upcome,
.live-list a,
.live-channel,
.sportsgame-list-content dt,
.sportsgame-list-content.predict p,
.tab-HS a,
.fm-bets th,
.bets-HS th,
.bets-GH th,
.fm-bets th p,
.bets-HS th p,
.bets-GH th p,
.horse-name li,
.quick_bet-wrap dt,
.quick_bet-wrap .btn span,
.quick_bet-wrap .btn-send span,
.quick_bet-wrap .pages a span,
.pages .quick_bet-wrap a span,
.quick_bet-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .quick_bet-wrap input span,
.quick_bet-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .quick_bet-wrap textarea span,
.filter-list .filter-content,
.select-betting .selection,
.suggestion-wrap .no-matching,
.suggestion-wrap p,
.suggestion-wrap a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.pop-warp,
.log-wrap,
.streaming-pop,
.more_drop-list,
.selection-list,
.slip_set-pop,
.oneclick_set-pop,
.sports-path-popup,
.tips-popup,
.full-amount,
.stake-popup,
.message-content,
.dialog-wrap-w,
.score-pop,
.score-pop-last,
.horse_info-hover,
.rules-wrap,
.pop_box,
.filter-pop,
.calendarPanel {
  box-shadow: 0 4px 5px rgba(0, 0, 0, .5)
}

.sports-header,
.matched-head,
.for-agent,
.head-bets-agent,
.expand>td {
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, .1)
}

.slip-back .col-stake_list ul,
.slip-lay .col-stake_list ul,
.login-clientform,
.account-wrap,
.menu,
.setting-tab,
.sports-header,
.matched-head,
.stake-popup,
.btn-wrap,
.slip-option,
.cashout-wrap,
.slider,
.tab-highlight,
.tab-markets,
.game-wrap-horse .hs-time,
.game-scores .scores-time,
.game-scores ul,
.tab-HS,
.game-info,
.tab,
.input-list,
.filter-list,
.filter-pop ul,
.acc-info,
.total-show {
  display: block
}

.slip-back .col-stake_list ul li,
.slip-lay .col-stake_list ul li,
.login-clientform li,
.account-wrap li,
.menu li,
.setting-tab li,
.sports-header li,
.matched-head li,
.stake-popup li,
.btn-wrap li,
.slip-option li,
.cashout-wrap li,
.slider li,
.tab-highlight li,
.tab-markets li,
.game-wrap-horse .hs-time li,
.game-scores .scores-time li,
.game-scores ul li,
.tab-HS li,
.game-info li,
.tab li,
.input-list li,
.filter-list li,
.filter-pop ul li,
.acc-info li,
.total-show li {
  display: block;
  float: left
}

/* start */

.account-wrap .main-wallet {
  flex: 1;
  width: auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.Playyyerrr {
  width: 100%;

}

.video-react-video {
  width: 100%;
}


.displayF,
.promo-banner .promo-control-nav,
.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd,
.power-content,
.account-wrap a,
.account-wrap .main-wallet,
.account-wrap .main-wallet .a-wallet ul,
.account-wrap p.loading-bar,
.licence_embed,
.live-head,
.change-channel,
.marquee-box,
.marquee-box h4,
.marquee-box .tc-content h5,
.tc-content .marquee-box h5,
.marquee-box .marquee a,
.game-E i,
.fm-match-button,
.fm-match-button a,
.game-head .open-tv-wrap,
.tv-control,
.horse-info,
.dog-info,
.horse-info>dt,
.dog-info>dt,
.horse-info>dd,
.dog-info>dd,
.multi_h3,
.game-wrap h3 .multi_name,
.quick-bet-confirm,
.gametab-head,
.gametab-head h4,
.gametab-head .tc-content h5,
.tc-content .gametab-head h5,
.btn_rules,
.fancy-th-layout,
.fancy-th-layout dt,
.fancy-th-layout dd,
.other-tab,
.back-gradient,
.lay-gradient,
.back-gradient dd a,
.lay-gradient dd a,
.download-list,
.download-list dt,
.download-list dt a,
.download-list dd,
.download-list dd a,
.special_bets-tab-wrap,
.special_bets-tab,
.special_bets-tab .more_drop>a,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages {
  display: flex;
}

.tv-control:nth-of-type(2) {
  bottom: 0;
  left: 0;
}


.tv-control a:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.betsbuzz365 .account-wrap .a-wallet {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.account-wrap .main-wallet .a-wallet ul {
  align-items: center;
  position: relative;
  width: auto;
  height: 100%;
  line-height: 12px;
  background-color: initial !important;
  padding: 0 7px;
}

.quick-bet-confirm li {
  width: calc(100% - 10px);
  list-style: none;
  line-height: 18px;
  color: #1E1E1E;
  padding: 0 5px;
}

.align-R,
.table01,
.table-s,
.slip-back input,
.slip-lay input,
.slip-book input,
.slip-back textarea,
.slip-lay textarea,
.slip-book textarea,
.slip-back .col-profit,
.slip-lay .col-profit,
.slip-book .col-profit,
.slip-back .inn_runs dd,
.slip-lay .inn_runs dd,
.slip-book .inn_runs dd,
.account-wrap .main-wallet p,
.time_zone,
.path ul,
.sports-header .col-profit,
.matched-head .col-profit,
.cashout-wrap dl,
.change-channel span,
.game-team .game-visit,
.game-scores .game-visit,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book,
.quick-bet-confirm li,
.form_list dt,
.table-trans .unit-num {
  text-align: right;
}

.account-wrap .main-wallet ul li {
  line-height: 24px;
  margin-left: 15px;
}

.account-wrap .main-wallet .a-wallet li {
  font-weight: bold;
  margin-right: 7px;
  margin-left: 0;
}

.account-wrap .main-wallet ul li {
  line-height: 24px;
  margin-left: 15px;
}

.account-wrap ul li {
  float: none;
  text-indent: 0;
  margin: 0;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.account-wrap .main-wallet .a-wallet li:last-child {
  margin-right: 0;
}

.betsbuzz365 .account-wrap .a-wallet .nums {
  border: 1px solid #000;
}

.account-wrap .main-wallet .a-wallet li {
  font-weight: bold;
  margin-right: 7px;
  margin-left: 0;
}

.account-wrap .main-wallet .nums {
  height: 14px;
  font-size: 11px;
  line-height: 14px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  padding: 0 8px;
}

.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
  justify-content: center;
  align-items: center;
}

.displayF,
.promo-banner .promo-control-nav,
.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd,
.power-content,
.account-wrap a,
.account-wrap .main-wallet,
.account-wrap .main-wallet .a-wallet ul,
.account-wrap p.loading-bar,
.licence_embed,
.live-head,
.change-channel,
.marquee-box,
.marquee-box h4,
.marquee-box .tc-content h5,
.tc-content .marquee-box h5,
.marquee-box .marquee a,
.game-E i,
.fm-match-button,
.fm-match-button a,
.game-head .open-tv-wrap,
.tv-control,
.horse-info,
.dog-info,
.horse-info>dt,
.dog-info>dt,
.horse-info>dd,
.dog-info>dd,
.multi_h3,
.game-wrap h3 .multi_name,
.quick-bet-confirm,
.gametab-head,
.gametab-head h4,
.gametab-head .tc-content h5,
.tc-content .gametab-head h5,
.btn_rules,
.fancy-th-layout,
.fancy-th-layout dt,
.fancy-th-layout dd,
.other-tab,
.back-gradient,
.lay-gradient,
.back-gradient dd a,
.lay-gradient dd a,
.download-list,
.download-list dt,
.download-list dt a,
.download-list dd,
.download-list dd a,
.special_bets-tab-wrap,
.special_bets-tab,
.special_bets-tab .more_drop>a,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages {
  display: flex;
}

.account-wrap .main-wallet .nums span {
  opacity: 1;
  font-size: 10px;
  font-weight: bold;
  margin-left: 1px;
}

.sportsgame-list-content {
  background-color: rgb(255, 255, 255);
}

.sportsgame-list-content:hover {
  background-color: #EFF2F2;
}

.fm-match-button {
  justify-content: center;
  list-style: none;
}


.fm-match-button li {
  position: relative;
}

.fm-match-button .favourite-pin {
  padding-left: 12px;
  background-image: url('data:image/svg+xml,<svg width="100" height="25" viewBox="0 0 100 25" xmlns="http://www.w3.org/2000/svg"><path d="M120 0l-8.293 17.752c-1.87 4.003-6.969 7.248-11.377 7.248h-80.661c-4.413 0-9.506-3.243-11.377-7.248l-8.293-17.752h120z" fill="rgb(59,81,96)"/></svg>');
}

.fm-match-button .favourite-pin:before {
  background-image: url('data:image/svg+xml,<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.714 5.25c.857.321 1.286.812 1.286 1.473 0 .232-.036.384-.107.455-.071.071-.214.107-.429.107h-2.893l-.429 4.714h-.286l-.429-4.714h-2.893c-.214 0-.357-.04-.429-.121-.071-.08-.107-.228-.107-.442 0-.661.429-1.152 1.286-1.473l.143-.054c.262-.107.429-.277.5-.509l.643-3.161v-.134c0-.143-.119-.259-.357-.348l-.036-.027h-.036c-.286-.089-.429-.241-.429-.455 0-.25.048-.406.143-.469.095-.063.262-.094.5-.094h3.286c.238 0 .405.031.5.094.095.063.143.219.143.469 0 .214-.143.366-.429.455h-.036l-.036.027c-.238.089-.357.205-.357.348v.134l.643 3.161c.071.232.238.402.5.509l.143.054z" fill="rgb(255,255,255)"/></svg>');
}

.fm-match-button a:before {
  content: '';
  width: 14px;
  height: 14px;
  margin-right: 2px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.fm-match-button li:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 25px;
  background: rgba(255, 255, 255, 0.5);
}

.fm-match-button .fm-refresh-button {
  padding-right: 12px;
  background-image: url('data:image/svg+xml,<svg width="100" height="25" viewBox="0 0 100 25" xmlns="http://www.w3.org/2000/svg"><path d="M100 0l-8.293 17.752c-1.87 4.003-6.969 7.248-11.377 7.248h-80.661c-4.413 0-9.506-3.243-11.377-7.248l-8.293-17.752h120z" fill="rgb(59,81,96)"/></svg>');
}

.fm-match-button .fm-refresh-button:before {
  background-image: url('data:image/svg+xml,<svg width="13" height="16" viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.408 3.223c1.164 0 2.238.288 3.223.863.972.563 1.739 1.324 2.302 2.283.588.998.882 2.072.882 3.223 0 1.151-.294 2.225-.882 3.223-.563.972-1.33 1.739-2.302 2.302-.998.588-2.072.882-3.223.882-1.151 0-2.225-.294-3.223-.882-.972-.563-1.739-1.33-2.302-2.302-.588-.998-.882-2.072-.882-3.223h1.612c0 .87.214 1.672.643 2.408.428.735 1.01 1.317 1.746 1.746.735.428 1.538.643 2.408.643.87 0 1.672-.214 2.408-.643.735-.428 1.317-1.01 1.746-1.746.428-.735.643-1.538.643-2.408 0-.87-.214-1.672-.643-2.408-.428-.735-1.01-1.317-1.746-1.746-.735-.428-1.538-.643-2.408-.643v3.223l-4.01-4.01 4.01-4.01v3.223z" fill="rgb(255,255,255)"/></svg>');
}

.fm-match-odds img {
  vertical-align: top;
  background-repeat: no-repeat;
  background-position: -394px -2987px;
  height: 30px;
  width: 20px;
}

.game-info {
  padding: 0 10px;
}

.game-info li {
  padding: 7px 0;
  margin-right: 8px;
}

.fm-match-odds,
.game-info li {
  float: left;
}

.game-head .fancy-info {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  float: none;
  padding: 0 6px;
  margin: 7px 0;
  background-color: #BED5D8;
}

.fm-match-odds {
  height: 30px;
  line-height: 30px;
  color: #000;
  font-weight: bold;
  padding-left: 10px;
  background-color: #C5D0D7;
}

.fm-match-button a {
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 25px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  box-sizing: border-box;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: bold;
}

.fm-match-button {
  justify-content: center;
  list-style: none;
}

.wallet-detail {
  display: none;
  position: absolute;
  top: 25px;
  left: 0;
  width: 100%;
  font-size: 12px;
  color: #000;
  background-color: #E0E6E6;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  z-index: 99;
}

.wallet-detail-group {
  margin: 12px 7px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
}

.wallet-detail-group .wallet-detail-content {
  padding: 10px 7px 0;
}

.wallet-detail-group .wallet-detail-content dt {
  line-height: 1.6;
  margin-bottom: 3px;
}

.wallet-detail-group .wallet-detail-content dd {
  padding-bottom: 10px;
}

.wallet-detail-group .wallet-balance-num {
  display: flex;
  align-items: center;
  font-size: 17px;
  line-height: 1.2;
  font-weight: bold;
  padding-right: 80px;
  color: #000;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.badge-currency {
  margin-right: 3px;
  padding: 0 5px;
  line-height: 16px;
  font-size: 10px;
  font-weight: bold !important;
  color: #fff;
  background-color: #5F849D;
  border-radius: 3px;
}

.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
  justify-content: center;
  align-items: center;
}

.displayF,
.promo-banner .promo-control-nav,
.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd,
.power-content,
.account-wrap a,
.account-wrap .main-wallet,
.account-wrap .main-wallet .a-wallet ul,
.account-wrap p.loading-bar,
.licence_embed,
.live-head,
.change-channel,
.marquee-box,
.marquee-box h4,
.marquee-box .tc-content h5,
.tc-content .marquee-box h5,
.marquee-box .marquee a,
.game-E i,
.fm-match-button,
.fm-match-button a,
.game-head .open-tv-wrap,
.tv-control,
.horse-info,
.dog-info,
.horse-info>dt,
.dog-info>dt,
.horse-info>dd,
.dog-info>dd,
.multi_h3,
.game-wrap h3 .multi_name,
.quick-bet-confirm,
.gametab-head,
.gametab-head h4,
.gametab-head .tc-content h5,
.tc-content .gametab-head h5,
.btn_rules,
.fancy-th-layout,
.fancy-th-layout dt,
.fancy-th-layout dd,
.other-tab,
.back-gradient,
.lay-gradient,
.back-gradient dd a,
.lay-gradient dd a,
.download-list,
.download-list dt,
.download-list dt a,
.download-list dd,
.download-list dd a,
.special_bets-tab-wrap,
.special_bets-tab,
.special_bets-tab .more_drop>a,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages {
  display: flex;
}

.wallet-detail-group .wallet-detail-content dd {
  padding-bottom: 10px;
}

.wallet-detail-group .wallet-exposure {
  display: flex;
  justify-content: space-between;
  font-weight: normal !important;
  padding: 7px 0;
  border-top: 1px solid #E0E6E6;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.wallet-detail-group .wallet-exposure span {
  color: #1E1E1E;
}

.wallet-detail-group {
  margin: 12px 7px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
}


.wallet-detail-group .wallet-detail-content {
  padding: 10px 7px 0;
}

.wallet-detail-group .wallet-detail-content dt {
  line-height: 1.6;
  margin-bottom: 3px;
}

.wallet-detail-group .wallet-detail-content dd {
  padding-bottom: 10px;
}

.wallet-detail-group .wallet-balance-num {
  display: flex;
  align-items: center;
  font-size: 17px;
  line-height: 1.2;
  font-weight: bold;
  padding-right: 80px;
  color: #000;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.badge-currency {
  margin-right: 3px;
  padding: 0 5px;
  line-height: 16px;
  font-size: 10px;
  font-weight: bold !important;
  color: #fff;
  background-color: #5F849D;
  border-radius: 3px;
}

.wallet-detail-group .wallet-detail-content dd {
  padding-bottom: 10px;
}

.btn-recall {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  line-height: 2.2;
  padding: 0 8px;
  background-color: rgba(94, 190, 255, 0.15);
  border-radius: 4px;
  border: 1px solid #7E97A7;
  cursor: pointer;
}


.account-wrap .main-wallet .a-wallet {
  height: auto;
  line-height: initial;
  border: 0;
  border-radius: 4px 0 0 4px;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.5);
  padding: 0;
}

.account-wrap .main-wallet .nums span {
  opacity: 1;
  font-size: 10px;
  font-weight: bold;
  margin-left: 1px;
}

.wallet-detail-group .wallet-detail-content {
  padding: 10px 7px 0;
}

.wallet-detail-group:nth-child(2) .wallet-detail-content {
  position: relative;
  border-bottom: 1px solid #ccc;
}

.wallet-detail-group:nth-child(2) .wallet-detail-content .wallet-recall {
  position: absolute;
  top: 50%;
  right: 7px;
  transform: translateY(-50%);
  text-align: right;
  padding: 0;
}

.wallet-detail-group .wallet-detail-content dd {
  padding-bottom: 10px;
}

.align-R,
.table01,
.table-s,
.slip-back input,
.slip-lay input,
.slip-book input,
.slip-back textarea,
.slip-lay textarea,
.slip-book textarea,
.slip-back .col-profit,
.slip-lay .col-profit,
.slip-book .col-profit,
.slip-back .inn_runs dd,
.slip-lay .inn_runs dd,
.slip-book .inn_runs dd,
.account-wrap .main-wallet p,
.time_zone,
.path ul,
.sports-header .col-profit,
.matched-head .col-profit,
.cashout-wrap dl,
.change-channel span,
.game-team .game-visit,
.game-scores .game-visit,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book,
.quick-bet-confirm li,
.form_list dt,
.table-trans .unit-num {
  text-align: right;
}

.btn-recall {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  line-height: 2.2;
  padding: 0 8px;
  background-color: rgba(94, 190, 255, 0.15);
  border-radius: 4px;
  border: 1px solid #7E97A7;
  cursor: pointer;
}

.btn-box {
  padding: 0 7px 10px;
}

.betsbuzz365 .account-wrap a {
  color: #ffb600;
  border-color: #000;
  background: rgba(255, 255, 255, .1);
}

.account-wrap .a-refresh {
  width: 24px;
  height: 24px;
  border-left: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0 4px 4px 0;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.5);
}

.betsbuzz365 .account-wrap .a-refresh img {
  background: url('data:image/svg+xml,<svg width="13" height="16" viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.408 3.223c1.164 0 2.238.288 3.223.863.972.563 1.739 1.324 2.302 2.283.588.998.882 2.072.882 3.223 0 1.151-.294 2.225-.882 3.223-.563.972-1.33 1.739-2.302 2.302-.998.588-2.072.882-3.223.882-1.151 0-2.225-.294-3.223-.882-.972-.563-1.739-1.33-2.302-2.302-.588-.998-.882-2.072-.882-3.223h1.612c0 .87.214 1.672.643 2.408.428.735 1.01 1.317 1.746 1.746.735.428 1.538.643 2.408.643.87 0 1.672-.214 2.408-.643.735-.428 1.317-1.01 1.746-1.746.428-.735.643-1.538.643-2.408 0-.87-.214-1.672-.643-2.408-.428-.735-1.01-1.317-1.746-1.746-.735-.428-1.538-.643-2.408-.643v3.223l-4.01-4.01 4.01-4.01v3.223z" fill="%23FFB600"/></svg>') no-repeat center center;
  background-size: contain;
  height: 14px;
  width: 14px;
}

.wallet-detail .btn,
.wallet-detail .btn-send,
.wallet-detail .pages a,
.pages .wallet-detail a,
.wallet-detail .calendarTable_inputBox input,
.calendarTable_inputBox .wallet-detail input,
.wallet-detail .calendarTable_inputBox textarea,
.calendarTable_inputBox .wallet-detail textarea {
  width: 100%;
  font-size: 13px;
  font-weight: 900;
  line-height: 31px;
  margin-bottom: 0;
}

.btn,
.btn-send,
.marquee-pop .pages a,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea {
  background: #eee url(../images/sprite/bg-btn.gif) repeat-x;
  border: 1px solid #bbb;
  border-radius: 4px;
  color: #1E1E1E;
  font-weight: bold;
  line-height: 23px;
  font-size: 12px;
  margin: 0 5px 10px 0;
}

/*End*/

.header h1 {
  width: 143px;
  height: 34px;
  background: url('') no-repeat
}

.betsbuzz365 .header h1 {
  width: 125px;
  height: 53px;

}

/* .betsbuzz365 .kv{
  background: url('../images/image112.jpg') no-repeat
} */

.betsbuzz365 .header h1 a {

  background: url(../images/headerlogo.png) no-repeat
}


.header h1 {
  width: 155px;
  height: 48px;
  background-size: contain
}

.icon-time,
.icon-live,
.icon-irun,
.icon-predict,
.icon-cashout {
  width: 15px;
  height: 15px;
  margin: 0 5px 0 0;
  vertical-align: top
}

.login-box-content {
  color: #fff;
  margin: 100px 0 0 25px
}

.login-box-content dt {
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 15px
}

.login-box-content dd {
  position: relative;
  width: 220px;
  margin-bottom: 7px
}

.login-box-content input,
.login-box-content textarea {
  width: 100%;
  height: 33px;
  font-size: 14px;
  line-height: 21px;
  border: 1px solid #aaa;
  box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, .1);
  margin: 0
}

.login-box-content input:focus,
.login-box-content textarea:focus {
  padding: 5px
}

.login-box-content .btn-send {
  width: 218px;
  height: 36px;
  line-height: 36px;
  font-size: 15px;
  margin: 15px 0 0;
  border-radius: 4px
}

/* 
.change_pass {
  padding: 30px 20px;
  font-size: 15px;
  line-height: 20px
}

.change_pass h2 {
  font-size: 25px;
  line-height: 30px;
  color: #000;
  margin-bottom: 10px
}

.change_pass {
  text-align: left;
  padding-bottom: 40px
}

.change_pass .login-box-content {
  width: 230px;
  margin: 0
}

.change_pass dd {
  width: 230px
}

.change_pass .btn-send {
  width: 228px
}

.change_pass .note {
  width: calc(100% - 230px - 27px);
  font-size: 12px;
  color: #666;
  line-height: 17px;
  margin: 40px 12px 0 15px
}
*/
.back-button.spark,
.spark.lay-button,
.fm-bets .back-1.spark a,
.bets-HS .back-1.spark a,
.bets-GH .back-1.spark a {
  animation: sparkBack .5s ease
}

@keyframes sparkBack {
  0% {
    background-color: #72bbef;
    color: #1e1e1e
  }

  50% {
    background-color: #f8e71c;
    color: #fff
  }

  100% {
    background-color: #72bbef;
    color: #1e1e1e
  }
}

.fm-bets .back-2.spark a,
.bets-HS .back-2.spark a,
.bets-GH .back-2.spark a {
  animation: sparkBack_2 .5s ease
}

@keyframes sparkBack_2 {
  0% {
    background-color: #b7d5eb;
    color: #1e1e1e
  }

  50% {
    background-color: #f8e71c;
    color: #fff
  }

  100% {
    background-color: #b7d5eb;
    color: #1e1e1e
  }
}

.fm-bets .back-3.spark a,
.bets-HS .back-3.spark a,
.bets-GH .back-3.spark a {
  animation: sparkBack_3 .5s ease
}

@keyframes sparkBack_3 {
  0% {
    background-color: #d7e8f4;
    color: #1e1e1e
  }

  50% {
    background-color: #f8e71c;
    color: #fff
  }

  100% {
    background-color: #d7e8f4;
    color: #1e1e1e
  }
}

.lay-button.spark,
.fm-bets .lay-1.spark a,
.bets-HS .lay-1.spark a,
.bets-GH .lay-1.spark a {
  animation: sparkLay .5s ease
}

@keyframes sparkLay {
  0% {
    background-color: #faa9ba;
    color: #1e1e1e
  }

  50% {
    background-color: #26f1f8;
    color: #fff
  }

  100% {
    background-color: #faa9ba;
    color: #1e1e1e
  }
}

.fm-bets .lay-2.spark a,
.bets-HS .lay-2.spark a,
.bets-GH .lay-2.spark a {
  animation: sparkLay_2 .5s ease
}

@keyframes sparkLay_2 {
  0% {
    background-color: #efd3d9;
    color: #1e1e1e
  }

  50% {
    background-color: #26f1f8;
    color: #fff
  }

  100% {
    background-color: #efd3d9;
    color: #1e1e1e
  }
}

.fm-bets .lay-3.spark a,
.bets-HS .lay-3.spark a,
.bets-GH .lay-3.spark a {
  animation: sparkLay_3 .5s ease
}

@keyframes sparkLay_3 {
  0% {
    background-color: #f6e6ea;
    color: #1e1e1e
  }

  50% {
    background-color: #26f1f8;
    color: #fff
  }

  100% {
    background-color: #f6e6ea;
    color: #1e1e1e
  }
}

input:focus,
textarea:focus,
.btn-wrap .btn:focus,
.btn-wrap .btn-send:focus,
.btn-wrap .pages a:focus,
.pages .btn-wrap a:focus,
.btn-wrap .calendarTable_inputBox input:focus,
.calendarTable_inputBox .btn-wrap input:focus,
.btn-wrap .calendarTable_inputBox textarea:focus,
.calendarTable_inputBox .btn-wrap textarea:focus,
.slip-option input:focus,
.slip-option textarea:focus {
  border-width: 1px;
  border-color: #2789ce;
  box-shadow: 0 0 4px 2px rgba(114, 187, 239, .8)
}

.slip-back input:focus,
.slip-lay input:focus,
.slip-back textarea:focus,
.slip-lay textarea:focus,
.slip-back .keep-option input:focus,
.slip-lay .keep-option input:focus,
.slip-back .keep-option textarea:focus,
.slip-lay .keep-option textarea:focus {
  border-width: 1px;
  border-color: #2789ce;
  box-shadow: 0 0 4px 2px rgba(31, 114, 172, .7)
}

.slipbar-content,
.matched-wrap,
.live-wrap,
.tv-wrap,
.game-wrap,
.highlight-edge-content,
.game-wrap-horse,
.favor-wrap,
.sub_path {
  background-color: #fff;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 1px
}

.slipbar-content h3,
.matched-wrap h3,
.live-wrap h3,
.tv-wrap h3,
.game-wrap h3,
.highlight-edge-content h3,
.game-wrap-horse h3,
.favor-wrap h3,
.sub_path h3 {
  color: #fff;
  font-size: 12px;
  line-height: 25px;
  font-weight: 400;
  padding-left: 10px;
  background-repeat: repeat-x;
  background-position: 0 -2507px
}

.slipbar-content h3 a,
.matched-wrap h3 a,
.live-wrap h3 a,
.tv-wrap h3 a,
.game-wrap h3 a,
.highlight-edge-content h3 a,
.game-wrap-horse h3 a,
.favor-wrap h3 a,
.sub_path h3 a {
  color: #fff
}

.slipbar-content h3 a:hover,
.matched-wrap h3 a:hover,
.live-wrap h3 a:hover,
.tv-wrap h3 a:hover,
.game-wrap h3 a:hover,
.highlight-edge-content h3 a:hover,
.game-wrap-horse h3 a:hover,
.favor-wrap h3 a:hover,
.sub_path h3 a:hover {
  text-decoration: none
}

.slipbar-content h3 img,
.matched-wrap h3 img,
.live-wrap h3 img,
.tv-wrap h3 img,
.game-wrap h3 img,
.highlight-edge-content h3 img,
.game-wrap-horse h3 img,
.favor-wrap h3 img,
.sub_path h3 img {
  margin-top: 5px
}

.slipbar-content .to-expand,
.matched-wrap .to-expand,
.live-wrap .to-expand,
.tv-wrap .to-expand,
.game-wrap .to-expand,
.highlight-edge-content .to-expand,
.game-wrap-horse .to-expand,
.favor-wrap .to-expand,
.sub_path .to-expand {
  background-position: 100% -113px
}

.close.slipbar-content,
.close.matched-wrap,
.close.live-wrap,
.close.tv-wrap,
.close.game-wrap,
.close.highlight-edge-content,
.close.game-wrap-horse,
.close.favor-wrap,
.close.sub_path {
  height: 25px;
  overflow: hidden
}

.close.slipbar-content .to-expand,
.close.matched-wrap .to-expand,
.close.live-wrap .to-expand,
.close.tv-wrap .to-expand,
.close.game-wrap .to-expand,
.close.highlight-edge-content .to-expand,
.close.game-wrap-horse .to-expand,
.close.favor-wrap .to-expand,
.close.sub_path .to-expand {
  background-position: 100% -700px
}

.slipbar-content,
.matched-wrap,
.live-wrap,
.tv-wrap {
  margin-bottom: 0
}

.slipbar-content h3,
.matched-wrap h3,
.live-wrap h3,
.tv-wrap h3 {
  box-shadow: 0 2px 0 rgba(0, 0, 0, .1);
  background-position: 0 -2582px;
  background: linear-gradient(180deg, #2d4a5c 0%, #203846 100%);

}

.slipbar-content .to-expand,
.matched-wrap .to-expand,
.live-wrap .to-expand,
.tv-wrap .to-expand {
  background-position: 100% -199px
}

.close.slipbar-content,
.close.matched-wrap,
.close.live-wrap,
.close.tv-wrap {
  border-bottom-color: #eee
}

.close.slipbar-content .to-expand,
.close.matched-wrap .to-expand,
.close.live-wrap .to-expand,
.close.tv-wrap .to-expand {
  background-position: 100% -85px
}

.game-wrap,
.highlight-edge-content,
.game-wrap-horse {
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 15px
}

.game-wrap h3,
.highlight-edge-content h3,
.game-wrap-horse h3 {
  background: #243a48;
  text-align: left;
}

.game-wrap .close-info,
.highlight-edge-content .close-info,
.game-wrap-horse .close-info {
  padding-left: 10px;
  color: #000
}

.game-wrap .to-expand,
.highlight-edge-content .to-expand,
.game-wrap-horse .to-expand {
  background-position: 100% -1308px
}

.close.game-wrap,
.close.highlight-edge-content,
.close.game-wrap-horse {
  border-bottom-color: #eee
}

.close.game-wrap .to-expand,
.close.highlight-edge-content .to-expand,
.close.game-wrap-horse .to-expand {
  background-position: 100% -1124px
}




.game-team .game-name span,
.game-scores .game-name span,
.multi-event_type {
  background-color: #fff;
  color: #000;
  padding: 1px 8px;
  border-radius: 4px;
  margin: 0 5px
}

.game-team,
.game-scores {
  width: 100%;
  background-color: #1b2d38;
  color: #fff;
  line-height: 22px;
  font-size: 18px;
  font-weight: 700
}

.game-team td,
.game-scores td {
  position: relative;
  width: 40%;
  height: 28px;
  vertical-align: top
}

.game-team .game-name,
.game-scores .game-name {
  padding: 5px 10px 5px 30px
}

.game-team .game-name span,
.game-scores .game-name span {
  font-size: 15px
}

.pop-warp .game-team .game-name,
.log-wrap .game-team .game-name,
.streaming-pop .game-team .game-name,
.pop-warp .game-scores .game-name,
.log-wrap .game-scores .game-name,
.streaming-pop .game-scores .game-name,
.log-wrap .game-team .game-name,
.log-wrap .game-scores .game-name {
  padding-left: 10px
}

.slipbar-content .slip_set,
.slip_refresh,
.tv_popup {
  margin-right: 7px
}

.slip-back dt,
.slip-lay dt {
  position: relative;
  width: 42.0904%;
  font-weight: 700;
  padding-left: 5px
}

.slip-back dt span,
.slip-lay dt span {
  color: #222;
  opacity: .5;
  font-weight: 400
}

.fm-bets .special_bet h3 a,
.bets-HS .special_bet h3 a,
.bets-GH .special_bet h3 a {
  color: #fff;
}

.fm-bets .special_bet a,
.bets-HS .special_bet a,
.bets-GH .special_bet a {
  height: inherit;
  padding: 0;
}

h3 .add-favourite,
h3 .delete-pin {
  margin: 0 7px 0 -10px;
  z-index: 1;
  background-position: -385px -1035px;
  width: 29px
}

.fm-bets .special_bet h3 p,
.bets-HS .special_bet h3 p,
.bets-GH .special_bet h3 p {
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  margin: 0 0 0 7px;
  opacity: .7;
}

.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info {
  position: absolute;
  top: 0;
  right: 2px;
  font-weight: normal;
  width: auto;
  height: 25px;
  margin: 0;
}

.account-wrap .main-wallet .nums,
.account-wrap .a-refresh,
.badge-currency,
.mob-live-number,
.mob-live-number strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
  justify-content: center;
  align-items: center;
}

td .fancy-info {
  float: left;
}

.fancy-info {
  line-height: 15px;
}

.bets-bookmaker tr,
.bets-bookmaker .fm-bet-zone {
  background-color: #faf8d8;
}

.fancy_bet .fm-bet-zone,
.sportsbook_bet .fm-bet-zone,
.bookmaker_bet .fm-bet-zone {
  line-height: 22px;

}

.fancy_bet .fancy-suspend-tr th,
.sportsbook_bet .fancy-suspend-tr th,
.bookmaker_bet .fancy-suspend-tr th,
.fancy_bet .fancy-suspend-tr td,
.sportsbook_bet .fancy-suspend-tr td,
.bookmaker_bet .fancy-suspend-tr td {
  position: relative;
  height: 0;
  border-width: 0;
  margin-bottom: -1px;
  padding: 0;
}

.game-head .open-tv-wrap {
  align-items: center;
}

.open-tv-wrap {
  height: 23px;
  line-height: 23px;
  background-image: linear-gradient(180deg, #1E5F89 0%, #194F72 100%);
  border-radius: 3px;
  color: #fff;
  padding: 0 7px;
  margin: 3px 7px 4px 5px;
}

.open-tv-wrap:before {
  content: '';
  vertical-align: middle;
  margin-right: 5px;
  background-position: -396px -2453px;
  height: 15px;
  width: 18px;
}

.displayIB,
.fancy-head h4 span,
.sportsbook-head h4 span,
.bookmaker h4 span,
.fancy-head .tc-content h5 span,
.tc-content .fancy-head h5 span,
.sportsbook-head .tc-content h5 span,
.tc-content .sportsbook-head h5 span,
.bookmaker .tc-content h5 span,
.tc-content .bookmaker h5 span,
.saddle_1:before,
.saddle_1A:before,
.saddle_1B:before,
.saddle_1C:before,
.saddle_1D:before,
.saddle_1X:before,
.saddle_1Y:before,
.saddle_2:before,
.saddle_2B:before,
.saddle_2C:before,
.saddle_2X:before,
.saddle_3:before,
.saddle_3C:before,
.saddle_3D:before,
.saddle_3E:before,
.saddle_3X:before,
.saddle_4:before,
.saddle_4D:before,
.saddle_4X:before,
.saddle_5:before,
.saddle_6:before,
.saddle_7:before,
.saddle_8:before,
.saddle_9:before,
.saddle_10:before,
.saddle_11:before,
.saddle_11F:before,
.saddle_12:before,
.saddle_12F:before,
.saddle_13:before,
.saddle_13F:before,
.saddle_14:before,
.saddle_14F:before,
.saddle_15:before,
.saddle_15F:before,
.saddle_16:before,
.saddle_16F:before,
.saddle_17:before,
.saddle_17F:before,
.saddle_18:before,
.saddle_18F:before,
.saddle_19:before,
.saddle_19F:before,
.saddle_20:before,
.saddle_20F:before,
.saddle_21:before,
.saddle_21F:before,
.saddle_22:before,
.saddle_22F:before,
.saddle_23:before,
.saddle_23F:before,
.saddle_24:before,
.saddle_24F:before,
.saddle_25:before,
.saddle_25F:before,
.saddle_26:before,
.saddle_26F:before,
.saddle_27:before,
.saddle_27F:before,
.saddle_28:before,
.saddle_28F:before,
.saddle_29:before,
.saddle_29F:before,
.saddle_30:before,
.saddle_30F:before,
.mob-inform-link li,
.navbar-content a.menu-drop:after,
.navbar-content a.menu-drop.select:after,
.favor-wrap .sports-side-menu-list a,
.upcome-wrap dt,
.upcome-wrap dd,
.app-link a,
.game-matched dt,
.game-matched dd,
.open-tv-wrap:before,
.one_click-stake li,
.fancy_bet .fancy-quick-tr .progress-bar-txt span,
.sportsbook_bet .fancy-quick-tr .progress-bar-txt span,
.bookmaker_bet .fancy-quick-tr .progress-bar-txt span,
.fancy-th-layout .fancy-tips li:before,
.btn-fancybet_rules,
.btn-sportsbook_rules,
.fancy-info dt,
.fancy-info dd,
.announce-header h1:before,
.announce-footer li {
  display: inline-block;
}

.bets-bookmaker td {
  border-left: none;
}

.slip-back dt .short-amount,
.slip-lay dt .short-amount,
.slip-back dt .full-amount,
.slip-lay dt .full-amount {
  opacity: 1;
  font-weight: 700
}

.slip-back dt .full-amount,
.slip-lay dt .full-amount {
  top: -2px
}

.slip-back dt .slip-type,
.slip-lay dt .slip-type {
  line-height: 22px;
  border-radius: 3px;
  color: #1e1e1e;
  padding: 0 5px;
  margin: 5px 5px 0 0;
  opacity: 1
}

.slip-back dt.slip-inline,
.slip-lay dt.slip-inline {
  line-height: 22px;
  height: 22px;
  padding: 5px 0 5px 5px
}

.slip-back dt.slip-inline .slip-type,
.slip-lay dt.slip-inline .slip-type {
  margin: 0 5px 0 0
}

.slip-back dt.slip-inline .delete,
.slip-lay dt.slip-inline .delete {
  margin-top: -5px
}

.slip-back dt.slip-inline .full-amount,
.slip-lay dt.slip-inline .full-amount {
  top: 7px
}

.slip-back dd,
.slip-lay dd {
  position: relative;
  color: #000;
  padding: 5px 0;
  line-height: 22px
}

.slip-back input,
.slip-lay input,
.slip-back textarea,
.slip-lay textarea {
  margin: 0;
  padding: 0 6px 0 0;
  width: 100%;
  line-height: 22px
}

.slip-back input.disable,
.slip-lay input.disable,
.slip-back textarea.disable,
.slip-lay textarea.disable {
  line-height: 20px
}

.slip-back input:focus,
.slip-lay input:focus,
.slip-back textarea:focus,
.slip-lay textarea:focus {
  line-height: 20px;
  border-width: 1px
}

.slip-back .refer,
.slip-lay .refer,
.slip-back .keep-option,
.slip-lay .keep-option {
  float: none;
  line-height: 16px;
  font-size: 10px;
  color: #000;
  padding: 0 5px
}

.slip-back .refer span,
.slip-lay .refer span,
.slip-back .keep-option span,
.slip-lay .keep-option span {
  margin-right: 10px
}

.slip-back .col-odd,
.slip-lay .col-odd {
  width: 14.12429%
}

.slip-back .col-odd input,
.slip-lay .col-odd input,
.slip-back .col-odd textarea,
.slip-lay .col-odd textarea {
  padding-right: 16px
}

.slip-back .col-stake,
.slip-lay .col-stake {
  width: 15.53672%;
  padding-left: 5px
}

.slip-back .col-profit,
.slip-lay .col-profit {
  width: 21.75141%;
  padding: 5px
}

.slip-back .keep-option,
.slip-lay .keep-option {
  clear: both;
  padding: 2px 5px
}

.slip-back .keep-option input,
.slip-lay .keep-option input,
.slip-back .keep-option textarea,
.slip-lay .keep-option textarea {
  margin-right: 5px
}

.slip-back .keep-option .edit,
.slip-lay .keep-option .edit {
  font-weight: 700;
  margin-right: 0
}

.slip-back .inn_runs,
.slip-lay .inn_runs {
  width: 100%;
  padding: 0
}

.slip-back .inn_runs dt,
.slip-lay .inn_runs dt {
  width: auto;
  font-weight: 400;
  line-height: 18px;
  color: #000;
  padding-left: 22px
}

.slip-back .inn_runs dd,
.slip-lay .inn_runs dd {
  width: auto;
  float: none;
  line-height: 18px;
  padding: 0 5px 0 0
}

.slip-back .col-stake_list,
.slip-lay .col-stake_list {
  width: 100%
}

.slip-back .col-stake_list ul,
.slip-lay .col-stake_list ul {
  padding-left: 5px
}

.slip-back .col-stake_list li,
.slip-lay .col-stake_list li {
  width: calc(100% / 6)
}

.slip-back .col-stake_list a,
.slip-lay .col-stake_list a {
  font-size: 11px;
  line-height: 18px;
  font-weight: 400;
  margin: 0 5px 0 0
}

.slip-back .col-stake_list:not(:target),
.slip-lay .col-stake_list:not(:target) {
  display: none
}

.slip-back .col-stake_list:target,
.slip-lay .col-stake_list:target {
  display: block
}


.btn-live,
.btn-book {
  width: 38px;
  height: 27px;
  line-height: 27px;
  background-color: #ffcc51;
  border: 1px solid #cf9a47;
  border-radius: 5px;
  color: #1e1e1e
}

.account-wrap ul,
.more_drop-list,
.selection-list {
  position: absolute;
  background-color: #fff;
  border-radius: 4px;
  z-index: 99
}

.account-wrap ul li,
.more_drop-list li,
.selection-list li {
  list-style: none
}

.account-wrap ul a,
.more_drop-list a,
.selection-list a {
  padding: 0 10px;
  border-bottom: 1px solid #e0e6e6
}

.account-wrap ul a:hover,
.more_drop-list a:hover,
.selection-list a:hover {
  text-decoration: none;
  background-color: #eff2f2
}

.game-head .game-low_liq,
.game-head .game-fancy,
.game-head .game-sportsbook,
.head-bets-agent .game-low_liq,
.head-bets-agent .game-fancy,
.head-bets-agent .game-sportsbook {
  padding: 7px 5px;
  margin-right: 0;
  border-radius: 0
}

.fancy-suspend,
.fancy-suspend-white {
  position: absolute;
  width: 100%;
  background-color: rgba(36, 58, 72, .4);
  z-index: 5
}

.fancy-suspend span,
.fancy-suspend-white span {
  opacity: .8;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, .5)
}

.fancy-suspend:hover,
.fancy-suspend-white:hover {
  background-color: rgba(36, 58, 72, .55)
}

.fancy-suspend:hover span,
.fancy-suspend-white:hover span {
  opacity: 1
}

.power-content {
  background: rgba(255, 255, 255, .25);
  border-radius: 8px;
  padding: 5px 10px 7px;
  color: rgba(0, 0, 0, .6);
  margin-bottom: 30px
}

.power-content h3 span {
  font-size: 10px;
  font-weight: 400
}

.power-content h3 img {
  background-position: 0 -314px;
  height: 18px;
  width: 107px
}

.power-content p {
  font-size: 11px;
  line-height: 14px;
  border-left: 1px solid rgba(0, 0, 0, .3);
  padding-left: 10px;
  margin: 3px 0 0 117px
}

.power-content a {
  color: rgba(0, 0, 0, .6);
  text-decoration: underline
}

.power-content-b {
  width: 107px;
  background: rgba(0, 0, 0, .25);
  border: 1px solid rgba(255, 255, 255, .4);
  border-radius: 8px;
  color: rgba(255, 255, 255, .4);
  padding: 5px 10px 7px;
  margin: 0 auto 20px
}

.power-content-b span {
  font-size: 10px;
  font-weight: 400
}

.power-content-b img {
  background-position: 0 -296px;
  height: 18px;
  width: 107px
}

.browser-footer-content {
  font-size: 11px;
  color: rgba(255, 255, 255, .6)
}

.browser-footer-content img {
  margin-bottom: 5px
}

.saddle_1,
.saddle_1A,
.saddle_1B,
.saddle_1C,
.saddle_1D,
.saddle_1X,
.saddle_1Y,
.saddle_2,
.saddle_2B,
.saddle_2C,
.saddle_2X,
.saddle_3,
.saddle_3C,
.saddle_3D,
.saddle_3E,
.saddle_3X,
.saddle_4,
.saddle_4D,
.saddle_4X,
.saddle_5,
.saddle_6,
.saddle_7,
.saddle_8,
.saddle_9,
.saddle_10,
.saddle_11,
.saddle_11F,
.saddle_12,
.saddle_12F,
.saddle_13,
.saddle_13F,
.saddle_14,
.saddle_14F,
.saddle_15,
.saddle_15F,
.saddle_16,
.saddle_16F,
.saddle_17,
.saddle_17F,
.saddle_18,
.saddle_18F,
.saddle_19,
.saddle_19F,
.saddle_20,
.saddle_20F,
.saddle_21,
.saddle_21F,
.saddle_22,
.saddle_22F,
.saddle_23,
.saddle_23F,
.saddle_24,
.saddle_24F,
.saddle_25,
.saddle_25F,
.saddle_26,
.saddle_26F,
.saddle_27,
.saddle_27F,
.saddle_28,
.saddle_28F,
.saddle_29,
.saddle_29F,
.saddle_30,
.saddle_30F {
  line-height: 19px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 3px;
  border: 1px solid transparent;
  background-image: none;
  box-sizing: border-box
}

.saddle_1:before,
.saddle_1A:before,
.saddle_1B:before,
.saddle_1C:before,
.saddle_1D:before,
.saddle_1X:before,
.saddle_1Y:before,
.saddle_2:before,
.saddle_2B:before,
.saddle_2C:before,
.saddle_2X:before,
.saddle_3:before,
.saddle_3C:before,
.saddle_3D:before,
.saddle_3E:before,
.saddle_3X:before,
.saddle_4:before,
.saddle_4D:before,
.saddle_4X:before,
.saddle_5:before,
.saddle_6:before,
.saddle_7:before,
.saddle_8:before,
.saddle_9:before,
.saddle_10:before,
.saddle_11:before,
.saddle_11F:before,
.saddle_12:before,
.saddle_12F:before,
.saddle_13:before,
.saddle_13F:before,
.saddle_14:before,
.saddle_14F:before,
.saddle_15:before,
.saddle_15F:before,
.saddle_16:before,
.saddle_16F:before,
.saddle_17:before,
.saddle_17F:before,
.saddle_18:before,
.saddle_18F:before,
.saddle_19:before,
.saddle_19F:before,
.saddle_20:before,
.saddle_20F:before,
.saddle_21:before,
.saddle_21F:before,
.saddle_22:before,
.saddle_22F:before,
.saddle_23:before,
.saddle_23F:before,
.saddle_24:before,
.saddle_24F:before,
.saddle_25:before,
.saddle_25F:before,
.saddle_26:before,
.saddle_26F:before,
.saddle_27:before,
.saddle_27F:before,
.saddle_28:before,
.saddle_28F:before,
.saddle_29:before,
.saddle_29F:before,
.saddle_30:before,
.saddle_30F:before {
  vertical-align: middle
}

.login-clientform .btn-login,
.betsbuzz365 .login-clientform .btn-signup {
  width: 80px;
  height: 25px;
  line-height: 25px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  border-radius: 4px
}

.login-clientform .btn-login:hover,
.betsbuzz365 .login-clientform .btn-signup:hover {
  text-decoration: none
}

.login-box-content .valid-code img {
  position: absolute;
  width: 70px;
  height: 19px;
  right: 5px;
  top: 7px
}

.login-box-content .error {
  color: #d0021b;
  font-size: 13px;
  line-height: 16px
}

.icon-login {
  background-position: 0 -196px;
  height: 12px;
  width: 12px
}

.mob-inform-link,
.RnR-link {
  display: none;
  /* width: 390px; */
  padding-top: 8px;
  margin: 8px auto 0;
  border-top: 1px solid rgba(0, 0, 0, .3);
  text-align: center
}

.mob-inform-link a,
.RnR-link a {
  color: rgba(0, 0, 0, .6);
  text-decoration: underline
}

.mob-inform-link li:after,
.RnR-link li:after,
.mob-inform-link li:first-child:before,
.RnR-link li:first-child:before {
  margin: 0 6px;
  content: "-"
}

.RnR-link {
  display: block
}

.header {
  height: 54px;
  padding-top: 20px
}

.header.main-content {
  width: 100%;
  min-height: inherit;
  height: 54px
}

.header h1 {
  margin: -2px 15px 0 0
}

.header a {
  height: 100%
}

.login-clientform li {
  margin: 0 5px 2px 0
}

.login-clientform li.user {
  padding-left: 22px;
  background-position: -96px -2399px
}

.login-clientform li.re_pass {
  width: 140px;
  padding-left: 22px;
  clear: both
}

.login-clientform li.re_pass input,
.login-clientform li.re_pass textarea {
  width: auto;
  margin-right: 5px
}

.login-clientform li.other_link,
.login-clientform li.re_pass {
  font-size: 11px
}

.login-clientform input,
.login-clientform textarea {
  width: 130px;
  height: 25px;
  margin: 0
}

.login-clientform a {
  color: #1e1e1e;
  text-decoration: underline
}

.login-clientform .btn-login {
  background-color: #e83523;
  background-image: linear-gradient(-180deg, #f72424 0, #bb1c00 100%)
}

.login-clientform .btn-login img {
  width: 10px;
  height: 11px;
  margin: -3px 0 0 7px;
  vertical-align: middle;
  background: url('data:image/svg+xml,<svg width="10" height="11" xmlns="http://www.w3.org/2000/svg"><path d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z" fill="%23FFF" fill-rule="evenodd"/></svg>') no-repeat;
}

.login-clientform .btn-signup {
  display: none
}

.login-clientform .valid-code {
  position: relative
}

.login-clientform .valid-code img {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 55px;
  height: 15px
}

.login-clientform .error {
  clear: both;
  background-color: transparent;
  padding-left: 22px;
  color: #d0021b;
  line-height: 1.1
}

.account-wrap li {
  position: relative;
  line-height: 25px;
  margin-left: 12px;
  margin-top: 4px;
}

.account-wrap a {
  color: #1e1e1e
}

.account-wrap .head-refresh {
  margin-left: 10px
}

.account-wrap .head-refresh a {
  background-position: -80px -975px;
  height: 25px;
  width: 30px
}

.account-wrap .account {
  text-indent: 27px;
  background-position: 0 -450px;
  height: 25px;
  width: 110px
}

.account-wrap .account.select {
  background-position: 0 -475px
}

.account-wrap ul {
  right: 0;
  width: 220px
}

.account-wrap ul:target {
  display: block
}

.account-wrap ul li {
  float: none;
  text-indent: 0;
  margin: 0
}

.account-wrap ul h4,
.account-wrap ul .tc-content h5,
.tc-content .account-wrap ul h5 {
  line-height: 27px;
  color: #000;
  border-bottom: 1px solid #7e97a7;
  padding: 0 0 0 10px
}

.account-wrap ul a {
  color: #1e1e1e
}

.account-wrap ul .logout {
  padding: 7px 10px 5px
}

.account-wrap ul .logout a {
  background-color: #7e97a7;
  border-bottom-width: 0;
  color: #fff;
  font-weight: 700;
  border-radius: 4px
}

.account-wrap ul .logout img {
  vertical-align: middle;
  margin: -1px 0 0 5px;
  background-position: -99px -2074px;
  height: 25px;
  width: 11px
}

.language {
  width: 29px;
  height: 11px;
  padding: 7px;
  background-position: -67px -525px
}

.flag {
  width: 17px;
  height: 11px
}

.flag.UK {
  background-position: 0 0
}

.betsbuzz365 .navbar-content {
  background-image: linear-gradient(90deg, #d0021b 0%, #ffea21 100%, #ff9e2c);
  box-shadow: inset 0 1px 0 0 rgb(255 255 255 / 75%);

}

.navbar-content {
  min-width: 1349px;
  background-image: linear-gradient(180deg, #FFCC2F 8%, #000 100%);
  line-height: 30px
}

.navbar-content a {
  color: #fff;
  padding: 0 10px
}

.navbar-content a.menu-drop {
  padding-right: 25px;
  background-position: 100% -2847px
}

.navbar-content a.one_click {
  padding: 0 12px 0 37px
}

.navbar-content .main-content {
  min-height: 30px;
  height: auto
}

.menu,
.setting-tab {
  font-weight: 700
}

.menu li,
.setting-tab li {
  border-right: 1px solid #383838
}

.menu li ul,
.setting-tab li ul {
  display: none;
  position: absolute;
  background-color: #1e1e1e;
  border-top: 1px solid #383838;
  z-index: 99
}

.menu li li,
.setting-tab li li {
  float: none;
  border-bottom: 1px solid #383838
}

.menu a:hover,
.setting-tab a:hover {
  background-color: #383838;
  text-decoration: none
}

.menu .select,
.setting-tab .select {
  background-color: #4d4d4d
}

.setting-tab {
  font-weight: 700
}

.setting-tab li {
  border-right-width: 0
}

.live-menu {
  border-left: 1px solid #383838
}

.live-menu img {
  margin: 6px 7px 0 0;
  vertical-align: top;
  background-position: -89px -1956px;
  height: 18px;
  width: 21px
}

.setting {
  border-left: 1px solid #383838
}

.setting img {
  margin-left: 5px;
  vertical-align: top;
  background-position: -97px -2658px;
  height: 30px;
  width: 13px
}

.one_click {
  border-top: 3px solid #6bbd11;
  margin-top: -3px;
  background-repeat: repeat-x;
  padding: 0 12px 0 7px;
  background-position: 0 -1560px
}

.one_click:hover,
.one_click.bg-1click-hover {
  background-position: 0 -690px
}

/* 
.one_click img {
  margin-right: 5px;
  vertical-align: top;
  background-position: -94px -1870px;
  height: 30px;
  width: 16px
} */

.one_click.select {
  background-repeat: repeat-x;
  background-position: 0 -1170px
}

.one_click.select:hover,
.one_click.select.bg-1click-select-hover {
  background-position: 0 -1140px
}

.one_click.select img {
  background-position: -94px -1720px
}

.slip_set-pop,
.oneclick_set-pop {
  position: absolute;
  top: 30px;
  right: 0;
  width: 282px;
  z-index: 99;
  border-radius: 0 0 4px 4px
}

.slip_set-pop .slip_set,
.oneclick_set-pop .slip_set {
  z-index: 1;
  background-position: -51px -544px;
  height: 25px;
  width: 29px
}

.slip_set-pop:target,
.oneclick_set-pop:target {
  display: block
}

.set-content {
  *height: auto !important;
  *height: 100px;
  min-height: 100px;
  background-color: #e0e6e6;
  font-size: 11px;
  color: #000;
  padding: 10px;
  border-radius: 0 0 4px 4px
}

.disable .sport-odds a:before,
.disable .last-col a:before,
.disable .col-draw a:before,
.disable.sport-odds a:before,
.disable.last-col a:before,
.disable.col-draw a:before {
  content: '';
  position: absolute;
  top: 0;
  background: rgba(51, 51, 51, 0.2) url(../images/sprite/bg-disabled.png);
  width: 100%;
  height: 100%;
}

.displayB,
.delete,
.btn,
.btn-send,
.marquee-pop .pages a,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea,
.slip-back .col-stake_list ul,
.slip-lay .col-stake_list ul,
.slip-book .col-stake_list ul,
.login-clientform,
.account-wrap,
.menu,
.setting-tab,
.sports-header,
.matched-head,
.stake-popup,
.btn-wrap,
.slip-option,
.cashout-wrap,
.slider,
.tab-highlight,
.tab-markets,
.game-wrap-horse .hs-time,
.game-scores .scores-time,
.game-scores ul,
.tab-HS,
.game-info,
.marquee-pop .input-list,
.marquee-pop .filter-list,
.tab,
.input-list,
.filter-list,
.filter-pop ul,
.acc-info,
.total-show,
.slip-back .col-stake_list ul li,
.slip-lay .col-stake_list ul li,
.slip-book .col-stake_list ul li,
.login-clientform li,
.account-wrap li,
.menu li,
.setting-tab li,
.sports-header li,
.matched-head li,
.stake-popup li,
.btn-wrap li,
.slip-option li,
.cashout-wrap li,
.slider li,
.tab-highlight li,
.tab-markets li,
.game-wrap-horse .hs-time li,
.game-scores .scores-time li,
.game-scores ul li,
.tab-HS li,
.game-info li,
.marquee-pop .input-list li,
.marquee-pop .filter-list li,
.tab li,
.input-list li,
.filter-list li,
.filter-pop ul li,
.acc-info li,
.total-show li,
.btn_rules:after,
.mob-live-number strong:before,
.game-head .ico_rules:before,
.age_box li .secondary:before,
.age_box li .btn-send:before,
.slipbar-content h3 a,
.matched-wrap h3 a,
.live-wrap h3 a,
.tv-wrap h3 a,
.game-wrap h3 a,
.highlight-edge-content h3 a,
.game-wrap-horse h3 a,
.favor-wrap h3 a,
.sub_path h3 a,
.slip-back dt:hover .full-amount,
.slip-lay dt:hover .full-amount,
.slip-book dt:hover .full-amount,
.slip-back dd:hover .full-amount,
.slip-lay dd:hover .full-amount,
.slip-book dd:hover .full-amount,
.slip-back .col-stake_list:target,
.slip-lay .col-stake_list:target,
.slip-book .col-stake_list:target,
.btn-live,
.btn-book,
.account-wrap ul a,
.more_drop-list a,
.selection-list a,
.multi-event_type,
.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after,
.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before,
.fancy-head .in-play span:before,
.sportsbook-head .in-play span:before,
.bookmaker .in-play span:before,
.fancy-suspend span,
.fancy-suspend-white span,
.power-content h3 img,
.power-content-b img,
.login-clientform .btn-login,
.login-clientform .btn-signup,
.header a,
.account-wrap li .refresh-bar,
.language,
.flag,
.navbar-content a,
.menu li:hover ul,
.setting-tab li:hover ul,
.sports-side-menu-list a,
.sports-side-menu-list .Go,
.favor-set,
.path .path-back,
.sports-path-popup a,
.short-amount,
.odd-add a,
.stake-popup a,
.slider-bar span,
.slider-bar a,
.live:before,
.load-pending strong,
.favor,
.images-grid a,
.promo-banner-wrap a,
.tab-highlight a,
.tab-markets a,
.event-left .sports-header span,
.event-right .sports-header span,
.event-left .matched-head span,
.event-right .matched-head span,
.app-link,
.live-list a,
.live-list a:after,
.change-channel::before,
.marquee-box h4:before,
.marquee-box .tc-content h5:before,
.tc-content .marquee-box h5:before,
.marquee-box h4:after,
.marquee-box .tc-content h5:after,
.tc-content .marquee-box h5:after,
.marquee-box .marquee a span,
.game-E i:before,
.game-E i:after,
.sportsgame-list-content dd a,
.sportsgame-list-content dd a span,
.sportsgame-list-content dd .info,
.game-head a,
.game-team .game-visit span,
.game-scores .game-visit span,
.game-team .game-home span,
.game-scores .game-home span,
.game-team .game-vs span,
.game-scores .game-vs span,
.game-scores ul .scores-box span,
.game-progress:after,
.sum-status,
.score-pop:before,
.score-pop-last:before,
.tab-HS a,
.tv-control a:before,
.fm-bets td a,
.bets-HS td a,
.bets-GH td a,
.fm-bets td span,
.bets-HS td span,
.bets-GH td span,
.disable .sport-odds a:before,
.disable .last-col a:before,
.disable .col-draw a:before,
.disable.sport-odds a:before,
.disable.last-col a:before,
.disable.col-draw a:before,
.horse-info>dd:hover .horse_info-hover,
.dog-info>dd:hover .horse_info-hover,
.to-win:before,
.to-lose:before,
.more,
.suspend span,
.fm-bets .suspend span,
.bets-HS .suspend span,
.bets-GH .suspend span,
.line_markets-team .game-vs div:before,
.line_markets-team .game-vs div:after,
.rules-wrap:target,
.line_market-name span,
.quick_bet-wrap .btn span,
.quick_bet-wrap .btn-send span,
.quick_bet-wrap .pages a span,
.pages .quick_bet-wrap a span,
.quick_bet-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .quick_bet-wrap input span,
.quick_bet-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .quick_bet-wrap textarea span,
.gametab-head h4:after,
.gametab-head .tc-content h5:after,
.tc-content .gametab-head h5:after,
.gametab-head h4:before,
.gametab-head .tc-content h5:before,
.tc-content .gametab-head h5:before,
.other-tab:before,
.other-tab:after,
.fancy-info dt span,
td .fancy-info dt,
.special_bets-tab a,
.special_bets-tab .more_drop>a:before,
.announce-footer .confirm-checkbox,
.close_pop,
.error-text,
.go-back,
.pop-close,
.tab a,
.expand-close,
.expand-open,
.selection,
.initial-balance dt span,
.final-balance dt span,
.casinozone-wrap-simple a:after,
.live_events .live_icon span:before,
.casino-title dd:after {
  display: block;
}

.disable .sport-odds a,
.disable .last-col a,
.disable .col-draw a,
.disable.sport-odds a,
.disable.last-col a,
.disable.col-draw a {
  position: relative;
  cursor: not-allowed;
}

.set-content input,
.set-content textarea {

  line-height: 20px;
  padding: 0 5px;
  margin: 0 5px 0 0
}

.set-content a {
  color: #1e1e1e;
  padding: 0
}

.set-content .btn,
.set-content .btn-send,
.set-content .pages a,
.pages .set-content a,
.set-content .calendarTable_inputBox input,
.calendarTable_inputBox .set-content input,
.set-content .calendarTable_inputBox textarea,
.calendarTable_inputBox .set-content textarea {
  line-height: 18px;
  font-weight: 400;
  font-size: 11px;
  margin: 0
}

.set-content .btn-wrap {
  margin-bottom: 0
}

.set-content .btn-wrap .btn,
.set-content .btn-wrap .btn-send,
.set-content .btn-wrap .pages a,
.pages .set-content .btn-wrap a,
.set-content .btn-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .set-content .btn-wrap input,
.set-content .btn-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .set-content .btn-wrap textarea {
  font-weight: 700;
  line-height: 23px
}

.stake-set,
.odds-set {
  position: relative;
  border-bottom: 1px solid #7e97a7;
  box-shadow: 0 1px 0 rgba(255, 255, 255, .8);
  line-height: 15px;
  padding-bottom: 2px;
  margin-bottom: 5px
}

.stake-set dt,
.odds-set dt {
  margin-bottom: 5px;
  font-weight: 700
}

.stake-set dd,
.odds-set dd {
  width: 50px;
  margin: 0 5px 5px 0
}

.stake-set dd.col-defult,
.odds-set dd.col-defult {
  width: 100%
}

.stake-set dd.col-edit,
.odds-set dd.col-edit {
  position: absolute;
  top: 20px;
  right: 0;
  width: 42px;
  margin-right: 0
}

.stake-set .stake-input,
.odds-set .stake-input {
  width: 29.16667%;
  font-size: 11px;
  margin-left: 5px
}

.stake-set .stake_edit-input,
.odds-set .stake_edit-input {
  height: 20px;
  width: 50px;
  font-size: 11px;
  margin-left: 0
}

.col-edit a {
  height: 43px;
  line-height: 43px;
  border-radius: 4px
}

.col-edit img {
  background-position: -101px -6221px;
  height: 9px;
  width: 9px
}

.col-edit .btn-edit {
  border: 1px solid #7e97a7;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, .8);
  color: #000
}

.col-edit .btn-edit:hover {
  text-decoration: underline
}

.col-edit .btn-send {
  line-height: 43px
}

.odds-set dd {
  width: 100%
}

.oneclick_set-pop {
  right: 96px
}

.time_zone {
  color: #fff;
  margin: 0;
  padding: 0 12px
}

.time_zone span {
  color: rgba(255, 255, 255, .6);
  font-weight: 400
}

.gmt {
  font-size: 11px;
  border-left: 1px solid #c5d0d7;
  padding: 0 5px
}

.promote-wrap {
  position: absolute;
  width: 260px;
  height: 64px;
  left: calc(50% - 260px / 2);
  top: 5px
}

.promote-wrap img {
  width: 260px;
  height: 64px
}

.sports-side-menu-list li {
  border-bottom: 1px solid #e0e6e6;
  list-style: none
}

.sports-side-menu-list a {
  line-height: 25px;
  padding: 0 10px
}

.sports-side-menu-list a:hover {
  background-color: #eff2f2;
  text-decoration: none
}

.sports-side-menu-list .select {
  background-color: #f2dca7;
  color: #1e1e1e
}

.sports-side-menu-list .select:hover {
  background-color: #f2dca7
}

.sports-side-menu-list .Go {
  padding: 0 0 0 8px;
  background-position: 100% -600px;
  height: 25px;
  width: 23px
}

.sports-side-menu-list .Go:hover,
.sports-side-menu-list .Go.Go-hover {
  background-position: 100% -625px
}

.star {
  width: 12px;
  height: 11px;
  margin: 4px 5px 0 0;
  background-position: -16px -1811px
}

.star:hover,
.star.star-hover {
  background-position: -16px -1786px
}

.favor-wrap {
  height: 180px
}

.favor-wrap h3 .star {
  background-position: -24px -1775px
}

.favor-wrap .sports-side-menu-list {
  height: calc(100% - 25px);
  overflow: hidden;
  overflow-y: auto
}

.favor-wrap .sports-side-menu-list a {
  width: calc(100% - 38px);
  height: 25px;
  vertical-align: middle;
  padding: 0 10px 0 2px
}

.favor-wrap .sports-side-menu-list a.btn-star {
  padding: 0 0 0 6px;
  background-position: 100% -1811px;
  height: 25px;
  width: 20px
}

.favor-wrap .sports-side-menu-list a.btn-star:hover,
.favor-wrap .sports-side-menu-list a.btn-star.star-hover {
  background-position: 100% -1786px
}

.favor-wrap .sports-side-menu-list a.btn-star:hover {
  background-color: transparent
}

.favor-set {
  line-height: 25px;
  border-bottom-width: 0;
  padding-right: 23px;
  background-position: 100% -775px
}

.sub_path {
  position: relative
}

.main-content .sub_path .sports-side-menu-list {
  height: calc(100% - 25px);
  overflow: hidden;
  overflow-y: auto;
  background: #fff
}

.path {
  position: relative;
  height: 25px;
  color: #fff;
  font-size: 12px;
  line-height: 25px;
  overflow: hidden;
  background-repeat: repeat-x;
  background-position: 0 -2507px;
  padding: 0 10px;
}

.path ul {
  position: absolute;
  right: 0;
  width: 9999px
}

.path li {
  display: inline;
  padding: 4px 13px 5px 6px;
  background-position: 100% -675px
}

.path a {
  display: inline;
  color: #fff
}

.path .path-last {
  background-image: none;
  padding-right: 6px
}

.path .path-back {
  position: absolute;
  left: 0;
  z-index: 2;
  background-position: 0 -1700px;
  height: 25px;
  width: 36px
}

.path .path-back:hover,
.path .path-back.path-back-hover {
  background-position: 0 -1750px
}

.path .path-back:active,
.path .path-back.path-back-active {
  background-position: 0 -1725px
}

.path .path-back.select {
  background-position: 0 -1750px;
  height: 25px;
  width: 36px
}

.sports-path-popup {
  display: none;
  position: absolute;
  top: 25px;
  left: 0;
  max-width: 100%;
  background-color: #000;
  padding: 5px 0;
  z-index: 5
}

.sports-path-popup li {
  list-style: none;
  white-space: nowrap
}

.sports-path-popup a {
  color: #fff;
  padding: 5px 10px 5px 15px;
  background-position: -21px -925px
}

.sports-path-popup:not(:target) {
  display: none
}

.sports-path-popup:target {
  display: block
}

.to-go {
  margin-bottom: 1px;
  background-position: 100% -750px
}

.slipbar-content {
  position: relative
}

.slipbar-content p {
  font-size: 13px;
  padding: 15px 5px 2px
}

.slipbar-content .slip_set {
  background-position: -51px -569px;
  height: 25px;
  width: 29px
}

.main-content .slipbar-content.close {
  height: 25px;
}

.main-content .slipbar-content {
  height: 300px;
  overflow: hidden;
}

.lay-gradient .select a,
.lay-gradient .select a:hover {
  color: #fff;
  background: #F4496D;
  border: 1px solid #FFFFFF;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
}


.main-content .slipbar-content.close {
  height: 25px
}

.main-content .slipbar-content .bet_slip {
  height: calc(100% - 25px)
}

.slipbar-content.full-bet_slip {
  height: calc(100% - 26px)
}

/* .slipbar-content.no-open-bet_slip {
  height: calc(100% - 0)
} */

.message-bet {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #c5d0d7
}

.message-bet h4,
.message-bet .tc-content h5,
.tc-content .message-bet h5 {
  font-weight: 400;
  line-height: 24px;
  padding: 0 5px
}

.message-bet p {
  color: #000;
  font-size: 11px;
  line-height: 25px;
  padding: 0 5px;
  margin-bottom: 0;
  text-align: left
}

.sports-header,
.matched-head {
  background-color: #ced5da;
  padding: 0 10px
}

.sports-header li,
.matched-head li {
  padding: 5px 0
}

.sports-header .col-bet,
.matched-head .col-bet {
  width: 43.23529%
}

.sports-header .col-odd,
.matched-head .col-odd {
  width: 14.70588%
}

.sports-header .col-stake,
.matched-head .col-stake {
  width: 16.17647%;
  padding-left: 5px
}

.sports-header .col-profit,
.matched-head .col-profit {
  width: 24.11765%
}

.matched-head {
  background-color: #fff
}

.slip-list {
  font-size: 11px
}

.slip-list h4,
.slip-list .tc-content h5,
.tc-content .slip-list h5 {
  font-weight: 400;
  padding: 2px 0 0 5px;
  margin-bottom: 4px
}

.slip-list .btn-wrap {
  padding: 0 5px
}

.main-content .slip-list {
  overflow: hidden;
  overflow-y: auto
}

.slip-list.unmatched-slip {
  max-height: 160px
}

.slip-list.full-unmatched {
  height: calc(100% - 83px)
}

.full-amount {
  display: none;
  width: auto !important;
  top: 7px;
  right: 0
}

.full_btn {
  border-top: 1px solid #e0e6e6
}

.full_btn .btn-wrap {
  margin-bottom: 0;
  padding: 0 5px 7px
}

.slip-back {
  background-color: #beddf4;
  border-bottom: 1px solid #67afe5
}


.slip-back .slip-type {
  background-color: #7dbbe9
}

.slip-back .refer,
.slip-back .keep-option {
  background-color: #d4e8f8
}

.slip-back .keep-option {
  border-top: 1px solid #7dbbe9
}

.slip-back .col-stake_list {
  border-top: 1px solid #7dbbe9;
  background-color: #d4e8f8
}

.slip-lay {
  background-color: #f3dce2;
  border-bottom: 1px solid #dfa3b3
}

.slip-lay .slip-type {
  background-color: #dfa3b3
}

.slip-lay .refer,
.slip-lay .keep-option {
  background-color: #f7e7eb
}

.slip-lay .keep-option {
  border-top: 1px solid #dfa3b3
}

.slip-lay .col-stake_list {
  border-top: 1px solid #dfa3b3;
  background-color: #faeff2
}

.odd-add {
  position: absolute;
  top: 7px;
  right: 2px;
  height: 19px;
  z-index: 2
}

.odd-add li {
  list-style: none
}

.odd-add .up {
  line-height: 10px;
  background-position: -68px -414px;
  height: 10px;
  width: 12px
}

.odd-add .up:hover,
.odd-add .up.num_up-hover {
  background-position: -68px -434px
}

.odd-add .down {
  line-height: 9px;
  background-position: -68px -387px;
  height: 9px;
  width: 12px
}

.odd-add .down:hover,
.odd-add .down.num_down-hover {
  background-position: -68px -405px
}

.odd-add.disable a {
  cursor: default
}

.odd-add.disable .up {
  background-position: -68px -424px;
  height: 10px;
  width: 12px
}

.odd-add.disable .down {
  background-position: -68px -396px;
  height: 9px;
  width: 12px
}

.tips-popup,
.full-amount {
  position: absolute;
  width: 45px;
  background-color: #f8e71c;
  line-height: 13px;
  color: #1e1e1e;
  border-radius: 4px;
  padding: 3px 5px;
  z-index: 50
}

.stake-popup {
  display: none;
  position: absolute;
  width: 93px;
  background-color: #000;
  border-radius: 0 5px 5px 5px;
  padding: 2px 0 1px 2px;
  z-index: 50
}

.stake-popup li {
  width: 45px;
  margin: 0 1px 1px 0
}

.stake-popup li:first-of-type a {
  border-radius: 4px 0 0 0
}

.stake-popup li:nth-of-type(2) a {
  border-radius: 0 4px 0 0
}

.stake-popup li:last-of-type a {
  border-radius: 0 0 4px 0
}

.stake-popup li:nth-last-of-type(2) a {
  border-radius: 0 0 0 4px
}

.stake-popup a {
  color: #000;
  line-height: 22px;
  background: #eee url(../images/sprite/bg-btn.gif) repeat-x
}

.stake-popup a:hover {
  text-decoration: none;
  background: #eee url('../images/sprite/bg-btn_hover.gif') repeat-x
}

.stake-popup:not(:target) {
  display: none
}

.stake-popup:target {
  display: block
}

.sum {
  margin: 5px
}

.sum dt {
  color: #777
}

.sum dd {
  color: #000;
  padding-left: 5px
}

.btn-wrap {
  margin-bottom: 7px
}

.btn-wrap li {
  width: 50%
}



.game-head .game-low_liq {
  padding: 7px 5px !important;
}

.btn-wrap .btn,
.btn-wrap .btn-send,
.btn-wrap .pages a,
.pages .btn-wrap a,
.btn-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .btn-wrap input,
.btn-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .btn-wrap textarea {
  width: 80%;
  margin: 0
}

.btn-wrap .btn-send {
  width: 95%
}

.btn-wrap .edit-function .btn,
.btn-wrap .edit-function .btn-send,
.btn-wrap .edit-function .pages a,
.pages .btn-wrap .edit-function a,
.btn-wrap .edit-function .calendarTable_inputBox input,
.calendarTable_inputBox .btn-wrap .edit-function input,
.btn-wrap .edit-function .calendarTable_inputBox textarea,
.calendarTable_inputBox .btn-wrap .edit-function textarea {
  width: 35%
}

.btn-wrap .edit-function .btn-send {
  width: 55%;
  margin-left: 5px
}

.slip-option {
  border-top: 1px solid #e0e6e6;
  padding: 2px 5px
}

.full_btn .slip-option:first-child {
  border-top-width: 0
}

.slip-option input,
.slip-option textarea {
  margin-bottom: 0;
  padding: 0;
  box-shadow: none
}

.slip-option li {
  list-style: none;
  padding: 3px 0 0;
  margin-right: 10px
}

.matched-wrap h3 {
  padding-left: 0;

}

.matched-wrap p {
  padding: 9px 5px;

}

.slip_refresh {
  background-position: -51px -519px;
  height: 25px;
  width: 29px
}

.slip-sort {
  padding: 5px
}

.slip-sort select {
  width: 100%;
  margin: 0
}

.cashout-wrap {
  margin: 5px 0 0;
  color: #000;
  padding-bottom: 7px;
  border-bottom: 1px solid #7e97a7
}

.cashout-wrap .col-cashout {
  width: 43.78531%;
  padding-right: 3px
}

.cashout-wrap .col-profit {
  width: 54.51977%;
  border: 1px solid #cb8009;
  border-radius: 4px
}

.cashout-wrap .btn,
.cashout-wrap .btn-send,
.cashout-wrap .pages a,
.pages .cashout-wrap a,
.cashout-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .cashout-wrap input,
.cashout-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .cashout-wrap textarea {
  margin: 0;
  line-height: 31px
}

.cashout-wrap .btn span,
.cashout-wrap .btn-send span,
.cashout-wrap .pages a span,
.pages .cashout-wrap a span,
.cashout-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .cashout-wrap input span,
.cashout-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .cashout-wrap textarea span {
  font-weight: 400;
  margin-left: 7px
}

.cashout-wrap dl dt {
  font-size: 10px;
  padding: 0 5px
}

.cashout-wrap dl dd {
  padding: 0 5px
}

.slider {
  width: 56.99482%;
  line-height: 31px;
  border-right: 1px solid #cb8009;
  padding-left: 5px
}

.slider li {
  font-size: 10px;
  padding-right: 5px
}

.slider .col-slider {
  width: 50%
}

.slider-bar {
  position: relative;
  height: 8px;
  border-radius: 4px;
  margin: 12px 0 0;
  cursor: pointer;
  background-repeat: repeat-x;
  background-position: 0 -3821px
}

.slider-bar span {
  height: 6px;
  border-radius: 4px;
  border: 1px solid #cb8009;
  background-repeat: repeat-x;
  background-position: 0 -3853px
}

.live-wrap h3,
.tv-wrap h3 {
  padding-left: 0
}

.live-wrap h3 img,
.tv-wrap h3 img {
  margin-top: 7px
}

.live {
  position: relative;
  height: 200px;
  background-color: #000
}

.live:before {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -35px;
  margin-left: -40px;
  content: '';
  background-position: 0 -274px;
  height: 69px;
  width: 80px
}

.tv_popup {
  background-position: -51px -594px;
  height: 25px;
  width: 29px
}

.icon-TV {
  margin-right: 5px;
  vertical-align: top;
  background-position: -66px -343px;
  height: 12px;
  width: 14px
}

.tv-wrap h3 {
  padding-left: 10px
}

.tv-wrap .live {
  height: calc(100% - 25px)
}

.one_click-loading {
  position: relative;
  height: 70px;
  border-bottom: 1px solid #7e97a7;
  overflow: hidden;
  box-shadow: 0 2px 0 rgba(0, 0, 0, .1)
}

.one_click-loading .loading {
  padding: 15px 0
}

.load-pending {
  position: absolute;
  top: 50%;
  width: auto;
  padding: 3px 7px;
  background-color: #d0021b;
  color: #fff;
  font-size: 11px;
  border-radius: 0 4px 4px 0;
  margin-top: -18px;
  animation: leftIn .6s ease
}

.load-pending strong {
  font-size: 14px
}

@keyframes leftIn {
  0% {
    opacity: 0;
    left: -70px
  }

  100% {
    opacity: 1;
    left: 0
  }
}

.favor {
  margin-right: 5px;
  background-position: -396px -1982px;
  height: 19px;
  width: 18px
}

.favor.select {
  background-position: -396px -1963px
}

.images-grid {
  margin-bottom: 12px
}

.marquee-wrap {
  display: none;
  position: relative;
  overflow: hidden;
  height: 25px;
  padding-left: 32px;
  margin-bottom: 1px;
  background: #333
}

.marquee-wrap:before {
  content: '';
  position: absolute;
  left: 0;
  background-position: -382px -1871px;
  height: 26px;
  width: 32px
}

.agent .marquee-wrap,
.report .marquee-wrap {
  margin-top: 6px;
  background: #fff;
  border-top: 1px solid #7e97a7;
  border-bottom: 1px solid #7e97a7
}

.agent .marquee-wrap:before,
.report .marquee-wrap:before {
  background-position: -26px -1194px;
  height: 25px;
  width: 32px
}

.marquee-list {
  position: absolute;
  width: calc(100% - 32px);
  list-style: none
}

.marquee-list li {
  height: 25px
}

.marquee-list li a {
  padding: 0 4px 0 10px;
  color: #fff;
  line-height: 25px;
  text-decoration: underline
}

.agent .marquee-list li a,
.report .marquee-list li a {
  color: #1e1e1e
}

.upcome-wrap {
  margin-bottom: 15px;
  background-color: #fff;
  border-bottom: 1px solid #7e97a7
}

.upcome-wrap a {
  font-weight: 700
}

.upcome-head {
  color: #fff;
  line-height: 25px;
  padding-left: 10px;
  background-repeat: repeat-x;
  box-shadow: 0 2px 0 rgba(0, 0, 0, .1);
  background-position: 0 -2607px
}

.upcome-head a {
  color: #75bff5
}

.upcome-head dt {
  padding-right: 13px;
  margin-right: 5px;
  background-position: 100% -2432px
}

.upcome-head dd {
  margin-right: 15px
}

.upcome-head span {
  font-weight: 400;
  color: #c5d0d7;
  padding-left: 5px
}

.upcome {
  height: 18px;
  line-height: 18px;
  padding: 6px 10px
}

.upcome-closed .upcome {
  padding: 10px
}

.upcome dt {
  font-size: 11px;
  line-height: 16px;
  color: #7e97a7;
  border: 1px solid #7e97a7;
  border-radius: 4px;
  padding: 0 5px;
  margin-right: 5px
}

.upcome dd {
  width: auto;
  margin-right: 5px;
  padding-left: 10px;
  background-position: -23px -142px
}

.upcome dd:first-of-type {
  background: 0;
  padding-left: 0
}

.highlight-edge-content h3 {
  /* background-color: #7a32d1; */
  background: linear-gradient(90deg, #d0021b 0%, #ffea21 100%, #ff9e2c);
  font-weight: bold;
  padding: 3px 2px 3px 10px;
  color: rgb(0, 0, 0);
  font-weight: 700
}

.highlight-edge-content .sports-header,
.highlight-edge-content .matched-head {
  background-color: #dddcd6
}

.game-list {
  position: relative
}

.tab-highlight,
.tab-markets {
  padding: 0 10px;
  background-repeat: repeat-x;
  background-position: 0 -4204px
}

.tab-highlight li,
.tab-markets li {
  list-style: none;
  line-height: 22px;
  margin-right: 3px
}

.tab-highlight a,
.tab-markets a {
  width: 130px;
  color: #fff;
  background-position: -284px -183px
}

.tab-highlight a.select,
.tab-markets a.select {
  height: 24px;
  color: #1e1e1e;
  margin-bottom: -2px;
  background-position: -284px -205px
}

.tab-highlight a.select:hover,
.tab-markets a.select:hover {
  text-decoration: none
}

.no-data {
  background-color: #fff;
  padding: 10px 10px 5px !important;
  color: #1e1e1e
}

.message-content {
  display: none;
  position: absolute;
  top: 0;
  width: 100%;
  padding: 8px 0;
  background-color: #f8e71c;
  font-size: 14px;
  color: #1e1e1e;
  z-index: 99
}

.message-content p {
  line-height: 22px;
  padding: 0 10px;
  margin-bottom: 0
}

.message-content .close-button {
  margin: 6px 10px 0 0
}

.centar-content .message-content {
  margin-left: -15px
}

.inplay .message-content {
  margin-left: 0
}

.player .message-content {
  top: 38px;
  margin-left: 0
}

.message-content:not(:target) {
  display: none
}

.message-content:target {
  display: block
}

.success {
  background-color: #6bbd11
}

.error {
  background-color: #d0021b;
  color: #fff
}

.warning {
  background-color: #f8e71c;
  color: #1e1e1e
}

.event-left,
.event-right {
  width: 49.5%
}

.event-left .sportsgame-list-content,
.event-right .sportsgame-list-content,
.event-left .sports-header,
.event-right .sports-header,
.event-left .matched-head,
.event-right .matched-head {
  padding-right: 0
}

.event-left dt,
.event-right dt {
  font-size: 11px
}

.event-left .sports-header span,
.event-right .sports-header span,
.event-left .matched-head span,
.event-right .matched-head span {
  width: 49%
}

.event-left .sports-header .game-low_liq,
.event-right .sports-header .game-low_liq,
.event-left .matched-head .game-low_liq,
.event-right .matched-head .game-low_liq,
.event-left .sports-header .game-fancy,
.event-right .sports-header .game-fancy,
.event-left .matched-head .game-fancy,
.event-right .matched-head .game-fancy,
.event-left .sports-header .game-sportsbook,
.event-right .sports-header .game-sportsbook,
.event-left .matched-head .game-sportsbook,
.event-right .matched-head .game-sportsbook {
  width: auto
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
  z-index: 53
}

.overlay:target {
  display: block
}

.dialog-wrap,
.dialog-wrap-w {
  top: 340px;
  background-color: rgba(0, 0, 0, .85);
  border-radius: 8px;
  color: #fff;
  z-index: 20;
  position: absolute;
  left: 50%;
  width: 320px;
  margin-left: -160px
}

.dialog-wrap h4,
.dialog-wrap-w h4,
.dialog-wrap .tc-content h5,
.tc-content .dialog-wrap h5,
.dialog-wrap-w .tc-content h5,
.tc-content .dialog-wrap-w h5 {
  font-size: 15px;
  line-height: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, .2);
  padding: 7px 0
}

.dialog-wrap .btn-wrap,
.dialog-wrap-w .btn-wrap {
  border-top: 1px solid rgba(255, 255, 255, .2);
  padding: 7px 10px 10px;
  margin-bottom: 0
}

.dialog-wrap .break li,
.dialog-wrap-w .break li {
  width: 100%;
  margin-bottom: 3px
}

.dialog-wrap .break .btn-send,
.dialog-wrap-w .break .btn-send {
  float: none;
  width: 46.42857%;
  margin: 0 auto
}

.dialog-content {
  font-size: 13px;
  line-height: 18px;
  padding: 5px 20px 0
}

.dialog-content .attention {
  color: #f8e71c
}

.dialog-wrap-w {
  background-color: #fff;
  color: #1e1e1e
}

.dialog-wrap-w .btn-wrap {
  border-top-color: rgba(0, 0, 0, .2)
}

.login-pg-go {
  top: 18%;
  width: 540px;
  height: 408px;
  position: absolute;
  left: 50%;
  width: 540px;
  margin-left: -270px
}

.login-pg-go .error {
  background-color: transparent;
  color: #d0021b;
  font-size: 13px;
  line-height: 16px
}

.login-pg-go .close {
  position: absolute;
  margin-top: 10px;
  margin-left: 15px;
  background-position: -394px -934px;
  height: 20px;
  width: 20px
}

.login-box-content {
  color: #000
}

/*
.change_pass {
  top: 300px;
  background-color: #fff;
  position: absolute;
  left: 50%;
  width: 440px;
  margin-left: -220px
}

.change_pass .note {
  color: #1e1e1e
}
*/
.footer {

  margin: 40px 0;
  padding-top: 6px
}

.support-wrap {
  display: none;
  color: rgba(0, 0, 0, .6);
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 10px
}

.support-wrap h3 {
  color: rgba(0, 0, 0, .3);
  font-size: 15px;
  margin-right: 15px
}

.support-wrap dl {
  margin-right: 10px
}

.support-wrap dd {
  padding-left: 27px;
  color: #000
}

.support-wrap dd span {
  color: rgba(0, 0, 0, .6);
  padding-right: 5px
}

.support-wrap a {
  color: #000;
  text-decoration: underline
}

.mob-inform-link li {
  margin-bottom: 5px;
}

/*
.support-mail img {
  background-position: -392px -1849px;
  height: 22px;
  width: 22px
} */

.support-app img {
  background-position: -392px -2062px;
  height: 22px;
  width: 22px
}

/*
.support-telegram img {
  background-position: -392px -2001px;
  height: 22px;
  width: 22px
}*/
.support-mail img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(166,166,166)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}

.support-mail.open img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(97,97,97)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}

.support-wrap .support-info {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.support-whatsapp.open img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>');
}

.support-wrap .support-service img {
  width: 25px;
  height: 100%;
}

.support-whatsapp img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.power-content {
  display: none;
  width: 578px;
  margin: 0 auto 30px;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, .3)
}

.power-content-b {
  background-color: rgba(255, 255, 255, .3);
  border-color: rgba(0, 0, 0, .3);
  color: rgba(0, 0, 0, .5);
  padding: 3px 7px 6px;
  margin-top: 4px
}

.power-content-b img {
  opacity: .5;
  background-position: 0 -314px;
  height: 18px;
  width: 107px
}

.browser-footer-content {
  color: rgba(0, 0, 0, .6)
}

.browser-footer-content img {
  background-position: 0 0;
  height: 20px;
  width: 50px
}

.apkdl-link {
  display: none;
  width: 100%;
  margin-top: 20px;
  color: rgba(0, 0, 0, .6);
  font-size: 10px;
  text-align: center
}

.apkdl-link a {
  margin-bottom: 2px
}

.apkdl-link img {
  width: 155px;
  height: auto
}

.live-pop {
  width: 100%;
  height: 100%;
  background-color: #000
}

.streaming-pop {
  background-color: #eee
}

.live-left {
  width: 210px;
  height: calc(100% - 3px);
  border-top: 3px solid #7e97a7;
  overflow: hidden;
  overflow-y: auto
}

.live-list {
  padding-bottom: 15px
}

.live-list dt {
  background-color: #e0e6e6;
  line-height: 20px;
  color: #000;
  font-size: 11px;
  font-weight: 700;
  border-bottom: 1px solid #c5d0d7;
  padding: 0 7px
}

.live-list dt img {
  margin-right: 5px;
  margin-top: 4px;
  vertical-align: top
}

.live-list dd {
  background-color: #fff;
  font-size: 12px;
  border-bottom: 1px solid #ccc
}

.live-list a {
  position: relative;
  line-height: 28px;
  color: #1e1e1e;
  padding: 0 23px 0 7px
}

.live-list a:after {
  content: '';
  position: absolute;
  top: 6px;
  right: 5px;
  background-position: -399px 0;
  height: 15px;
  width: 15px
}

.live-list a:hover {
  background-color: #eff2f2;
  text-decoration: none
}

.live-list a.select {
  background-color: #f2dca7
}

.live-right {
  width: calc(100% - 210px);
  height: 100%;
  background-color: #000
}

.live-head h3 {
  line-height: 35px;
  color: #fff;
  font-size: 15px;
  padding: 0 10px;
  background-repeat: repeat-x;
  background-position: 0 -2632px
}

.live-head h3 span {
  color: #7e97a7;
  font-size: 12px;
  font-weight: 400
}

.icon-TV_head {
  vertical-align: top;
  margin: 8px 7px 0 0;
  background-position: -392px -1365px;
  height: 19px;
  width: 22px
}

.live-channel {
  line-height: 25px;
  color: #fff;
  font-weight: 700;
  padding: 0 10px;
  margin-bottom: 0;
  background-repeat: repeat-x;
  background-position: 0 -2135px
}

.live-channel span {
  height: 17px;
  line-height: 17px;
  font-size: 11px;
  color: #1e1e1e;
  font-weight: 400;
  background-color: #000;
  padding: 0 4px;
  margin: 4px 7px 0 0;
  border-radius: 3px
}

.col-game,
.sportsgame-list-content dt {
  width: calc(64% - 42px)
}

.col3 .col-game,
.col3 .sportsgame-list-content dt,
.sportsgame-list-content .col3 dt {
  width: calc(64% - 42px)
}

.event-left .col-game,
.event-right .col-game,
.event-left .sportsgame-list-content dt,
.sportsgame-list-content .event-left dt,
.event-right .sportsgame-list-content dt,
.sportsgame-list-content .event-right dt {
  width: 66.22517%
}

.sport-odds,
.last-col,
.col-draw {
  width: 12%
}

.sports-header .sport-odds,
.matched-head .sport-odds,
.sports-header .last-col,
.matched-head .last-col,
.sports-header .col-draw,
.matched-head .col-draw {
  padding: 5px 3px
}

.sportsgame-list-content .sport-odds,
.sportsgame-list-content .last-col,
.sportsgame-list-content .col-draw {
  padding: 2px 3px
}

.event-left .sport-odds,
.event-right .sport-odds,
.event-left .last-col,
.event-right .last-col,
.event-left .col-draw,
.event-right .col-draw {
  width: 31.78808%
}

.sportsgame-list-content .info-icon {
  padding: 2px 3px
}

.sportsgame-list-content {
  position: relative;
  padding: 0 6px 0 10px;
  border-bottom: 1px solid #e0e6e6
}

.sportsgame-list-content:hover {
  background-color: #eff2f2
}

.sportsgame-list-content:hover .to-win {
  background-position: -404px -1333px
}

.sportsgame-list-content:hover .to-lose {
  background-position: -404px -2457px
}

.mob-live-numberDesktop {
  position: absolute;
  top: -6px;
  right: 3px;
  min-width: 33px;
  height: 12px;
  border-radius: 3px;
  padding-right: 3px;
  color: #FFFFFF;
  text-align: center;
  font-size: 10px;
  line-height: 12px;
  background-image: linear-gradient(180deg, #FB3434 0%, #E80505 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
}

.profile-wrap {
  background-color: #fff;
  border-bottom: 1px solid #7E97A7;
  margin-bottom: 15px;
}

.asdf {
  visibility: hidden;
}

.slides .slick-prev,
.slides .slick-next {
  position: absolute;
  top: 50%;
  z-index: 1;
}

.slick-dots li button:before {
  font-family: 'slick';
  font-size: 12px !important;
  line-height: 0 !important;
  position: absolute;
  top: -19px;
  left: 0;
  width: 20px;
  height: 20px;
  content: '•';
  text-align: center;
  opacity: .25;
  color: rgb(255 241 241);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.images-grid img {
  width: 100%;
}

.slides {
  position: relative;
}

.slides .slick-prev,
.slides .slick-next {
  position: absolute;
  top: 50%;
  z-index: 1;
}

.slides .slick-prev {
  left: 5%;
}

.slides .slick-next {
  right: 5%;
}

.slip_set-pop.active {
  visibility: visible;
}

.asdf.active {
  visibility: visible;
  box-shadow: 0 4px 5px rgba(0, 0, 0, .5);
}

.slip_set-pop {
  visibility: hidden;
}

.Toastify__toast--warning {
  background-color: #bd362f !important;
  opacity: .8;
  border-radius: 3px !important;
  overflow: hidden;
  box-sizing: 'border-box';
}

.top {
  min-width: 1350px;
  background-attachment: fixed;
  margin-bottom: 1px;
}

.Toastify__toast-body {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=') !important;
  background-position: 15px center;
  background-repeat: no-repeat;
  font-size: 14px !important;
  margin: 0 0 6px !important;
  padding: 15px 15px 15px 50px !important;
  text-align: center !important;
}

.col3 .col-game,
.col3 .sportsgame-list-content dt,
.sportsgame-list-content .col3 dt {
  width: calc(64% - 42px);
}

.mob-live-numberDesktop,
.mob-live-numberDesktop strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd {
  justify-content: center;
  align-items: center;
}

.mob-live-numberDesktop strong:before {
  width: 14px;
  height: 8px;
  background: url('data:image/svg+xml,<svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,0,0)" fill-rule="evenodd"><path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z"/><circle cx="6.8" cy="4.4" r="1.6"/></g></svg>') no-repeat;
  background-size: contain;
}

.mob-live-numberDesktop strong:before,
.live_events .live_icon span:before {
  animation: twinkling 1.4s infinite ease;
}

.mob-live-numberDesktop strong:before,
.game-head .ico_rules:before,
.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.mob-live-numberDesktop strong:before,
.game-head .ico_rules:before,
.age_box li .secondary:before,
.age_box li .btn-send:before {
  content: "";
}

.displayB,
.delete,
.btn,
.btn-send,
.marquee-pop .pages a,
.pages a,
.calendarTable_inputBox input,
.calendarTable_inputBox textarea,
.slip-back .col-stake_list ul,
.slip-lay .col-stake_list ul,
.slip-book .col-stake_list ul,
.login-clientform,
.account-wrap,
.menu,
.setting-tab,
.sports-header,
.matched-head,
.stake-popup,
.btn-wrap,
.slip-option,
.cashout-wrap,
.slider,
.tab-highlight,
.tab-markets,
.game-wrap-horse .hs-time,
.game-scores .scores-time,
.game-scores ul,
.tab-HS,
.game-info,
.marquee-pop .input-list,
.marquee-pop .filter-list,
.tab,
.input-list,
.filter-list,
.filter-pop ul,
.acc-info,
.total-show,
.slip-back .col-stake_list ul li,
.slip-lay .col-stake_list ul li,
.slip-book .col-stake_list ul li,
.login-clientform li,
.account-wrap li,
.menu li,
.setting-tab li,
.sports-header li,
.matched-head li,
.stake-popup li,
.btn-wrap li,
.slip-option li,
.cashout-wrap li,
.slider li,
.tab-highlight li,
.tab-markets li,
.game-wrap-horse .hs-time li,
.game-scores .scores-time li,
.game-scores ul li,
.tab-HS li,
.game-info li,
.marquee-pop .input-list li,
.marquee-pop .filter-list li,
.tab li,
.input-list li,
.filter-list li,
.filter-pop ul li,
.acc-info li,
.total-show li,
.btn_rules:after,
.mob-live-numberDesktop strong:before,
.game-head .ico_rules:before,
.age_box li .secondary:before,
.age_box li .btn-send:before,
.slipbar-content h3 a,
.matched-wrap h3 a,
.live-wrap h3 a,
.tv-wrap h3 a,
.game-wrap h3 a,
.highlight-edge-content h3 a,
.game-wrap-horse h3 a,
.favor-wrap h3 a,
.sub_path h3 a,
.slip-back dt:hover .full-amount,
.slip-lay dt:hover .full-amount,
.slip-book dt:hover .full-amount,
.slip-back dd:hover .full-amount,
.slip-lay dd:hover .full-amount,
.slip-book dd:hover .full-amount,
.slip-back .col-stake_list:target,
.slip-lay .col-stake_list:target,
.slip-book .col-stake_list:target,
.btn-live,
.btn-book,
.account-wrap ul a,
.more_drop-list a,
.selection-list a,
.multi-event_type,
.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after,
.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before,
.fancy-head .in-play span:before,
.sportsbook-head .in-play span:before,
.bookmaker .in-play span:before,
.fancy-suspend span,
.fancy-suspend-white span,
.power-content h3 img,
.power-content-b img,
.login-clientform .btn-login,
.login-clientform .btn-signup,
.header a,
.account-wrap li .refresh-bar,
.account-wrap a,
.language,
.flag,
.navbar-content a,
.menu li:hover ul,
.setting-tab li:hover ul,
.sports-side-menu-list a,
.sports-side-menu-list .Go,
.favor-set,
.path .path-back,
.sports-path-popup a,
.short-amount,
.odd-add a,
.stake-popup a,
.slider-bar span,
.slider-bar a,
.live:before,
.load-pending strong,
.favor,
.images-grid a,
.promo-banner-wrap a,
.tab-highlight a,
.tab-markets a,
.event-left .sports-header span,
.event-right .sports-header span,
.event-left .matched-head span,
.event-right .matched-head span,
.app-link,
.live-list a,
.live-list a:after,
.change-channel::before,
.marquee-box h4:before,
.marquee-box .tc-content h5:before,
.tc-content .marquee-box h5:before,
.marquee-box h4:after,
.marquee-box .tc-content h5:after,
.tc-content .marquee-box h5:after,
.marquee-box .marquee a span,
.game-E i:before,
.game-E i:after,
.sportsgame-list-content dd a,
.sportsgame-list-content dd a span,
.sportsgame-list-content dd .info,
.game-head a,
.game-team .game-visit span,
.game-scores .game-visit span,
.game-team .game-home span,
.game-scores .game-home span,
.game-team .game-vs span,
.game-scores .game-vs span,
.game-scores ul .scores-box span,
.game-progress:after,
.sum-status,
.score-pop:before,
.score-pop-last:before,
.tab-HS a,
.tv-control a:before,
.fm-bets td a,
.bets-HS td a,
.bets-GH td a,
.fm-bets td span,
.bets-HS td span,
.bets-GH td span,
.disabled .sport-odds a:before,
.disabled .last-col a:before,
.disabled .col-draw a:before,
.disabled.sport-odds a:before,
.disabled.last-col a:before,
.disabled.col-draw a:before,
.horse-info>dd:hover .horse_info-hover,
.dog-info>dd:hover .horse_info-hover,
.to-win:before,
.to-lose:before,
.more,
.suspend span,
.fm-bets .suspend span,
.bets-HS .suspend span,
.bets-GH .suspend span,
.line_markets-team .game-vs div:before,
.line_markets-team .game-vs div:after,
.rules-wrap:target,
.line_market-name span,
.quick_bet-wrap .btn span,
.quick_bet-wrap .btn-send span,
.quick_bet-wrap .pages a span,
.pages .quick_bet-wrap a span,
.quick_bet-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .quick_bet-wrap input span,
.quick_bet-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .quick_bet-wrap textarea span,
.gametab-head h4:after,
.gametab-head .tc-content h5:after,
.tc-content .gametab-head h5:after,
.gametab-head h4:before,
.gametab-head .tc-content h5:before,
.tc-content .gametab-head h5:before,
.other-tab:before,
.other-tab:after,
.fancy-info dt span,
td .fancy-info dt,
.special_bets-tab a,
.special_bets-tab .more_drop>a:before,
.announce-footer .confirm-checkbox,
.close_pop,
.error-text,
.go-back,
.pop-close,
.tab a,
.expand-close,
.expand-open,
.selection,
.initial-balance dt span,
.final-balance dt span,
.casinozone-wrap-simple a:after,
.live_events .live_icon span:before,
.casino-title dd:after {
  display: block;
}

.border-box,
.mob-live-numberDesktop,
.game-E,
.marquee-pop .announce-content,
.live_events,
.live_events .live_icon span,
.live_events .live_icon span:before,
.live_events dd span {
  box-sizing: border-box;
}

.displayF,
.promo-banner .promo-control-nav,
.mob-live-numberDesktop,
.mob-live-numberDesktop strong,
.tv-control a,
.fm-bets .special_bet .fancy-info,
.bets-HS .special_bet .fancy-info,
.bets-GH .special_bet .fancy-info,
.back-gradient dd,
.lay-gradient dd,
.age_box li .secondary,
.age_box li .btn-send,
.live_events .live_icon,
.live_events .live_icon span,
.live_events dd,
.power-content,
.licence_embed,
.live-head,
.change-channel,
.marquee-box,
.marquee-box h4,
.marquee-box .tc-content h5,
.tc-content .marquee-box h5,
.marquee-box .marquee a,
.game-E i,
.fm-match-button,
.fm-match-button a,
.game-head .open-tv-wrap,
.tv-control,
.horse-info,
.dog-info,
.horse-info>dt,
.dog-info>dt,
.horse-info>dd,
.dog-info>dd,
.multi_h3,
.game-wrap h3 .multi_name,
.quick-bet-confirm,
.gametab-head,
.gametab-head h4,
.gametab-head .tc-content h5,
.tc-content .gametab-head h5,
.btn_rules,
.fancy-th-layout,
.fancy-th-layout dt,
.fancy-th-layout dd,
.other-tab,
.back-gradient,
.lay-gradient,
.back-gradient dd a,
.lay-gradient dd a,
.download-list,
.download-list dt,
.download-list dt a,
.download-list dd,
.download-list dd a,
.special_bets-tab-wrap,
.special_bets-tab,
.special_bets-tab .more_drop>a,
.marquee-pop,
.marquee-pop .nofound,
.marquee-pop .nofound .nofound_box,
.marquee-pop .pages {
  display: flex;
}

.sportsgame-list-content dt {
  padding: 5px 0;
  font-weight: 700;
  vertical-align: middle
}

.sportsgame-list-content dt span {
  font-weight: 400;
  padding: 0 3px
}

.sportsgame-list-content dt .sportsgame-time-list {
  color: #777
}

.sportsgame-list-content dt .game-list-soon {
  color: #1e1e1e
}

.sportsgame-list-content dd {
  position: relative
}

.sportsgame-list-content dd a {
  width: 49%;
  font-size: 11px;
  line-height: 13px;
  padding: 4px 0;
  cursor: pointer
}

.sportsgame-list-content dd a span {
  float: none;
  font-weight: 400
}

.sportsgame-list-content dd .info {
  background-position: -399px -1767px;
  height: 15px;
  width: 15px
}

.sportsgame-list-content dd .info:hover,
.sportsgame-list-content dd .info.icon-info-hover {
  background-position: -399px -1782px
}

.sportsgame-list-content .sport-odds,
.sportsgame-list-content .last-col,
.sportsgame-list-content .col-draw {
  background-position: 100% -399px
}

.sportsgame-list-content .last-col {
  background-image: none
}

.sport_list-wrap .sportsgame-list-content dt {
  width: 70px;
  color: #000;
  padding: 8px 0
}

.sport_list-wrap .sportsgame-list-content dd {
  padding: 8px 5px 8px 0
}

.sport_list-wrap .sportsgame-list-content dd a {
  float: none;
  font-size: 12px;
  line-height: 15px
}

.sportsgame-list-content.predict dt {
  padding: 2px 0
}

.sportsgame-list-content.predict dd {
  padding: 7px 3px
}

.sportsgame-list-content.predict p {
  margin-bottom: 1px
}

.sportsgame-list-content.predict .lose,
.sportsgame-list-content.predict .to-lose,
.sportsgame-list-content.predict .win,
.sportsgame-list-content.predict .to-win {
  padding: 0
}

.sportsgame-list-content.predict .to-lose,
.sportsgame-list-content.predict .to-win {
  padding-left: 13px
}

.in_play {
  font-weight: bold !important;
  color: #508d0e
}

.game-wrap-horse {
  margin-bottom: 5px
}

.game-wrap-horse dl {
  padding-bottom: 5px
}

.game-wrap-horse dt,
.game-wrap-horse dd {
  float: none;
  width: auto
}

.game-wrap-horse dt .game-list-place {
  color: #777;
  padding-left: 7px;
  margin-left: 5px;
  background-position: 0 -3735px
}

.game-wrap-horse .hs-time a {
  width: 40px;
  line-height: 19px;
  font-size: 12px;
  border: 1px solid transparent;
  border-radius: 3px;
  margin-right: 5px
}

.game-wrap-horse .hs-time a:hover {
  border-color: #2789ce;
  text-decoration: none
}

.game-wrap-horse .hs-time .in-play {
  background-color: #6bbd11;
  color: #fff;
  border-color: #6bbd11
}

.game-wrap-horse .hs-time .in-play:hover {
  background-color: #6bbd11;
  color: #fff;
  border-color: #6bbd11
}

.sport_list-wrap {
  background-color: #fff;
  border-bottom: 1px solid #7e97a7
}

.game-head {
  position: relative;
  background-color: #fff;
  border-bottom: 1px solid #7e97a7;
  color: #000;
  font-size: 13px;
  margin-bottom: 15px
}

.game-head .favor {
  position: absolute;
  top: 7px;
  margin-left: 5px;
  z-index: 3;
  background-position: -392px -1489px;
  height: 23px;
  width: 22px
}

.game-head .favor:hover,
.game-head .favor.icon-big_star-hover {
  background-position: -392px -1466px
}

.game-head .favor.select {
  background-position: -392px -1443px
}

.game-head .favor.select:hover,
.game-head .favor.select.icon-big_star-add-hover {
  background-position: -392px -1420px
}

.game-head .refresh {
  position: absolute;
  top: 7px;
  right: 0;
  margin-left: 0;
  margin-right: 5px;
  z-index: 3;
  background-position: -392px -1918px;
  height: 23px;
  width: 22px
}

.game-head .fancy-info {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  float: none;
  padding: 0 6px;
  margin: 7px 0;
  background-color: #bed5d8;
  font-size: 12px;
  line-height: 16px;
  border-radius: 3px
}

.game-head .fancy-info dt {
  color: #315195
}

.game-team .game-visit,
.game-scores .game-visit {
  padding: 5px 30px
}

.game-team .game-visit span,
.game-scores .game-visit span {
  position: absolute;
  top: 0;
  right: -1px;
  background-position: -388px -656px;
  height: 38px;
  width: 26px
}

.game-team .game-home,
.game-scores .game-home {
  padding: 5px 30px
}

.game-team .game-home span,
.game-scores .game-home span {
  position: absolute;
  top: 0;
  left: 0;
  background-position: -388px -295px;
  height: 38px;
  width: 26px
}

.game-team .game-vs,
.game-scores .game-vs {
  width: 20%;
  font-size: 12px;
  color: #000;
  line-height: 16px;
  vertical-align: top
}

.game-team .game-vs div,
.game-scores .game-vs div {
  height: 34px;
  background-color: #eee;
  white-space: nowrap
}

.game-team .game-vs span,
.game-scores .game-vs span {
  color: #7e97a7;
  font-weight: 400
}

.game-scores {
  table-layout: fixed
}

.game-scores td {
  position: static;
  width: auto;
  height: auto;
  padding: 5px
}

.game-scores h4,
.game-scores .tc-content h5,
.tc-content .game-scores h5 {
  height: 22px;
  margin-bottom: 3px;
  overflow: hidden
}

.game-scores h4 span,
.game-scores .tc-content h5 span,
.tc-content .game-scores h5 span {
  font-size: 12px;
  font-weight: 400;
  vertical-align: top
}

.game-scores h4 span.rank,
.game-scores .tc-content h5 span.rank,
.tc-content .game-scores h5 span.rank {
  color: #fff;
  background-color: #48575f;
  border-radius: 3px;
  padding: 3px 4px
}

.game-scores .scores-team {
  padding: 5px 10px
}

.game-scores .scores-box {
  width: 19.63534%;
  padding: 5px 10px;
  background-color: #0e181e;
  border-right: 1px solid #34444e
}

.game-scores .scores-box.last-box {
  border-right: 1px solid #34444e
}

.game-scores .scores-space {
  width: 22px
}

.game-scores .scores-space:first-of-type {
  width: 15px
}

.game-scores .scores-time {
  font-size: 10px;
  color: #8eea29;
  font-weight: 400;
  line-height: 14px
}

.game-scores .scores-time li {
  list-style: none;
  margin-right: 5px;
  padding-left: 10px;
  background-position: -23px -142px
}

.game-scores .scores-time li.finished {
  color: #fff
}

.game-scores .scores-time .filter-first {
  background: 0;
  padding-left: 0
}

.game-scores .scores-time span {
  color: #7e97a7
}

.game-scores .scores-inns {
  font-size: 10px;
  color: #7e97a7;
  font-weight: 400;
  line-height: 14px
}

.game-scores .scores-other {
  color: #7e97a7
}

.game-scores .scores-other h4,
.game-scores .scores-other .tc-content h5,
.tc-content .game-scores .scores-other h5 {
  font-weight: 400
}

.game-scores .scores-now {
  color: #8eea29
}

.game-scores .scores-win {
  color: #000
}

.game-scores ul .game-visit {
  width: calc(50% - 96px);
  padding: 8px 8px 8px 30px
}

.game-scores ul .game-home {
  width: calc(50% - 96px);
  padding: 8px 30px 8px 8px
}

.game-scores ul .scores-box {
  width: 116px;
  background-color: transparent;
  padding: 0;
  border-width: 0;
  background-position: -298px -2489px
}

.game-scores ul .scores-box p {
  padding: 3px 0 3px;
  margin-bottom: 0
}

.game-scores ul .scores-box span {
  line-height: 16px;
  font-size: 10px;
  font-weight: 400
}

.tennis .scores-box {
  width: 4.90884%;
  padding: 5px;
  border-width: 0
}

.its_turn {
  vertical-align: middle;
  background-position: 100% -1812px;
  height: 22px;
  width: 8px
}

.game-progress {
  position: relative;
  padding: 9px 0
}

.game-progress:after {
  position: absolute;
  left: 50%;
  content: '';
  width: 1px;
  height: 9px;
  background-color: #fff
}

.progress-bar {
  position: relative;
  width: calc(100% - 30px);
  height: 6px;
  margin: 0 15px;
  background-repeat: repeat-x;
  border-radius: 3px;
  background-position: 0 -3757px
}

.progress-bar img {
  position: absolute;
  width: 13px;
  height: 13px;
  margin-left: -6px;
  cursor: pointer
}

.progress-now {
  position: absolute;
  height: 6px;
  background-repeat: repeat-x;
  border-radius: 3px;
  background-position: 0 -3751px
}

.icon-card-yellow {
  background-position: -401px -1534px
}

.icon-card-red {
  background-position: -401px -1521px
}

.icon-soccer {
  background-position: -401px -1950px
}

.sum-status {
  position: absolute;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background-color: #ffcc2f;
  background-image: linear-gradient(-180deg, #ffcc2f 0, #000 71%);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .5);
  font-size: 12px;
  color: #1e1e1e;
  font-weight: 400;
  border-radius: 50%;
  margin-left: -7px;
  margin-top: -1px;
  cursor: pointer;
  transform: scale(.7, .7)
}

.team-a {
  top: -8px
}

.team-b {
  top: 2px
}

.score-pop,
.score-pop-last {
  position: absolute;
  top: 15px;
  background-color: #fff3d4;
  padding: 5px;
  border-radius: 0 0 4px 4px;
  margin-left: -4px;
  z-index: 10;
  pointer-events: none
}

.score-pop:before,
.score-pop-last:before {
  content: '';
  position: absolute;
  top: -8px;
  margin-left: -10px;
  background-position: -395px -109px;
  height: 8px;
  width: 19px
}

.score-pop ul li,
.score-pop-last ul li {
  float: none;
  font-size: 11px;
  color: #1e1e1e;
  font-weight: 400;
  line-height: 15px;
  list-style: none
}

.score-pop img,
.score-pop-last img {
  position: static;
  margin: 0;
  vertical-align: middle
}

.score-pop .scores-now,
.score-pop-last .scores-now {
  color: #508e0d
}

.score-pop.team-b,
.team-b.score-pop-last {
  top: 25px
}

.score-pop-last:before {
  right: 0;
  margin-right: -5px
}

.scores-event,
.scores-line {
  height: 29px;
  line-height: 29px;
  color: #000;
  font-weight: 700;
  padding-left: 10px;
  background-repeat: repeat-x;
  background-position: 0 -3763px
}

.scores-event img,
.scores-line img {
  margin-left: 2px;
  vertical-align: top;
  background-position: -396px -2109px;
  height: 29px;
  width: 18px
}

.tab-HS {
  line-height: 31px;
  height: 32px;
  background-repeat: repeat-x;
  background-position: 0 -3930px
}

.tab-HS a {
  width: 95px;
  color: #000;
  padding: 0 10px;
  border-right: 1px solid #96abb8
}

.tab-HS a.select {
  background-color: #fff;
  border-top: 2px solid #000;
  height: 30px;
  line-height: 28px
}

.tab-HS a.select:hover {
  text-decoration: none
}

.tab-HS .more_drop {
  width: 75px;
  padding-right: 30px;
  background-position: 100% -2223px
}

.tab-HS .more_drop:hover,
.tab-HS .more_drop.more_drop-hover {
  background-position: 100% -2192px
}

.tab-HS .more_drop.select {
  background-position: 100% -2192px
}

.more_drop-list {
  position: absolute;
  min-width: 115px;
  border-radius: 0;
  line-height: 28px
}

.more_drop-list:not(:target) {
  display: none
}

.more_drop-list:target {
  display: block
}

.more_drop-list li {
  float: none
}

.more_drop-list li:last-of-type a {
  border-bottom-color: #7e97a7
}

.more_drop-list a {
  width: calc(100% - 20px);
  border-right-width: 0;
  text-align: left
}

.game-info {
  padding: 0 10px
}

.game-info li {
  padding: 7px 0;

}

.game-info .info-live {
  padding: 3px 0
}

.btn-live {
  width: 61px;
  height: 21px;
  line-height: 21px
}

.btn-live img {
  margin-top: 3px
}

.game-low_liq,
.game-fancy,
.game-sportsbook {
  background-color: #d0021b;
  color: #fff;
  line-height: 5px;
  font-size: 11px;
  padding: 0 5px;
  margin-right: 5px;
  border-radius: 3px
}

.game-matched {
  padding: 0 5px
}

.game-matched dt {
  padding: 7px 0
}

.game-matched dd {
  font-weight: 700;
  color: #1e1e1e;
  padding: 7px 0 7px 5px
}

.bets-wrap {
  position: relative;
  background-color: #fff;
  border-top: 1px solid #7e97a7;
  margin-top: 38px;
  margin-bottom: 30px
}

.player .bets-wrap {
  *height: auto !important;
  *height: 650px;
  min-height: 650px;
  margin-bottom: 10px
}

.lit-content-center .bookmaker_bet {
  margin: 20px 0 60px;
}

.bookmaker_bet {
  background-color: transparent;
}

.bookmaker_bet .fm-bets,
.bookmaker_bet .bets-HS,
.bookmaker_bet .bets-GH {
  background-color: #fff;
  margin-bottom: 15px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
}

.fancy_bet .fm-bets,
.sportsbook_bet .fm-bets,
.bookmaker_bet .fm-bets,
.fancy_bet .bets-HS,
.sportsbook_bet .bets-HS,
.bookmaker_bet .bets-HS,
.fancy_bet .bets-GH,
.sportsbook_bet .bets-GH,
.bookmaker_bet .bets-GH {
  table-layout: fixed;
  margin-top: 0;
}

.fm-bets .special_bet,
.bets-HS .special_bet,
.bets-GH .special_bet {
  background-color: #000;
  color: #fff;


}

.fm-bets .special_bet td,
.bets-HS .special_bet td,
.bets-GH .special_bet td {
  padding: 0;
  border-left-width: 0;
  border-bottom-color: #fff;
  line-height: 25px;
}

.bets-bookmaker td {
  border-left: none;
}

.fm-bets .special_bet h3,
.bets-HS .special_bet h3,
.bets-GH .special_bet h3 {
  position: relative;
  padding: 0 0 0 10px;
}

.align-L,
.table01 caption,
.table-s caption,
.slip-back .refer,
.slip-lay .refer,
.slip-book .refer,
.slip-back .keep-option,
.slip-lay .keep-option,
.slip-book .keep-option,
.message-bet p,
.sports-header .col-bet,
.matched-head .col-bet,
.tips-popup,
.full-amount,
.no-data,
.event-left .col-game,
.event-right .col-game,
.event-left .sportsgame-list-content dt,
.sportsgame-list-content .event-left dt,
.event-right .sportsgame-list-content dt,
.sportsgame-list-content .event-right dt,
.fm-bets th,
.bets-HS th,
.bets-GH th,
.fm-bets .refer-bet,
.bets-HS .refer-bet,
.bets-GH .refer-bet,
.bets-HS .refer-book,
.bets-GH .refer-book,
.fm-bets .special_bet td,
.bets-HS .special_bet td,
.bets-GH .special_bet td,
.fancy_bet .td-fancy_merge,
.sportsbook_bet .td-fancy_merge,
.bookmaker_bet .td-fancy_merge,
.fancy_bet .fancy-quick-tr td,
.sportsbook_bet .fancy-quick-tr td,
.bookmaker_bet .fancy-quick-tr td {
  text-align: left;
}

.fm-bets td,
.bets-HS td,
.bets-GH td {
  width: 8.97436%;
  border-bottom: 1px solid #7E97A7;
  font-weight: bold;
  vertical-align: top;
}

.player .lit-content-center .bets-wrap {
  min-height: calc(100% - 34px)
}

.game-wrap .bets-wrap {
  margin: 26px 3px 5px
}

.refer_only {
  position: absolute;
  top: -24px;
  font-size: 11px;
  color: #7e97a7;
  line-height: 23px;
  margin-left: 5px
}

.for-agent {
  height: 182px;
  background-color: #e2e8ed;
  padding: 0 0 15px
}

.for-agent .bets-wrap {
  margin: 0
}

.for-agent .refer-book {
  padding-right: 10px
}

.for-agent .refer_only {
  margin-left: 10px
}

.for-agent .fancy_bet,
.for-agent .sportsbook_bet {
  margin-top: 38px
}

.for-agent .fancy-head {
  width: calc(100% - 5px);
  padding-right: 5px
}

.for-agent .fancy-head h4:after,
.for-agent .fancy-head .tc-content h5:after,
.tc-content .for-agent .fancy-head h5:after {
  content: '';
  background-position: -402px -2084px;
  height: 25px;
  width: 12px
}

.for-agent .sportsbook-head {
  width: calc(100% - 5px);
  padding-right: 5px
}

.head-bets-agent {
  background-color: rgba(255, 255, 255, .5);
  margin-bottom: 28px;
  border-bottom: 1px solid #7e97a7;
  padding: 0 10px
}

.head-bets-agent .game-matched {
  float: left;
  padding: 0;
  margin-right: 20px
}

.head-bets-agent .game-info {
  padding: 0
}

.head-bets-agent .game-info li {
  margin: 0 0 0 20px
}

.head-bets-agent .game-low_liq,
.head-bets-agent .game-fancy,
.head-bets-agent .game-sportsbook {
  line-height: 15px;
  margin-left: -10px;
  margin-right: 5px
}

.fm-bets,
.bets-HS,
.bets-GH {
  width: 100%;
  margin-top: -24px
}

.fm-bets tr:hover,
.bets-HS tr:hover,
.bets-GH tr:hover {
  background-color: #eff2f2
}

.fancy_bet .fancy-quick-tr .quick_bet-wrap,
.sportsbook_bet .fancy-quick-tr .quick_bet-wrap,
.bookmaker_bet .fancy-quick-tr .quick_bet-wrap {
  border-width: 0;
}

.quick_bet-wrap dt .bet-check {
  font-size: 12px;
  opacity: 1;
}

.quick_bet-wrap input,
.quick_bet-wrap textarea {
  line-height: 33px;
  height: 33px;
}

.slip-back input,
.slip-lay input,
.slip-book input,
.slip-back textarea,
.slip-lay textarea,
.slip-book textarea {
  margin: 0;
  padding: 0 6px 0 0;
  width: 100%;
  line-height: 22px;
}

.align-R,
.table01,
.table-s,
.slip-back input,
.slip-lay input,
.slip-book input,
.slip-back textarea,
.slip-lay textarea,
.slip-book textarea,
.slip-back .col-profit,
.slip-lay .col-profit,
.slip-book .col-profit,
.slip-back .inn_runs dd,
.slip-lay .inn_runs dd,
.slip-book .inn_runs dd,
.account-wrap .main-wallet p,
.time_zone,
.path ul,
.sports-header .col-profit,
.matched-head .col-profit,
.cashout-wrap dl,
.change-channel span,
.game-team .game-visit,
.game-scores .game-visit,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book,
.quick-bet-confirm li,
.form_list dt,
.table-trans .unit-num {
  text-align: right;
}

input[type=checkbox],
textarea[type=checkbox],
input[type=radio],
textarea[type=radio] {
  width: auto !important;
  height: auto !important;
  border-width: 0;
  border-radius: 0;
  background-color: transparent !important;
  padding: 0 !important;
  box-shadow: none;
}

input,
textarea {
  font-family: Tahoma, Helvetica, sans-serif;
  color: #1E1E1E;
  font-size: 12px;
  border: 0px #aaa solid;
  background: #fff;
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 5px;
  margin: 0 5px 5px 0;
  box-sizing: border-box;
}

.bookmaker_bet .fancy-quick-tr dt span {
  display: inline-block;
}

fancy_bet .fancy-quick-tr td a,
.sportsbook_bet .fancy-quick-tr td a,
.bookmaker_bet .fancy-quick-tr td a {
  padding: 0;
}

.fm-bets .special_bet td:hover,
.bets-HS .special_bet td:hover,
.bets-GH .special_bet td:hover {
  background-color: #000;
}

.fm-bets tr:hover .to-win,
.bets-HS tr:hover .to-win,
.bets-GH tr:hover .to-win {
  background-position: -404px -1333px
}

.fm-bets tr:hover .to-lose,
.bets-HS tr:hover .to-lose,
.bets-GH tr:hover .to-lose {
  background-position: -404px -2457px
}

.fm-bets th,
.bets-HS th,
.bets-GH th {
  position: relative;
  padding: 9px 10px;
  border-bottom: 1px solid #7e97a7;
  vertical-align: top
}

.fm-bets th p,
.bets-HS th p,
.bets-GH th p {
  width: 292px;
  margin-bottom: 0
}

.fm-bets th span,
.bets-HS th span,
.bets-GH th span {
  font-weight: 400
}

.bets-bookmaker .fancy-suspend,
.bets-bookmaker .fancy-suspend-white,
.bets-bookmaker .fancy-suspend-white {
  height: 46px;
}

.bets-bookmaker .fancy-suspend span,
.bets-bookmaker .fancy-suspend-white span,
.bets-bookmaker .fancy-suspend-white span {
  line-height: 46px;
}

.fancy_bet .fancy-suspend-tr span,
.sportsbook_bet .fancy-suspend-tr span,
.bookmaker_bet .fancy-suspend-tr span {
  font-size: 12px;
}

.fm-bets td span,
.bets-HS td span,
.bets-GH td span {
  font-weight: normal;
}

.fancy-suspend span,
.fancy-suspend-white span {
  opacity: 0.8;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.fancy_bet .fm-bets th,
.sportsbook_bet .fm-bets th,
.fancy_bet .bets-HS th,
.sportsbook_bet .bets-HS th,
.bookmaker_bet .bets-HS th,
.fancy_bet .bets-GH th,
.sportsbook_bet .bets-GH th,
.bookmaker_bet .bets-GH th {
  padding: 4px 5px 3px 10px;
}

.lay-gradient {
  background-image: linear-gradient(270deg, rgba(231, 170, 184, 0.15) 5%, rgba(231, 170, 184, 0.8) 60%) !important;
}

.fm-bets th.predict,
.bets-HS th.predict,
.bets-GH th.predict {
  padding: 3px 10px
}

.bets-bookmaker td {
  border-left: none;
}

.lay-gradient dd {
  color: #A9616D;
}

.lay-gradient dd a {
  background-color: #FAA9BA;
}

.back-gradient dd a:hover,
.lay-gradient dd a:hover {
  background: #80c2f1;
}

.lay-gradient dd a:hover {
  background: #fbb7c6;
}

.fm-bets td a,
.bets-HS td a,
.bets-GH td a {
  position: relative;
  height: 35px;
  color: #1E1E1E;
  padding: 3px 0 2px;
  cursor: pointer;
}

.back-gradient dd,
.lay-gradient dd {
  flex: 1;
  padding: 2px;
  color: #59708D;
}

.back-gradient p,
.lay-gradient p {
  width: 100%;
  margin-bottom: 0;
}

.lay-gradient dd a {
  justify-content: center;
  align-items: center;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  padding: 0;
  margin: 0;

  border: 1px solid #FFFFFF;
  border-radius: 4px;
}

/*Scoreboard start*/





/*Scoreboard End*/

.back-gradient dd a {
  justify-content: center;
  align-items: center;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  padding: 0;
  margin: 0;
  background-color: #72BBEF;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
}

.fm-bets td a,
.bets-HS td a,
.bets-GH td a {
  position: relative;
  height: 35px;
  color: #1E1E1E;
  padding: 3px 0 2px;
  cursor: pointer;
}

.back-gradient,
.lay-gradient {
  height: 46px;
  background-image: linear-gradient(90deg, rgba(130, 183, 221, 0.15) 0%, rgba(130, 183, 221, 0.8) 65%);
}

.fm-bets th.predict p,
.bets-HS th.predict p,
.bets-GH th.predict p {
  margin-bottom: 3px
}

.fm-bets td,
.bets-HS td,
.bets-GH td {
  width: 8.97436%;
  border-bottom: 1px solid #7e97a7;
  border-left: 1px solid #ddd;
  font-weight: 700
}

.fm-bets td:hover,
.bets-HS td:hover,
.bets-GH td:hover {
  background-color: #ededed
}

.fm-bets td a,
.bets-HS td a,
.bets-GH td a {
  position: relative;
  height: 35px;
  color: #1e1e1e;
  padding: 3px 0 2px;
  cursor: pointer
}

.fm-bets td a:hover,
.bets-HS td a:hover,
.bets-GH td a:hover {
  text-decoration: none
}

.fm-bets td span,
.bets-HS td span,
.bets-GH td span {
  font-weight: 400;
  font-size: 11px
}

.fm-bets td.no-liq a,
.bets-HS td.no-liq a,
.bets-GH td.no-liq a {
  line-height: 35px
}

.fm-bets td.no-liq span,
.bets-HS td.no-liq span,
.bets-GH td.no-liq span {
  display: none
}

.fm-bets .refer-bet,
.bets-HS .refer-bet,
.bets-GH .refer-bet,
.fm-bets .refer-book,
.bets-HS .refer-book,
.bets-GH .refer-book {
  font-size: 11px;
  line-height: 22px;
  font-weight: 400
}

.fm-bets .back-1,
.bets-HS .back-1,
.bets-GH .back-1 {
  background-color: #72bbef;
  border-left-color: #fff
}

.fm-bets .back-1:hover,
.bets-HS .back-1:hover,
.bets-GH .back-1:hover {
  background-color: #80c2f1
}

.fm-bets .back-1.select,
.bets-HS .back-1.select,
.bets-GH .back-1.select {
  background-color: #1a8ee1;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .back-1.select a,
.bets-HS .back-1.select a,
.bets-GH .back-1.select a {
  color: #fff
}

.fm-bets .back-2,
.bets-HS .back-2,
.bets-GH .back-2 {
  background-color: #b7d5eb;
  border-left-color: #fff
}

.fm-bets .back-2:hover,
.bets-HS .back-2:hover,
.bets-GH .back-2:hover {
  background-color: #c3dcee
}

.fm-bets .back-2.select,
.bets-HS .back-2.select,
.bets-GH .back-2.select {
  background-color: #67a6d5;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .back-2.select a,
.bets-HS .back-2.select a,
.bets-GH .back-2.select a {
  color: #fff
}

.disable .fm-bets .back-2,
.disable .bets-HS .back-2,
.disable .bets-GH .back-2 {
  background-color: #ddd
}

.fm-bets .back-3,
.bets-HS .back-3,
.bets-GH .back-3 {
  background-color: #d7e8f4;
  border-left-color: #fff
}

.fm-bets .back-3:hover,
.bets-HS .back-3:hover,
.bets-GH .back-3:hover {
  background-color: #e3eff7
}

.fm-bets .back-3.select,
.bets-HS .back-3.select,
.bets-GH .back-3.select {
  background-color: #87bade;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .back-3.select a,
.bets-HS .back-3.select a,
.bets-GH .back-3.select a {
  color: #fff
}

.fm-bets .lay-1,
.bets-HS .lay-1,
.bets-GH .lay-1 {
  background-color: #faa9ba;
  border-left-color: #fff
}

.fm-bets .lay-1:hover,
.bets-HS .lay-1:hover,
.bets-GH .lay-1:hover {
  background-color: #fbb7c6
}

.fm-bets .lay-1.select,
.bets-HS .lay-1.select,
.bets-GH .lay-1.select {
  background-color: #f4496d;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .lay-1.select a,
.bets-HS .lay-1.select a,
.bets-GH .lay-1.select a {
  color: #fff
}

.fm-bets .lay-2,
.bets-HS .lay-2,
.bets-GH .lay-2 {
  background-color: #efd3d9;
  border-left-color: #fff
}

.fm-bets .lay-2:hover,
.bets-HS .lay-2:hover,
.bets-GH .lay-2:hover {
  background-color: #f3dee3
}

.fm-bets .lay-2.select,
.bets-HS .lay-2.select,
.bets-GH .lay-2.select {
  background-color: #d48898;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .lay-2.select a,
.bets-HS .lay-2.select a,
.bets-GH .lay-2.select a {
  color: #fff
}

.fm-bets .lay-3,
.bets-HS .lay-3,
.bets-GH .lay-3 {
  background-color: #f6e6ea;
  border-left-color: #fff
}

.fm-bets .lay-3:hover,
.bets-HS .lay-3:hover,
.bets-GH .lay-3:hover {
  background-color: #faf1f3
}

.fm-bets .lay-3.select,
.bets-HS .lay-3.select,
.bets-GH .lay-3.select {
  background-color: #db9bab;
  color: #fff;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .5)
}

.fm-bets .lay-3.select a,
.bets-HS .lay-3.select a,
.bets-GH .lay-3.select a {
  color: #fff
}

.fm-bets .fm-bet-zone:hover,
.bets-HS .fm-bet-zone:hover,
.bets-GH .fm-bet-zone:hover {
  background-color: transparent
}

.fm-bets .fm-bet-zone td,
.bets-HS .fm-bet-zone td,
.bets-GH .fm-bet-zone td {
  background-color: transparent;
  border-left-color: transparent;
  padding-bottom: 1px
}

.fm-bets .fm-bet-zone td.lay-all,
.bets-HS .fm-bet-zone td.lay-all,
.bets-GH .fm-bet-zone td.lay-all {
  border-left-color: #fff
}

.fm-bets .fm-bet-zone a,
.bets-HS .fm-bet-zone a,
.bets-GH .fm-bet-zone a {
  position: relative;
  width: 100%;
  height: 17px;
  background-color: transparent;
  line-height: 17px;
  cursor: pointer
}

.fm-bets .fm-bet-zone img,
.bets-HS .fm-bet-zone img,
.bets-GH .fm-bet-zone img {
  position: absolute;
  top: 0;
  width: calc(100% - 11px);
  height: 100%
}

.fm-bets .fm-bet-zone span,
.bets-HS .fm-bet-zone span,
.bets-GH .fm-bet-zone span {
  position: absolute;
  width: 100%;
  font-weight: 700;
  font-size: 12px
}

.fm-bets .back-all,
.bets-HS .back-all,
.bets-GH .back-all {
  background-position: -274px -229px
}

.fm-bets .back-all:hover,
.bets-HS .back-all:hover,
.bets-GH .back-all:hover,
.fm-bets .back-all.bg-backall-left-hover,
.bets-HS .back-all.bg-backall-left-hover,
.bets-GH .back-all.bg-backall-left-hover {
  background-position: -274px -273px
}

.fm-bets .back-all img,
.bets-HS .back-all img,
.bets-GH .back-all img {
  left: 11px;
  background-repeat: repeat-x;
  background-position: 0 -2091px
}

.fm-bets .back-all img:hover,
.bets-HS .back-all img:hover,
.bets-GH .back-all img:hover,
.fm-bets .back-all img.bg-backall-hover,
.bets-HS .back-all img.bg-backall-hover,
.bets-GH .back-all img.bg-backall-hover {
  background-position: 0 -2113px
}

.fm-bets .back-all:hover img,
.bets-HS .back-all:hover img,
.bets-GH .back-all:hover img {
  background-repeat: repeat-x;
  background-position: 0 -2113px
}

.fm-bets .lay-all,
.bets-HS .lay-all,
.bets-GH .lay-all {
  background-position: 100% -333px
}

.fm-bets .lay-all:hover,
.bets-HS .lay-all:hover,
.bets-GH .lay-all:hover,
.fm-bets .lay-all.bg-layall-right-hover,
.bets-HS .lay-all.bg-layall-right-hover,
.bets-GH .lay-all.bg-layall-right-hover {
  background-position: 100% -377px
}

.fm-bets .lay-all img,
.bets-HS .lay-all img,
.bets-GH .lay-all img {
  right: 11px;
  background-repeat: repeat-x;
  background-position: 0 -2667px
}

.fm-bets .lay-all img:hover,
.bets-HS .lay-all img:hover,
.bets-GH .lay-all img:hover,
.fm-bets .lay-all img.bg-layall-hover,
.bets-HS .lay-all img.bg-layall-hover,
.bets-GH .lay-all img.bg-layall-hover {
  background-position: 0 -2689px
}

.fm-bets .lay-all:hover img,
.bets-HS .lay-all:hover img,
.bets-GH .lay-all:hover img {
  background-repeat: repeat-x;
  background-position: 0 -2689px
}

.bets.disable td a,
.disable.bets-HS td a,
.disable.bets-GH td a {
  color: #999;
  cursor: not-allowed
}

.bets.disable .back-all,
.disable.bets-HS .back-all,
.disable.bets-GH .back-all {
  background-position: -274px -251px
}

.bets.disable .back-all img,
.disable.bets-HS .back-all img,
.disable.bets-GH .back-all img {
  background-repeat: repeat-x;
  background-position: 0 -2160px
}

.bets.disable .lay-all,
.disable.bets-HS .lay-all,
.disable.bets-GH .lay-all {
  background-position: 100% -355px
}

.bets.disable .lay-all img,
.disable.bets-HS .lay-all img,
.disable.bets-GH .lay-all img {
  background-repeat: repeat-x;
  background-position: 0 -2160px
}

.bets-HS th,
.bets-GH th {
  padding: 4px 10px 5px 5px;
  overflow: visible
}

.bets-HS td,
.bets-GH td {
  vertical-align: middle
}

.bets-HS td a,
.bets-GH td a {
  height: 35px
}

.bets-HS td.suspend span,
.bets-GH td.suspend span {
  line-height: 38px
}

.bets-HS .predict th,
.bets-GH .predict th {
  padding: 3px 10px 3px 5px
}

.bets-HS .predict td a,
.bets-GH .predict td a {
  padding: 10px 0 9px
}

.bets-HS .predict .suspend,
.bets-GH .predict .suspend {
  height: 53px
}

.bets-HS .predict .suspend span,
.bets-GH .predict .suspend span {
  height: 100%;
  line-height: 53px
}

.horse-info,
.dog-info {
  width: 292px;
  height: 31px
}

.horse-info>dt,
.dog-info>dt {
  flex: 0 0 auto;
  margin-right: 7px;
  align-items: center
}

.horse-info>dd,
.dog-info>dd {
  flex: 1;
  min-width: 0;
  position: relative;
  align-items: center
}

.horse-info>dd:hover .horse_info-hover,
.dog-info>dd:hover .horse_info-hover {
  display: block
}

.horse-info li,
.dog-info li {
  list-style: none
}

.horse-info .icon-predict,
.dog-info .icon-predict {
  margin-right: 0
}

.predict .horse-info,
.predict .dog-info {
  margin-bottom: 2px
}

.horse-box {
  min-width: 25px
}

.horse-box li {
  list-style: none;
  font-size: 11px;
  font-weight: 400
}

.horse-box.only-num {
  font-size: 13px
}

.uniform {
  width: 26px;
  height: 21px;
  margin: 0 0 0 3px;
  background-position: -388px -635px
}

.uniform img {
  width: 26px;
  height: 21px
}

.horse-name {
  cursor: default;
  min-width: 0
}

.horse-name li {
  font-weight: 400
}

.horse-name li:first-of-type {
  font-weight: 700
}

.horse_info-hover {
  display: none;
  position: absolute;
  top: 100%;
  background-color: #fff;
  font-size: 11px;
  font-weight: 400;
  padding: 5px 7px;
  border-radius: 4px;
  z-index: 10;
  pointer-events: none
}

.horse_info-hover dt {
  clear: left;
  margin-right: 5px
}

.horse_info-hover dd {
  clear: right
}

.win,
.to-win {
  color: #508d0e;
  margin: 0 5px 0 0
}

.to-win {
  padding-left: 13px;
  background-position: -404px -1349px
}

.to-win:hover,
.to-win.green_arrow-hover {
  background-position: -404px -1333px
}

.lose,
.to-lose {
  color: #d0021b;
  margin: 0 5px 0 0
}

.to-lose {
  padding-left: 13px;
  background-position: -404px -2473px
}

.to-lose:hover,
.to-lose.red_arrow-hover {
  background-position: -404px -2457px
}

.more {
  line-height: 24px;
  padding-right: 20px;
  background-position: 100% -1384px
}

.suspend {
  position: absolute;
  width: 24%;
  height: calc(100% - 2px);
  background-color: #fff;
  border: 1px solid #d0021b;
  color: #d0021b;
  margin-left: calc(76% - 42px);
  z-index: 5
}

.suspend span {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -8px
}

.event-left .suspend,
.event-right .suspend {
  width: 31.78808%;
  margin-left: 66.22517%
}

.col3 .suspend {
  width: 36%;
  margin-left: calc(64% - 38px)
}

dd .suspend,
.event-left dd .suspend,
.event-right dd .suspend,
.col3 dd .suspend {
  width: calc(100% - 8px);
  height: calc(100% - 6px);
  margin-left: 0
}

td .suspend {
  top: 0;
  width: calc(100% - 2px);
  margin-left: 0
}

.fm-bets .suspend,
.bets-HS .suspend,
.bets-GH .suspend {
  position: static;
  border-right-width: 0
}

.fm-bets .suspend span,
.bets-HS .suspend span,
.bets-GH .suspend span {
  position: static;
  top: 0;
  width: calc(100% - 2px);
  background-color: #fff;
  line-height: 37px;
  border: 1px solid #d0021b;
  margin-top: 0
}

.btn-book {
  position: absolute;
  top: 6px;
  right: 5px;
  font-weight: 400
}

.line_markets-team {
  background-repeat: repeat-x;
  background-position: 0 -2733px
}

.line_markets-team .game-visit span {
  background-position: -388px -484px;
  height: 38px;
  width: 26px
}

.line_markets-team .game-home span {
  background-position: -388px -424px;
  height: 38px;
  width: 26px
}

.line_markets-team .game-vs div {
  position: relative;
  background-repeat: repeat-x;
  background-position: 0 -2771px
}

.line_markets-team .game-vs div:before {
  position: absolute;
  content: '';
  background-position: -394px -522px;
  height: 34px;
  width: 20px
}

.line_markets-team .game-vs div:after {
  position: absolute;
  top: 0;
  right: 0;
  content: '';
  background-position: -394px -556px;
  height: 34px;
  width: 20px
}

.btn-rules {
  position: absolute;
  width: 68px;
  left: 50%;
  background-color: #e0e6e6;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
  margin-top: 3px;
  margin-left: -34px
}

.btn-rules img {
  margin-right: 5px;
  background-position: -404px -1941px;
  height: 9px;
  width: 10px
}

.rules-wrap {
  position: absolute;
  left: 50%;
  width: 460px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  margin-left: -230px;
  margin-top: -119px;
  z-index: 10
}

.rules-wrap:not(:target) {
  display: none
}

.rules-wrap:target {
  display: block
}

.rules-wrap h3 {
  height: 40px;
  line-height: 40px;
  background-color: #eee
}

.rules-wrap .rules-content {
  height: 340px;
  padding: 8px 15px;
  line-height: 18px;
  color: rgba(36, 58, 72, .9);
  overflow: hidden;
  overflow-y: auto
}

.rules-wrap ol {
  margin: 0 0 10px 20px
}

.rules-wrap ol li {
  margin-bottom: 5px
}

.rules-wrap .btn-wrap {
  border-top: 1px solid #ccc;
  padding: 8px 0 0
}

.rules-wrap .btn-wrap li {
  width: 100%
}

.rules-wrap .btn-wrap .btn,
.rules-wrap .btn-wrap .btn-send,
.rules-wrap .btn-wrap .pages a,
.pages .rules-wrap .btn-wrap a,
.rules-wrap .btn-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .rules-wrap .btn-wrap input,
.rules-wrap .btn-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .rules-wrap .btn-wrap textarea {
  width: 150px;
  margin: 0 auto
}

.line_market-name {
  position: absolute;
  top: -24px;
  font-size: 12px;
  color: #fff;
  line-height: 22px;
  padding-right: 11px;
  background-position: 100% -462px
}

.line_market-name span {
  height: 22px;
  background-repeat: repeat-x;
  padding-left: 5px;
  background-position: 0 -2711px
}

.scores-line {
  color: #fff;
  background-repeat: repeat-x;
  background-position: 0 -3792px
}

.scores-line img {
  background-position: -396px -2138px;
  height: 29px;
  width: 18px
}

.tab-markets {
  background: transparent;
  border-bottom: 1px solid #21323d;
  margin-bottom: 5px
}

.tab-markets a {
  background-position: -284px -613px
}

.tab-markets a.select {
  height: 23px;
  color: #000;
  margin-bottom: -1px;
  background-position: -284px -590px
}

.closed-wrap {
  position: relative;
  height: 390px;
  background-size: cover;
  margin-bottom: 1px
}

.closed-next h2 {
  font-size: 25px;
  line-height: 50px;
  border-bottom: 1px solid rgba(255, 255, 255, .3);
  margin: 0;
  padding: 0
}

.closed-next p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 0;
  padding: 9px 0
}

.closed-next a {
  color: #60bbfd;
  font-weight: 700
}

.add-favourite,
.delete-pin {
  background-position: -393px -78px;
  height: 21px;
  width: 21px
}

.add-favourite:hover,
.delete-pin:hover,
.add-favourite.add-favourite-hover,
.add-favourite-hover.delete-pin {
  background-position: -393px -15px
}

.info-icon .add-favourite,
.info-icon .delete-pin {
  padding: 0;
  background-position: -398px -57px;
  height: 21px;
  width: 16px
}

.info-icon .add-favourite:hover,
.info-icon .delete-pin:hover,
.info-icon .add-favourite.add-favourite-s-hover,
.info-icon .add-favourite-s-hover.delete-pin {
  background-position: -398px -36px
}

.game-head .add-favourite,
.game-head .delete-pin {
  position: absolute;
  top: 8px;
  left: 5px;
  z-index: 3
}

h3 .add-favourite,
h3 .delete-pin {
  margin: 0 7px 0 -10px;
  background-position: -385px -869px;
  height: 25px;
  width: 29px
}

h3 .add-favourite:hover,
h3 .delete-pin:hover,
h3 .add-favourite.btn-add-favourite-hover,
h3 .btn-add-favourite-hover.delete-pin {
  background-position: -385px -794px
}

h4 .add-favourite,
.tc-content h5 .add-favourite,
h4 .delete-pin,
.tc-content h5 .delete-pin {
  border-top: 1px solid #097d8c;
  border-right: 1px solid #097d8c;
  background-position: -385px -869px;
  height: 25px;
  width: 29px
}

h4 .add-favourite:hover,
.tc-content h5 .add-favourite:hover,
h4 .delete-pin:hover,
.tc-content h5 .delete-pin:hover,
h4 .add-favourite.btn-add-favourite-hover,
.tc-content h5 .add-favourite.btn-add-favourite-hover,
h4 .btn-add-favourite-hover.delete-pin,
.tc-content h5 .btn-add-favourite-hover.delete-pin {
  background-position: -385px -794px
}

.delete-pin {
  background-position: -393px -1212px;
  height: 21px;
  width: 21px
}

.delete-pin:hover,
.delete-pin.delete-pin-hover {
  background-position: -393px -1149px
}

.info-icon .delete-pin {
  background-position: -398px -1191px;
  height: 21px;
  width: 16px
}

.info-icon .delete-pin:hover,
.info-icon .delete-pin.delete-pin-s-hover {
  background-position: -398px -1170px
}

h3 .delete-pin {
  background-position: -385px -979px;
  height: 25px;
  width: 29px
}

h3 .delete-pin:hover,
h3 .delete-pin.btn-delete-pin-hover {
  background-position: -385px -954px
}

h4 .delete-pin,
.tc-content h5 .delete-pin {
  background-position: -385px -979px;
  height: 25px;
  width: 29px
}

h4 .delete-pin:hover,
.tc-content h5 .delete-pin:hover,
h4 .delete-pin.btn-delete-pin-hover,
.tc-content h5 .delete-pin.btn-delete-pin-hover {
  background-position: -385px -954px
}

.multi_refresh {
  background-position: -51px -519px;
  height: 25px;
  width: 29px
}

.game-wrap h3 .multi_name {
  width: auto
}

.one_click-wrap {
  position: relative
}

.one_click-wrap .overlay {
  z-index: 51
}

.one_click-wrap .dialog-wrap,
.one_click-wrap .dialog-wrap-w {
  top: -170px;
  z-index: 52;
  animation: upIn .8s ease
}

.arrow-dialog {
  position: absolute;
  margin-left: 152px;
  background-position: -398px -99px;
  height: 10px;
  width: 16px
}

@keyframes upIn {
  0% {
    opacity: 0;
    top: -140px
  }

  100% {
    opacity: 1;
    top: -170px
  }
}

.white-halo {
  box-shadow: 0 0 8px 8px rgba(255, 255, 255, .7)
}

.one_click-setting {
  position: relative;
  height: 31px;
  background-repeat: repeat-x;
  background-color: #3a7000;
  color: #fff;
  padding: 0 10px;
  overflow: hidden;
  z-index: 52;
  background-position: 0 -2060px
}

.one_click-setting h4,
.one_click-setting .tc-content h5,
.tc-content .one_click-setting h5 {
  line-height: 31px
}

.one_click-setting a {
  width: 68px;
  height: 18px;
  border: 1px solid #164f00;
  font-size: 11px;
  line-height: 18px;
  margin: 0
}

.one_click-setting .a-edit {
  border-radius: 4px;
  color: #fff;
  margin-top: 5px;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, .5)
}

.one_click-setting .a-edit img {
  margin-left: 3px;
  background-position: -405px -1701px;
  height: 9px;
  width: 9px
}

.one_click-setting .btn-send {
  margin-top: 5px
}

.one_click-stake {
  position: absolute;
  left: 50%;
  margin-left: -207px;
  background-position: 0 -3003px;
  height: 31px;
  width: 414px
}

.one_click-stake li {
  width: 65px;
  padding-top: 5px
}

.one_click-stake .btn,
.one_click-stake .btn-send,
.one_click-stake .pages a,
.pages .one_click-stake a,
.one_click-stake .calendarTable_inputBox input,
.calendarTable_inputBox .one_click-stake input,
.one_click-stake .calendarTable_inputBox textarea,
.calendarTable_inputBox .one_click-stake textarea {
  width: calc(100% - 2px);
  font-weight: 400;
  border-color: #174f00
}

.one_click-stake .btn.select,
.one_click-stake .select.btn-send,
.one_click-stake .pages a.select,
.pages .one_click-stake a.select,
.one_click-stake .calendarTable_inputBox input.select,
.calendarTable_inputBox .one_click-stake input.select,
.one_click-stake .calendarTable_inputBox textarea.select,
.calendarTable_inputBox .one_click-stake textarea.select {
  border-color: #6a3d0c
}

.one_click-stake input,
.one_click-stake textarea {
  width: 100%;
  line-height: 18px;
  font-size: 11px;
  color: #174f00;
  padding: 0;
  margin: 0;
  border: 1px solid #174f00;
  background-color: #6ea73c;
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, .15)
}

.one_click-stake input:focus,
.one_click-stake textarea:focus {
  border-color: #fff;
  background-color: #9fbf69
}

.quick_bet-wrap {
  border: 1px solid #7e97a7;
  border-width: 1px 0 1px 0;
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, .1);
  padding: 0 2px 0 7px
}

.quick_bet-wrap dt,
.quick_bet-wrap dd {
  box-sizing: border-box
}

.quick_bet-wrap dt {
  width: 53.79665%;
  height: auto;
  line-height: 22px;
  padding: 13px 5px 12px 0
}

.quick_bet-wrap dt .slip-type {
  margin-top: 0
}

.quick_bet-wrap dd {
  padding: 7px 5px 7px 0
}

.quick_bet-wrap .col-btn {
  width: 9.00901%
}

.quick_bet-wrap .col-odd {
  width: 8.36551%
}

.quick_bet-wrap .col-stake {
  width: 10.29601%;
  padding-left: 0
}

.quick_bet-wrap .col-send {
  width: 18.01802%
}

.quick_bet-wrap .btn,
.quick_bet-wrap .btn-send,
.quick_bet-wrap .pages a,
.pages .quick_bet-wrap a,
.quick_bet-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .quick_bet-wrap input,
.quick_bet-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .quick_bet-wrap textarea {
  height: 31px;
  line-height: 31px;
  margin: 0
}

.quick_bet-wrap .btn.line-2,
.quick_bet-wrap .line-2.btn-send,
.quick_bet-wrap .pages a.line-2,
.pages .quick_bet-wrap a.line-2,
.quick_bet-wrap .calendarTable_inputBox input.line-2,
.calendarTable_inputBox .quick_bet-wrap input.line-2,
.quick_bet-wrap .calendarTable_inputBox textarea.line-2,
.calendarTable_inputBox .quick_bet-wrap textarea.line-2 {
  line-height: 18px
}

.quick_bet-wrap .btn span,
.quick_bet-wrap .btn-send span,
.quick_bet-wrap .pages a span,
.pages .quick_bet-wrap a span,
.quick_bet-wrap .calendarTable_inputBox input span,
.calendarTable_inputBox .quick_bet-wrap input span,
.quick_bet-wrap .calendarTable_inputBox textarea span,
.calendarTable_inputBox .quick_bet-wrap textarea span {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px
}

.quick_bet-wrap input,
.quick_bet-wrap textarea {
  line-height: 33px;
  height: 33px
}

.quick_bet-wrap input.disable,
.quick_bet-wrap textarea.disable,
.quick_bet-wrap input:focus,
.quick_bet-wrap textarea:focus {
  line-height: 31px
}

.quick_bet-wrap input.highlight,
.quick_bet-wrap textarea.highlight {
  background-color: #f6eed0
}

.quick_bet-wrap .odd-add {
  height: 29px;
  top: 9px;
  right: 7px
}

.quick_bet-wrap .odd-add .up {
  line-height: 15px;
  background-position: -402px -2384px;
  height: 16px;
  width: 12px
}

.quick_bet-wrap .odd-add .up:hover,
.quick_bet-wrap .odd-add .up.num_up-big-hover {
  background-position: -402px -2416px
}

.quick_bet-wrap .odd-add .down {
  line-height: 9px;
  background-position: -402px -2342px;
  height: 14px;
  width: 12px
}

.quick_bet-wrap .odd-add .down:hover,
.quick_bet-wrap .odd-add .down.num_down-big-hover {
  background-position: -402px -2370px
}

.quick_bet-wrap .odd-add.disable .up {
  background-position: -402px -2400px;
  height: 16px;
  width: 12px
}

.quick_bet-wrap .odd-add.disable .down {
  background-position: -402px -2356px;
  height: 14px;
  width: 12px
}

.event-left .quick_bet-wrap dt,
.event-right .quick_bet-wrap dt {
  width: 9.36709%
}

.event-left .quick_bet-wrap .col-btn,
.event-right .quick_bet-wrap .col-btn {
  width: 17.72152%
}

.event-left .quick_bet-wrap .col-odd,
.event-right .quick_bet-wrap .col-odd {
  width: 16.4557%
}

.event-left .quick_bet-wrap .col-stake,
.event-right .quick_bet-wrap .col-stake {
  width: 20.25316%
}

.event-left .quick_bet-wrap .col-send,
.event-right .quick_bet-wrap .col-send {
  width: 36.20253%
}

.quick_bet-wrap .col-stake_list {
  width: calc(100%+7px+2px);
  padding: 5px 0;
  margin-left: -7px
}

.quick_bet-wrap .col-stake_list ul {
  width: 70%;
  padding-right: 5px
}

.quick_bet-wrap .col-stake_list a {
  height: auto;
  line-height: 23px;
  font-size: 12px
}

.back-gradient dd,
.lay-gradient dd {
  flex: 1;
  padding: 2px;
  color: #59708D;
}

.back-gradient p,
.lay-gradient p {
  width: 100%;
  margin-bottom: 0;
}

.edit img {
  margin-left: 2px;
  background-position: -405px -1512px;
  height: 9px;
  width: 9px
}

.quick-bet-confirm {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, .5);
  flex-direction: column;
  justify-content: center;
}

.quick-bet-confirm li {
  list-style: none;
  line-height: 18px;
  color: #1e1e1e;
  padding: 0 5px
}

.quick-bet-confirm .quick-bet-confirm-title {
  font-size: 10px;
  line-height: 12px;
  color: #222;
  opacity: .5
}

.quick_bet-progress {
  padding: 0;
  background-color: #e2e8ed
}

.quick_bet-progress .progress-bar {
  width: auto;
  height: 30px;
  padding: 0;
  margin: 0;
  background: #c2d5e4;
  border-radius: 0;
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, .1);
  transition: width .4s ease
}

.quick_bet-progress .progress-bar-txt {
  position: absolute;
  width: 100%;
  font-weight: 700;
  color: #000;
  line-height: 30px;
  padding: 0
}

.quick_bet-progress .progress-bar-txt span {
  font-weight: 400;
  font-size: 11px;
  padding-left: 12px
}

.quick_bet-message {
  padding: 0 10px;
  border-bottom-width: 0
}

.quick_bet-message dd {
  width: 100%;
  padding: 0;
  line-height: 30px
}

.quick_bet-message strong {
  padding-right: 5px
}

.quick_bet-message .close-button {
  margin-top: 9px
}

.game-fancy {
  background-color: #0a92a5
}

.game-head .game-fancy {
  padding: 0 5px;
  border-radius: 3px
}

.game-fancy .info-inplay {
  margin-right: 5px;
  background-position: -395px -1730px;
  height: 16px;
  width: 19px
}

.game-fancy.in-play {
  overflow: auto;
  padding-left: 0
}

.game-fancy.in-play:before {
  content: '';
  margin-right: 5px;
  background-position: -395px -1730px;
  height: 16px;
  width: 19px
}

.fancy_bet,
.sportsbook_bet {
  box-shadow: 0 2px 0 rgba(0, 0, 0, .1)
}

.fancy_bet .fm-bets,
.sportsbook_bet .fm-bets,
.fancy_bet .bets-HS,
.sportsbook_bet .bets-HS,
.fancy_bet .bets-GH,
.sportsbook_bet .bets-GH {
  margin-top: 0
}

.fancy_bet .fm-bet-zone,
.sportsbook_bet .fm-bet-zone {
  line-height: 22px
}

.fancy_bet .td-fancy_merge,
.sportsbook_bet .td-fancy_merge {
  width: 17.94872%;
  border-left-width: 0;
  font-weight: 400;
  text-align: left
}

.fancy_bet .td-fancy_merge .btn-book,
.sportsbook_bet .td-fancy_merge .btn-book {
  height: 27px;
  padding: 0;
  right: 10px;
  margin-bottom: 10px
}

.fancy_bet .td-fancy_merge .btn-book:hover,
.sportsbook_bet .td-fancy_merge .btn-book:hover {
  text-decoration: underline
}

.fancy_bet .td-fancy_merge:hover,
.sportsbook_bet .td-fancy_merge:hover {
  background-color: transparent
}

.lit-content-center .fancy_bet,
.lit-content-center .sportsbook_bet {
  margin: 48px 0 40px
}

.game-wrap .fancy_bet,
.game-wrap .sportsbook_bet {
  margin: 0 3px 5px;
  border-top: 0;
  box-shadow: none
}

.fancy_bet .fancy-suspend-tr th,
.sportsbook_bet .fancy-suspend-tr th,
.fancy_bet .fancy-suspend-tr td,
.sportsbook_bet .fancy-suspend-tr td {
  position: relative;
  height: 0;
  border-width: 0;
  margin-bottom: -1px;
  padding: 0
}

.fancy_bet .fancy-suspend-tr span,
.sportsbook_bet .fancy-suspend-tr span {
  font-size: 12px
}

.fancy_bet .fancy-quick-tr td,
.sportsbook_bet .fancy-quick-tr td {
  text-align: left
}

.fancy_bet .fancy-quick-tr td a,
.sportsbook_bet .fancy-quick-tr td a {
  padding: 0
}

.fancy_bet .fancy-quick-tr td .close-button,
.sportsbook_bet .fancy-quick-tr td .close-button {
  height: 10px
}

.fancy_bet .fancy-quick-tr .quick_bet-wrap,
.sportsbook_bet .fancy-quick-tr .quick_bet-wrap {
  border-width: 0
}

.fancy-head {
  position: absolute;
  top: -28px;
  width: 100%;
  border-bottom: 3px solid #0a92a5
}

.fancy-head h4,
.fancy-head .tc-content h5,
.tc-content .fancy-head h5 {
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  color: #fff
}

.fancy-head h4 span,
.fancy-head .tc-content h5 span,
.tc-content .fancy-head h5 span {
  min-width: 72px;
  background-repeat: repeat-x;
  line-height: 25px;
  padding: 0 0 0 10px;
  vertical-align: top;
  background-position: 0 -2182px
}

.fancy-head .in-play span {
  padding: 0 14px 0 8px
}

.fancy-head .in-play span:before {
  content: '';
  margin: 6px 6px 0 0;
  background-position: -399px -1797px;
  height: 15px;
  width: 15px
}

.btn-fancybet_rules {
  vertical-align: top;
  margin-left: -4px;
  background-position: -377px -1004px;
  height: 25px;
  width: 37px
}

.fancy-info {
  line-height: 15px;
  margin: 4px 0 0 15px
}

.fancy-info dt {
  color: #7e97a7;
  margin-right: 2px
}

.fancy-info dt span {
  width: 56px;
  background-color: #bed5d8;
  border-radius: 3px;
  color: #000;
  font-size: 11px
}

.fancy-info dd {
  margin-right: 8px
}

.fancy-info dd:last-of-type {
  margin-right: 0
}

.fancy-info:last-of-type {
  margin-right: 0
}

td .fancy-info {
  width: calc(70% - 3%);
  margin: 4px 0 0 3%;
  float: left
}

td .fancy-info:last-of-type {
  width: calc(30% - 3%)
}

td .fancy-info dt {
  display: block;
  font-size: 11px
}

.fancy-suspend,
.fancy-suspend-white {
  height: 45px
}

.fancy-suspend span,
.fancy-suspend-white span {
  line-height: 40px
}

.fancy-suspend-white {
  height: calc(40px - 2px);
  background-color: #fff;
  border: 1px solid #d0021b
}

.fancy-suspend-white span {
  line-height: calc(40px - 2px);
  color: #d0021b;
  text-shadow: none;
  opacity: 1
}

.fancy-suspend-white:hover {
  background-color: #fff
}

.game-sportsbook {
  background-color: #e8771b
}

.game-head .game-sportsbook {
  padding: 0 5px;
  border-radius: 3px
}

.sportsbook_bet .fancy-quick-tr dt span {
  display: inline-block
}

.sportsbook-head {
  position: absolute;
  top: -28px;
  width: 100%;
  border-bottom: 3px solid #e8771b
}

.sportsbook-head h4,
.sportsbook-head .tc-content h5,
.tc-content .sportsbook-head h5 {
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  color: #fff
}

.sportsbook-head h4:after,
.sportsbook-head .tc-content h5:after,
.tc-content .sportsbook-head h5:after {
  content: '';
  background-position: -402px -2167px;
  height: 25px;
  width: 12px
}

.sportsbook-head h4 span,
.sportsbook-head .tc-content h5 span,
.tc-content .sportsbook-head h5 span {
  min-width: 75px;
  background-repeat: repeat-x;
  line-height: 25px;
  padding: 0 5px 0 10px;
  vertical-align: top;
  background-position: 0 -3861px
}

.no_bet {
  font-size: 13px;
  line-height: 16px;
  padding: 7px 10px 17px;
  border-bottom: 1px solid #7e97a7
}

.saddle_1 {
  background-color: #bc0000;
  color: #fff
}

.saddle_1:before {
  content: "1"
}

.saddle_1A {
  background-color: #bc0000;
  color: #fff
}

.saddle_1A:before {
  content: "1A"
}

.saddle_1B {
  background-color: #bc0000;
  color: #fff
}

.saddle_1B:before {
  content: "1B"
}

.saddle_1C {
  background-color: #bc0000;
  color: #fff
}

.saddle_1C:before {
  content: "1C"
}

.saddle_1D {
  background-color: #bc0000;
  color: #fff
}

.saddle_1D:before {
  content: "1D"
}

.saddle_1X {
  background-color: #bc0000;
  color: #fff
}

.saddle_1X:before {
  content: "1X"
}

.saddle_1Y {
  background-color: #bc0000;
  color: #fff
}

.saddle_1Y:before {
  content: "1Y"
}

.saddle_2 {
  content: "2";
  background-color: #fff;
  border-color: #dfdfdf;
  color: #000
}

.saddle_2:before {
  content: "2"
}

.saddle_2B {
  content: "2B";
  background-color: #fff;
  border-color: #dfdfdf;
  color: #000
}

.saddle_2B:before {
  content: "2B"
}

.saddle_2C {
  content: "2C";
  background-color: #fff;
  border-color: #dfdfdf;
  color: #000
}

.saddle_2C:before {
  content: "2C"
}

.saddle_2X {
  content: "2X";
  background-color: #fff;
  border-color: #dfdfdf;
  color: #000
}

.saddle_2X:before {
  content: "2X"
}

.saddle_3 {
  background-color: #243b84;
  color: #fff
}

.saddle_3:before {
  content: "3"
}

.saddle_3C {
  background-color: #243b84;
  color: #fff
}

.saddle_3C:before {
  content: "3C"
}

.saddle_3D {
  background-color: #243b84;
  color: #fff
}

.saddle_3D:before {
  content: "3D"
}

.saddle_3E {
  background-color: #243b84;
  color: #fff
}

.saddle_3E:before {
  content: "3E"
}

.saddle_3X {
  background-color: #243b84;
  color: #fff
}

.saddle_3X:before {
  content: "3X"
}

.saddle_4 {
  background-color: #c1a800;
  color: #000
}

.saddle_4:before {
  content: "4"
}

.saddle_4D {
  background-color: #c1a800;
  color: #000
}

.saddle_4D:before {
  content: "4D"
}

.saddle_4X {
  background-color: #c1a800;
  color: #000
}

.saddle_4X:before {
  content: "4X"
}

.saddle_5 {
  background-color: #1c5b1b;
  color: #fff
}

.saddle_5:before {
  content: "5"
}

.saddle_6 {
  background-color: #252525;
  color: #fff
}

.saddle_6:before {
  content: "6"
}

.saddle_7 {
  background-color: #b63d13;
  color: #000
}

.saddle_7:before {
  content: "7"
}

.saddle_8 {
  background-color: #b27692;
  color: #000
}

.saddle_8:before {
  content: "8"
}

.saddle_9 {
  background-color: #14a19c;
  color: #000
}

.saddle_9:before {
  content: "9"
}

.saddle_10 {
  background-color: #610f9a;
  color: #fff
}

.saddle_10:before {
  content: "10"
}

.saddle_11 {
  background-color: #6b6b6b;
  color: #fff
}

.saddle_11:before {
  content: "11"
}

.saddle_11F {
  background-color: #6b6b6b;
  color: #fff
}

.saddle_11F:before {
  content: "11F"
}

.saddle_12 {
  background-color: #2e9a3b;
  color: #fff
}

.saddle_12:before {
  content: "12"
}

.saddle_12F {
  background-color: #2e9a3b;
  color: #fff
}

.saddle_12F:before {
  content: "12F"
}

.saddle_13 {
  background-color: #413733;
  color: #fff
}

.saddle_13:before {
  content: "13"
}

.saddle_13F {
  background-color: #413733;
  color: #fff
}

.saddle_13F:before {
  content: "13F"
}

.saddle_14 {
  background-color: #790031;
  color: #fff
}

.saddle_14:before {
  content: "14"
}

.saddle_14F {
  background-color: #790031;
  color: #fff
}

.saddle_14F:before {
  content: "14F"
}

.saddle_15 {
  background-color: #715933;
  color: #fff
}

.saddle_15:before {
  content: "15"
}

.saddle_15F {
  background-color: #715933;
  color: #fff
}

.saddle_15F:before {
  content: "15F"
}

.saddle_16 {
  background-color: #3b5d8f;
  color: #fff
}

.saddle_16:before {
  content: "16"
}

.saddle_16F {
  background-color: #3b5d8f;
  color: #fff
}

.saddle_16F:before {
  content: "16F"
}

.saddle_17 {
  background-color: #191986;
  color: #fff
}

.saddle_17:before {
  content: "17"
}

.saddle_17F {
  background-color: #191986;
  color: #fff
}

.saddle_17F:before {
  content: "17F"
}

.saddle_18 {
  background-color: #0d4507;
  color: #fff
}

.saddle_18:before {
  content: "18"
}

.saddle_18F {
  background-color: #0d4507;
  color: #fff
}

.saddle_18F:before {
  content: "18F"
}

.saddle_19 {
  background-color: #283f62;
  color: #fff
}

.saddle_19:before {
  content: "19"
}

.saddle_19F {
  background-color: #283f62;
  color: #fff
}

.saddle_19F:before {
  content: "19F"
}

.saddle_20 {
  background-color: #45001b;
  color: #fff
}

.saddle_20:before {
  content: "20"
}

.saddle_20F {
  background-color: #45001b;
  color: #fff
}

.saddle_20F:before {
  content: "20F"
}

.saddle_21 {
  background-color: #45001b;
  color: #fff
}

.saddle_21:before {
  content: "21"
}

.saddle_21F {
  background-color: #45001b;
  color: #fff
}

.saddle_21F:before {
  content: "21F"
}

.saddle_22 {
  background-color: #45001b;
  color: #fff
}

.saddle_22:before {
  content: "22"
}

.saddle_22F {
  background-color: #45001b;
  color: #fff
}

.saddle_22F:before {
  content: "22F"
}

.saddle_23 {
  background-color: #45001b;
  color: #fff
}

.saddle_23:before {
  content: "23"
}

.saddle_23F {
  background-color: #45001b;
  color: #fff
}

.saddle_23F:before {
  content: "23F"
}

.saddle_24 {
  background-color: #45001b;
  color: #fff
}

.saddle_24:before {
  content: "24"
}

.saddle_24F {
  background-color: #45001b;
  color: #fff
}

.saddle_24F:before {
  content: "24F"
}

.saddle_25 {
  background-color: #45001b;
  color: #fff
}

.saddle_25:before {
  content: "25"
}

.saddle_25F {
  background-color: #45001b;
  color: #fff
}

.saddle_25F:before {
  content: "25F"
}

.saddle_26 {
  background-color: #45001b;
  color: #fff
}

.saddle_26:before {
  content: "26"
}

.saddle_26F {
  background-color: #45001b;
  color: #fff
}

.saddle_26F:before {
  content: "26F"
}

.saddle_27 {
  background-color: #45001b;
  color: #fff
}

.saddle_27:before {
  content: "27"
}

.saddle_27F {
  background-color: #45001b;
  color: #fff
}

.saddle_27F:before {
  content: "27F"
}

.saddle_28 {
  background-color: #45001b;
  color: #fff
}

.saddle_28:before {
  content: "28"
}

.saddle_28F {
  background-color: #45001b;
  color: #fff
}

.saddle_28F:before {
  content: "28F"
}

.saddle_29 {
  background-color: #45001b;
  color: #fff
}

.saddle_29:before {
  content: "29"
}

.saddle_29F {
  background-color: #45001b;
  color: #fff
}

.saddle_29F:before {
  content: "29F"
}

.saddle_30 {
  background-color: #45001b;
  color: #fff
}

.saddle_30:before {
  content: "30"
}

.saddle_30F {
  background-color: #45001b;
  color: #fff
}

.saddle_30F:before {
  content: "30F"
}

.profile-wrap {
  background-color: #fff;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 15px
}

.profile-wrap h3 {
  background-color: #7e97a7;
  color: #fff;
  line-height: 24px;
  padding: 0 10px
}

.profile-wrap dt {
  width: 125px;
  padding: 5px 0 5px 10px;
  color: #000
}

.profile-wrap dd {
  position: relative;
  min-height: 16px;
  padding: 5px 0 5px 10px;
  border-bottom: 1px solid #e0e6e6
}

.profile-wrap dd:last-child {
  border-bottom-width: 0
}

.profile-wrap .favor-set {
  position: absolute;
  right: 0;
  top: 1px
}

.profile-wrap select {
  min-width: 150px;
  margin: 0
}

.pop_bg {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
  z-index: 80
}

.pop_bg:not(:target) {
  display: none
}

.pop_bg:target {
  display: block
}

.pop_box {
  position: fixed;
  top: 110px;
  left: 50%;
  background-color: #eee;
  width: 400px;
  border-radius: 5px;
  padding: 15px;
  transform: translate(-50%, 0);
}

.pop_box h3 {
  font-size: 16px;
  color: #000;
  margin-bottom: 18px
}

.pop_box .btn,
.pop_box .btn-send,
.pop_box .pages a,
.pages .pop_box a,
.pop_box .calendarTable_inputBox input,
.calendarTable_inputBox .pop_box input,
.pop_box .calendarTable_inputBox textarea,
.calendarTable_inputBox .pop_box textarea {
  width: 55%;
  margin: 15px 0 0
}

.close_pop {
  position: absolute;
  right: 15px;
  background-position: -41px -632px;
  height: 16px;
  width: 17px
}

.form_list {
  padding: 0 20px;
  margin-bottom: 10px
}

.form_list dt {
  width: 122px;
  text-align: right;
  margin-right: 10px;
  line-height: 24px
}

.form_list dd {
  position: relative;
  margin-bottom: 10px;
  padding-left: 132px
}

.form_list dd input,
.form_list dd textarea {
  width: 160px;
  margin: 0
}

.form_list dd select {
  width: 172px
}

.must {
  font-size: 13px;
  color: #d0021b
}

.error-text {
  color: #d0021b;
  font-size: 11px
}

input.error,
textarea.error {
  background-color: #efd3d9;
  color: #1e1e1e
}

.confirm_box {
  width: 280px;
  margin: 15% 0 0 -140px
}

.confirm_box h3 {
  height: 15px
}

.confirm_box .white-wrap {
  padding: 15px 10px;
  margin-bottom: 10px
}

.confirm_box .white-wrap p {
  width: 100%
}

.confirm_box .btn_box .btn,
.confirm_box .btn_box .btn-send,
.confirm_box .btn_box .pages a,
.pages .confirm_box .btn_box a,
.confirm_box .btn_box .calendarTable_inputBox input,
.calendarTable_inputBox .confirm_box .btn_box input,
.confirm_box .btn_box .calendarTable_inputBox textarea,
.calendarTable_inputBox .confirm_box .btn_box textarea {
  width: 110px;
  margin-right: 5px
}

.confirm_box .btn_box .btn:last-of-type,
.confirm_box .btn_box .btn-send:last-of-type,
.confirm_box .btn_box .pages a:last-of-type,
.pages .confirm_box .btn_box a:last-of-type,
.confirm_box .btn_box .calendarTable_inputBox input:last-of-type,
.calendarTable_inputBox .confirm_box .btn_box input:last-of-type,
.confirm_box .btn_box .calendarTable_inputBox textarea:last-of-type,
.calendarTable_inputBox .confirm_box .btn_box textarea:last-of-type {
  margin-right: 0
}

.go-back,
.pop-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 85px;
  height: 100%;
  line-height: 38px;
  color: #fff;
  font-weight: 400;
  border-left: 1px solid #5f6c74
}

.go-back img,
.pop-close img {
  margin-right: 5px;
  background-position: -46px -1182px;
  height: 12px;
  width: 12px
}

.pop-close img {
  background-position: -46px -1242px;
  height: 12px;
  width: 12px
}

.pop-content {
  height: calc(100% - 35px - 38px);
  padding: 20px 15px 15px;
  overflow: auto
}

.tab {
  min-width: 375px;
  width: 40%;
  margin: 0 0 10px;
  border-left: 1px solid #000;
  border-radius: 5px
}

.tab li {
  list-style: none;
  border: 1px solid #000;
  border-width: 1px 0
}

.tab li:first-child {
  border-radius: 4px 0 0 4px
}

.tab li:first-child a {
  border-radius: 3px 0 0 3px
}

.tab li:last-child {
  border-radius: 0 4px 4px 0
}

.tab li:last-child a {
  border-radius: 0 3px 3px 0
}

.tab a {
  background-color: #fff;
  border-right: 1px solid #000;
  color: #000;
  font-size: 13px;
  line-height: 27px;
  font-weight: 700
}

.tab .select {
  background: #3b5160;
  color: #fff
}

.tab .select:hover {
  text-decoration: none
}

.tab.col2 li {
  width: 50%
}

.tab.col3 li {
  width: 33.33%
}

.tab.col4 li {
  width: 25%
}

.tab.col5 li {
  width: 20%
}

.function-wrap {
  position: relative;
  padding: 10px 10px 0;
  background-color: #e0e6e6;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 10px
}

.white-wrap .function-wrap {
  border-bottom-color: #e0e6e6;
  margin-bottom: 0
}

.game-wrap .function-wrap {
  margin-bottom: 0;
  padding-top: 5px
}

.game-wrap .function-wrap .input-list,
.game-wrap .function-wrap .filter-list {
  margin-bottom: 0
}

.input-list,
.filter-list {
  margin-bottom: 5px
}

.input-list li,
.filter-list li {
  list-style: none;
  line-height: 25px;
  margin: 0 5px 5px 0;
  white-space: nowrap
}

.input-list label,
.filter-list label {
  margin-right: 5px
}

.input-list input,
.filter-list input,
.input-list textarea,
.filter-list textarea,
.input-list select,
.filter-list select {
  margin: 0 5px
}

.input-list .time-input,
.filter-list .time-input {
  margin-left: -3px
}

.input-list .btn,
.filter-list .btn,
.input-list .btn-send,
.filter-list .btn-send,
.input-list .pages a,
.pages .input-list a,
.filter-list .pages a,
.pages .filter-list a,
.input-list .calendarTable_inputBox input,
.calendarTable_inputBox .input-list input,
.filter-list .calendarTable_inputBox input,
.calendarTable_inputBox .filter-list input,
.input-list .calendarTable_inputBox textarea,
.calendarTable_inputBox .input-list textarea,
.filter-list .calendarTable_inputBox textarea,
.calendarTable_inputBox .filter-list textarea {
  width: 95px;
  margin: 0;
  font-weight: 400
}

.input-list .btn-send,
.filter-list .btn-send {
  width: 115px;
  font-weight: 700
}

.filter-list .filter-head {
  width: 85px;
  font-weight: 700
}

.filter-list .filter-content {
  width: calc(100% - 195px);
  height: 25px
}

.filter-list .filter-content span {
  margin-right: 5px;
  color: #000;
  padding-left: 10px;
  background-position: -23px -142px
}

.filter-list .filter-content .filter-first {
  background: 0;
  padding-left: 0
}

.filter-list .filter-btn {
  width: 95px
}

.filter-list .filter-btn .btn,
.filter-list .filter-btn .btn-send,
.filter-list .filter-btn .pages a,
.pages .filter-list .filter-btn a,
.filter-list .filter-btn .calendarTable_inputBox input,
.calendarTable_inputBox .filter-list .filter-btn input,
.filter-list .filter-btn .calendarTable_inputBox textarea,
.calendarTable_inputBox .filter-list .filter-btn textarea {
  width: 93px
}

.filter-list.golf-list .filter-content {
  width: calc(100% - 95px);
  height: auto
}

.filter-list.golf-list .compt {
  position: relative;
  width: auto;
  height: 23px;
  padding: 0 0 0 10px
}

.filter-list.golf-list .compt img {
  border-radius: 0 4px 4px 0;
  vertical-align: middle;
  margin-top: -3px;
  margin-left: 5px;
  background-position: -15px -71px;
  height: 23px;
  width: 12px
}

.filter-list.golf-list .compt img:hover,
.filter-list.golf-list .compt img.btn-comt-hover {
  background-position: -15px -48px
}

.filter-list.golf-list .compt:hover img {
  background-position: -15px -48px
}

.filter-pop {
  position: absolute;
  right: 0;
  width: 500px;
  border-radius: 4px;
  background-color: #fff;
  padding: 8px 8px 0;
  margin-left: -500px;
  z-index: 3
}

.filter-pop:not(:target) {
  display: none
}

.filter-pop:target {
  display: block
}

.filter-pop ul {
  margin-bottom: 5px
}

.filter-pop li {
  width: 250px;
  list-style: none;
  margin-bottom: 3px
}

.filter-pop .btn-wrap {
  border-top: 1px solid #ccc;
  padding-top: 8px
}

.filter-pop .btn-wrap .btn,
.filter-pop .btn-wrap .btn-send,
.filter-pop .btn-wrap .pages a,
.pages .filter-pop .btn-wrap a,
.filter-pop .btn-wrap .calendarTable_inputBox input,
.calendarTable_inputBox .filter-pop .btn-wrap input,
.filter-pop .btn-wrap .calendarTable_inputBox textarea,
.calendarTable_inputBox .filter-pop .btn-wrap textarea {
  width: 15%;
  margin-right: 10px
}

.filter-pop .btn-wrap .btn-send {
  width: 20%
}

.expand-close,
.expand-open {
  text-decoration: none;
  color: #000;
  padding-right: 20px;
  background-position: 100% -112px
}

table .expand-close,
table .expand-open {
  text-decoration: none
}

.align-L .expand-close,
.table01 caption .expand-close,
.table-s caption .expand-close,
.slip-back .refer .expand-close,
.slip-lay .refer .expand-close,
.slip-back .keep-option .expand-close,
.slip-lay .keep-option .expand-close,
.sports-header .col-bet .expand-close,
.matched-head .col-bet .expand-close,
.tips-popup .expand-close,
.full-amount .expand-close,
.no-data .expand-close,
.event-left .col-game .expand-close,
.event-right .col-game .expand-close,
.event-left .sportsgame-list-content dt .expand-close,
.sportsgame-list-content .event-left dt .expand-close,
.event-right .sportsgame-list-content dt .expand-close,
.sportsgame-list-content .event-right dt .expand-close,
.fm-bets th .expand-close,
.bets-HS th .expand-close,
.bets-GH th .expand-close,
.fm-bets .refer-bet .expand-close,
.bets-HS .refer-bet .expand-close,
.bets-GH .refer-bet .expand-close,
.fm-bets .refer-book .expand-close,
.bets-HS .refer-book .expand-close,
.bets-GH .refer-book .expand-close,
.align-L .expand-open,
.table01 caption .expand-open,
.table-s caption .expand-open,
.slip-back .refer .expand-open,
.slip-lay .refer .expand-open,
.slip-back .keep-option .expand-open,
.slip-lay .keep-option .expand-open,
.sports-header .col-bet .expand-open,
.matched-head .col-bet .expand-open,
.tips-popup .expand-open,
.full-amount .expand-open,
.no-data .expand-open,
.event-left .col-game .expand-open,
.event-right .col-game .expand-open,
.event-left .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-left dt .expand-open,
.event-right .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-right dt .expand-open,
.fm-bets th .expand-open,
.bets-HS th .expand-open,
.bets-GH th .expand-open,
.fm-bets .refer-bet .expand-open,
.bets-HS .refer-bet .expand-open,
.bets-GH .refer-bet .expand-open,
.fm-bets .refer-book .expand-open,
.bets-HS .refer-book .expand-open,
.bets-GH .refer-book .expand-open {
  padding-right: 0;
  padding-left: 15px;
  color: #2789ce;
  background-position: -16px -112px
}

.expand-open {
  background-position: 100% -127px
}

.align-L .expand-open,
.table01 caption .expand-open,
.table-s caption .expand-open,
.slip-back .refer .expand-open,
.slip-lay .refer .expand-open,
.slip-back .keep-option .expand-open,
.slip-lay .keep-option .expand-open,
.sports-header .col-bet .expand-open,
.matched-head .col-bet .expand-open,
.tips-popup .expand-open,
.full-amount .expand-open,
.no-data .expand-open,
.event-left .col-game .expand-open,
.event-right .col-game .expand-open,
.event-left .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-left dt .expand-open,
.event-right .sportsgame-list-content dt .expand-open,
.sportsgame-list-content .event-right dt .expand-open,
.fm-bets th .expand-open,
.bets-HS th .expand-open,
.bets-GH th .expand-open,
.fm-bets .refer-bet .expand-open,
.bets-HS .refer-bet .expand-open,
.bets-GH .refer-bet .expand-open,
.fm-bets .refer-book .expand-open,
.bets-HS .refer-book .expand-open,
.bets-GH .refer-book .expand-open {
  background-position: -16px -127px
}

.table-s td,
.table-s th {
  padding: 5px
}

.table-s input,
.table-s textarea {
  margin-bottom: 0;
  padding: 0
}

.small-date {
  font-size: 11px;
  line-height: 13px
}

.market-float {
  width: 94%
}

.expand {
  background-color: #e2e8ed
}

.expand>td {
  position: relative;
  padding: 0;
  border-top-color: #7e97a7;
  border-bottom: 1px solid #7e97a7
}

.expand table {
  width: 85%;
  border-left: 1px solid #7e97a7;
  border-bottom-width: 0;
  margin-left: 15%
}

.expand table th {
  background-color: transparent;
  border-top-width: 0
}

.expand table td {
  border-width: 0;
  padding: 8px 10px
}

.expand table .even {
  background-color: #f2f4f7
}

.table-s .expand table td {
  padding: 5px
}

.expand .table-commission {
  width: 75%;
  margin-left: 23%;
  border-right: 1px solid #7e97a7
}

.expand .sum-pl {
  background-color: #d9e4ec;
  border-top: 1px solid #7e97a7
}

.expand .sum-pl td {
  padding: 0
}

.expand-arrow {
  position: absolute;
  left: 15%;
  margin-left: -10px;
  background-position: -17px -103px;
  height: 9px;
  width: 10px
}

.sum-pl dl {
  padding: 5px 0
}

.sum-pl dt {
  width: 82%;
  padding: 0 10px 5px;
  color: #000
}

.sum-pl dd {
  padding: 0 10px 5px
}

.sum-pl .net_total {
  padding-top: 5px;
  border-top: 1px dotted #7e97a7
}

.expand-arrow-R {
  position: absolute;
  left: 98%;
  margin-top: -1px;
  background-position: -17px -94px;
  height: 9px;
  width: 10px
}

.white-wrap {
  background-color: #fff;
  color: #000;
  padding: 7px 10px 5px;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 15px
}

.white-wrap h3 {
  width: 85%;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 7px
}

.white-wrap p {
  width: 85%;
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 5px
}

.acc-info {
  margin-bottom: 5px
}

.acc-info li {
  margin-right: 15px;
  padding-left: 20px
}

.acc-info .user {
  background-position: -12px -181px
}

.acc-info .time {
  background-position: -12px -166px
}

.total-show {
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  margin-bottom: 5px
}

.total-show select {
  width: 140px;
  margin-bottom: 0;
  font-weight: 700
}

.table-other {
  margin-top: -10px;
  color: #000
}

.head-balance {
  width: 31.37255%;
  border-right: 1px solid #d8d8d8;
  margin-right: 10px
}

.head-balance dt {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 7px
}

.head-balance dd {
  font-size: 30px;
  line-height: 36px;
  font-weight: 700;
  color: #2789ce
}

.head-balance dd span {
  font-size: 12px;
  color: #7e97a7;
  font-weight: 400
}

.total,
.grand-total {
  font-weight: 700;
  color: #000
}

.total td,
.grand-total td {
  border-top-color: #7e97a7;
  border-bottom: 1px solid #7e97a7
}

.grand-total {
  background-color: #e0e6e6
}

.tax {
  font-weight: 700;
  border-bottom: 2px solid #979797
}

.fromto {
  margin: 0 5px;
  background-position: -20px -158px;
  height: 8px;
  width: 7px
}

.pages {
  margin: 25px 0
}

.pages li {
  list-style: none;
  line-height: 25px;
  margin-right: 5px
}

.pages a {
  display: inline;
  font-weight: 400;
  margin: 0;
  padding: 4px 10px
}

.calendarPanel {
  position: absolute;
  z-index: 9999;
  left: 0;
  top: 0;
  background-color: #fff
}

.calendarTable_1 {
  background-color: #000;
  width: 100%
}

.calendarTable_1 th {
  line-height: 30px;
  height: 30px;
  padding: 5px
}

.calendarTable_1 select {
  margin: 0;
  width: 80px
}

.calendarTable_1 .calendarYear {
  width: 60px
}

.calendarTable_1 input,
.calendarTable_1 textarea {
  width: 27px;
  height: 20px;
  cursor: pointer;
  margin: 0;
  border-radius: 0;
  box-shadow: none
}

.prevMonth {
  background-position: 0 -256px
}

.prevMonth:hover,
.prevMonth.prev_m-hover {
  background-position: 0 -236px
}

.nextMonth {
  background-position: 0 -216px
}

.nextMonth:hover,
.nextMonth.mext_m-hover {
  background-position: 0 -196px
}

.calendarTable_2 {
  font-size: 12px
}

.calendarTable_2 th {
  width: 25px;
  padding: 3px;
  font-weight: 400;
  font-size: 11px;
  color: #000;
  border: 1px solid #7e97a7;
  border-width: 1px 0 1px 0;
  background-color: #e4e4e4
}

.calendarTable_2 td {
  width: 25px;
  padding: 3px;
  border: 1px solid #ddd
}

.calendarTable_inputBox {
  background-color: #c2c2c2
}

.calendarTable_inputBox th {
  border-bottom-width: 0
}

.calendarTable_inputBox input,
.calendarTable_inputBox textarea {
  width: 100%;
  font-size: 12px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  box-shadow: none;
  font-weight: 400
}

.comingDate {
  color: #999 !important
}

.pop-left {
  position: relative;
  width: 310px;
  height: 542px;
  padding: 20px 20px 0 20px;
  overflow: hidden;
  font-size: 15px;
  line-height: 20px
}

.pop-left dl {
  margin-bottom: 10px
}

.pop-left dt {
  width: 125px;
  margin-bottom: 10px;
  color: #000
}

.pop-left dd {
  position: relative;
  color: #000;
  font-weight: 700
}

.pop-left .select-betting {
  line-height: 23px;
  border-bottom: 1px solid #c5d0d7
}

.selection {
  height: 23px;
  line-height: 23px;
  border: 1px solid #7e97a7;
  border-radius: 4px;
  padding: 0 10px;
  background-position: 100% 0
}

.select-betting .selection {
  width: 163px
}

.selection-list {
  top: 25px;
  right: 0;
  min-width: 185px;
  font-weight: 400;
  z-index: 5
}

.selection-list:not(:target) {
  display: none
}

.selection-list:target {
  display: block
}

.selection-list a {
  font-size: 14px;
  line-height: 28px;
  white-space: nowrap
}

.chart-wrap {
  width: 278px;
  overflow: hidden;
  font-size: 13px;
  margin-bottom: 10px
}

.chart-wrap img {
  width: 350px;
  height: 255px;
  margin-bottom: -5px
}

.chart-wrap h2 {
  position: absolute;
  width: 100%;
  font-size: 18px;
  line-height: 25px;
  background-color: #fff;
  margin: 0;
  padding: 0
}

.pop-note {
  position: absolute;
  bottom: 0;
  width: 310px;
  border-top: 1px solid #c5d0d7;
  font-size: 12px;
  color: #000;
  line-height: 14px;
  padding: 5px 0 10px;
  margin-bottom: 0
}

.pop-right {
  width: 529px;
  height: 542px;
  padding: 20px 20px 0;
  overflow: auto;
  overflow-x: hidden;
  border-left: 1px solid #c5d0d7
}

.pop-right h2 {
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 5px;
  padding-top: 0
}

.tab-depth {
  border-left: 1px solid #eee
}

.tab-depth td {
  border-right: 1px solid #eee;
  border-color: #eee;
  padding: 5px 10px
}

.tab-depth .back {
  background-color: #cde8fd;
  color: #1e1e1e !important;
  border-color: #fff
}

.tab-depth .lay {
  background-color: #fae5eb;
  color: #1e1e1e !important;
  border-color: #fff
}

.initial-balance,
.final-balance {
  background-color: #ece7dc;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid #7e97a7
}

.initial-balance dt,
.final-balance dt,
.initial-balance dd,
.final-balance dd {
  padding: 10px
}

.initial-balance dt span,
.final-balance dt span {
  width: 60px;
  color: #1e1e1e;
  background-color: #cea976;
  margin-right: 15px;
  font-weight: 700;
  border-radius: 3px
}

.initial-balance dd,
.final-balance dd {
  padding-left: 0;
  color: #000
}

.initial-balance dd:first-of-type,
.final-balance dd:first-of-type {
  width: 120px;
  padding-left: 10px;
  color: #000
}

.table01 .initial-balance,
.table-s .initial-balance,
.table01 .final-balance,
.table-s .final-balance {
  background-color: #fff;
  font-size: 12px;
  line-height: 15px
}

.table01 .initial-balance td,
.table-s .initial-balance td,
.table01 .final-balance td,
.table-s .final-balance td {
  border: 1px solid #7e97a7;
  border-width: 1px 0 1px 0
}

.final-balance {
  border-top: 1px solid #7e97a7;
  margin: -15px 0 15px
}

.tab-scroll-y {
  width: 100%;
  height: 512px;
  overflow: hidden;
  overflow-y: auto;
  margin-bottom: 15px;
  border-bottom: 1px solid #7e97a7
}

.tab-scroll-y .table01,
.tab-scroll-y .table-s {
  margin-bottom: 0;
  border-bottom-width: 0
}

.tc-content,
.announce-content {
  overflow-y: scroll;
  height: calc(580px - 56px - 72px);
  padding: 16px 24px;
  font-size: 14px;
  line-height: 24px
}

.mob-announce-content {
  position: relative;
  top: 60px;
  width: 720px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .5)
}

.announce-header {
  height: 56px;
  padding-left: 24px;
  border-bottom: 1px solid #e0e6e6
}

.announce-header h1 {
  color: #000;
  font-size: 20px;
  line-height: 56px
}

.announce-header h1:before {
  position: relative;
  top: 4px;
  width: 6px;
  height: 24px;
  margin-right: 8px;
  content: "";
  background: #000;
  border-radius: 100px
}

.announce-footer {
  max-height: 73px;
  padding: 12px 0;
  background: #fff;
  border-top: 1px solid #e0e6e6;
  font-size: 16px;
  border-radius: 0 0 8px 8px
}

.announce-footer input[type=checkbox],
.announce-footer textarea[type=checkbox] {
  box-sizing: border-box
}

.announce-footer a {
  width: 240px;
  height: 40px;
  margin: 0 16px 0 0;
  color: #1e1e1e;
  font-size: 16px;
  line-height: 40px
}

.announce-footer .confirm-checkbox {
  margin-bottom: 12px
}

.urgent-notice {
  z-index: 99;
  width: 660px;
  opacity: 0;
  animation: urgent-notice .3s ease 1s 1 alternate forwards
}

.urgent-notice .announce-header {
  padding: 0;
  background: #121212 url('../images/betsbuzz365/bg-send-skyEX.png') repeat-x;
  border-radius: 8px 8px 0 0
}

.urgent-notice .announce-header h1 {
  color: #f8d61c;
  font-size: 24px;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 0 2px 4px rgba(0, 0, 0, .6)
}

.urgent-notice .announce-header h1:before {
  display: none
}

.urgent-notice .notice-content {
  padding: 24px 20px;
  font-size: 16px;
  line-height: 24px
}

.urgent-notice .notice-img {
  margin-top: 12px;
  width: 620px;
  height: auto
}

.urgent-notice .hilight {
  font-weight: 700;
  text-decoration: underline
}

@keyframes urgent-notice {
  0% {
    top: -2%;
    opacity: 0
  }

  100% {
    top: 12%;
    opacity: 1
  }
}

.tc-content h1 {
  margin: 40px 0 24px 0;
  font-size: 22px;
  color: #000;
  text-decoration: underline
}

.tc-content h2 {
  margin: 16px 0;
  padding: 0;
  font-size: 20px
}

.tc-content h3 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 18px;
  color: rgba(30, 30, 30, .9)
}

.tc-content h4,
.tc-content h5 {
  margin-left: 8px;
  font-size: 14px;
  color: rgba(30, 30, 30, .9)
}

.tc-content h5 {
  margin-left: 32px;
  text-decoration: underline
}

.tc-content ul,
.tc-content ol {
  margin-left: 32px;
  margin-bottom: 16px
}

.tc-content ul ul,
.tc-content ul ol,
.tc-content ol ul,
.tc-content ol ol {
  margin-left: 24px
}

.declared {
  background-color: #ededed;
  font-size: 13px;
  line-height: 1.4;
  padding: 15px;
  margin: 10px 0;
  border-radius: 8px
}

.declared p:last-of-type {
  margin-bottom: 0
}

.announce-content {
  font-size: 16px;
  line-height: 22px
}

.announce-content h3 {
  margin: 8px 0;
  font-size: 16px
}

.announce-content p {
  margin-bottom: 8px
}

.announce-content table {
  margin: 8px 0 16px 0;
  font-size: 14px
}

.announce-content ul {
  margin-left: 24px
}

.article-wrap {
  position: relative;
  padding: 0 0 56px 60px
}

.article-wrap h2 {
  margin-bottom: 16px;
  color: #000;
  font-size: 28px;
  line-height: 28px
}

.article-date {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  margin-right: 24px;
  border-top: 4px solid #4a4a4a;
  color: #4a4a4a
}

.article-date dt {
  margin: 4px 0 2px 0;
  font-size: 30px;
  line-height: 30px
}

.article-date dd {
  font-size: 14px;
  line-height: 16px
}

.mob-news-popup {
  top: 72px;
  width: 640px
}

.mob-news-popup .announce-header {
  height: 60px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 8px 8px 0 0
}

.mob-news-popup .announce-content {
  height: 412px;
  padding: 24px 20px
}

.mob-news-popup h2 {
  color: #000;
  font-size: 24px
}




.betsbuzz365 .announce-header h1:before {
  background: #000
}







.announce-header h1:before {
  background: #443a56
}

.mob-news-popup .announce-header h1:before {
  background: #ed7218
}

.mob-news-popup .fancyfair .announce-header h1:before {
  background: #50996b
}

.login-policy ul {
  list-style: none
}

.login-policy ul ul {
  list-style: none
}

.login-policy p {
  margin-bottom: 12px
}

.login-policy .tc-content {
  max-height: inherit;
  height: calc(100% - 56px - 24px - 8px);
  padding-top: 0;
  padding-bottom: 24px;
  margin-top: 56px
}

.login-policy .announce-header {
  position: fixed;
  width: 100%;
  background: #fff
}

@media screen and (max-height: 700px) {
  .mob-announce-content {
    top: 24px;
    height: calc(100% - 24px - 24px);
    min-height: 298px
  }

  .tc-content,
  .mob-news-popup .announce-content {

    min-height: 200px
  }

  .announce-content {
    height: calc(100% - 24px - 24px - 56px - 42px);
    min-height: 200px
  }

  .mob-news-popup {
    min-height: 333px
  }

  .mob-news-popup .announce-content {
    height: calc(100% - 24px - 24px - 60px - 73px - 24px);
    min-height: 200px
  }

  .login-policy {
    top: 0;
    height: 100%
  }

  .login-policy .tc-content {
    max-height: inherit;
    height: calc(100% - 56px - 24px - 8px)
  }

  .urgent-notice {
    height: auto
  }
}

.marquee-pop .announce-header h1:before {
  display: none
}

.marquee-pop .cal-input {
  width: 140px
}

.marquee-pop .btn-send {
  width: 110px
}

.marquee-pop .announce-content {
  height: 544px;
  box-sizing: border-box
}

.marquee-search {
  height: 32px;
  padding: 8px 0 0 24px;
  background: #e0e6e6;
  border-bottom: 1px solid #fff
}

.apk-dl {
  top: 0;
  width: 480px;
  height: 324px;
  margin-bottom: 0
}

.apk-img {
  text-align: center
}

.apk-img img {
  width: 200px
}

.searchbar-header {
  position: relative
}

.main-input-search {
  width: 280px;
  padding-left: 25px;
  margin: 0;
  height: 25px;
  box-sizing: border-box;
  background-position: -86px -2424px
}

.main-input-search::placeholder {
  color: #aaa
}

.main-input-search:focus {
  padding-left: 25px;
  padding-right: 25px
}

.main-input-search:focus::placeholder {
  color: transparent
}

.search-clear {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  border: 0;
  background-position: -90px -1900px
}

.suggestion-wrap {
  position: absolute;
  z-index: 4;
  top: 22px;
  width: 280px;
  background: #fff;
  border-top: 1px solid #e0e6e6;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .5);
  box-sizing: border-box
}

.suggestion-wrap ul {
  max-height: 210px;
  overflow: hidden;
  overflow-y: auto
}

.suggestion-wrap li {
  height: 32px;
  line-height: 32px;
  list-style: none;
  text-indent: 6px
}

.suggestion-wrap .no-matching,
.suggestion-wrap p,
.suggestion-wrap a {
  margin: 0;
  color: #666;
  cursor: default
}

.suggestion-wrap p,
.suggestion-wrap a {
  color: #1e1e1e;
  cursor: pointer
}

.suggestion-wrap p:hover,
.suggestion-wrap p.hover,
.suggestion-wrap a:hover,
.suggestion-wrap a.hover {
  background-color: #e2e8ed
}


body.betsbuzz365 {
  background-color: #eee
}

.betsbuzz365 .btn.select,
.betsbuzz365 .select.btn-send,
.betsbuzz365 .pages a.select,
.pages .betsbuzz365 a.select,
.betsbuzz365 .calendarTable_inputBox input.select,
.calendarTable_inputBox .betsbuzz365 input.select,
.betsbuzz365 .calendarTable_inputBox textarea.select,
.calendarTable_inputBox .betsbuzz365 textarea.select {
  color: #ffb600;
  background: #444 url('../images/betsbuzz365/btn-select-skyEX.jpg') repeat-x;
  border-color: #222
}

.betsbuzz365 .btn.select:hover,
.betsbuzz365 .select.btn-send:hover,
.betsbuzz365 .pages a.select:hover,
.pages .betsbuzz365 a.select:hover,
.betsbuzz365 .calendarTable_inputBox input.select:hover,
.calendarTable_inputBox .betsbuzz365 input.select:hover,
.betsbuzz365 .calendarTable_inputBox textarea.select:hover,
.calendarTable_inputBox .betsbuzz365 textarea.select:hover {
  background: #444 url('../images/betsbuzz365/btn-select-skyEX.jpg') repeat-x
}

.betsbuzz365 .btn-send:hover {
  background-image: linear-gradient(0deg, #474747 0%, #070707 100%);
}

.betsbuzz365 .btn-send.disable {
  background: #a4a4a4 url('../images/betsbuzz365/bg-send-disable-skyEX.png') repeat-x;
  border-color: #aaa;
  color: #e6dfcd
}

.betsbuzz365 .betsbuzz365 .login-box-content {
  color: #000
}

.betsbuzz365 .power-content-b {
  display: none
}

.betsbuzz365 .RnR-link {
  display: none
}

.betsbuzz365 .icon-login {
  background-position: 0 -161px;
  height: 12px;
  width: 12px;
  margin-LEFT: 7PX;

}

.betsbuzz365 .announce-header h1:before {
  background: #000
}

.betsbuzz365 .top {
  background: #000;
  background-image: url(../images/betsbuzz365/bg-top-skyEX.jpg), linear-gradient(180deg, #270000 0%, #270000 100%);
}

.betsbuzz365 .header {
  color: #000
}

.betsbuzz365 .header h1 {
  margin-top: -10px
}

.betsbuzz365 .login-clientform li.user {
  background-position: -96px -2299px
}

.betsbuzz365 .login-clientform .error {
  color: #f8d61c
}

.betsbuzz365 .login-clientform .btn-signup {
  display: block;
  width: 80px;

  background-image: linear-gradient(-180deg, #666 0, #333 100%)
}

/* .betsbuzz365 .account-wrap li .refresh-bar {
  background: url('../images/livesports/refresh80-livesports.gif') no-repeat center
} */

.betsbuzz365 .account-wrap li strong.red {
  padding: 1px 3px;
  color: #f2e9cf !important;
  background-color: #bf0000;
  border-radius: 3px
}


.betsbuzz365 .account-wrap .head-refresh a {
  background-position: -80px -900px;
  height: 25px;
  width: 30px
}

.betsbuzz365 .account-wrap .account {
  background-position: 0 -351px;
  height: 25px;
  width: 110px
}

.betsbuzz365 .account-wrap ul a {
  color: #1e1e1e;
  padding: 0 10px;
  border-bottom: 1px solid #e0e6e6;
}

.betsbuzz365 .account-wrap .logout a {
  color: #fff
}

.betsbuzz365 .navbar-content {
  background-repeat: repeat-x;

}

.slipbar-content.no-open-bet_slip {
  height: calc(100% - 0px);
}

.betsbuzz365 .menu li,
.betsbuzz365 .setting-tab li {
  border-right-color: rgb(255 255 255 / 34%)
}

.betsbuzz365 .menu li ul a,
.betsbuzz365 .setting-tab li ul a {
  color: #000
}

.betsbuzz365 .menu a,
.betsbuzz365 .setting-tab a {
  color: #ffff
}

.betsbuzz365 .menu a:hover,
.betsbuzz365 .setting-tab a:hover {
  background-color: transparent;
  text-decoration: underline
}

.betsbuzz365 .menu .select {
  background: #ffdc7a;
}

.betsbuzz365 .setting-tab .select {
  box-shadow: inset 0 1px 3px 0 rgba(52, 9, 9, 0.5);

  background-position: inherit;
}

.betsbuzz365 .setting {
  border-left-color: rgba(69, 32, 7, .2)
}

.betsbuzz365 .setting img {
  background-position: -97px -2597px
}

.betsbuzz365 .one_click {
  background-image: linear-gradient(180deg, #444 13%, #1B1B1B 81%);
  background-position: inherit;
  border-top-color: #085E7F;
  background-repeat: repeat-x;
  color: #000 !important;
}

.betsbuzz365 .one_click.select:hover {
  background-image: linear-gradient(180deg, #009347 100%, #00C15D 0%) !important;
}



.main-content .one_click::after {
  background: rgba(255, 255, 255, .2);
}

.one_click::after {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: flex;
  width: 16px;
  height: 16px;
  background: rgba(255, 255, 255, .15);
  border-radius: 4px;
  content: "";
}

.betsbuzz365 .one_click.select {
  color: #1e1e1e !important;
  background-repeat: repeat-x;
  box-shadow: inset 0 2px 3px -2px rgba(0, 0, 0, .4);
  background-position: 0 -1260px
}

.betsbuzz365 .one_click.select:hover,
.betsbuzz365 .one_click.select.bg-1click-skyEX-select-hover {
  background-position: inherit;
}

.betsbuzz365 .one_click.select:hover {
  background-image: linear-gradient(180deg, #009347 100%, #00C15D 0%) !important;
}

.betsbuzz365 .menu a:hover,
.betsbuzz365 .setting-tab a:hover {
  background-color: rgba(255, 255, 255, .2);
  text-decoration: none;
}

.betsbuzz365 .one_click:hover {
  background-image: linear-gradient(0deg, #4b4b4b 0%, #1e1e1e 100%);
}

.betsbuzz365 .one_click.select {
  color: #1E1E1E !important;
  background-image: linear-gradient(180deg, #00C15D 0%, #009347 100%) !important;
  background-position: inherit;
}

.betsbuzz365 .menu .select,
.betsbuzz365 .setting-tab .select {
  box-shadow: inset 0 1px 3px 0 rgb(52 9 9 / 50%);
  background-image: linear-gradient(180deg, #ff0018 0%, #ff0018 61%);
  background-position: inherit;
}

.one_click.select:hover,
.one_click.select.bg-1click-select-hover {
  background-position: 0 -3540px;
}

.betsbuzz365 .menu a,
.betsbuzz365 .setting-tab a {
  color: #000;
}

.menu a:hover,
.setting-tab a:hover {
  background-color: #383838;
  text-decoration: none;
}

.navbar-content a.one_click {
  padding: 0 12px 0 37px;
}

.betsbuzz365 .one_click {

  color: #fff !important;
  border-top-color: #085E7F;
  background-image: linear-gradient(180deg, #4b4b4b 0%, #1e1e1e 100%);
}

.one_click.select {
  background-repeat: repeat-x;

}



.menu .select,
.setting-tab .select {
  background-color: #4d4d4d;
}

.betsbuzz365 .one_click.select img {
  background-position: -94px -1750px
}

.betsbuzz365 .slip_set-pop a:hover,
.betsbuzz365 .oneclick_set-pop a:hover {
  text-decoration: none
}

.betsbuzz365 .slip_set-pop .btn-send,
.betsbuzz365 .oneclick_set-pop .btn-send {
  color: #ffff
}

.betsbuzz365 .time_zone {
  color: #000
}

.betsbuzz365 .time_zone span {
  color: #9a7816
}

.betsbuzz365 .sports-side-menu-list li {
  border-bottom-color: #efe1c1;

}

.betsbuzz365 .sports-side-menu-list a {
  color: #000
}

.betsbuzz365 .sports-side-menu-list a:hover {
  background-color: #d9837e
}

.betsbuzz365 .sports-side-menu-list .select {
  background-color: #f2dca7;
  color: #222
}

.betsbuzz365 .sports-side-menu-list .select:hover {
  background-color: #f2dca7
}

.betsbuzz365 .sports-side-menu-list .Go {
  background-position: 100% -201px;
  height: 25px;
  width: 23px
}

.betsbuzz365 .sports-side-menu-list .Go:hover,
.betsbuzz365 .sports-side-menu-list .Go.Go-skyEX-hover {
  background-position: 100% -525px
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after {
  content: "";
  background-size: cover;
  width: 12px;
  height: 12px;
}

.betsbuzz365 .path {
  background: linear-gradient(180deg, #000 0%, #000 100%)
}

.betsbuzz365 .path a {
  color: #fff
}

.betsbuzz365 .path .path-back {
  background-position: 0 -1575px;
  height: 25px;
  width: 36px
}

.betsbuzz365 .path .path-back:hover,
.betsbuzz365 .path .path-back.path-back-skyEX-hover {
  background-position: 0 -1650px
}

.betsbuzz365 .path .path-back.select {
  background-position: 0 -1575px;
  height: 25px;
  width: 36px
}

.betsbuzz365 .sports-path-popup {
  background-color: #222
}

.betsbuzz365 .login-pg-go {
  /* background-color:#ffb80c */
  background-image: linear-gradient(275deg, #d0021b 0%, #ffea21 100%, #ff9e2c);
}

.betsbuzz365 .login-pg-go .close {
  background-position: -394px -914px;
  height: 20px;
  filter: invert(1);
  width: 20px
}

.betsbuzz365 .one_click-setting {
  color: #1e1e1e;
  background-repeat: repeat-x;
  background-color: #008841;
  background-position: 0 -1967px
}

.betsbuzz365 .one_click-setting a {
  border-color: #005f2d
}

.betsbuzz365 .one_click-setting .a-edit {
  color: #1e1e1e
}

.betsbuzz365 .one_click-setting .a-edit img {
  background-position: -405px -1674px;
  height: 9px;
  width: 9px
}

.betsbuzz365 .one_click-stake {
  background-position: 0 -2910px;
  height: 31px;
  width: 414px
}

.betsbuzz365 .one_click-stake input,
.betsbuzz365 .one_click-stake textarea {
  border-color: #005f2d;
  color: #fff;
  background-color: #1f8c53
}

.betsbuzz365 .one_click-stake input:focus,
.betsbuzz365 .one_click-stake textarea:focus {
  border-color: #fff;
  background-color: #00632f
}

.betsbuzz365 .menu .logout,
.betsbuzz365 .setting-tab .logout {
  border-left-width: 0
}

.betsbuzz365 .menu .logout img,
.betsbuzz365 .setting-tab .logout img {
  background-position: 0 -64px;
  height: 12px;
  width: 12px
}

.betsbuzz365 .footer_fixed .main_wrap,
.betsbuzz365 .footer_fixed .header {
  background-color: #f0ece1
}

.betsbuzz365 .submit-wrap .btn-send span {
  background-color: #666
}

.betsbuzz365 .marquee-pop .announce-header {
  background: #000 url('../images/betsbuzz365/bg-top-skyEX.jpg') repeat-x
}

.betsbuzz365 .marquee-pop .announce-header h1 {
  color: #f8d61c
}

.support-telegram.open img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>');
}

.support-wrap .support-service img {
  width: 25px;
  height: 100%;
}

.support-fb img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.925 0 0 4.946 0 11.046a11.026 11.026 0 009.165 10.88v-8.575H6.512v-3.086h2.653V7.989c0-2.64 1.606-4.079 3.952-4.079 1.124 0 2.09.084 2.37.121v2.76h-1.628c-1.275 0-1.52.61-1.52 1.502v1.97h3.043l-.397 3.086h-2.647V22C17.781 21.335 22 16.688 22 11.043 22 4.946 17.075 0 11 0z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

.support-fb.open img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.925 0 0 4.946 0 11.046a11.026 11.026 0 009.165 10.88v-8.575H6.512v-3.086h2.653V7.989c0-2.64 1.606-4.079 3.952-4.079 1.124 0 2.09.084 2.37.121v2.76h-1.628c-1.275 0-1.52.61-1.52 1.502v1.97h3.043l-.397 3.086h-2.647V22C17.781 21.335 22 16.688 22 11.043 22 4.946 17.075 0 11 0z" fill="rgb(97,97,97)" fill-rule="nonzero"/></svg>');
}

.support-telegram img {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgb(166,166,166)" fill-rule="nonzero"/></svg>');
}

[class^="support-"] img {
  background-size: contain;
  background-repeat: no-repeat;
}


*::-ms-backdrop,
th {
  text-align: right
}

.path a {
  color: #eee9
}

.slip-back dd input,
.slip-back dd textarea,
.slip-lay dd input,
.slip-lay dd textarea {
  height: 22px\\9
}

.quick_bet-wrap dd input,
.quick_bet-wrap dd textarea {
  height: 33px\\9
}

*::-ms-backdrop,
.slip-back dd input,
.slip-back dd textarea {
  height: 22px
}

*::-ms-backdrop,
.slip-lay dd input,
.slip-lay dd textarea {
  height: 22px
}

*::-ms-backdrop,
.quick_bet-wrap dd input,
.quick_bet-wrap dd textarea {
  height: 33px
}

.expand td {
  position: static\\9
}

.expand td {
  position: relative\\9\\0
}

.expand-arrow {
  visibility: hidden\\9
}

.expand-arrow {
  visibility: visible\\9\\0
}

.table01 .border-t td,
.table-s .border-t td {
  border-top: 2px solid #7e97a7 \\9
}

@media screen and (-webkit-min-device-pixel-ratio:0) {
  .game-scores .scores-inns {
    display: inline-block;
    transform: scale(.8)
  }

  .slider {
    display: flex
  }

  .fancy-info {
    padding: 0 6px;
    transform: scale(.9)
  }

  td .fancy-info {
    padding: 0
  }

  .table-pt td {
    padding: 8px 3px
  }
}

.slipbar-content.no-open-bet_slip {
  height: 26px;
}

.slipbar-content.open-bet_slip {
  height: calc(50%);
}

.slipbar-content.miniopen-bet_slip {
  height: calc(96.5%);
}

.slipbar-content.showfull-bet_slip {
  height: calc(100%) !important;
}


.react-datepicker__header {
  background-color: #3546b3 !important;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #fff !important;
}

.react-datepicker__day-name {
  color: #fff !important;
}

.react-datepicker__navigation--previous {
  color: #fff !important;
}

.react-datepicker__navigation--next {
  color: #fff !important;
}


.menu .tag-new:before,
.setting-tab .tag-new:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background-position: 100% -6777px;
  height: 29px;
  width: 29px;
}

.menu .casino:after,
.setting-tab .casino:after {
  content: '';
  display: inline-block;
  position: relative;
  top: 4px;
  left: 2px;
  width: 18px;
  height: 18px;
  background-position: 100% -6759px;
}


.menu .tag-new:not(*:root),
.setting-tab .tag-new:not(*:root) {
  padding: 0 10px 0 20px;
  transform: none;
}

.betsbuzz365 .menu .tag-new,
.betsbuzz365 .setting-tab .tag-new {
  color: #FFFFFF;
}

.betsbuzz365 .menu a,
.betsbuzz365 .setting-tab a {
  color: #000;
}

.menu .tag-new,
.setting-tab .tag-new {
  width: inherit;
  height: inherit;
  color: #FFFFFF;
  line-height: inherit;
  font-size: inherit;
  filter: none;
  padding-left: 20px;
}

.menu a,
.setting-tab a {
  position: relative;
}


.betsbuzz365 .menu .tag-new,
.betsbuzz365 .setting-tab .tag-new {
  color: #FFFFFF;
}

.tag-new:not(*:root) {
  padding: 6px;
  transform: scale(0.8);
}

.menu .casino,
.setting-tab .casino,
.menu .bet-game,
.setting-tab .bet-game {
  position: relative;
  background-image: linear-gradient(#4B4B4B, #1E1E1E);
}

.menu a,
.setting-tab a {
  position: relative;
}

/*
.navbar-content a {
  color: #fff;
  padding: 0 10px;
}*/

.tag-new {
  position: absolute;
  width: 32px;
  height: 18px;
  background: url('data:image/svg+xml,<svg width="32" height="16" viewBox="0 0 32 16" xmlns="http://www.w3.org/2000/svg"><path d="M20 12l-7 4 1-4h-11c-1.657 0-3-1.343-3-3v-6c0-1.657 1.343-3 3-3h26c1.657 0 3 1.343 3 3v6c0 1.657-1.343 3-3 3h-9z" fill="%23D0021B"/></svg>') center no-repeat;
  background-size: contain;
  color: #FFFFFF;
  line-height: 12px;
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  -webkit-filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
  z-index: 2;
}


.menu .bet-game:after,
.setting-tab .bet-game:after {
  left: 5px;
  width: 18px;
  height: 19px;
  background-position: 100% -6740px;
}





.menu .dark_menu-li,
.setting-tab .dark_menu-li {
  border-right: 1px solid #383838 !important;
}


.menu .casino:after,
.setting-tab .casino:after {
  content: '';
  display: inline-block;
  position: relative;
  top: 4px;
  left: 2px;
  width: 18px;
  height: 18px;

}

.menu .bet-game:after,
.setting-tab .bet-game:after {
  content: '';
  display: inline-block;
  position: relative;
  top: 4px;

  width: 18px;
  height: 19px;
}


.menu .casino:hover,
.setting-tab .casino:hover,
.menu .bet-game:hover,
.setting-tab .bet-game:hover {
  background: linear-gradient(0deg, #4B4B4B, #1E1E1E)
}



.centar-content.casinozone {
  margin-left: auto;
  margin-right: auto;
  width: 74.38889%;
  height: auto;
  overflow: initial;
  margin: 0 auto;
}

.casinozone-wrap-simple {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
}

.casinozone-wrap-simple a {
  position: relative;
  grid-column: span 2;
  overflow: hidden;
  height: 195px;

}

.casinozone-wrap-simple a:before {
  content: '';
  padding-top: 38.35616%;
  float: left;
}

.live_events {
  position: absolute;
  z-index: 3;
  right: 0;
  width: 120px;
  padding: 6px;
  background-image: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.7) 82%, transparent 100%);
}

.live_events dt {
  margin-bottom: 12px;
}


.live_events .live_icon {
  height: 20px;
  line-height: 20px;
  color: #fff;
  padding-right: 5px;
  font-size: 12px;
  font-weight: bold;
  background-image: linear-gradient(180deg, #FB3434 0%, #E80505 100%);
  border-radius: 3px;
  margin-bottom: 0;
  display: inline-flex;
}

.live_events .live_icon span {
  height: 100%;
  padding: 0 3px;
  margin-right: 5px;
  background-image: linear-gradient(180deg, #fff 0%, #E8E8E8 100%);
  border-radius: 3px 0 0 3px;
}

.live_events .live_icon span:before {
  width: 16px;
  height: 10px;
  background: url('data:image/svg+xml,<svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(255,0,0)" fill-rule="evenodd"><path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z"/><circle cx="6.8" cy="4.4" r="1.6"/></g></svg>') no-repeat;
  background-size: contain;
  content: "";
}

.mob-live-number strong:before,
.live_events .live_icon span:before {
  animation: twinkling 1.4s infinite ease;
}

.border-box,
.mob-live-number,
.game-E,
.marquee-pop .announce-content,
.live_events,
.live_events .live_icon span,
.live_events .live_icon span:before,
.live_events dd span {
  box-sizing: border-box;
}

.live_events dd {
  color: #fff;
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 7px;
  vertical-align: top;
  flex-wrap: wrap;
}

.live_events dd p {
  flex: 1;
  margin-bottom: 0;
  line-height: 16px;
}

.live_events dd span {
  color: #333333;
  background: #FFFFFF;
  text-align: center;
  border-radius: 3px;
  padding: 0 3px;
  min-width: 16px;
  height: 16px;
}

.casino-title {
  position: absolute;
  z-index: 4;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-image: linear-gradient(270deg, rgba(69, 94, 104, 0) 4%, #000000 97%);
//   border-bottom: 5px solid #dd5122;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}







.casinozone-wrap-simple a img {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  height: 100%;
}

.casinozone-wrap-simple .mob-casino-half {
  grid-column: span 1;
}


.meter {

  box-sizing: content-box;
  height: 10px;
  position: relative;
  margin: 10px 0 10px 35px;
  background: transparent;
  border-radius: 25px;
  padding: 5px;
  box-shadow: inset 0 0px 1px rgb(0 0 0);

}

.meter>span {
  display: block;
  height: 100%;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: rgb(43, 194, 83);
  background-image: linear-gradient(center bottom,
      rgb(43, 194, 83) 37%,
      rgb(84, 240, 84) 69%);
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

.meter>span:after,
.animate>span>span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(-45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
  z-index: 1;
  background-size: 50px 50px;
  animation: move 2s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}

.animate>span:after {
  display: none;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 50px 50px;
  }
}

.orange>span {
  background-image: linear-gradient(#f1a165, #f36d0a);
}

.red>span {
  background-image: linear-gradient(#000, #f42323);
}


#page-wrap {
  width: 370px;

}



.bl-Preloader_Spinner {
  box-sizing: border-box;
  width: 45px;
  height: 45px;
  margin: 0 auto;
  border: 2px solid #757575;
  border-left: 3px solid #000;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-animation: bl-Spinner .6s linear infinite;
  animation: bl-Spinner .6s linear infinite;
}

@keyframes bl-Spinner {
  0% {
    transform: translateX(-50%) translateY(-50%) rotate(0deg);
  }

  100% {
    transform: translateX(-50%) translateY(-50%) rotate(360deg);
  }
}

.bl-Preloader {

  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: #000000e0;
  z-index: 99;
  justify-content: center;
  align-items: center;
}

.casinozone-wrap-simple a img:hover {
  -webkit-transform: scale3d(1.1, 1.1, 1);
  transform: scale3d(1.1, 1.1, 1);
}

.casinozone-wrap-simple img {
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

.logo-dg {

  width: 215px;
  margin-top: 173px;
  margin-left: 14px;
}

.tennis-col {
  width: calc(64% - -56px) !important;
}

.fm-bets .bet-all td,
.bets-HS .bet-all td,
.bets-GH .bet-all td {
  background-color: transparent;
  border-left-color: transparent;
  padding-bottom: 1px;
}

.support-wrap.extend-support {
  display: block;
  width: 690px;
  background-color: transparent;
  border-radius: 8px;
  margin: 0 auto 20px auto;
  padding: 5px 0px;
}

.support-wrap {
  background-color: rgba(255, 255, 255, 0.5);
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
}

.support-wrap {
  text-align: center;
}

.extend-wrap {
  display: flex;
  justify-content: space-between;
}

.support-wrap {
  background-color: rgba(255, 255, 255, 0.5);
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
}

.extend-btn {
  flex-basis: 49%;
  background-color: #fff;
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 13px;
  justify-content: center;
  margin-bottom: 8px;
}

.extend-btn img {
  width: 26px;
  height: 26px;
  margin-right: 5px;
  vertical-align: middle;
}

[class^="support-"] img {
  background-size: contain;
  background-repeat: no-repeat;
}

.support-wrap.extend-support a {
  color: rgba(0, 0, 0, 0.5);
  line-height: 40px;
  text-align: center;
}

.extend-btn a {
  margin-right: 8px;
}

.support-wrap.extend-support a.split-line {
  border-left: 1px solid rgba(0, 0, 0, 0.5);
  padding-left: 10px;
}

.extend-btn a:last-child {
  margin-right: 0;
}

.support-wrap.extend-support a {
  color: rgba(0, 0, 0, 0.5);
  line-height: 40px;
  text-align: center;
}

.extend-wrap {
  display: flex;
  justify-content: space-between;
}

.support-customer {
  background-image: url('data:image/svg+xml,<svg width="159" height="159" xmlns="http://www.w3.org/2000/svg"><path d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
}

/* .support-whatsapp {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
/* .support-telegram {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
.support-social {
  flex-basis: 32%;
  background-color: #fff;
  padding: 8px 0;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 13px;
  justify-content: center;
  text-align: center;
}

.support-social img {
  width: 26px;
  height: 26px;
  margin-right: 5px;
  vertical-align: middle;
}

.support-wrap.extend-support a {
  color: rgba(0, 0, 0, 0.5);
  line-height: 40px;
  text-align: center;
}

/* .support-skype {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
}
 .support-mail {
    background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgba(0,0,0,0.5)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
}
.support-ig {
    background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
.support-ig img {
  background-image: url("data:image/svg+xml,<svg width=\\"40\\" height=\\"40\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z\\" fill=\\"rgb(166,166,166)\\" fill-rule=\\"nonzero\\"/></svg>");
}

.support-skype img {
  background-image: url("data:image/svg+xml,<svg width=\\"22\\" height=\\"22\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z\\" fill=\\"rgb(166,166,166)\\" fill-rule=\\"nonzero\\"/></svg>");
}

.support-telegram img {
  background-image: url("data:image/svg+xml,<svg width=\\"22\\" height=\\"22\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z\\" fill=\\"rgb(166,166,166)\\" fill-rule=\\"nonzero\\"/></svg>");
}

.support-wrap .support-service {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}

.support-wrap .support-service a.open::after {
  content: "";
  position: absolute;
  top: 100%;
  height: 27px;
  background-image: url(../images/sprite/support_arrow_w.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-color: initial;
}

.support-wrap .support-service a::after {
  content: "";
  position: absolute;
  top: 100%;
  display: block;
  width: 50px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.15);
}

.kv {
  background: url(../images/image112.webp) 0% 0% / contain no-repeat;
  background-size: 272px;
}

.support-wrap .support-service::before,
.support-wrap .support-service::after {
  content: "";
  display: block;
  flex: 1 1 0%;
  align-self: flex-end;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.15);
  margin-bottom: -1px;
}

.support-wrap .support-service a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
}

.highlight-sorting {
  display: block;
  float: right;
  font-weight: normal;
}

.highlight-sorting .select {
  width: 108px;
  height: 23px;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.4);
  box-shadow: inset 0px 1px 0px 0px rgb(255 255 255 / 50%);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  margin-right: 2px;
  position: relative;
  margin-left: 7px;
  display: inline-block;
}

.highlight-sorting .select select {
  width: 108px;
  height: 23px;
  background: none;
  border: none;
  color: inherit;
  appearance: none;
  padding-left: 9px;
  margin: 0;
  z-index: 1;
}

option {
  padding: 3px;
  color: #222;
}

.account-wrap p.loading-bar {
  width: 80px;
  height: 23px;
  align-items: center;
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 10px 0 15px;
  border-radius: 4px 0 0 4px;
}

.account-wrap .main-wallet p {
  font-weight: bold;
  margin-right: 7px;
  line-height: 1.4;
}

.account-wrap .main-wallet p {
  text-align: right;
}

.account-wrap p.loading-bar span:nth-child(1) {
  animation-delay: 0s;
}

.account-wrap .loading-bar span {
  background: #fff;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.account-wrap p.loading-bar span {
  width: 4px;
  height: 4px;
  border-radius: 50%;

  margin-right: 6px;

  animation: loadBar 0.8s ease infinite;
  /* display: block; */
}

@keyframes loadBar {
  0% {
    opacity: 0.1
  }

  50% {
    opacity: 1;
    transform: scale(1.4)
  }

  100% {
    opacity: 0.1
  }
}


.account-wrap p.loading-bar span:nth-child(2) {
  animation-delay: 0.1s
}

.account-wrap p.loading-bar span:nth-child(3) {
  animation-delay: 0.2s
}

.account-wrap p.loading-bar span:nth-child(4) {
  animation-delay: 0.3s
}

.account-wrap p.loading-bar span:nth-child(5) {
  animation-delay: 0.4s
}

.account-wrap p.loading-bar span:nth-child(6) {
  animation-delay: 0.5s
}

.account-wrap p.loading-bar span:nth-child(7) {
  animation-delay: 0.6s
}

.account-wrap p.loading-bar span:nth-child(8) {
  animation-delay: 0.7s;
  margin-right: 0
}




/* popup */
.pop-warp,
.log-wrap,
.streaming-pop,
.selection-list,
.slip_set-pop,
.oneclick_set-pop,
.path-pop,
.message-content,
.dialog-wrap-w,
.pop_box,
.pop_refer,
.filter-pop,
.calendarPanel,
.account_pop,
.tips-popup,
.filter_setting-tab,
.filter_setting-stakes-wrap {
  box-shadow: 0 4px 5px rgb(0 0 0 / 50%);
}

.pop-warp,
.log-wrap,
.streaming-pop {
  width: 920px;
  height: 600px;
  overflow: hidden;
  margin: 70px auto;
  background-color: #fff;
}

.game-team {
  width: 100%;
  background-color: #1b2d38;
  color: #fff;
  line-height: 22px;
  font-size: 18px;
  font-weight: bold;
}


.pop-warp .game-team .game-name,
.log-wrap .game-team .game-name,
.streaming-pop .game-team .game-name,
.log-wrap .game-team .game-name {
  padding-left: 10px;
}

.game-team .game-name {
  padding: 5px 10px 5px 30px;
}

.pop-warp .game-name,
.log-wrap .game-name,
.streaming-pop .game-name {
  position: relative;
  padding-right: 130px;
}

.game-team td {
  position: relative;
  width: 40%;
  height: 28px;
  vertical-align: top;
}

.trans-wrap .function-wrap {
  margin-bottom: 0;
}

.function-wrap {
  position: relative;
  padding: 10px 10px 0;
  background-color: #e0e6e6;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 10px;
}



.trans-wrap .input-list:first-of-type,
.trans-wrap .filter-list:first-of-type {
  margin-left: 0;
}

.trans-wrap .input-list,
.trans-wrap .filter-list {
  display: inline-block;
  margin-left: 12px;
}

.input-list,
.filter-list {
  margin-bottom: 5px;
  margin-right: 5px;
}

.pop-content {
  height: calc(100% - 35px - 38px);
  padding: 20px 15px 15px;
  overflow: auto;
}

.trans-wrap .pop-title {
  height: calc(100% - 35px - 48px);
  overflow-y: auto;
  margin-bottom: 0;
  padding-bottom: 16px;
  border: none;
  box-sizing: border-box;
}

.pop-title {
  margin-bottom: 20px;
}

.top_player-wrap,
.racing-wrap,
.game-wrap,
.highlight-edge-content,
.favor-wrap,
.sub_path,
.pop-title {
  background-color: #fff;
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 1px;
}


.table-trans {
  width: 100%;
  border-top: 1px solid #7e97a7;
  border-bottom: 1px solid #7e97a7;
}

.table-trans tr:nth-child(odd) {
  background-color: #f2f4f7;
}


.table-trans th {
  padding: 8px;
  border-right: 1px solid #7e97a7;
  border-bottom: 1px solid #7e97a7;
  background-color: #e4e4e4;
  color: #243a48;
}

.table-trans tr:nth-child(odd) {
  background-color: #f2f4f7;
}

.table-trans td {
  padding: 8px;
}

.table-trans {
  width: 100%;
  border-top: 1px solid #7e97a7;
  border-bottom: 1px solid #7e97a7;
}

.trans-wrap .pages {
  position: relative;
  height: 24px;
  margin: 0 auto;
  padding: 12px 0;
  background: #ffffff;
}

.casino-result {
  width: 1200px;
}

.announce-wrap,
.casino-result {
  position: relative;
  top: 12%;
  width: 720px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgb(0 0 0 / 50%);
}

.announce-header {
  height: 56px;
  padding-left: 24px;
  border-bottom: 1px solid #e0e6e6;
}

.casino-result .announce-header .close_pop {
  top: 18px;
  transform: scale(1.4);
}

.close_pop {
  position: absolute;
  right: 15px;
  background-position: -41px -632px;
  height: 16px;
  width: 17px;
}

.casino-result iframe {
  width: calc(100% - 16px);
  height: calc(560px - 16px);
  padding: 8px;
  overflow-y: scroll;
}

.support-wrap.extend-support {
  display: block;
  width: 690px;
  background-color: transparent;
  border-radius: 8px;
  margin: 0 auto 20px auto;
  padding: 5px 0px;
}

.support-wrap {
  background-color: rgba(255, 255, 255, 0.5);
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
}

.extend-wrap {
  display: flex;
  justify-content: space-between;
}

.extend-btn {
  flex-basis: 49%;
  background-color: #fff;
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 13px;
  justify-content: center;
  margin-bottom: 8px;
}

.extend-btn img {
  width: 26px;
  height: 26px;
  margin-right: 5px;
  vertical-align: middle;
}


.support-customer {
  background-image: url('data:image/svg+xml,<svg width="159" height="159" xmlns="http://www.w3.org/2000/svg"><path d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
}

.support-wrap.extend-support a {
  color: rgba(0, 0, 0, 0.5);
  line-height: 40px;
  text-align: center;
  text-decoration: none;
}

.extend-btn a {
  margin-right: 8px;
}

.extend-wrap {
  display: flex;
  justify-content: space-between;
}

.support-social {
  flex-basis: 32%;
  background-color: #fff;
  padding: 8px 0;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 13px;
  justify-content: center;
  text-align: center;
}

/* .support-whatsapp {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
/* .support-telegram {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M11 21c5.524 0 10-4.476 10-10S16.524 1 11 1 1 5.476 1 11s4.476 10 10 10zM5.576 10.783l9.642-3.717c.447-.162.838.109.693.786V7.85l-1.641 7.734c-.122.548-.447.682-.903.423l-2.5-1.842-1.206 1.162c-.133.133-.246.245-.504.245l.177-2.544 4.633-4.186c.202-.177-.045-.277-.31-.1L7.93 12.346l-2.468-.77c-.536-.17-.548-.535.113-.794z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
/* .support-skype {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */
/* .support-mail {
  background-image: url('data:image/svg+xml,<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="rgba(0,0,0,0.5)" fill-rule="nonzero"><path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z"/></g></svg>');
} */
/* .support-ig {
  background-image: url('data:image/svg+xml,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z" fill="rgba(0,0,0,0.5)" fill-rule="nonzero"/></svg>');
} */

.support-social img {
  width: 26px;
  height: 26px;
  margin-right: 5px;
  vertical-align: middle;
}

[class^="support-"] img {
  background-size: contain;
  background-repeat: no-repeat;
}

.account-wrap p.loading-bar {
  width: 80px;
  height: 23px;
  align-items: center;
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 10px 0 15px;
  border-radius: 4px 0 0 4px;
}

.account-wrap .main-wallet p {
  font-weight: bold;
  margin-right: 7px;
  line-height: 1.4;
}

.account-wrap .main-wallet p {
  text-align: right;
}

.account-wrap p.loading-bar span:nth-child(1) {
  animation-delay: 0s;
}

.account-wrap .loading-bar span {
  background: #fff;
}

.account-wrap .main-wallet span:first-of-type {
  opacity: 0.7;
  font-weight: normal;
}

.account-wrap p.loading-bar span {
  width: 4px;
  height: 4px;
  border-radius: 50%;

  margin-right: 6px;

  animation: loadBar 0.8s ease infinite;
  /* display: block; */
}

@keyframes loadBar {
  0% {
    opacity: 0.1
  }

  50% {
    opacity: 1;
    transform: scale(1.4)
  }

  100% {
    opacity: 0.1
  }
}


.account-wrap p.loading-bar span:nth-child(2) {
  animation-delay: 0.1s
}

.account-wrap p.loading-bar span:nth-child(3) {
  animation-delay: 0.2s
}

.account-wrap p.loading-bar span:nth-child(4) {
  animation-delay: 0.3s
}

.account-wrap p.loading-bar span:nth-child(5) {
  animation-delay: 0.4s
}

.account-wrap p.loading-bar span:nth-child(6) {
  animation-delay: 0.5s
}

.account-wrap p.loading-bar span:nth-child(7) {
  animation-delay: 0.6s
}

.account-wrap p.loading-bar span:nth-child(8) {
  animation-delay: 0.7s;
  margin-right: 0
}

.account-wrap .loading-bar span {
  background: #000;
}

/* new col */
.sportsgame-list-content-rate {
  position: relative;
  padding: 0 6px 0 10px;
  border-bottom: 1px solid #e0e6e6;
  display: flex
}

.sportsgame-list-content-rate:hover {
  background-color: #eff2f2
}

.sportsgame-list-content-rate dt {
  padding: 0;
  font-weight: bold;
  vertical-align: middle;
  padding: 2px 0 3px 0
}

.event-left .sportsgame-list-content-rate dt,
.event-right .sportsgame-list-content-rate dt,
.event-right .sportsgame-list-content-rate dt {
  padding: 5px 0
}

.sportsgame-list-content-rate dt span {
  font-weight: normal;
  padding: 0 3px;
  margin-left: 8px;
}

.sportsgame-list-content-rate dt a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 13px);
  margin-bottom: 2px
}

.event-left .sportsgame-list-content-rate dt a,
.event-right .sportsgame-list-content-rate dt a,
.event-right .sportsgame-list-content-rate dt a {
  width: auto
}

.sportsgame-list-content-rate dt .sportsgame-time-list {
  color: #777;
  max-width: 105px;
  margin-left: 9px
}

.sportsgame-list-content-rate dt .game-list-soon {
  color: #1e1e1e;
  margin-left: 9px
}

.sportsgame-list-content-rate dd {
  position: relative;
  align-self: center
}

.sportsgame-list-content-rate dd a {
  width: 49%;
  font-size: 11px;
  line-height: 26px;
  padding: 4px 0;
  cursor: pointer
}

.event-left .sportsgame-list-content-rate dd a,
.event-right .sportsgame-list-content-rate dd a,
.event-right .sportsgame-list-content-rate dd a {
  line-height: 13px
}

.sportsgame-list-content-rate dd a span {
  float: none;
  font-weight: normal
}

.sportsgame-list-content-rate dd .info {
  background-position: -399px -2891px;
  height: 15px;
  width: 15px
}

.sportsgame-list-content-rate dd .info:hover,
.sportsgame-list-content-rate dd .info.icon-info-hover {
  background-position: -399px -2906px
}

.sportsgame-list-content-rate .sport-odds,
.sportsgame-list-content-rate .last-col,
.sportsgame-list-content-rate .col-draw,
.sportsgame-list-content-rate .col-matched {
  border-right: 1px solid #eee
}

.sportsgame-list-content-rate .last-col {
  border: none
}

.sportsgame-list-content-rate .col-matched {
  color: #777;
  padding: 5px 6px 5px 0;
  text-align: right;
  line-height: 24px
}

.sport_list-wrap .sportsgame-list-content-rate dt {
  width: 70px;
  color: #243a48;
  padding: 8px 0
}

.sport_list-wrap .sportsgame-list-content-rate dd {
  padding: 8px 5px 8px 0
}

.sport_list-wrap .sportsgame-list-content-rate dd a {
  float: none;
  font-size: 12px;
  line-height: 15px
}

.sportsgame-list-content-rate.predict dt {
  padding: 2px 0
}

.sportsgame-list-content-rate.predict dd {
  padding: 7px 3px
}

.sportsgame-list-content-rate.predict p {
  margin-bottom: 1px
}

.sportsgame-list-content-rate.predict .lose,
.sportsgame-list-content-rate.predict .to-lose,
.sportsgame-list-content-rate.predict .win,
.sportsgame-list-content-rate.predict .to-win {
  padding: 0
}

.in_play {
  font-weight: bold !important;
  color: #508d0e
}

.sportsgame-list-content-rate .in_play {
  padding: 0
}

.game-wrap-horse {
  margin-bottom: 5px
}

.sportsgame-list-content-rate:after,
.sportsgame-list-content-rate dd:after {
  content: "";
  display: block;
  clear: both;
}

.col3 .col-game,
.col3 .sportsgame-list-content-rate dt,
.sportsgame-list-content-rate .col3 dt {
  width: calc(51.4% - 42px)
}

.sportsgame-list-content-rate dt {
  padding: 0;
  font-weight: bold;
  vertical-align: middle;
  padding: 2px 0 3px 0;
}

.sportsgame-list-content-rate dt,
.sportsgame-list-content-rate dt a,
.sportsgame-list-content-rate dd,
.sportsgame-list-content-rate dd a {
  float: left;
}

.inplay-icon .highlight-edge-content,
.sportsgame-list-content-rate .inplay-icon {
  margin-top: 3px;
}

.sportsgame-list-content-rate .inplay-icon {
  float: left;
}

.inplay-icon {
  margin-right: 5px;
  background-position: -406px -1818px;
  height: 8px;
  width: 8px;
}

.sportsgame-list-content-rate .inplay-icon {
  /* background-image: url(../images/sprite/main-sab3d65c1f7.png); */
  background-image: url(../images/sprite/main-se21de741bc.png);
  background-repeat: no-repeat;
}

.sportsgame-list-content-rate dt a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 13px);
  margin-bottom: 2px;
}

.sportsgame-list-content-rate dt,
.sportsgame-list-content-rate dt a,
.sportsgame-list-content-rate dd,
.sportsgame-list-content-rate dd a {
  float: left;
}

.sportsgame-list-content-rate dt .sportsgame-time-list {
  color: #777;
  max-width: 105px;
  margin-left: 9px;
}

.clear,
.set-content,
.btn-wrap,
.kv-wrap a:after,
.sportsgame-list-content-rate dt .sportsgame-time-list,
.casinozone-wrap-simple a:after {
  clear: both;
}

.sportsgame-list-content-rate dt span {
  font-weight: normal;
  padding: 0 3px;
}

.sportsgame-list-content-rate .in_play {
  padding: 0;
}

.sportsgame-list-content-rate dt span {
  font-weight: normal;
  padding: 0 3px;
}

.in_play {
  font-weight: bold !important;
  color: #508d0e;
}

.sportsgame-list-content-rate .game-live {
  float: none;
  vertical-align: text-top;
  margin-right: 0;
}

.sportsgame-list-content-rate .game-fancy,
.sportsgame-list-content-rate .game-sportsbook,
.sportsgame-list-content-rate .game-bookmaker,
.sportsgame-list-content-rate .game-live {
  float: right;
}

.sportsgame-list-content-rate dt span {
  font-weight: normal;
  padding: 0 3px;
}

.game-live {
  width: 18px;
  background-color: #1876b2;
}

.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live {
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  height: 16px;
  padding: 0 !important;
}

.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live {
  font-size: 0;
  text-indent: -99999px;
}

.game-live:after {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g fill="none" fill-rule="evenodd"><circle cx="6" cy="6" r="6" fill="%234AA2DB"/><path fill="%23FFF" d="M6 0a6 6 0 110 12A6 6 0 016 0zm0 1a5 5 0 100 10A5 5 0 006 1z" opacity=".605"/><path fill="%23FFF" d="M4 3v6l5-3z"/></g></svg>');
  background-repeat: no-repeat;
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after {
  content: "";
  background-size: cover;
  width: 12px;
  height: 12px;
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after,
.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before {
  display: block;
}

.sportsgame-list-content-rate .game-fancy {
  float: none;
  vertical-align: text-top;
  margin-right: 0;
}

.game-fancy {
  background-color: #0a92a5;
}

.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  background-position: -395px -1730px;
  height: 16px;
  width: 19px;
  border-radius: 3px 0 0 3px;
}

.in-play.game-fancy:after,
.in-play.game-sportsbook:after,
.in-play.game-bookmaker:after,
.in-play.game-live:after {
  margin-left: 19px;
}

.game-fancy:after,
.game-sportsbook:after,
.game-bookmaker:after,
.game-live:after {
  content: "";
  background-size: cover;
  width: 12px;
  height: 12px;
}

.sportsgame-list-content-rate .game-bookmaker {
  float: none;
  vertical-align: text-top;
  margin-right: 0;
}

.game-bookmaker {
  background-color: #226bc3;
}

.game-bookmaker:after {
  background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.58 21c.876 0 1.642-.257 2.3-.77.656-.513 1.085-1.195 1.286-2.047l.986-4.487c.091-.348.05-.679-.123-.992A1.722 1.722 0 0019.33 12c.365-.14.699-.365 1-.678.3-.313.497-.644.588-.992l.986-4.513c.2-.852.087-1.534-.342-2.047-.43-.513-1.09-.77-1.985-.77H5.997L2 21h13.58zm-1.096-10.122h-3.942l1.26-5.608h3.942l-1.26 5.608zm-1.752 7.879H8.79l1.26-5.635h3.942l-1.26 5.635z" fill="%23CAFCFF" fill-rule="nonzero"/></svg>');
}

.game-fancy,
.game-sportsbook,
.game-bookmaker,
.game-live {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;
  border-radius: 3px;
  width: 17px;
  height: 16px;
  padding: 0 !important;
}

.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  background-position: -395px -1730px;
  height: 16px;
  width: 19px;
  border-radius: 3px 0 0 3px;
}

.in-play.game-fancy:before,
.in-play.game-sportsbook:before,
.in-play.game-bookmaker:before,
.in-play.game-live:before {
  background-image: url(../images/sprite/main-se21de741bc.png)
}

.in-play.game-fancy,
.in-play.game-sportsbook,
.in-play.game-bookmaker,
.in-play.game-live {
  position: relative;
  overflow: hidden;
  width: 35px;
}

.sportsgame-list-content-rate .col-matched {
  color: #777;
  padding: 5px 6px 5px 0;
  text-align: right;
  line-height: 24px;
}

.sportsgame-list-content-rate .sport-odds,
.sportsgame-list-content-rate .last-col,
.sportsgame-list-content-rate .col-draw,
.sportsgame-list-content-rate .col-matched {
  padding: 2px 3px;
}

.sportsgame-list-content-rate dd {
  position: relative;
  align-self: center;
}

.sportsgame-list-content-rate dd a {
  width: 49%;
  font-size: 11px;
  line-height: 26px;
  padding: 4px 0;
  cursor: pointer;
  text-align: center;
  float: left;
}

.highlight-edge-content {
  border-bottom: 1px solid #7e97a7;
  margin-bottom: 15px
}

.icon-no_play {
  float: left;
  margin-top: 3px;
}

.sportsgame-list-content-rate .game-live {
  float: none;
  vertical-align: text-top;
  margin-right: 0;
}

.slick-dots li.slick-active button:before {
  color: white !important;
}

.slick-prev {
  left: -14px !important;
  z-index: 444 !important;
}

.slick-prev:before {
  background-image: url(../images/sprite/arrowleft.svg);
  background-size: 45px !important;
  height: 48px !important;
  position: absolute !important;
  width: 48px !important;
  background-repeat: no-repeat !important;
  top: 0px !important;
}

.slick-prev:before,
.slick-next:before {
  color: transparent !important;
}

.slick-next:before {
  background-image: url(../images/sprite/arrowright.svg);
  background-size: 45px !important;
  height: 48px !important;
  position: absolute !important;
  width: 48px !important;
  background-repeat: no-repeat !important;
  top: 0px !important;
}

.slick-next {
  right: 33px !important;
}

.centar-content1 .marquee-box {
  margin-bottom: 10px;
}

/* colrate */
.highlight-sorting .select:after {
  content: "â–¾";
  font-size: 11px;
  color: inherit;
  display: block;
  left: 95px;
  top: -2px;
  position: absolute;
  z-index: 0;
  pointer-events: none;
}

.col3 .col-game,
.col3 .sportsgame-list-content-rate dt,
.sportsgame-list-content-rate .col3 dt {
  width: calc(51.4% - 42px);
}

.game-fancy:after {
  background-image: url('data:image/svg+xml,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.44 21.32l1.792-8.456h5.628l.504-2.408h-5.628l1.288-6.02h7.252L20.78 2H10.112c-.896 0-1.68.275-2.352.826-.672.55-1.11 1.283-1.316 2.198L3 21.32h6.44z" fill="%23C5F6EE" fill-rule="nonzero"/></svg>');
}

.game-highlight-wrap .highlight-sorting {
  display: block;
  float: right;
  font-weight: normal;
}

.highlight-sorting .select::after {
  content: "▾";
  font-size: 11px;
  color: inherit;
  display: block;
  left: 95px;
  top: -2px;
  position: absolute;
  z-index: 0;
  pointer-events: none;
}



@-webkit-keyframes twinkling {

  0%,
  100% {
    opacity: 1
  }

  50% {
    opacity: .3
  }
}

@keyframes twinkling {

  0%,
  100% {
    opacity: 1
  }

  50% {
    opacity: .3
  }
}

.main-content .one_click .select:before {
  background-image: url('data:image/svg+xml,<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M13.56 3.18c.228.157.369.364.422.623a.831.831 0 0 1-.185.716l-5.465 7.09c-.176.203-.4.328-.673.375a.989.989 0 0 1-.752-.165c-.14-.093-.51-.426-1.109-.997a87.437 87.437 0 0 1-1.69-1.655l-.818-.798A.914.914 0 0 1 3 7.688c0-.266.106-.493.317-.681.211-.188.457-.278.739-.27.282.008.52.114.713.317l2.613 2.512 4.752-6.174c.176-.204.4-.329.673-.376a.989.989 0 0 1 .752.165Z" fill="%23000" fill-rule="evenodd"/></svg>') !important;
}

.inplay .marquee-box {
  margin-bottom: 10px;
}

.over-wrap {
  overflow: hidden;
  overflow-y: scroll;
}</style>`;

